(function () {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7e31"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7e31"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hrKNH", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $cb3942e418027aec$export$ef7acd7185315e22; });
/**
* vue v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ parcelRequire("6zPDN");
var $9pglz = parcelRequire("9pglz");
var $6zPDN = parcelRequire("6zPDN");
function $cb3942e418027aec$var$initDev() {
    (0, $9pglz.initCustomFormatter)();
}
const $cb3942e418027aec$export$ef7acd7185315e22 = ()=>{};
$parcel$exportWildcard(module.exports, $6zPDN);

});
parcelRegister("6zPDN", function(module, exports) {

$parcel$export(module.exports, "Transition", function () { return $4c9e11c6bdea98d0$export$be58926105124dd4; });
$parcel$export(module.exports, "vShow", function () { return $4c9e11c6bdea98d0$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "useCssVars", function () { return $4c9e11c6bdea98d0$export$ef28b76f07940108; });
$parcel$export(module.exports, "defineCustomElement", function () { return $4c9e11c6bdea98d0$export$a00e2346eabbdbef; });
$parcel$export(module.exports, "VueElement", function () { return $4c9e11c6bdea98d0$export$b337c1a55163dbe3; });
$parcel$export(module.exports, "defineSSRCustomElement", function () { return $4c9e11c6bdea98d0$export$6debb2e68f212638; });
$parcel$export(module.exports, "hydrate", function () { return $4c9e11c6bdea98d0$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "render", function () { return $4c9e11c6bdea98d0$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "useCssModule", function () { return $4c9e11c6bdea98d0$export$9300d5b90d56e3d1; });
$parcel$export(module.exports, "TransitionGroup", function () { return $4c9e11c6bdea98d0$export$19ffa8f511f7bc2e; });
$parcel$export(module.exports, "vModelText", function () { return $4c9e11c6bdea98d0$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelCheckbox", function () { return $4c9e11c6bdea98d0$export$8847c2e532b35714; });
$parcel$export(module.exports, "vModelRadio", function () { return $4c9e11c6bdea98d0$export$b4356c59b38b7aa9; });
$parcel$export(module.exports, "vModelSelect", function () { return $4c9e11c6bdea98d0$export$87d227567b51ca39; });
$parcel$export(module.exports, "vModelDynamic", function () { return $4c9e11c6bdea98d0$export$5ad5c0e01ff62c5; });
$parcel$export(module.exports, "withModifiers", function () { return $4c9e11c6bdea98d0$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $4c9e11c6bdea98d0$export$f691a8759658f782; });
$parcel$export(module.exports, "createApp", function () { return $4c9e11c6bdea98d0$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "createSSRApp", function () { return $4c9e11c6bdea98d0$export$35800275c0037383; });
$parcel$export(module.exports, "initDirectivesForSSR", function () { return $4c9e11c6bdea98d0$export$800b28255aa678d9; });
/**
* @vue/runtime-dom v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $Dz4HH = parcelRequire("Dz4HH");

var $j3cSI = parcelRequire("j3cSI");
const $4c9e11c6bdea98d0$var$svgNS = "http://www.w3.org/2000/svg";
const $4c9e11c6bdea98d0$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $4c9e11c6bdea98d0$var$doc = typeof document !== "undefined" ? document : null;
const $4c9e11c6bdea98d0$var$templateContainer = $4c9e11c6bdea98d0$var$doc && /* @__PURE__ */ $4c9e11c6bdea98d0$var$doc.createElement("template");
const $4c9e11c6bdea98d0$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $4c9e11c6bdea98d0$var$doc.createElementNS($4c9e11c6bdea98d0$var$svgNS, tag) : namespace === "mathml" ? $4c9e11c6bdea98d0$var$doc.createElementNS($4c9e11c6bdea98d0$var$mathmlNS, tag) : $4c9e11c6bdea98d0$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$4c9e11c6bdea98d0$var$doc.createTextNode(text),
    createComment: (text)=>$4c9e11c6bdea98d0$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$4c9e11c6bdea98d0$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $4c9e11c6bdea98d0$var$templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = $4c9e11c6bdea98d0$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $4c9e11c6bdea98d0$var$TRANSITION = "transition";
const $4c9e11c6bdea98d0$var$ANIMATION = "animation";
const $4c9e11c6bdea98d0$var$vtcKey = Symbol("_vtc");
const $4c9e11c6bdea98d0$export$be58926105124dd4 = (props, { slots: slots })=>(0, $9pglz.h)((0, $9pglz.BaseTransition), $4c9e11c6bdea98d0$var$resolveTransitionProps(props), slots);
$4c9e11c6bdea98d0$export$be58926105124dd4.displayName = "Transition";
const $4c9e11c6bdea98d0$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $4c9e11c6bdea98d0$var$TransitionPropsValidators = $4c9e11c6bdea98d0$export$be58926105124dd4.props = /* @__PURE__ */ (0, $j3cSI.extend)({}, (0, $9pglz.BaseTransitionPropsValidators), $4c9e11c6bdea98d0$var$DOMTransitionPropsValidators);
const $4c9e11c6bdea98d0$var$callHook = (hook, args = [])=>{
    if ((0, $j3cSI.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $4c9e11c6bdea98d0$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $j3cSI.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $4c9e11c6bdea98d0$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $4c9e11c6bdea98d0$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $4c9e11c6bdea98d0$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, leaveFromClass);
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, leaveToClass);
        $4c9e11c6bdea98d0$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $4c9e11c6bdea98d0$var$callHook(hook, [
                el,
                resolve
            ]);
            $4c9e11c6bdea98d0$var$nextFrame(()=>{
                $4c9e11c6bdea98d0$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $4c9e11c6bdea98d0$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$4c9e11c6bdea98d0$var$hasExplicitCallback(hook)) $4c9e11c6bdea98d0$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $j3cSI.extend)(baseProps, {
        onBeforeEnter (el) {
            $4c9e11c6bdea98d0$var$callHook(onBeforeEnter, [
                el
            ]);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, enterFromClass);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $4c9e11c6bdea98d0$var$callHook(onBeforeAppear, [
                el
            ]);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, appearFromClass);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $4c9e11c6bdea98d0$var$addTransitionClass(el, leaveFromClass);
            $4c9e11c6bdea98d0$var$forceReflow();
            $4c9e11c6bdea98d0$var$addTransitionClass(el, leaveActiveClass);
            $4c9e11c6bdea98d0$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $4c9e11c6bdea98d0$var$removeTransitionClass(el, leaveFromClass);
                $4c9e11c6bdea98d0$var$addTransitionClass(el, leaveToClass);
                if (!$4c9e11c6bdea98d0$var$hasExplicitCallback(onLeave)) $4c9e11c6bdea98d0$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $4c9e11c6bdea98d0$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $4c9e11c6bdea98d0$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $4c9e11c6bdea98d0$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $4c9e11c6bdea98d0$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $4c9e11c6bdea98d0$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $j3cSI.isObject)(duration)) return [
        $4c9e11c6bdea98d0$var$NumberOf(duration.enter),
        $4c9e11c6bdea98d0$var$NumberOf(duration.leave)
    ];
    else {
        const n = $4c9e11c6bdea98d0$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $4c9e11c6bdea98d0$var$NumberOf(val) {
    const res = (0, $j3cSI.toNumber)(val);
    return res;
}
function $4c9e11c6bdea98d0$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$4c9e11c6bdea98d0$var$vtcKey] || (el[$4c9e11c6bdea98d0$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $4c9e11c6bdea98d0$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$4c9e11c6bdea98d0$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$4c9e11c6bdea98d0$var$vtcKey] = void 0;
    }
}
function $4c9e11c6bdea98d0$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $4c9e11c6bdea98d0$var$endId = 0;
function $4c9e11c6bdea98d0$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$4c9e11c6bdea98d0$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $4c9e11c6bdea98d0$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $4c9e11c6bdea98d0$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$4c9e11c6bdea98d0$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$4c9e11c6bdea98d0$var$TRANSITION}Duration`);
    const transitionTimeout = $4c9e11c6bdea98d0$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$4c9e11c6bdea98d0$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$4c9e11c6bdea98d0$var$ANIMATION}Duration`);
    const animationTimeout = $4c9e11c6bdea98d0$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $4c9e11c6bdea98d0$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $4c9e11c6bdea98d0$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $4c9e11c6bdea98d0$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $4c9e11c6bdea98d0$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $4c9e11c6bdea98d0$var$TRANSITION : $4c9e11c6bdea98d0$var$ANIMATION : null;
        propCount = type ? type === $4c9e11c6bdea98d0$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $4c9e11c6bdea98d0$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$4c9e11c6bdea98d0$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $4c9e11c6bdea98d0$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$4c9e11c6bdea98d0$var$toMs(d) + $4c9e11c6bdea98d0$var$toMs(delays[i])));
}
function $4c9e11c6bdea98d0$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $4c9e11c6bdea98d0$var$forceReflow() {
    return document.body.offsetHeight;
}
function $4c9e11c6bdea98d0$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$4c9e11c6bdea98d0$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $4c9e11c6bdea98d0$var$vShowOriginalDisplay = Symbol("_vod");
const $4c9e11c6bdea98d0$var$vShowHidden = Symbol("_vsh");
const $4c9e11c6bdea98d0$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$4c9e11c6bdea98d0$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $4c9e11c6bdea98d0$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $4c9e11c6bdea98d0$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $4c9e11c6bdea98d0$var$setDisplay(el, false);
            });
        } else $4c9e11c6bdea98d0$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $4c9e11c6bdea98d0$var$setDisplay(el, value);
    }
};
function $4c9e11c6bdea98d0$var$setDisplay(el, value) {
    el.style.display = value ? el[$4c9e11c6bdea98d0$var$vShowOriginalDisplay] : "none";
    el[$4c9e11c6bdea98d0$var$vShowHidden] = !value;
}
function $4c9e11c6bdea98d0$var$initVShowForSSR() {
    $4c9e11c6bdea98d0$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $4c9e11c6bdea98d0$var$CSS_VAR_TEXT = Symbol("");
function $4c9e11c6bdea98d0$export$ef28b76f07940108(getter) {
    const instance = (0, $9pglz.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$4c9e11c6bdea98d0$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $4c9e11c6bdea98d0$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $9pglz.watchPostEffect)(setVars);
    (0, $9pglz.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $9pglz.onUnmounted)(()=>ob.disconnect());
    });
}
function $4c9e11c6bdea98d0$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $4c9e11c6bdea98d0$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $4c9e11c6bdea98d0$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $9pglz.Fragment)) vnode.children.forEach((c)=>$4c9e11c6bdea98d0$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $9pglz.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $4c9e11c6bdea98d0$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $4c9e11c6bdea98d0$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$4c9e11c6bdea98d0$var$CSS_VAR_TEXT] = cssText;
    }
}
const $4c9e11c6bdea98d0$var$displayRE = /(^|;)\s*display\s*:/;
function $4c9e11c6bdea98d0$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $j3cSI.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $j3cSI.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $4c9e11c6bdea98d0$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $4c9e11c6bdea98d0$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $4c9e11c6bdea98d0$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$4c9e11c6bdea98d0$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $4c9e11c6bdea98d0$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($4c9e11c6bdea98d0$var$vShowOriginalDisplay in el) {
        el[$4c9e11c6bdea98d0$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$4c9e11c6bdea98d0$var$vShowHidden]) style.display = "none";
    }
}
const $4c9e11c6bdea98d0$var$semicolonRE = /[^\\];\s*$/;
const $4c9e11c6bdea98d0$var$importantRE = /\s*!important$/;
function $4c9e11c6bdea98d0$var$setStyle(style, name, val) {
    if ((0, $j3cSI.isArray)(val)) val.forEach((v)=>$4c9e11c6bdea98d0$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $4c9e11c6bdea98d0$var$autoPrefix(style, name);
            if ($4c9e11c6bdea98d0$var$importantRE.test(val)) style.setProperty((0, $j3cSI.hyphenate)(prefixed), val.replace($4c9e11c6bdea98d0$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $4c9e11c6bdea98d0$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $4c9e11c6bdea98d0$var$prefixCache = {};
function $4c9e11c6bdea98d0$var$autoPrefix(style, rawName) {
    const cached = $4c9e11c6bdea98d0$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $j3cSI.camelize)(rawName);
    if (name !== "filter" && name in style) return $4c9e11c6bdea98d0$var$prefixCache[rawName] = name;
    name = (0, $j3cSI.capitalize)(name);
    for(let i = 0; i < $4c9e11c6bdea98d0$var$prefixes.length; i++){
        const prefixed = $4c9e11c6bdea98d0$var$prefixes[i] + name;
        if (prefixed in style) return $4c9e11c6bdea98d0$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $4c9e11c6bdea98d0$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $4c9e11c6bdea98d0$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($4c9e11c6bdea98d0$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($4c9e11c6bdea98d0$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $j3cSI.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $j3cSI.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $4c9e11c6bdea98d0$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $j3cSI.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $4c9e11c6bdea98d0$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $4c9e11c6bdea98d0$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $4c9e11c6bdea98d0$var$veiKey = Symbol("_vei");
function $4c9e11c6bdea98d0$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$4c9e11c6bdea98d0$var$veiKey] || (el[$4c9e11c6bdea98d0$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $4c9e11c6bdea98d0$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $4c9e11c6bdea98d0$var$createInvoker(nextValue, instance);
            $4c9e11c6bdea98d0$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $4c9e11c6bdea98d0$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $4c9e11c6bdea98d0$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $4c9e11c6bdea98d0$var$parseName(name) {
    let options;
    if ($4c9e11c6bdea98d0$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($4c9e11c6bdea98d0$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $j3cSI.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $4c9e11c6bdea98d0$var$cachedNow = 0;
const $4c9e11c6bdea98d0$var$p = /* @__PURE__ */ Promise.resolve();
const $4c9e11c6bdea98d0$var$getNow = ()=>$4c9e11c6bdea98d0$var$cachedNow || ($4c9e11c6bdea98d0$var$p.then(()=>$4c9e11c6bdea98d0$var$cachedNow = 0), $4c9e11c6bdea98d0$var$cachedNow = Date.now());
function $4c9e11c6bdea98d0$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $9pglz.callWithAsyncErrorHandling)($4c9e11c6bdea98d0$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $4c9e11c6bdea98d0$var$getNow();
    return invoker;
}
function $4c9e11c6bdea98d0$var$patchStopImmediatePropagation(e, value) {
    if ((0, $j3cSI.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $4c9e11c6bdea98d0$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $4c9e11c6bdea98d0$var$patchProp = (el, key, prevValue, nextValue, namespace, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $4c9e11c6bdea98d0$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $4c9e11c6bdea98d0$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $j3cSI.isOn)(key)) {
        if (!(0, $j3cSI.isModelListener)(key)) $4c9e11c6bdea98d0$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $4c9e11c6bdea98d0$var$shouldSetAsProp(el, key, nextValue, isSVG)) $4c9e11c6bdea98d0$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $4c9e11c6bdea98d0$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $4c9e11c6bdea98d0$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $4c9e11c6bdea98d0$var$isNativeOn(key) && (0, $j3cSI.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($4c9e11c6bdea98d0$var$isNativeOn(key) && (0, $j3cSI.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $4c9e11c6bdea98d0$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $9pglz.defineComponent)(options);
    class VueCustomElement extends $4c9e11c6bdea98d0$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $4c9e11c6bdea98d0$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options)=>{
    return /* @__PURE__ */ $4c9e11c6bdea98d0$export$a00e2346eabbdbef(options, $4c9e11c6bdea98d0$export$fa8d919ba61d84db);
};
const $4c9e11c6bdea98d0$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $4c9e11c6bdea98d0$export$b337c1a55163dbe3 extends $4c9e11c6bdea98d0$var$BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        if (this._ob) {
            this._ob.disconnect();
            this._ob = null;
        }
        (0, $9pglz.nextTick)(()=>{
            if (!this._connected) {
                $4c9e11c6bdea98d0$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $j3cSI.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $j3cSI.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $j3cSI.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $j3cSI.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $j3cSI.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        const camelKey = (0, $j3cSI.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $j3cSI.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $j3cSI.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $j3cSI.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $j3cSI.hyphenate)(key));
            }
        }
    }
    _update() {
        $4c9e11c6bdea98d0$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $9pglz.createVNode)(this._def, (0, $j3cSI.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $j3cSI.hyphenate)(event) !== event) dispatch((0, $j3cSI.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $4c9e11c6bdea98d0$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function $4c9e11c6bdea98d0$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $9pglz.getCurrentInstance)();
        if (!instance) return 0, $j3cSI.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $j3cSI.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $j3cSI.EMPTY_OBJ;
        return mod;
    }
}
const $4c9e11c6bdea98d0$var$positionMap = /* @__PURE__ */ new WeakMap();
const $4c9e11c6bdea98d0$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $4c9e11c6bdea98d0$var$moveCbKey = Symbol("_moveCb");
const $4c9e11c6bdea98d0$var$enterCbKey = Symbol("_enterCb");
const $4c9e11c6bdea98d0$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $j3cSI.extend)({}, $4c9e11c6bdea98d0$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $9pglz.getCurrentInstance)();
        const state = (0, $9pglz.useTransitionState)();
        let prevChildren;
        let children;
        (0, $9pglz.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$4c9e11c6bdea98d0$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($4c9e11c6bdea98d0$var$callPendingCbs);
            prevChildren.forEach($4c9e11c6bdea98d0$var$recordPosition);
            const movedChildren = prevChildren.filter($4c9e11c6bdea98d0$var$applyTranslation);
            $4c9e11c6bdea98d0$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $4c9e11c6bdea98d0$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$4c9e11c6bdea98d0$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$4c9e11c6bdea98d0$var$moveCbKey] = null;
                        $4c9e11c6bdea98d0$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $Dz4HH.toRaw)(props);
            const cssTransitionProps = $4c9e11c6bdea98d0$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $9pglz.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $9pglz.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $9pglz.setTransitionHooks)(child, (0, $9pglz.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $9pglz.setTransitionHooks)(child, (0, $9pglz.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $4c9e11c6bdea98d0$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $9pglz.createVNode)(tag, null, children);
        };
    }
};
const $4c9e11c6bdea98d0$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $4c9e11c6bdea98d0$var$removeMode($4c9e11c6bdea98d0$var$TransitionGroupImpl.props);
const $4c9e11c6bdea98d0$export$19ffa8f511f7bc2e = $4c9e11c6bdea98d0$var$TransitionGroupImpl;
function $4c9e11c6bdea98d0$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$4c9e11c6bdea98d0$var$moveCbKey]) el[$4c9e11c6bdea98d0$var$moveCbKey]();
    if (el[$4c9e11c6bdea98d0$var$enterCbKey]) el[$4c9e11c6bdea98d0$var$enterCbKey]();
}
function $4c9e11c6bdea98d0$var$recordPosition(c) {
    $4c9e11c6bdea98d0$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $4c9e11c6bdea98d0$var$applyTranslation(c) {
    const oldPos = $4c9e11c6bdea98d0$var$positionMap.get(c);
    const newPos = $4c9e11c6bdea98d0$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $4c9e11c6bdea98d0$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$4c9e11c6bdea98d0$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $4c9e11c6bdea98d0$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $4c9e11c6bdea98d0$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $j3cSI.isArray)(fn) ? (value)=>(0, $j3cSI.invokeArrayFns)(fn, value) : fn;
};
function $4c9e11c6bdea98d0$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $4c9e11c6bdea98d0$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $4c9e11c6bdea98d0$var$assignKey = Symbol("_assign");
const $4c9e11c6bdea98d0$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$4c9e11c6bdea98d0$var$assignKey] = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $4c9e11c6bdea98d0$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $j3cSI.looseToNumber)(domValue);
            el[$4c9e11c6bdea98d0$var$assignKey](domValue);
        });
        if (trim) $4c9e11c6bdea98d0$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $4c9e11c6bdea98d0$var$addEventListener(el, "compositionstart", $4c9e11c6bdea98d0$var$onCompositionStart);
            $4c9e11c6bdea98d0$var$addEventListener(el, "compositionend", $4c9e11c6bdea98d0$var$onCompositionEnd);
            $4c9e11c6bdea98d0$var$addEventListener(el, "change", $4c9e11c6bdea98d0$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$4c9e11c6bdea98d0$var$assignKey] = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = number || el.type === "number" ? (0, $j3cSI.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $4c9e11c6bdea98d0$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$4c9e11c6bdea98d0$var$assignKey] = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        $4c9e11c6bdea98d0$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $4c9e11c6bdea98d0$var$getValue(el);
            const checked = el.checked;
            const assign = el[$4c9e11c6bdea98d0$var$assignKey];
            if ((0, $j3cSI.isArray)(modelValue)) {
                const index = (0, $j3cSI.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $j3cSI.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($4c9e11c6bdea98d0$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $4c9e11c6bdea98d0$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$4c9e11c6bdea98d0$var$assignKey] = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        $4c9e11c6bdea98d0$var$setChecked(el, binding, vnode);
    }
};
function $4c9e11c6bdea98d0$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $j3cSI.isArray)(value)) el.checked = (0, $j3cSI.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $j3cSI.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $j3cSI.looseEqual)(value, $4c9e11c6bdea98d0$var$getCheckboxValue(el, true));
}
const $4c9e11c6bdea98d0$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $j3cSI.looseEqual)(value, vnode.props.value);
        el[$4c9e11c6bdea98d0$var$assignKey] = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        $4c9e11c6bdea98d0$var$addEventListener(el, "change", ()=>{
            el[$4c9e11c6bdea98d0$var$assignKey]($4c9e11c6bdea98d0$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$4c9e11c6bdea98d0$var$assignKey] = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $j3cSI.looseEqual)(value, vnode.props.value);
    }
};
const $4c9e11c6bdea98d0$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $j3cSI.isSet)(value);
        $4c9e11c6bdea98d0$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $j3cSI.looseToNumber)($4c9e11c6bdea98d0$var$getValue(o)) : $4c9e11c6bdea98d0$var$getValue(o));
            el[$4c9e11c6bdea98d0$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $9pglz.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$4c9e11c6bdea98d0$var$assignKey] = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value, modifiers: { number: number } }) {
        $4c9e11c6bdea98d0$var$setSelected(el, value, number);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$4c9e11c6bdea98d0$var$assignKey] = $4c9e11c6bdea98d0$var$getModelAssigner(vnode);
    },
    updated (el, { value: value, modifiers: { number: number } }) {
        if (!el._assigning) $4c9e11c6bdea98d0$var$setSelected(el, value, number);
    }
};
function $4c9e11c6bdea98d0$var$setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $j3cSI.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $j3cSI.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $4c9e11c6bdea98d0$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.includes(number ? (0, $j3cSI.looseToNumber)(optionValue) : optionValue);
                else option.selected = (0, $j3cSI.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $j3cSI.looseEqual)($4c9e11c6bdea98d0$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $4c9e11c6bdea98d0$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $4c9e11c6bdea98d0$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $4c9e11c6bdea98d0$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $4c9e11c6bdea98d0$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $4c9e11c6bdea98d0$export$87d227567b51ca39;
        case "TEXTAREA":
            return $4c9e11c6bdea98d0$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $4c9e11c6bdea98d0$export$8847c2e532b35714;
                case "radio":
                    return $4c9e11c6bdea98d0$export$b4356c59b38b7aa9;
                default:
                    return $4c9e11c6bdea98d0$export$f1f88689f5728478;
            }
    }
}
function $4c9e11c6bdea98d0$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $4c9e11c6bdea98d0$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $4c9e11c6bdea98d0$var$initVModelForSSR() {
    $4c9e11c6bdea98d0$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $4c9e11c6bdea98d0$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $j3cSI.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $4c9e11c6bdea98d0$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $j3cSI.isArray)(value)) {
            if (vnode.props && (0, $j3cSI.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $j3cSI.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $4c9e11c6bdea98d0$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $4c9e11c6bdea98d0$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $4c9e11c6bdea98d0$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $4c9e11c6bdea98d0$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$4c9e11c6bdea98d0$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $4c9e11c6bdea98d0$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $4c9e11c6bdea98d0$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $4c9e11c6bdea98d0$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $4c9e11c6bdea98d0$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $j3cSI.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $4c9e11c6bdea98d0$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $4c9e11c6bdea98d0$var$rendererOptions = /* @__PURE__ */ (0, $j3cSI.extend)({
    patchProp: $4c9e11c6bdea98d0$var$patchProp
}, $4c9e11c6bdea98d0$var$nodeOps);
let $4c9e11c6bdea98d0$var$renderer;
let $4c9e11c6bdea98d0$var$enabledHydration = false;
function $4c9e11c6bdea98d0$var$ensureRenderer() {
    return $4c9e11c6bdea98d0$var$renderer || ($4c9e11c6bdea98d0$var$renderer = (0, $9pglz.createRenderer)($4c9e11c6bdea98d0$var$rendererOptions));
}
function $4c9e11c6bdea98d0$var$ensureHydrationRenderer() {
    $4c9e11c6bdea98d0$var$renderer = $4c9e11c6bdea98d0$var$enabledHydration ? $4c9e11c6bdea98d0$var$renderer : (0, $9pglz.createHydrationRenderer)($4c9e11c6bdea98d0$var$rendererOptions);
    $4c9e11c6bdea98d0$var$enabledHydration = true;
    return $4c9e11c6bdea98d0$var$renderer;
}
const $4c9e11c6bdea98d0$export$b3890eb0ae9dca99 = (...args)=>{
    $4c9e11c6bdea98d0$var$ensureRenderer().render(...args);
};
const $4c9e11c6bdea98d0$export$fa8d919ba61d84db = (...args)=>{
    $4c9e11c6bdea98d0$var$ensureHydrationRenderer().hydrate(...args);
};
const $4c9e11c6bdea98d0$export$4e373c34abfa8c68 = (...args)=>{
    const app = $4c9e11c6bdea98d0$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $4c9e11c6bdea98d0$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $j3cSI.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, $4c9e11c6bdea98d0$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $4c9e11c6bdea98d0$export$35800275c0037383 = (...args)=>{
    const app = $4c9e11c6bdea98d0$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $4c9e11c6bdea98d0$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $4c9e11c6bdea98d0$var$resolveRootNamespace(container));
    };
    return app;
};
function $4c9e11c6bdea98d0$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $4c9e11c6bdea98d0$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $j3cSI.isHTMLTag)(tag) || (0, $j3cSI.isSVGTag)(tag) || (0, $j3cSI.isMathMLTag)(tag),
        writable: false
    });
}
function $4c9e11c6bdea98d0$var$injectCompilerOptionsCheck(app) {
    if ((0, $9pglz.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $9pglz.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $9pglz.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $9pglz.warn)(msg);
            }
        });
    }
}
function $4c9e11c6bdea98d0$var$normalizeContainer(container) {
    if ((0, $j3cSI.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $4c9e11c6bdea98d0$var$ssrDirectiveInitialized = false;
const $4c9e11c6bdea98d0$export$800b28255aa678d9 = ()=>{
    if (!$4c9e11c6bdea98d0$var$ssrDirectiveInitialized) {
        $4c9e11c6bdea98d0$var$ssrDirectiveInitialized = true;
        $4c9e11c6bdea98d0$var$initVModelForSSR();
        $4c9e11c6bdea98d0$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $9pglz);

});
parcelRegister("9pglz", function(module, exports) {

$parcel$export(module.exports, "callWithErrorHandling", function () { return $6d932106fee366bf$export$b22fcaf88446e9bf; });
$parcel$export(module.exports, "assertNumber", function () { return $6d932106fee366bf$export$dfbcecb440255e4a; });
$parcel$export(module.exports, "ErrorCodes", function () { return $6d932106fee366bf$export$10e8e1cf990558d7; });
$parcel$export(module.exports, "handleError", function () { return $6d932106fee366bf$export$d3da1ecaf1206c58; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $6d932106fee366bf$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $6d932106fee366bf$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return $6d932106fee366bf$export$59536a0199721cab; });
$parcel$export(module.exports, "Fragment", function () { return $6d932106fee366bf$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $6d932106fee366bf$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $6d932106fee366bf$export$4d299b491347818a; });
$parcel$export(module.exports, "Static", function () { return $6d932106fee366bf$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "pushScopeId", function () { return $6d932106fee366bf$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $6d932106fee366bf$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withScopeId", function () { return $6d932106fee366bf$export$15ba313e13f3dd04; });
$parcel$export(module.exports, "withCtx", function () { return $6d932106fee366bf$export$694b237e827a3d23; });
$parcel$export(module.exports, "setBlockTracking", function () { return $6d932106fee366bf$export$c20bee82f26f1e27; });
$parcel$export(module.exports, "createVNode", function () { return $6d932106fee366bf$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "cloneVNode", function () { return $6d932106fee366bf$export$ee4f9e12c0a92a1a; });
$parcel$export(module.exports, "isVNode", function () { return $6d932106fee366bf$export$3868d13f8734ae81; });
$parcel$export(module.exports, "resolveComponent", function () { return $6d932106fee366bf$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $6d932106fee366bf$export$b44c564a05ca975; });
$parcel$export(module.exports, "resolveDirective", function () { return $6d932106fee366bf$export$a1989e995cd481be; });
$parcel$export(module.exports, "Suspense", function () { return $6d932106fee366bf$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "openBlock", function () { return $6d932106fee366bf$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "ssrContextKey", function () { return $6d932106fee366bf$export$f2549a27e18acf2d; });
$parcel$export(module.exports, "useSSRContext", function () { return $6d932106fee366bf$export$6b1c54dc4befcda; });
$parcel$export(module.exports, "inject", function () { return $6d932106fee366bf$export$a976684a0efeb93f; });
$parcel$export(module.exports, "watchEffect", function () { return $6d932106fee366bf$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watchPostEffect", function () { return $6d932106fee366bf$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watchSyncEffect", function () { return $6d932106fee366bf$export$2035654f31b0e555; });
$parcel$export(module.exports, "watch", function () { return $6d932106fee366bf$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "withDirectives", function () { return $6d932106fee366bf$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "useTransitionState", function () { return $6d932106fee366bf$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $6d932106fee366bf$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $6d932106fee366bf$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $6d932106fee366bf$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $6d932106fee366bf$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $6d932106fee366bf$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $6d932106fee366bf$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $6d932106fee366bf$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $6d932106fee366bf$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $6d932106fee366bf$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "defineAsyncComponent", function () { return $6d932106fee366bf$export$d75d499b4c16cf21; });
$parcel$export(module.exports, "onUpdated", function () { return $6d932106fee366bf$export$5876c47052fb88b1; });
$parcel$export(module.exports, "KeepAlive", function () { return $6d932106fee366bf$export$70eb8a58709972df; });
$parcel$export(module.exports, "onActivated", function () { return $6d932106fee366bf$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $6d932106fee366bf$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onUnmounted", function () { return $6d932106fee366bf$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onBeforeMount", function () { return $6d932106fee366bf$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $6d932106fee366bf$export$ab91988a13872e4c; });
$parcel$export(module.exports, "onServerPrefetch", function () { return $6d932106fee366bf$export$ebf0c601f267bceb; });
$parcel$export(module.exports, "onRenderTriggered", function () { return $6d932106fee366bf$export$898295a813d662eb; });
$parcel$export(module.exports, "onRenderTracked", function () { return $6d932106fee366bf$export$2b41f4235363e921; });
$parcel$export(module.exports, "onErrorCaptured", function () { return $6d932106fee366bf$export$6a3a15856e50ad19; });
$parcel$export(module.exports, "renderList", function () { return $6d932106fee366bf$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "createSlots", function () { return $6d932106fee366bf$export$85738f8fcd0a5430; });
$parcel$export(module.exports, "renderSlot", function () { return $6d932106fee366bf$export$4abee4c34694ada1; });
$parcel$export(module.exports, "createBlock", function () { return $6d932106fee366bf$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "toHandlers", function () { return $6d932106fee366bf$export$2fb94ff667a6a1a; });
$parcel$export(module.exports, "defineProps", function () { return $6d932106fee366bf$export$80b33eababae110e; });
$parcel$export(module.exports, "defineEmits", function () { return $6d932106fee366bf$export$51ecece22fc17ddc; });
$parcel$export(module.exports, "defineExpose", function () { return $6d932106fee366bf$export$da25b65ca24b518a; });
$parcel$export(module.exports, "defineOptions", function () { return $6d932106fee366bf$export$77e79129327f3d0d; });
$parcel$export(module.exports, "defineSlots", function () { return $6d932106fee366bf$export$1b3acd4bb805b712; });
$parcel$export(module.exports, "defineModel", function () { return $6d932106fee366bf$export$acd55aa037e791bb; });
$parcel$export(module.exports, "withDefaults", function () { return $6d932106fee366bf$export$4df9c0969a9e0160; });
$parcel$export(module.exports, "useSlots", function () { return $6d932106fee366bf$export$9203a8e84125433c; });
$parcel$export(module.exports, "useAttrs", function () { return $6d932106fee366bf$export$75e29435042cd2ea; });
$parcel$export(module.exports, "mergeDefaults", function () { return $6d932106fee366bf$export$ec60f47d4a8a2e7f; });
$parcel$export(module.exports, "mergeModels", function () { return $6d932106fee366bf$export$ad4f724f587e6828; });
$parcel$export(module.exports, "createPropsRestProxy", function () { return $6d932106fee366bf$export$7c343e855c563faa; });
$parcel$export(module.exports, "withAsyncContext", function () { return $6d932106fee366bf$export$d6d6f7369f1fb104; });
$parcel$export(module.exports, "computed", function () { return $6d932106fee366bf$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "provide", function () { return $6d932106fee366bf$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "version", function () { return $6d932106fee366bf$export$83d89fbfd8236492; });
$parcel$export(module.exports, "hasInjectionContext", function () { return $6d932106fee366bf$export$caf6761f24fc571a; });
$parcel$export(module.exports, "createTextVNode", function () { return $6d932106fee366bf$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $6d932106fee366bf$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $6d932106fee366bf$export$200524cf0d997ff0; });
$parcel$export(module.exports, "Teleport", function () { return $6d932106fee366bf$export$76d55a0304a371f4; });
$parcel$export(module.exports, "createElementBlock", function () { return $6d932106fee366bf$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $6d932106fee366bf$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "transformVNodeArgs", function () { return $6d932106fee366bf$export$83beccd3afeeb809; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $6d932106fee366bf$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "mergeProps", function () { return $6d932106fee366bf$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createStaticVNode", function () { return $6d932106fee366bf$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "createCommentVNode", function () { return $6d932106fee366bf$export$49553837c7236d3c; });
$parcel$export(module.exports, "registerRuntimeCompiler", function () { return $6d932106fee366bf$export$667bb5a67822b941; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $6d932106fee366bf$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "useModel", function () { return $6d932106fee366bf$export$fb78bd113157f1a1; });
$parcel$export(module.exports, "h", function () { return $6d932106fee366bf$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $6d932106fee366bf$export$aed4979be6a60047; });
$parcel$export(module.exports, "withMemo", function () { return $6d932106fee366bf$export$2a6d714a4d738ae; });
$parcel$export(module.exports, "isMemoSame", function () { return $6d932106fee366bf$export$bf525184d622787c; });
$parcel$export(module.exports, "warn", function () { return $6d932106fee366bf$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "ErrorTypeStrings", function () { return $6d932106fee366bf$export$795e0ad4a0e2ed30; });
$parcel$export(module.exports, "devtools", function () { return $6d932106fee366bf$export$6922d3b3a607469e; });
$parcel$export(module.exports, "setDevtoolsHook", function () { return $6d932106fee366bf$export$b0c258b32c26c785; });
$parcel$export(module.exports, "ssrUtils", function () { return $6d932106fee366bf$export$a9679033567b336d; });
$parcel$export(module.exports, "resolveFilter", function () { return $6d932106fee366bf$export$83cf26e06ea620e1; });
$parcel$export(module.exports, "compatUtils", function () { return $6d932106fee366bf$export$dc678eddf276286e; });
$parcel$export(module.exports, "DeprecationTypes", function () { return $6d932106fee366bf$export$22072a82865312f6; });
$parcel$export(module.exports, "EffectScope", function () { return (parcelRequire("Dz4HH")).EffectScope; });
$parcel$export(module.exports, "ReactiveEffect", function () { return (parcelRequire("Dz4HH")).ReactiveEffect; });
$parcel$export(module.exports, "TrackOpTypes", function () { return (parcelRequire("Dz4HH")).TrackOpTypes; });
$parcel$export(module.exports, "TriggerOpTypes", function () { return (parcelRequire("Dz4HH")).TriggerOpTypes; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("Dz4HH")).customRef; });
$parcel$export(module.exports, "effect", function () { return (parcelRequire("Dz4HH")).effect; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("Dz4HH")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("Dz4HH")).getCurrentScope; });
$parcel$export(module.exports, "isProxy", function () { return (parcelRequire("Dz4HH")).isProxy; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("Dz4HH")).isReactive; });
$parcel$export(module.exports, "isReadonly", function () { return (parcelRequire("Dz4HH")).isReadonly; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("Dz4HH")).isRef; });
$parcel$export(module.exports, "isShallow", function () { return (parcelRequire("Dz4HH")).isShallow; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("Dz4HH")).markRaw; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("Dz4HH")).onScopeDispose; });
$parcel$export(module.exports, "proxyRefs", function () { return (parcelRequire("Dz4HH")).proxyRefs; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("Dz4HH")).reactive; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("Dz4HH")).readonly; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("Dz4HH")).ref; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("Dz4HH")).shallowReactive; });
$parcel$export(module.exports, "shallowReadonly", function () { return (parcelRequire("Dz4HH")).shallowReadonly; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("Dz4HH")).shallowRef; });
$parcel$export(module.exports, "stop", function () { return (parcelRequire("Dz4HH")).stop; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("Dz4HH")).toRaw; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("Dz4HH")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("Dz4HH")).toRefs; });
$parcel$export(module.exports, "toValue", function () { return (parcelRequire("Dz4HH")).toValue; });
$parcel$export(module.exports, "triggerRef", function () { return (parcelRequire("Dz4HH")).triggerRef; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("Dz4HH")).unref; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("j3cSI")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("j3cSI")).capitalize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("j3cSI")).normalizeClass; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("j3cSI")).normalizeProps; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("j3cSI")).normalizeStyle; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("j3cSI")).toDisplayString; });
$parcel$export(module.exports, "toHandlerKey", function () { return (parcelRequire("j3cSI")).toHandlerKey; });
/**
* @vue/runtime-core v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $Dz4HH = parcelRequire("Dz4HH");

var $j3cSI = parcelRequire("j3cSI");
const $6d932106fee366bf$var$stack = [];
function $6d932106fee366bf$var$pushWarningContext(vnode) {
    $6d932106fee366bf$var$stack.push(vnode);
}
function $6d932106fee366bf$var$popWarningContext() {
    $6d932106fee366bf$var$stack.pop();
}
function $6d932106fee366bf$var$warn$1(msg, ...args) {
    (0, $Dz4HH.pauseTracking)();
    const instance = $6d932106fee366bf$var$stack.length ? $6d932106fee366bf$var$stack[$6d932106fee366bf$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $6d932106fee366bf$var$getComponentTrace();
    if (appWarnHandler) $6d932106fee366bf$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$6d932106fee366bf$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$6d932106fee366bf$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $Dz4HH.resetTracking)();
}
function $6d932106fee366bf$var$getComponentTrace() {
    let currentVNode = $6d932106fee366bf$var$stack[$6d932106fee366bf$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $6d932106fee366bf$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$6d932106fee366bf$var$formatTraceEntry(entry));
    });
    return logs;
}
function $6d932106fee366bf$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$6d932106fee366bf$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$6d932106fee366bf$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $6d932106fee366bf$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$6d932106fee366bf$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $6d932106fee366bf$var$formatProp(key, value, raw) {
    if ((0, $j3cSI.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $Dz4HH.isRef)(value)) {
        value = $6d932106fee366bf$var$formatProp(key, (0, $Dz4HH.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $j3cSI.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $Dz4HH.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $6d932106fee366bf$export$dfbcecb440255e4a(val, type) {
    return;
}
const $6d932106fee366bf$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER"
};
const $6d932106fee366bf$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://github.com/vuejs/core ."
};
function $6d932106fee366bf$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $6d932106fee366bf$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $j3cSI.isFunction)(fn)) {
        const res = $6d932106fee366bf$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $j3cSI.isPromise)(res)) res.catch((err)=>{
            $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($6d932106fee366bf$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $6d932106fee366bf$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $6d932106fee366bf$var$logError(err, type, contextVNode, throwInDev);
}
function $6d932106fee366bf$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $6d932106fee366bf$var$isFlushing = false;
let $6d932106fee366bf$var$isFlushPending = false;
const $6d932106fee366bf$var$queue = [];
let $6d932106fee366bf$var$flushIndex = 0;
const $6d932106fee366bf$var$pendingPostFlushCbs = [];
let $6d932106fee366bf$var$activePostFlushCbs = null;
let $6d932106fee366bf$var$postFlushIndex = 0;
const $6d932106fee366bf$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $6d932106fee366bf$var$currentFlushPromise = null;
const $6d932106fee366bf$var$RECURSION_LIMIT = 100;
function $6d932106fee366bf$export$bdd553fddd433dcb(fn) {
    const p = $6d932106fee366bf$var$currentFlushPromise || $6d932106fee366bf$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $6d932106fee366bf$var$findInsertionIndex(id) {
    let start = $6d932106fee366bf$var$flushIndex + 1;
    let end = $6d932106fee366bf$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $6d932106fee366bf$var$queue[middle];
        const middleJobId = $6d932106fee366bf$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $6d932106fee366bf$var$queueJob(job) {
    if (!$6d932106fee366bf$var$queue.length || !$6d932106fee366bf$var$queue.includes(job, $6d932106fee366bf$var$isFlushing && job.allowRecurse ? $6d932106fee366bf$var$flushIndex + 1 : $6d932106fee366bf$var$flushIndex)) {
        if (job.id == null) $6d932106fee366bf$var$queue.push(job);
        else $6d932106fee366bf$var$queue.splice($6d932106fee366bf$var$findInsertionIndex(job.id), 0, job);
        $6d932106fee366bf$var$queueFlush();
    }
}
function $6d932106fee366bf$var$queueFlush() {
    if (!$6d932106fee366bf$var$isFlushing && !$6d932106fee366bf$var$isFlushPending) {
        $6d932106fee366bf$var$isFlushPending = true;
        $6d932106fee366bf$var$currentFlushPromise = $6d932106fee366bf$var$resolvedPromise.then($6d932106fee366bf$var$flushJobs);
    }
}
function $6d932106fee366bf$var$invalidateJob(job) {
    const i = $6d932106fee366bf$var$queue.indexOf(job);
    if (i > $6d932106fee366bf$var$flushIndex) $6d932106fee366bf$var$queue.splice(i, 1);
}
function $6d932106fee366bf$export$59536a0199721cab(cb) {
    if (!(0, $j3cSI.isArray)(cb)) {
        if (!$6d932106fee366bf$var$activePostFlushCbs || !$6d932106fee366bf$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $6d932106fee366bf$var$postFlushIndex + 1 : $6d932106fee366bf$var$postFlushIndex)) $6d932106fee366bf$var$pendingPostFlushCbs.push(cb);
    } else $6d932106fee366bf$var$pendingPostFlushCbs.push(...cb);
    $6d932106fee366bf$var$queueFlush();
}
function $6d932106fee366bf$var$flushPreFlushCbs(instance, seen, i = $6d932106fee366bf$var$isFlushing ? $6d932106fee366bf$var$flushIndex + 1 : 0) {
    for(; i < $6d932106fee366bf$var$queue.length; i++){
        const cb = $6d932106fee366bf$var$queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            $6d932106fee366bf$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $6d932106fee366bf$var$flushPostFlushCbs(seen) {
    if ($6d932106fee366bf$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($6d932106fee366bf$var$pendingPostFlushCbs)
        ].sort((a, b)=>$6d932106fee366bf$var$getId(a) - $6d932106fee366bf$var$getId(b));
        $6d932106fee366bf$var$pendingPostFlushCbs.length = 0;
        if ($6d932106fee366bf$var$activePostFlushCbs) {
            $6d932106fee366bf$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $6d932106fee366bf$var$activePostFlushCbs = deduped;
        for($6d932106fee366bf$var$postFlushIndex = 0; $6d932106fee366bf$var$postFlushIndex < $6d932106fee366bf$var$activePostFlushCbs.length; $6d932106fee366bf$var$postFlushIndex++)$6d932106fee366bf$var$activePostFlushCbs[$6d932106fee366bf$var$postFlushIndex]();
        $6d932106fee366bf$var$activePostFlushCbs = null;
        $6d932106fee366bf$var$postFlushIndex = 0;
    }
}
const $6d932106fee366bf$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $6d932106fee366bf$var$comparator = (a, b)=>{
    const diff = $6d932106fee366bf$var$getId(a) - $6d932106fee366bf$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $6d932106fee366bf$var$flushJobs(seen) {
    $6d932106fee366bf$var$isFlushPending = false;
    $6d932106fee366bf$var$isFlushing = true;
    $6d932106fee366bf$var$queue.sort($6d932106fee366bf$var$comparator);
    const check = (0, $j3cSI.NOOP);
    try {
        for($6d932106fee366bf$var$flushIndex = 0; $6d932106fee366bf$var$flushIndex < $6d932106fee366bf$var$queue.length; $6d932106fee366bf$var$flushIndex++){
            const job = $6d932106fee366bf$var$queue[$6d932106fee366bf$var$flushIndex];
            if (job && job.active !== false) $6d932106fee366bf$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $6d932106fee366bf$var$flushIndex = 0;
        $6d932106fee366bf$var$queue.length = 0;
        $6d932106fee366bf$var$flushPostFlushCbs(seen);
        $6d932106fee366bf$var$isFlushing = false;
        $6d932106fee366bf$var$currentFlushPromise = null;
        if ($6d932106fee366bf$var$queue.length || $6d932106fee366bf$var$pendingPostFlushCbs.length) $6d932106fee366bf$var$flushJobs(seen);
    }
}
function $6d932106fee366bf$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $6d932106fee366bf$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $6d932106fee366bf$var$getComponentName(instance.type);
            $6d932106fee366bf$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $6d932106fee366bf$var$isHmrUpdating = false;
const $6d932106fee366bf$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $6d932106fee366bf$var$map = /* @__PURE__ */ new Map();
function $6d932106fee366bf$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $6d932106fee366bf$var$map.get(id);
    if (!record) {
        $6d932106fee366bf$var$createRecord(id, instance.type);
        record = $6d932106fee366bf$var$map.get(id);
    }
    record.instances.add(instance);
}
function $6d932106fee366bf$var$unregisterHMR(instance) {
    $6d932106fee366bf$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $6d932106fee366bf$var$createRecord(id, initialDef) {
    if ($6d932106fee366bf$var$map.has(id)) return false;
    $6d932106fee366bf$var$map.set(id, {
        initialDef: $6d932106fee366bf$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $6d932106fee366bf$var$normalizeClassComponent(component) {
    return $6d932106fee366bf$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $6d932106fee366bf$var$rerender(id, newRender) {
    const record = $6d932106fee366bf$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $6d932106fee366bf$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $6d932106fee366bf$var$isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        $6d932106fee366bf$var$isHmrUpdating = false;
    });
}
function $6d932106fee366bf$var$reload(id, newComp) {
    const record = $6d932106fee366bf$var$map.get(id);
    if (!record) return;
    newComp = $6d932106fee366bf$var$normalizeClassComponent(newComp);
    $6d932106fee366bf$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $6d932106fee366bf$var$normalizeClassComponent(instance.type);
        if (!$6d932106fee366bf$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $6d932106fee366bf$var$updateComponentDef(oldComp, newComp);
            $6d932106fee366bf$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $6d932106fee366bf$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $6d932106fee366bf$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            $6d932106fee366bf$var$queueJob(instance.parent.update);
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $6d932106fee366bf$export$59536a0199721cab(()=>{
        for (const instance of instances)$6d932106fee366bf$var$hmrDirtyComponents.delete($6d932106fee366bf$var$normalizeClassComponent(instance.type));
    });
}
function $6d932106fee366bf$var$updateComponentDef(oldComp, newComp) {
    (0, $j3cSI.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $6d932106fee366bf$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $6d932106fee366bf$var$devtools$1;
let $6d932106fee366bf$var$buffer = [];
let $6d932106fee366bf$var$devtoolsNotInstalled = false;
function $6d932106fee366bf$var$emit$1(event, ...args) {
    if ($6d932106fee366bf$var$devtools$1) $6d932106fee366bf$var$devtools$1.emit(event, ...args);
    else if (!$6d932106fee366bf$var$devtoolsNotInstalled) $6d932106fee366bf$var$buffer.push({
        event: event,
        args: args
    });
}
function $6d932106fee366bf$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $6d932106fee366bf$var$devtools$1 = hook;
    if ($6d932106fee366bf$var$devtools$1) {
        $6d932106fee366bf$var$devtools$1.enabled = true;
        $6d932106fee366bf$var$buffer.forEach(({ event: event, args: args })=>$6d932106fee366bf$var$devtools$1.emit(event, ...args));
        $6d932106fee366bf$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $6d932106fee366bf$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$6d932106fee366bf$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $6d932106fee366bf$var$devtoolsNotInstalled = true;
                $6d932106fee366bf$var$buffer = [];
            }
        }, 3e3);
    } else {
        $6d932106fee366bf$var$devtoolsNotInstalled = true;
        $6d932106fee366bf$var$buffer = [];
    }
}
function $6d932106fee366bf$var$devtoolsInitApp(app, version) {
    $6d932106fee366bf$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $6d932106fee366bf$export$ffb0004e005737fa,
        Text: $6d932106fee366bf$export$5f1af8db9871e1d6,
        Comment: $6d932106fee366bf$export$4d299b491347818a,
        Static: $6d932106fee366bf$export$c1b9a1d3af45b7b6
    });
}
function $6d932106fee366bf$var$devtoolsUnmountApp(app) {
    $6d932106fee366bf$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $6d932106fee366bf$var$devtoolsComponentAdded = /* @__PURE__ */ $6d932106fee366bf$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $6d932106fee366bf$var$devtoolsComponentUpdated = /* @__PURE__ */ $6d932106fee366bf$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $6d932106fee366bf$var$_devtoolsComponentRemoved = /* @__PURE__ */ $6d932106fee366bf$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $6d932106fee366bf$var$devtoolsComponentRemoved = (component)=>{
    if ($6d932106fee366bf$var$devtools$1 && typeof $6d932106fee366bf$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$6d932106fee366bf$var$devtools$1.cleanupBuffer(component)) $6d932106fee366bf$var$_devtoolsComponentRemoved(component);
};
function $6d932106fee366bf$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $6d932106fee366bf$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $6d932106fee366bf$var$devtoolsPerfStart = /* @__PURE__ */ $6d932106fee366bf$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $6d932106fee366bf$var$devtoolsPerfEnd = /* @__PURE__ */ $6d932106fee366bf$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $6d932106fee366bf$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $6d932106fee366bf$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $6d932106fee366bf$var$devtoolsComponentEmit(component, event, params) {
    $6d932106fee366bf$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $6d932106fee366bf$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $j3cSI.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $j3cSI.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $j3cSI.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $j3cSI.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $j3cSI.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $j3cSI.toHandlerKey)((0, $j3cSI.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $j3cSI.toHandlerKey)((0, $j3cSI.hyphenate)(event))];
    if (handler) $6d932106fee366bf$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $6d932106fee366bf$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $6d932106fee366bf$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $j3cSI.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $6d932106fee366bf$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $j3cSI.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $j3cSI.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $j3cSI.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $j3cSI.extend)(normalized, raw);
    if ((0, $j3cSI.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $6d932106fee366bf$var$isEmitListener(options, key) {
    if (!options || !(0, $j3cSI.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $j3cSI.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $j3cSI.hasOwn)(options, (0, $j3cSI.hyphenate)(key)) || (0, $j3cSI.hasOwn)(options, key);
}
let $6d932106fee366bf$var$currentRenderingInstance = null;
let $6d932106fee366bf$var$currentScopeId = null;
function $6d932106fee366bf$var$setCurrentRenderingInstance(instance) {
    const prev = $6d932106fee366bf$var$currentRenderingInstance;
    $6d932106fee366bf$var$currentRenderingInstance = instance;
    $6d932106fee366bf$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $6d932106fee366bf$export$ac020265ca2cc4cd(id) {
    $6d932106fee366bf$var$currentScopeId = id;
}
function $6d932106fee366bf$export$f2dc6805dc11834e() {
    $6d932106fee366bf$var$currentScopeId = null;
}
const $6d932106fee366bf$export$15ba313e13f3dd04 = (_id)=>$6d932106fee366bf$export$694b237e827a3d23;
function $6d932106fee366bf$export$694b237e827a3d23(fn, ctx = $6d932106fee366bf$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $6d932106fee366bf$export$c20bee82f26f1e27(-1);
        const prevInstance = $6d932106fee366bf$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $6d932106fee366bf$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $6d932106fee366bf$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $6d932106fee366bf$var$accessedAttrs = false;
function $6d932106fee366bf$var$markAttrsAccessed() {
    $6d932106fee366bf$var$accessedAttrs = true;
}
function $6d932106fee366bf$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $6d932106fee366bf$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $6d932106fee366bf$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $6d932106fee366bf$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $6d932106fee366bf$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $6d932106fee366bf$var$blockStack.length = 0;
        $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, 1);
        result = $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $j3cSI.isModelListener))) fallthroughAttrs = $6d932106fee366bf$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $6d932106fee366bf$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $6d932106fee366bf$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $6d932106fee366bf$var$setCurrentRenderingInstance(prev);
    return result;
}
const $6d932106fee366bf$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $6d932106fee366bf$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $6d932106fee366bf$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $6d932106fee366bf$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($6d932106fee366bf$export$3868d13f8734ae81(child)) {
            if (child.type !== $6d932106fee366bf$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $6d932106fee366bf$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $j3cSI.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $6d932106fee366bf$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $j3cSI.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $6d932106fee366bf$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $6d932106fee366bf$export$4d299b491347818a;
};
function $6d932106fee366bf$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $6d932106fee366bf$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$6d932106fee366bf$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $6d932106fee366bf$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $6d932106fee366bf$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$6d932106fee366bf$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $6d932106fee366bf$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $6d932106fee366bf$var$COMPONENTS = "components";
const $6d932106fee366bf$var$DIRECTIVES = "directives";
function $6d932106fee366bf$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $6d932106fee366bf$var$resolveAsset($6d932106fee366bf$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $6d932106fee366bf$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $6d932106fee366bf$export$b44c564a05ca975(component) {
    if ((0, $j3cSI.isString)(component)) return $6d932106fee366bf$var$resolveAsset($6d932106fee366bf$var$COMPONENTS, component, false) || component;
    else return component || $6d932106fee366bf$var$NULL_DYNAMIC_COMPONENT;
}
function $6d932106fee366bf$export$a1989e995cd481be(name) {
    return $6d932106fee366bf$var$resolveAsset($6d932106fee366bf$var$DIRECTIVES, name);
}
function $6d932106fee366bf$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $6d932106fee366bf$var$currentRenderingInstance || $6d932106fee366bf$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $6d932106fee366bf$var$COMPONENTS) {
            const selfName = $6d932106fee366bf$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $j3cSI.camelize)(name) || selfName === (0, $j3cSI.capitalize)((0, $j3cSI.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $6d932106fee366bf$var$resolve(instance[type] || Component[type], name) || // global registration
        $6d932106fee366bf$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $6d932106fee366bf$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $j3cSI.camelize)(name)] || registry[(0, $j3cSI.capitalize)((0, $j3cSI.camelize)(name))]);
}
const $6d932106fee366bf$var$isSuspense = (type)=>type.__isSuspense;
let $6d932106fee366bf$var$suspenseId = 0;
const $6d932106fee366bf$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $6d932106fee366bf$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $6d932106fee366bf$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $6d932106fee366bf$var$hydrateSuspense,
    create: $6d932106fee366bf$var$createSuspenseBoundary,
    normalize: $6d932106fee366bf$var$normalizeSuspenseChildren
};
const $6d932106fee366bf$export$74bf444e3cd11ea5 = $6d932106fee366bf$var$SuspenseImpl;
function $6d932106fee366bf$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $j3cSI.isFunction)(eventListener)) eventListener();
}
function $6d932106fee366bf$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $6d932106fee366bf$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $6d932106fee366bf$var$triggerEvent(vnode, "onPending");
        $6d932106fee366bf$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $6d932106fee366bf$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $6d932106fee366bf$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($6d932106fee366bf$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $6d932106fee366bf$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $6d932106fee366bf$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $6d932106fee366bf$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $6d932106fee366bf$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $6d932106fee366bf$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $6d932106fee366bf$var$setActiveBranch(suspense, newBranch);
    } else {
        $6d932106fee366bf$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $6d932106fee366bf$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $6d932106fee366bf$var$hasWarned = false;
function $6d932106fee366bf$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $6d932106fee366bf$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $j3cSI.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $6d932106fee366bf$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $6d932106fee366bf$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $6d932106fee366bf$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $6d932106fee366bf$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $6d932106fee366bf$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $6d932106fee366bf$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $6d932106fee366bf$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $6d932106fee366bf$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized);
                if (placeholder) remove(placeholder);
                $6d932106fee366bf$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $6d932106fee366bf$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $6d932106fee366bf$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $6d932106fee366bf$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $6d932106fee366bf$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $6d932106fee366bf$var$normalizeSuspenseSlot(children.fallback) : $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a);
}
function $6d932106fee366bf$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $j3cSI.isFunction)(s)) {
        const trackBlock = $6d932106fee366bf$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $6d932106fee366bf$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $6d932106fee366bf$var$currentBlock;
            $6d932106fee366bf$var$closeBlock();
        }
    }
    if ((0, $j3cSI.isArray)(s)) {
        const singleChild = $6d932106fee366bf$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $6d932106fee366bf$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $6d932106fee366bf$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $j3cSI.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $6d932106fee366bf$export$59536a0199721cab(fn);
}
function $6d932106fee366bf$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $6d932106fee366bf$var$updateHOCHostEl(parentComponent, el);
    }
}
function $6d932106fee366bf$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
const $6d932106fee366bf$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $6d932106fee366bf$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $6d932106fee366bf$export$a976684a0efeb93f($6d932106fee366bf$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $6d932106fee366bf$export$ede35fc0e5500309(effect, options) {
    return $6d932106fee366bf$var$doWatch(effect, null, options);
}
function $6d932106fee366bf$export$b7f27ea67102d543(effect, options) {
    return $6d932106fee366bf$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $6d932106fee366bf$export$2035654f31b0e555(effect, options) {
    return $6d932106fee366bf$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $6d932106fee366bf$var$INITIAL_WATCHER_VALUE = {};
function $6d932106fee366bf$export$3db5d71bdb2d5499(source, cb, options) {
    return $6d932106fee366bf$var$doWatch(source, cb, options);
}
function $6d932106fee366bf$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, once: once, onTrack: onTrack, onTrigger: onTrigger } = (0, $j3cSI.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        $6d932106fee366bf$var$warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = $6d932106fee366bf$var$currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        $6d932106fee366bf$var$traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $Dz4HH.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $Dz4HH.isShallow)(source);
    } else if ((0, $Dz4HH.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $j3cSI.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $Dz4HH.isReactive)(s) || (0, $Dz4HH.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $Dz4HH.isRef)(s)) return s.value;
                else if ((0, $Dz4HH.isReactive)(s)) return reactiveGetter(s);
                else if ((0, $j3cSI.isFunction)(s)) return $6d932106fee366bf$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $j3cSI.isFunction)(source)) {
        if (cb) getter = ()=>$6d932106fee366bf$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return $6d932106fee366bf$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $j3cSI.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$6d932106fee366bf$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $6d932106fee366bf$export$b22fcaf88446e9bf(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if ($6d932106fee366bf$var$isInSSRComponentSetup) {
        onCleanup = (0, $j3cSI.NOOP);
        if (!cb) getter();
        else if (immediate) $6d932106fee366bf$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $6d932106fee366bf$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $j3cSI.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($6d932106fee366bf$var$INITIAL_WATCHER_VALUE) : $6d932106fee366bf$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $j3cSI.hasChanged)(v1, oldValue[i])) : (0, $j3cSI.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $6d932106fee366bf$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $6d932106fee366bf$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $6d932106fee366bf$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$6d932106fee366bf$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$6d932106fee366bf$var$queueJob(job);
    }
    const effect = new (0, $Dz4HH.ReactiveEffect)(getter, (0, $j3cSI.NOOP), scheduler);
    const scope = (0, $Dz4HH.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, $j3cSI.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $6d932106fee366bf$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $6d932106fee366bf$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $j3cSI.isString)(source) ? source.includes(".") ? $6d932106fee366bf$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $j3cSI.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $6d932106fee366bf$var$setCurrentInstance(this);
    const res = $6d932106fee366bf$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $6d932106fee366bf$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $6d932106fee366bf$var$traverse(value, depth, currentDepth = 0, seen) {
    if (!(0, $j3cSI.isObject)(value) || value["__v_skip"]) return value;
    if (depth && depth > 0) {
        if (currentDepth >= depth) return value;
        currentDepth++;
    }
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $Dz4HH.isRef)(value)) $6d932106fee366bf$var$traverse(value.value, depth, currentDepth, seen);
    else if ((0, $j3cSI.isArray)(value)) for(let i = 0; i < value.length; i++)$6d932106fee366bf$var$traverse(value[i], depth, currentDepth, seen);
    else if ((0, $j3cSI.isSet)(value) || (0, $j3cSI.isMap)(value)) value.forEach((v1)=>{
        $6d932106fee366bf$var$traverse(v1, depth, currentDepth, seen);
    });
    else if ((0, $j3cSI.isPlainObject)(value)) for(const key in value)$6d932106fee366bf$var$traverse(value[key], depth, currentDepth, seen);
    return value;
}
function $6d932106fee366bf$var$validateDirectiveName(name) {
    if ((0, $j3cSI.isBuiltInDirective)(name)) $6d932106fee366bf$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $6d932106fee366bf$export$49729353e7c1e6c5(vnode, directives) {
    if ($6d932106fee366bf$var$currentRenderingInstance === null) return vnode;
    const instance = $6d932106fee366bf$var$getExposeProxy($6d932106fee366bf$var$currentRenderingInstance) || $6d932106fee366bf$var$currentRenderingInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $j3cSI.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $j3cSI.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $6d932106fee366bf$var$traverse(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $6d932106fee366bf$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $Dz4HH.pauseTracking)();
            $6d932106fee366bf$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $Dz4HH.resetTracking)();
        }
    }
}
const $6d932106fee366bf$var$leaveCbKey = Symbol("_leaveCb");
const $6d932106fee366bf$var$enterCbKey = Symbol("_enterCb");
function $6d932106fee366bf$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $6d932106fee366bf$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $6d932106fee366bf$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $6d932106fee366bf$var$TransitionHookValidator = [
    Function,
    Array
];
const $6d932106fee366bf$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $6d932106fee366bf$var$TransitionHookValidator,
    onEnter: $6d932106fee366bf$var$TransitionHookValidator,
    onAfterEnter: $6d932106fee366bf$var$TransitionHookValidator,
    onEnterCancelled: $6d932106fee366bf$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $6d932106fee366bf$var$TransitionHookValidator,
    onLeave: $6d932106fee366bf$var$TransitionHookValidator,
    onAfterLeave: $6d932106fee366bf$var$TransitionHookValidator,
    onLeaveCancelled: $6d932106fee366bf$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $6d932106fee366bf$var$TransitionHookValidator,
    onAppear: $6d932106fee366bf$var$TransitionHookValidator,
    onAfterAppear: $6d932106fee366bf$var$TransitionHookValidator,
    onAppearCancelled: $6d932106fee366bf$var$TransitionHookValidator
};
const $6d932106fee366bf$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $6d932106fee366bf$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $6d932106fee366bf$export$f13e630aa3915748();
        const state = $6d932106fee366bf$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $6d932106fee366bf$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $6d932106fee366bf$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $Dz4HH.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $6d932106fee366bf$var$emptyPlaceholder(child);
            const innerChild = $6d932106fee366bf$var$getKeepAliveChild(child);
            if (!innerChild) return $6d932106fee366bf$var$emptyPlaceholder(child);
            const enterHooks = $6d932106fee366bf$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $6d932106fee366bf$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $6d932106fee366bf$var$getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== $6d932106fee366bf$export$4d299b491347818a && !$6d932106fee366bf$var$isSameVNodeType(innerChild, oldInnerChild)) {
                const leavingHooks = $6d932106fee366bf$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $6d932106fee366bf$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return $6d932106fee366bf$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $6d932106fee366bf$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $6d932106fee366bf$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$6d932106fee366bf$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$6d932106fee366bf$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $6d932106fee366bf$export$abd95b5f5e8a8837 = $6d932106fee366bf$var$BaseTransitionImpl;
function $6d932106fee366bf$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $6d932106fee366bf$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $6d932106fee366bf$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $6d932106fee366bf$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $j3cSI.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$6d932106fee366bf$var$leaveCbKey]) el[$6d932106fee366bf$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $6d932106fee366bf$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$6d932106fee366bf$var$leaveCbKey]) leavingVNode.el[$6d932106fee366bf$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$6d932106fee366bf$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$6d932106fee366bf$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$6d932106fee366bf$var$enterCbKey]) el[$6d932106fee366bf$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$6d932106fee366bf$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$6d932106fee366bf$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $6d932106fee366bf$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $6d932106fee366bf$var$emptyPlaceholder(vnode) {
    if ($6d932106fee366bf$var$isKeepAlive(vnode)) {
        vnode = $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $6d932106fee366bf$var$getKeepAliveChild(vnode) {
    return $6d932106fee366bf$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $6d932106fee366bf$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $6d932106fee366bf$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $6d932106fee366bf$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $6d932106fee366bf$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($6d932106fee366bf$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $6d932106fee366bf$export$4d299b491347818a) ret.push(key != null ? $6d932106fee366bf$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $6d932106fee366bf$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $j3cSI.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $j3cSI.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $6d932106fee366bf$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $6d932106fee366bf$export$d75d499b4c16cf21(source) {
    if ((0, $j3cSI.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $6d932106fee366bf$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $6d932106fee366bf$var$currentInstance;
            if (resolvedComp) return ()=>$6d932106fee366bf$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $6d932106fee366bf$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $6d932106fee366bf$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$6d932106fee366bf$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $6d932106fee366bf$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $Dz4HH.ref)(false);
            const error = (0, $Dz4HH.ref)();
            const delayed = (0, $Dz4HH.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $6d932106fee366bf$var$isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    $6d932106fee366bf$var$queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $6d932106fee366bf$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $6d932106fee366bf$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $6d932106fee366bf$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $6d932106fee366bf$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $6d932106fee366bf$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $6d932106fee366bf$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $6d932106fee366bf$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $6d932106fee366bf$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $6d932106fee366bf$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $j3cSI.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $6d932106fee366bf$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $j3cSI.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $6d932106fee366bf$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $6d932106fee366bf$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$6d932106fee366bf$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $6d932106fee366bf$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $6d932106fee366bf$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$6d932106fee366bf$var$matches(include, name));
            exclude && pruneCache((name)=>!$6d932106fee366bf$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $6d932106fee366bf$var$getInnerChild(instance.subTree));
        };
        $6d932106fee366bf$export$6d1641039221b5cb(cacheSubtree);
        $6d932106fee366bf$export$5876c47052fb88b1(cacheSubtree);
        $6d932106fee366bf$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $6d932106fee366bf$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $6d932106fee366bf$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $6d932106fee366bf$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$6d932106fee366bf$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $6d932106fee366bf$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $6d932106fee366bf$var$getComponentName($6d932106fee366bf$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$6d932106fee366bf$var$matches(include, name)) || exclude && name && $6d932106fee366bf$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $6d932106fee366bf$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $6d932106fee366bf$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $6d932106fee366bf$export$70eb8a58709972df = $6d932106fee366bf$var$KeepAliveImpl;
function $6d932106fee366bf$var$matches(pattern, name) {
    if ((0, $j3cSI.isArray)(pattern)) return pattern.some((p)=>$6d932106fee366bf$var$matches(p, name));
    else if ((0, $j3cSI.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $j3cSI.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $6d932106fee366bf$export$ba52d824b95a2154(hook, target) {
    $6d932106fee366bf$var$registerKeepAliveHook(hook, "a", target);
}
function $6d932106fee366bf$export$bf1440eeaf5fa709(hook, target) {
    $6d932106fee366bf$var$registerKeepAliveHook(hook, "da", target);
}
function $6d932106fee366bf$var$registerKeepAliveHook(hook, type, target = $6d932106fee366bf$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $6d932106fee366bf$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($6d932106fee366bf$var$isKeepAlive(current.parent.vnode)) $6d932106fee366bf$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $6d932106fee366bf$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $6d932106fee366bf$var$injectHook(type, hook, keepAliveRoot, true);
    $6d932106fee366bf$export$13348a43ccacfe58(()=>{
        (0, $j3cSI.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $6d932106fee366bf$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $6d932106fee366bf$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $6d932106fee366bf$var$injectHook(type, hook, target = $6d932106fee366bf$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $Dz4HH.pauseTracking)();
            const reset = $6d932106fee366bf$var$setCurrentInstance(target);
            const res = $6d932106fee366bf$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $Dz4HH.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $6d932106fee366bf$var$createHook = (lifecycle)=>(hook, target = $6d932106fee366bf$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$6d932106fee366bf$var$isInSSRComponentSetup || lifecycle === "sp") && $6d932106fee366bf$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $6d932106fee366bf$export$23b7aeb0d671f804 = $6d932106fee366bf$var$createHook("bm");
const $6d932106fee366bf$export$6d1641039221b5cb = $6d932106fee366bf$var$createHook("m");
const $6d932106fee366bf$export$ab91988a13872e4c = $6d932106fee366bf$var$createHook("bu");
const $6d932106fee366bf$export$5876c47052fb88b1 = $6d932106fee366bf$var$createHook("u");
const $6d932106fee366bf$export$40c420df62d2614 = $6d932106fee366bf$var$createHook("bum");
const $6d932106fee366bf$export$13348a43ccacfe58 = $6d932106fee366bf$var$createHook("um");
const $6d932106fee366bf$export$ebf0c601f267bceb = $6d932106fee366bf$var$createHook("sp");
const $6d932106fee366bf$export$898295a813d662eb = $6d932106fee366bf$var$createHook("rtg");
const $6d932106fee366bf$export$2b41f4235363e921 = $6d932106fee366bf$var$createHook("rtc");
function $6d932106fee366bf$export$6a3a15856e50ad19(hook, target = $6d932106fee366bf$var$currentInstance) {
    $6d932106fee366bf$var$injectHook("ec", hook, target);
}
function $6d932106fee366bf$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $j3cSI.isArray)(source) || (0, $j3cSI.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $j3cSI.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $6d932106fee366bf$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $j3cSI.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $6d932106fee366bf$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($6d932106fee366bf$var$currentRenderingInstance.isCE || $6d932106fee366bf$var$currentRenderingInstance.parent && $6d932106fee366bf$var$isAsyncWrapper($6d932106fee366bf$var$currentRenderingInstance.parent) && $6d932106fee366bf$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $6d932106fee366bf$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $6d932106fee366bf$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $6d932106fee366bf$var$ensureValidVNode(slot(props));
    const rendered = $6d932106fee366bf$export$9f2dfe8048dfb22b($6d932106fee366bf$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $6d932106fee366bf$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$6d932106fee366bf$export$3868d13f8734ae81(child)) return true;
        if (child.type === $6d932106fee366bf$export$4d299b491347818a) return false;
        if (child.type === $6d932106fee366bf$export$ffb0004e005737fa && !$6d932106fee366bf$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $6d932106fee366bf$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $j3cSI.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $6d932106fee366bf$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($6d932106fee366bf$var$isStatefulComponent(i)) return $6d932106fee366bf$var$getExposeProxy(i) || i.proxy;
    return $6d932106fee366bf$var$getPublicInstance(i.parent);
};
const $6d932106fee366bf$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $j3cSI.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$6d932106fee366bf$var$getPublicInstance(i.parent),
    $root: (i)=>$6d932106fee366bf$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $6d932106fee366bf$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            $6d932106fee366bf$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $6d932106fee366bf$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $6d932106fee366bf$var$instanceWatch.bind(i) : (0, $j3cSI.NOOP)
});
const $6d932106fee366bf$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $6d932106fee366bf$var$hasSetupBinding = (state, key)=>state !== (0, $j3cSI.EMPTY_OBJ) && !state.__isScriptSetup && (0, $j3cSI.hasOwn)(state, key);
const $6d932106fee366bf$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($6d932106fee366bf$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $j3cSI.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $6d932106fee366bf$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $6d932106fee366bf$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $Dz4HH.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $j3cSI.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($6d932106fee366bf$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $j3cSI.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $j3cSI.EMPTY_OBJ) && (0, $j3cSI.hasOwn)(data, key) || $6d932106fee366bf$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $j3cSI.hasOwn)(normalizedProps, key) || (0, $j3cSI.hasOwn)(ctx, key) || (0, $j3cSI.hasOwn)($6d932106fee366bf$var$publicPropertiesMap, key) || (0, $j3cSI.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $j3cSI.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $6d932106fee366bf$var$target;
const $6d932106fee366bf$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $j3cSI.extend)({}, $6d932106fee366bf$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $6d932106fee366bf$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $j3cSI.isGloballyAllowed)(key);
        return has;
    }
});
function $6d932106fee366bf$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($6d932106fee366bf$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$6d932106fee366bf$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $j3cSI.NOOP)
        });
    });
    return target;
}
function $6d932106fee366bf$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $j3cSI.NOOP)
        });
    });
}
function $6d932106fee366bf$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $Dz4HH.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($6d932106fee366bf$var$isReservedPrefix(key[0])) {
                $6d932106fee366bf$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $j3cSI.NOOP)
            });
        }
    });
}
const $6d932106fee366bf$var$warnRuntimeUsage = (method)=>$6d932106fee366bf$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $6d932106fee366bf$export$80b33eababae110e() {
    return null;
}
function $6d932106fee366bf$export$51ecece22fc17ddc() {
    return null;
}
function $6d932106fee366bf$export$da25b65ca24b518a(exposed) {}
function $6d932106fee366bf$export$77e79129327f3d0d(options) {}
function $6d932106fee366bf$export$1b3acd4bb805b712() {
    return null;
}
function $6d932106fee366bf$export$acd55aa037e791bb() {}
function $6d932106fee366bf$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $6d932106fee366bf$export$9203a8e84125433c() {
    return $6d932106fee366bf$var$getContext().slots;
}
function $6d932106fee366bf$export$75e29435042cd2ea() {
    return $6d932106fee366bf$var$getContext().attrs;
}
function $6d932106fee366bf$var$getContext() {
    const i = $6d932106fee366bf$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $6d932106fee366bf$var$createSetupContext(i));
}
function $6d932106fee366bf$var$normalizePropsOrEmits(props) {
    return (0, $j3cSI.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $6d932106fee366bf$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $6d932106fee366bf$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $j3cSI.isArray)(opt) || (0, $j3cSI.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $6d932106fee366bf$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $j3cSI.isArray)(a) && (0, $j3cSI.isArray)(b)) return a.concat(b);
    return (0, $j3cSI.extend)({}, $6d932106fee366bf$var$normalizePropsOrEmits(a), $6d932106fee366bf$var$normalizePropsOrEmits(b));
}
function $6d932106fee366bf$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $6d932106fee366bf$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $6d932106fee366bf$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $6d932106fee366bf$var$unsetCurrentInstance();
    if ((0, $j3cSI.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $6d932106fee366bf$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$6d932106fee366bf$var$setCurrentInstance(ctx)
    ];
}
function $6d932106fee366bf$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $6d932106fee366bf$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $6d932106fee366bf$var$shouldCacheAccess = true;
function $6d932106fee366bf$var$applyOptions(instance) {
    const options = $6d932106fee366bf$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $6d932106fee366bf$var$shouldCacheAccess = false;
    if (options.beforeCreate) $6d932106fee366bf$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $6d932106fee366bf$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $j3cSI.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $j3cSI.isObject)(data)) ;
        else instance.data = (0, $Dz4HH.reactive)(data);
    }
    $6d932106fee366bf$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $j3cSI.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $j3cSI.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $j3cSI.NOOP);
        const set = !(0, $j3cSI.isFunction)(opt) && (0, $j3cSI.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $j3cSI.NOOP);
        const c = $6d932106fee366bf$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$6d932106fee366bf$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $j3cSI.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $6d932106fee366bf$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $6d932106fee366bf$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $j3cSI.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($6d932106fee366bf$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($6d932106fee366bf$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($6d932106fee366bf$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($6d932106fee366bf$export$5876c47052fb88b1, updated);
    registerLifecycleHook($6d932106fee366bf$export$ba52d824b95a2154, activated);
    registerLifecycleHook($6d932106fee366bf$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($6d932106fee366bf$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($6d932106fee366bf$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($6d932106fee366bf$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($6d932106fee366bf$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($6d932106fee366bf$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($6d932106fee366bf$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $j3cSI.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $j3cSI.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $6d932106fee366bf$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $j3cSI.NOOP)) {
    if ((0, $j3cSI.isArray)(injectOptions)) injectOptions = $6d932106fee366bf$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $j3cSI.isObject)(opt)) {
            if ("default" in opt) injected = $6d932106fee366bf$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $6d932106fee366bf$export$a976684a0efeb93f(opt.from || key);
        } else injected = $6d932106fee366bf$export$a976684a0efeb93f(opt);
        if ((0, $Dz4HH.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $6d932106fee366bf$var$callHook(hook, instance, type) {
    $6d932106fee366bf$export$dae85862a8d94378((0, $j3cSI.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $6d932106fee366bf$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $6d932106fee366bf$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $j3cSI.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $j3cSI.isFunction)(handler)) $6d932106fee366bf$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $j3cSI.isFunction)(raw)) $6d932106fee366bf$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $j3cSI.isObject)(raw)) {
        if ((0, $j3cSI.isArray)(raw)) raw.forEach((r)=>$6d932106fee366bf$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $j3cSI.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $j3cSI.isFunction)(handler)) $6d932106fee366bf$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $6d932106fee366bf$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$6d932106fee366bf$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $6d932106fee366bf$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $j3cSI.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $6d932106fee366bf$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $6d932106fee366bf$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$6d932106fee366bf$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $6d932106fee366bf$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $6d932106fee366bf$var$internalOptionMergeStrats = {
    data: $6d932106fee366bf$var$mergeDataFn,
    props: $6d932106fee366bf$var$mergeEmitsOrPropsOptions,
    emits: $6d932106fee366bf$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $6d932106fee366bf$var$mergeObjectOptions,
    computed: $6d932106fee366bf$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $6d932106fee366bf$var$mergeAsArray,
    created: $6d932106fee366bf$var$mergeAsArray,
    beforeMount: $6d932106fee366bf$var$mergeAsArray,
    mounted: $6d932106fee366bf$var$mergeAsArray,
    beforeUpdate: $6d932106fee366bf$var$mergeAsArray,
    updated: $6d932106fee366bf$var$mergeAsArray,
    beforeDestroy: $6d932106fee366bf$var$mergeAsArray,
    beforeUnmount: $6d932106fee366bf$var$mergeAsArray,
    destroyed: $6d932106fee366bf$var$mergeAsArray,
    unmounted: $6d932106fee366bf$var$mergeAsArray,
    activated: $6d932106fee366bf$var$mergeAsArray,
    deactivated: $6d932106fee366bf$var$mergeAsArray,
    errorCaptured: $6d932106fee366bf$var$mergeAsArray,
    serverPrefetch: $6d932106fee366bf$var$mergeAsArray,
    // assets
    components: $6d932106fee366bf$var$mergeObjectOptions,
    directives: $6d932106fee366bf$var$mergeObjectOptions,
    // watch
    watch: $6d932106fee366bf$var$mergeWatchOptions,
    // provide / inject
    provide: $6d932106fee366bf$var$mergeDataFn,
    inject: $6d932106fee366bf$var$mergeInject
};
function $6d932106fee366bf$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $j3cSI.extend)((0, $j3cSI.isFunction)(to) ? to.call(this, this) : to, (0, $j3cSI.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $6d932106fee366bf$var$mergeInject(to, from) {
    return $6d932106fee366bf$var$mergeObjectOptions($6d932106fee366bf$var$normalizeInject(to), $6d932106fee366bf$var$normalizeInject(from));
}
function $6d932106fee366bf$var$normalizeInject(raw) {
    if ((0, $j3cSI.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $6d932106fee366bf$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $6d932106fee366bf$var$mergeObjectOptions(to, from) {
    return to ? (0, $j3cSI.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $6d932106fee366bf$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $j3cSI.isArray)(to) && (0, $j3cSI.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $j3cSI.extend)(/* @__PURE__ */ Object.create(null), $6d932106fee366bf$var$normalizePropsOrEmits(to), $6d932106fee366bf$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $6d932106fee366bf$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $j3cSI.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $6d932106fee366bf$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $6d932106fee366bf$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $j3cSI.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $6d932106fee366bf$var$uid$1 = 0;
function $6d932106fee366bf$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $j3cSI.isFunction)(rootComponent)) rootComponent = (0, $j3cSI.extend)({}, rootComponent);
        if (rootProps != null && !(0, $j3cSI.isObject)(rootProps)) rootProps = null;
        const context = $6d932106fee366bf$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: $6d932106fee366bf$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $6d932106fee366bf$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $j3cSI.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $j3cSI.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = $6d932106fee366bf$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $6d932106fee366bf$var$devtoolsInitApp(app, $6d932106fee366bf$export$83d89fbfd8236492);
                    }
                    return $6d932106fee366bf$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $6d932106fee366bf$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $6d932106fee366bf$var$currentApp;
                $6d932106fee366bf$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $6d932106fee366bf$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $6d932106fee366bf$var$currentApp = null;
function $6d932106fee366bf$export$abe1e183e22e10ad(key, value) {
    if (!$6d932106fee366bf$var$currentInstance) ;
    else {
        let provides = $6d932106fee366bf$var$currentInstance.provides;
        const parentProvides = $6d932106fee366bf$var$currentInstance.parent && $6d932106fee366bf$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $6d932106fee366bf$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $6d932106fee366bf$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $6d932106fee366bf$var$currentInstance || $6d932106fee366bf$var$currentRenderingInstance;
    if (instance || $6d932106fee366bf$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $6d932106fee366bf$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $j3cSI.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $6d932106fee366bf$export$caf6761f24fc571a() {
    return !!($6d932106fee366bf$var$currentInstance || $6d932106fee366bf$var$currentRenderingInstance || $6d932106fee366bf$var$currentApp);
}
function $6d932106fee366bf$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $j3cSI.def)(attrs, $6d932106fee366bf$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $6d932106fee366bf$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $Dz4HH.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $6d932106fee366bf$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $6d932106fee366bf$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $Dz4HH.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($6d932106fee366bf$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $j3cSI.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $j3cSI.camelize)(key);
                        props[camelizedKey] = $6d932106fee366bf$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($6d932106fee366bf$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $j3cSI.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $j3cSI.hyphenate)(key)) === key || !(0, $j3cSI.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $6d932106fee366bf$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $j3cSI.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $Dz4HH.trigger)(instance, "set", "$attrs");
}
function $6d932106fee366bf$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $j3cSI.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $j3cSI.hasOwn)(options, camelKey = (0, $j3cSI.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$6d932106fee366bf$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $Dz4HH.toRaw)(props);
        const castValues = rawCastValues || (0, $j3cSI.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $6d932106fee366bf$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $j3cSI.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $6d932106fee366bf$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $j3cSI.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $j3cSI.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $6d932106fee366bf$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $j3cSI.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $6d932106fee366bf$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $j3cSI.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $6d932106fee366bf$var$normalizePropsOptions(raw2, appContext, true);
            (0, $j3cSI.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $j3cSI.isObject)(comp)) cache.set(comp, (0, $j3cSI.EMPTY_ARR));
        return 0, $j3cSI.EMPTY_ARR;
    }
    if ((0, $j3cSI.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $j3cSI.camelize)(raw[i]);
        if ($6d932106fee366bf$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $j3cSI.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $j3cSI.camelize)(key);
        if ($6d932106fee366bf$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $j3cSI.isArray)(opt) || (0, $j3cSI.isFunction)(opt) ? {
                type: opt
            } : (0, $j3cSI.extend)({}, opt);
            if (prop) {
                const booleanIndex = $6d932106fee366bf$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $6d932106fee366bf$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $j3cSI.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $j3cSI.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $6d932106fee366bf$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $j3cSI.isReservedProp)(key)) return true;
    return false;
}
function $6d932106fee366bf$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $6d932106fee366bf$var$isSameType(a, b) {
    return $6d932106fee366bf$var$getType(a) === $6d932106fee366bf$var$getType(b);
}
function $6d932106fee366bf$var$getTypeIndex(type, expectedTypes) {
    if ((0, $j3cSI.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$6d932106fee366bf$var$isSameType(t, type));
    else if ((0, $j3cSI.isFunction)(expectedTypes)) return $6d932106fee366bf$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $6d932106fee366bf$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $Dz4HH.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $6d932106fee366bf$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, $j3cSI.hasOwn)(rawProps, key) && !(0, $j3cSI.hasOwn)(rawProps, (0, $j3cSI.hyphenate)(key)));
    }
}
function $6d932106fee366bf$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $6d932106fee366bf$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $j3cSI.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $6d932106fee366bf$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $6d932106fee366bf$var$warn$1($6d932106fee366bf$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $6d932106fee366bf$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $6d932106fee366bf$var$isSimpleType = /* @__PURE__ */ (0, $j3cSI.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $6d932106fee366bf$var$assertType(value, type) {
    let valid;
    const expectedType = $6d932106fee366bf$var$getType(type);
    if ($6d932106fee366bf$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $j3cSI.isObject)(value);
    else if (expectedType === "Array") valid = (0, $j3cSI.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $6d932106fee366bf$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $j3cSI.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $j3cSI.toRawType)(value);
    const expectedValue = $6d932106fee366bf$var$styleValue(value, expectedType);
    const receivedValue = $6d932106fee366bf$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $6d932106fee366bf$var$isExplicable(expectedType) && !$6d932106fee366bf$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($6d932106fee366bf$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $6d932106fee366bf$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $6d932106fee366bf$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $6d932106fee366bf$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $6d932106fee366bf$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $6d932106fee366bf$var$normalizeSlotValue = (value)=>(0, $j3cSI.isArray)(value) ? value.map($6d932106fee366bf$var$normalizeVNode) : [
        $6d932106fee366bf$var$normalizeVNode(value)
    ];
const $6d932106fee366bf$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $6d932106fee366bf$export$694b237e827a3d23((...args)=>{
        return $6d932106fee366bf$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $6d932106fee366bf$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($6d932106fee366bf$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $j3cSI.isFunction)(value)) slots[key] = $6d932106fee366bf$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $6d932106fee366bf$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $6d932106fee366bf$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $6d932106fee366bf$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $6d932106fee366bf$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $Dz4HH.toRaw)(children);
            (0, $j3cSI.def)(children, "_", type);
        } else $6d932106fee366bf$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $6d932106fee366bf$var$normalizeVNodeSlots(instance, children);
    }
    (0, $j3cSI.def)(instance.slots, $6d932106fee366bf$var$InternalObjectKey, 1);
};
const $6d932106fee366bf$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $j3cSI.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $j3cSI.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $6d932106fee366bf$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $6d932106fee366bf$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$6d932106fee366bf$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function $6d932106fee366bf$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $j3cSI.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$6d932106fee366bf$var$setRef(r, oldRawRef && ((0, $j3cSI.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($6d932106fee366bf$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $6d932106fee366bf$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $j3cSI.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $j3cSI.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $j3cSI.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $Dz4HH.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $j3cSI.isFunction)(ref)) $6d932106fee366bf$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $j3cSI.isString)(ref);
        const _isRef = (0, $Dz4HH.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $j3cSI.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $j3cSI.isArray)(existing) && (0, $j3cSI.remove)(existing, refValue);
                    else {
                        if (!(0, $j3cSI.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $j3cSI.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $j3cSI.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $6d932106fee366bf$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $6d932106fee366bf$var$hasMismatch = false;
const $6d932106fee366bf$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $6d932106fee366bf$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $6d932106fee366bf$var$getContainerType = (container)=>{
    if ($6d932106fee366bf$var$isSVGContainer(container)) return "svg";
    if ($6d932106fee366bf$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $6d932106fee366bf$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $6d932106fee366bf$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $6d932106fee366bf$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $6d932106fee366bf$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $6d932106fee366bf$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $6d932106fee366bf$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($6d932106fee366bf$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $6d932106fee366bf$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            if (!("__vnode" in node)) Object.defineProperty(node, "__vnode", {
                value: vnode,
                enumerable: false
            });
            if (!("__vueParentComponent" in node)) Object.defineProperty(node, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $6d932106fee366bf$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $6d932106fee366bf$var$hasMismatch = true;
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $6d932106fee366bf$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $6d932106fee366bf$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $6d932106fee366bf$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $6d932106fee366bf$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($6d932106fee366bf$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $6d932106fee366bf$var$getContainerType(container), optimized);
                    if ($6d932106fee366bf$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $6d932106fee366bf$export$22f9b5ffd89dac9("") : $6d932106fee366bf$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $6d932106fee366bf$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $6d932106fee366bf$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $6d932106fee366bf$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $6d932106fee366bf$var$needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $6d932106fee366bf$var$hasMismatch = true;
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $6d932106fee366bf$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $6d932106fee366bf$var$hasMismatch = true;
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $6d932106fee366bf$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (forcePatch || !optimized || patchFlag & 48) {
                    for(const key in props)if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $j3cSI.isOn)(key) && !(0, $j3cSI.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                    key[0] === ".") patchProp(el, key, null, props[key], void 0, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $6d932106fee366bf$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $6d932106fee366bf$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $6d932106fee366bf$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $6d932106fee366bf$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $6d932106fee366bf$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $6d932106fee366bf$var$hasMismatch = true;
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    $6d932106fee366bf$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $6d932106fee366bf$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $6d932106fee366bf$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $6d932106fee366bf$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $6d932106fee366bf$var$hasMismatch = true;
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $6d932106fee366bf$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : $6d932106fee366bf$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $6d932106fee366bf$var$getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $6d932106fee366bf$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $6d932106fee366bf$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var _a;
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $j3cSI.normalizeClass)(clientValue);
        if (!$6d932106fee366bf$var$isSetEqual($6d932106fee366bf$var$toClassSet(actual || ""), $6d932106fee366bf$var$toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style");
        expected = (0, $j3cSI.isString)(clientValue) ? clientValue : (0, $j3cSI.stringifyStyle)((0, $j3cSI.normalizeStyle)(clientValue));
        const actualMap = $6d932106fee366bf$var$toStyleMap(actual);
        const expectedMap = $6d932106fee366bf$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        const root = instance == null ? void 0 : instance.subTree;
        if (vnode === root || (root == null ? void 0 : root.type) === $6d932106fee366bf$export$ffb0004e005737fa && root.children.includes(vnode)) {
            const cssVars = (_a = instance == null ? void 0 : instance.getCssVars) == null ? void 0 : _a.call(instance);
            for(const key2 in cssVars)expectedMap.set(`--${key2}`, String(cssVars[key2]));
        }
        if (!$6d932106fee366bf$var$isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, $j3cSI.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $j3cSI.isBooleanAttr)(key) || (0, $j3cSI.isKnownHtmlAttr)(key))) {
        if ((0, $j3cSI.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $j3cSI.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $j3cSI.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $6d932106fee366bf$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $6d932106fee366bf$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $6d932106fee366bf$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $6d932106fee366bf$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key == null ? void 0 : key.trim();
        value = value == null ? void 0 : value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $6d932106fee366bf$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
let $6d932106fee366bf$var$supported;
let $6d932106fee366bf$var$perf;
function $6d932106fee366bf$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $6d932106fee366bf$var$isSupported()) $6d932106fee366bf$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsPerfStart(instance, type, $6d932106fee366bf$var$isSupported() ? $6d932106fee366bf$var$perf.now() : Date.now());
}
function $6d932106fee366bf$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $6d932106fee366bf$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $6d932106fee366bf$var$perf.mark(endTag);
        $6d932106fee366bf$var$perf.measure(`<${$6d932106fee366bf$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $6d932106fee366bf$var$perf.clearMarks(startTag);
        $6d932106fee366bf$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsPerfEnd(instance, type, $6d932106fee366bf$var$isSupported() ? $6d932106fee366bf$var$perf.now() : Date.now());
}
function $6d932106fee366bf$var$isSupported() {
    if ($6d932106fee366bf$var$supported !== void 0) return $6d932106fee366bf$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $6d932106fee366bf$var$supported = true;
        $6d932106fee366bf$var$perf = window.performance;
    } else $6d932106fee366bf$var$supported = false;
    return $6d932106fee366bf$var$supported;
}
function $6d932106fee366bf$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $j3cSI.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $j3cSI.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $j3cSI.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $6d932106fee366bf$var$queuePostRenderEffect = $6d932106fee366bf$var$queueEffectWithSuspense;
function $6d932106fee366bf$export$53ae2f996c64e9a(options) {
    return $6d932106fee366bf$var$baseCreateRenderer(options);
}
function $6d932106fee366bf$export$200524cf0d997ff0(options) {
    return $6d932106fee366bf$var$baseCreateRenderer(options, $6d932106fee366bf$var$createHydrationFunctions);
}
function $6d932106fee366bf$var$baseCreateRenderer(options, createHydrationFns) {
    $6d932106fee366bf$var$initFeatureFlags();
    const target = (0, $j3cSI.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $j3cSI.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$6d932106fee366bf$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $6d932106fee366bf$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $6d932106fee366bf$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $6d932106fee366bf$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $6d932106fee366bf$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $6d932106fee366bf$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $6d932106fee366bf$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $j3cSI.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $6d932106fee366bf$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $6d932106fee366bf$var$queuePostRenderEffect(()=>{
            vnodeHook && $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(children[i]) : $6d932106fee366bf$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $j3cSI.EMPTY_OBJ);
        const newProps = n2.props || (0, $j3cSI.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $6d932106fee366bf$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $6d932106fee366bf$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $6d932106fee366bf$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $6d932106fee366bf$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $6d932106fee366bf$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $6d932106fee366bf$var$queuePostRenderEffect(()=>{
            vnodeHook && $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $6d932106fee366bf$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $6d932106fee366bf$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$6d932106fee366bf$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $j3cSI.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $j3cSI.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $j3cSI.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $6d932106fee366bf$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $6d932106fee366bf$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($6d932106fee366bf$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $6d932106fee366bf$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($6d932106fee366bf$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $6d932106fee366bf$var$invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $6d932106fee366bf$var$isAsyncWrapper(initialVNode);
                $6d932106fee366bf$var$toggleRecurse(instance, false);
                if (bm) (0, $j3cSI.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $6d932106fee366bf$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $6d932106fee366bf$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $6d932106fee366bf$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $6d932106fee366bf$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $6d932106fee366bf$var$queuePostRenderEffect(()=>$6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $6d932106fee366bf$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $6d932106fee366bf$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $6d932106fee366bf$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $6d932106fee366bf$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $j3cSI.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $6d932106fee366bf$var$toggleRecurse(instance, true);
                const nextTree = $6d932106fee366bf$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $6d932106fee366bf$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $6d932106fee366bf$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $6d932106fee366bf$var$queuePostRenderEffect(()=>$6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $Dz4HH.ReactiveEffect)(componentUpdateFn, (0, $j3cSI.NOOP), ()=>$6d932106fee366bf$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.id = instance.uid;
        $6d932106fee366bf$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $6d932106fee366bf$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $6d932106fee366bf$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $Dz4HH.pauseTracking)();
        $6d932106fee366bf$var$flushPreFlushCbs(instance);
        (0, $Dz4HH.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $j3cSI.EMPTY_ARR);
        c2 = c2 || (0, $j3cSI.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[i]) : $6d932106fee366bf$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[i]) : $6d932106fee366bf$var$normalizeVNode(c2[i]);
            if ($6d932106fee366bf$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[e2]) : $6d932106fee366bf$var$normalizeVNode(c2[e2]);
            if ($6d932106fee366bf$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[i]) : $6d932106fee366bf$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $6d932106fee366bf$var$cloneIfMounted(c2[i]) : $6d932106fee366bf$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $6d932106fee366bf$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $6d932106fee366bf$var$getSequence(newIndexToOldIndexMap) : (0, $j3cSI.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $6d932106fee366bf$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $6d932106fee366bf$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $6d932106fee366bf$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $6d932106fee366bf$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$6d932106fee366bf$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $6d932106fee366bf$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $6d932106fee366bf$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $6d932106fee366bf$var$queuePostRenderEffect(()=>{
            vnodeHook && $6d932106fee366bf$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $6d932106fee366bf$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $6d932106fee366bf$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $6d932106fee366bf$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $j3cSI.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $6d932106fee366bf$var$queuePostRenderEffect(um, parentSuspense);
        $6d932106fee366bf$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $6d932106fee366bf$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        if (!isFlushing) {
            isFlushing = true;
            $6d932106fee366bf$var$flushPreFlushCbs();
            $6d932106fee366bf$var$flushPostFlushCbs();
            isFlushing = false;
        }
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $6d932106fee366bf$var$createAppAPI(render, hydrate)
    };
}
function $6d932106fee366bf$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $6d932106fee366bf$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $6d932106fee366bf$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $6d932106fee366bf$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $j3cSI.isArray)(ch1) && (0, $j3cSI.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $6d932106fee366bf$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $6d932106fee366bf$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $6d932106fee366bf$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $6d932106fee366bf$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $6d932106fee366bf$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $6d932106fee366bf$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
const $6d932106fee366bf$var$isTeleport = (type)=>type.__isTeleport;
const $6d932106fee366bf$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $6d932106fee366bf$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $6d932106fee366bf$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $6d932106fee366bf$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $j3cSI.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $6d932106fee366bf$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $6d932106fee366bf$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $6d932106fee366bf$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                if (namespace === "svg" || $6d932106fee366bf$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || $6d932106fee366bf$var$isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $6d932106fee366bf$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $6d932106fee366bf$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $6d932106fee366bf$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $6d932106fee366bf$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $6d932106fee366bf$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $6d932106fee366bf$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $6d932106fee366bf$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $6d932106fee366bf$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $6d932106fee366bf$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$6d932106fee366bf$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $6d932106fee366bf$var$moveTeleport,
    hydrate: $6d932106fee366bf$var$hydrateTeleport
};
function $6d932106fee366bf$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $6d932106fee366bf$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $6d932106fee366bf$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $6d932106fee366bf$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($6d932106fee366bf$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $6d932106fee366bf$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $6d932106fee366bf$export$76d55a0304a371f4 = $6d932106fee366bf$var$TeleportImpl;
function $6d932106fee366bf$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $6d932106fee366bf$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $6d932106fee366bf$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $6d932106fee366bf$export$4d299b491347818a = Symbol.for("v-cmt");
const $6d932106fee366bf$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $6d932106fee366bf$var$blockStack = [];
let $6d932106fee366bf$var$currentBlock = null;
function $6d932106fee366bf$export$e7eaa45e502fe5cc(disableTracking = false) {
    $6d932106fee366bf$var$blockStack.push($6d932106fee366bf$var$currentBlock = disableTracking ? null : []);
}
function $6d932106fee366bf$var$closeBlock() {
    $6d932106fee366bf$var$blockStack.pop();
    $6d932106fee366bf$var$currentBlock = $6d932106fee366bf$var$blockStack[$6d932106fee366bf$var$blockStack.length - 1] || null;
}
let $6d932106fee366bf$var$isBlockTreeEnabled = 1;
function $6d932106fee366bf$export$c20bee82f26f1e27(value) {
    $6d932106fee366bf$var$isBlockTreeEnabled += value;
}
function $6d932106fee366bf$var$setupBlock(vnode) {
    vnode.dynamicChildren = $6d932106fee366bf$var$isBlockTreeEnabled > 0 ? $6d932106fee366bf$var$currentBlock || (0, $j3cSI.EMPTY_ARR) : null;
    $6d932106fee366bf$var$closeBlock();
    if ($6d932106fee366bf$var$isBlockTreeEnabled > 0 && $6d932106fee366bf$var$currentBlock) $6d932106fee366bf$var$currentBlock.push(vnode);
    return vnode;
}
function $6d932106fee366bf$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $6d932106fee366bf$var$setupBlock($6d932106fee366bf$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $6d932106fee366bf$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $6d932106fee366bf$var$setupBlock($6d932106fee366bf$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $6d932106fee366bf$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $6d932106fee366bf$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $6d932106fee366bf$var$vnodeArgsTransformer;
function $6d932106fee366bf$export$83beccd3afeeb809(transformer) {
    $6d932106fee366bf$var$vnodeArgsTransformer = transformer;
}
const $6d932106fee366bf$var$createVNodeWithArgsTransform = (...args)=>{
    return $6d932106fee366bf$var$_createVNode(...$6d932106fee366bf$var$vnodeArgsTransformer ? $6d932106fee366bf$var$vnodeArgsTransformer(args, $6d932106fee366bf$var$currentRenderingInstance) : args);
};
const $6d932106fee366bf$var$InternalObjectKey = `__vInternal`;
const $6d932106fee366bf$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $6d932106fee366bf$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $j3cSI.isString)(ref) || (0, $Dz4HH.isRef)(ref) || (0, $j3cSI.isFunction)(ref) ? {
        i: $6d932106fee366bf$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $6d932106fee366bf$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $6d932106fee366bf$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $6d932106fee366bf$var$normalizeKey(props),
        ref: props && $6d932106fee366bf$var$normalizeRef(props),
        scopeId: $6d932106fee366bf$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $6d932106fee366bf$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $6d932106fee366bf$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $j3cSI.isString)(children) ? 8 : 16;
    if ($6d932106fee366bf$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $6d932106fee366bf$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $6d932106fee366bf$var$currentBlock.push(vnode);
    return vnode;
}
const $6d932106fee366bf$export$bf5c4cf060303d58 = $6d932106fee366bf$var$_createVNode;
function $6d932106fee366bf$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $6d932106fee366bf$var$NULL_DYNAMIC_COMPONENT) type = $6d932106fee366bf$export$4d299b491347818a;
    if ($6d932106fee366bf$export$3868d13f8734ae81(type)) {
        const cloned = $6d932106fee366bf$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $6d932106fee366bf$var$normalizeChildren(cloned, children);
        if ($6d932106fee366bf$var$isBlockTreeEnabled > 0 && !isBlockNode && $6d932106fee366bf$var$currentBlock) {
            if (cloned.shapeFlag & 6) $6d932106fee366bf$var$currentBlock[$6d932106fee366bf$var$currentBlock.indexOf(type)] = cloned;
            else $6d932106fee366bf$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($6d932106fee366bf$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $6d932106fee366bf$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $j3cSI.isString)(klass)) props.class = (0, $j3cSI.normalizeClass)(klass);
        if ((0, $j3cSI.isObject)(style)) {
            if ((0, $Dz4HH.isProxy)(style) && !(0, $j3cSI.isArray)(style)) style = (0, $j3cSI.extend)({}, style);
            props.style = (0, $j3cSI.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $j3cSI.isString)(type) ? 1 : $6d932106fee366bf$var$isSuspense(type) ? 128 : $6d932106fee366bf$var$isTeleport(type) ? 64 : (0, $j3cSI.isObject)(type) ? 4 : (0, $j3cSI.isFunction)(type) ? 2 : 0;
    return $6d932106fee366bf$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $6d932106fee366bf$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $Dz4HH.isProxy)(props) || $6d932106fee366bf$var$InternalObjectKey in props ? (0, $j3cSI.extend)({}, props) : props;
}
function $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $6d932106fee366bf$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $6d932106fee366bf$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $j3cSI.isArray)(ref) ? ref.concat($6d932106fee366bf$var$normalizeRef(extraProps)) : [
            ref,
            $6d932106fee366bf$var$normalizeRef(extraProps)
        ] : $6d932106fee366bf$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $6d932106fee366bf$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $6d932106fee366bf$var$deepCloneVNode(vnode) {
    const cloned = $6d932106fee366bf$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $j3cSI.isArray)(vnode.children)) cloned.children = vnode.children.map($6d932106fee366bf$var$deepCloneVNode);
    return cloned;
}
function $6d932106fee366bf$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$5f1af8db9871e1d6, null, text, flag);
}
function $6d932106fee366bf$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $6d932106fee366bf$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($6d932106fee366bf$export$e7eaa45e502fe5cc(), $6d932106fee366bf$export$9f2dfe8048dfb22b($6d932106fee366bf$export$4d299b491347818a, null, text)) : $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a, null, text);
}
function $6d932106fee366bf$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$4d299b491347818a);
    else if ((0, $j3cSI.isArray)(child)) return $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $6d932106fee366bf$var$cloneIfMounted(child);
    else return $6d932106fee366bf$export$bf5c4cf060303d58($6d932106fee366bf$export$5f1af8db9871e1d6, null, String(child));
}
function $6d932106fee366bf$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $6d932106fee366bf$export$ee4f9e12c0a92a1a(child);
}
function $6d932106fee366bf$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $j3cSI.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $6d932106fee366bf$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !($6d932106fee366bf$var$InternalObjectKey in children)) children._ctx = $6d932106fee366bf$var$currentRenderingInstance;
            else if (slotFlag === 3 && $6d932106fee366bf$var$currentRenderingInstance) {
                if ($6d932106fee366bf$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $j3cSI.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $6d932106fee366bf$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $6d932106fee366bf$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $6d932106fee366bf$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $j3cSI.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $j3cSI.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $j3cSI.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $j3cSI.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $6d932106fee366bf$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $6d932106fee366bf$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $6d932106fee366bf$var$emptyAppContext = $6d932106fee366bf$var$createAppContext();
let $6d932106fee366bf$var$uid = 0;
function $6d932106fee366bf$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $6d932106fee366bf$var$emptyAppContext;
    const instance = {
        uid: $6d932106fee366bf$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $Dz4HH.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $6d932106fee366bf$var$normalizePropsOptions(type, appContext),
        emitsOptions: $6d932106fee366bf$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $j3cSI.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $j3cSI.EMPTY_OBJ),
        data: (0, $j3cSI.EMPTY_OBJ),
        props: (0, $j3cSI.EMPTY_OBJ),
        attrs: (0, $j3cSI.EMPTY_OBJ),
        slots: (0, $j3cSI.EMPTY_OBJ),
        refs: (0, $j3cSI.EMPTY_OBJ),
        setupState: (0, $j3cSI.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $6d932106fee366bf$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $6d932106fee366bf$var$currentInstance = null;
const $6d932106fee366bf$export$f13e630aa3915748 = ()=>$6d932106fee366bf$var$currentInstance || $6d932106fee366bf$var$currentRenderingInstance;
let $6d932106fee366bf$var$internalSetCurrentInstance;
let $6d932106fee366bf$var$setInSSRSetupState;
{
    const g = (0, $j3cSI.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $6d932106fee366bf$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$6d932106fee366bf$var$currentInstance = v1);
    $6d932106fee366bf$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$6d932106fee366bf$var$isInSSRComponentSetup = v1);
}const $6d932106fee366bf$var$setCurrentInstance = (instance)=>{
    const prev = $6d932106fee366bf$var$currentInstance;
    $6d932106fee366bf$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $6d932106fee366bf$var$internalSetCurrentInstance(prev);
    };
};
const $6d932106fee366bf$var$unsetCurrentInstance = ()=>{
    $6d932106fee366bf$var$currentInstance && $6d932106fee366bf$var$currentInstance.scope.off();
    $6d932106fee366bf$var$internalSetCurrentInstance(null);
};
const $6d932106fee366bf$var$isBuiltInTag = /* @__PURE__ */ (0, $j3cSI.makeMap)("slot,component");
function $6d932106fee366bf$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($6d932106fee366bf$var$isBuiltInTag(name) || isNativeTag(name)) $6d932106fee366bf$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $6d932106fee366bf$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $6d932106fee366bf$var$isInSSRComponentSetup = false;
function $6d932106fee366bf$var$setupComponent(instance, isSSR = false) {
    isSSR && $6d932106fee366bf$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $6d932106fee366bf$var$isStatefulComponent(instance);
    $6d932106fee366bf$var$initProps(instance, props, isStateful, isSSR);
    $6d932106fee366bf$var$initSlots(instance, children);
    const setupResult = isStateful ? $6d932106fee366bf$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $6d932106fee366bf$var$setInSSRSetupState(false);
    return setupResult;
}
function $6d932106fee366bf$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $Dz4HH.markRaw)(new Proxy(instance.ctx, $6d932106fee366bf$var$PublicInstanceProxyHandlers));
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $6d932106fee366bf$var$createSetupContext(instance) : null;
        const reset = $6d932106fee366bf$var$setCurrentInstance(instance);
        (0, $Dz4HH.pauseTracking)();
        const setupResult = $6d932106fee366bf$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $Dz4HH.resetTracking)();
        reset();
        if ((0, $j3cSI.isPromise)(setupResult)) {
            setupResult.then($6d932106fee366bf$var$unsetCurrentInstance, $6d932106fee366bf$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $6d932106fee366bf$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $6d932106fee366bf$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $6d932106fee366bf$var$handleSetupResult(instance, setupResult, isSSR);
    } else $6d932106fee366bf$var$finishComponentSetup(instance, isSSR);
}
function $6d932106fee366bf$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $j3cSI.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $j3cSI.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $Dz4HH.proxyRefs)(setupResult);
    }
    $6d932106fee366bf$var$finishComponentSetup(instance, isSSR);
}
let $6d932106fee366bf$var$compile;
let $6d932106fee366bf$var$installWithProxy;
function $6d932106fee366bf$export$667bb5a67822b941(_compile) {
    $6d932106fee366bf$var$compile = _compile;
    $6d932106fee366bf$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $6d932106fee366bf$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $6d932106fee366bf$export$c93a9c496c5211fa = ()=>!$6d932106fee366bf$var$compile;
function $6d932106fee366bf$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $6d932106fee366bf$var$compile && !Component.render) {
            const template = Component.template || $6d932106fee366bf$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $j3cSI.extend)((0, $j3cSI.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $6d932106fee366bf$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $j3cSI.NOOP);
        if ($6d932106fee366bf$var$installWithProxy) $6d932106fee366bf$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $6d932106fee366bf$var$setCurrentInstance(instance);
        (0, $Dz4HH.pauseTracking)();
        try {
            $6d932106fee366bf$var$applyOptions(instance);
        } finally{
            (0, $Dz4HH.resetTracking)();
            reset();
        }
    }
}
function $6d932106fee366bf$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get (target, key) {
            (0, $Dz4HH.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $6d932106fee366bf$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $Dz4HH.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $6d932106fee366bf$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $6d932106fee366bf$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $6d932106fee366bf$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $Dz4HH.proxyRefs)((0, $Dz4HH.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $6d932106fee366bf$var$publicPropertiesMap) return $6d932106fee366bf$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $6d932106fee366bf$var$publicPropertiesMap;
        }
    }));
}
const $6d932106fee366bf$var$classifyRE = /(?:^|[-_])(\w)/g;
const $6d932106fee366bf$var$classify = (str)=>str.replace($6d932106fee366bf$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $6d932106fee366bf$var$getComponentName(Component, includeInferred = true) {
    return (0, $j3cSI.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $6d932106fee366bf$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $6d932106fee366bf$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $6d932106fee366bf$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $6d932106fee366bf$var$isClassComponent(value) {
    return (0, $j3cSI.isFunction)(value) && "__vccOpts" in value;
}
const $6d932106fee366bf$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $Dz4HH.computed)(getterOrOptions, debugOptions, $6d932106fee366bf$var$isInSSRComponentSetup);
    return c;
};
function $6d932106fee366bf$export$fb78bd113157f1a1(props, name, options = (0, $j3cSI.EMPTY_OBJ)) {
    const i = $6d932106fee366bf$export$f13e630aa3915748();
    const camelizedName = (0, $j3cSI.camelize)(name);
    const hyphenatedName = (0, $j3cSI.hyphenate)(name);
    const res = (0, $Dz4HH.customRef)((track, trigger)=>{
        let localValue;
        $6d932106fee366bf$export$2035654f31b0e555(()=>{
            const propValue = props[name];
            if ((0, $j3cSI.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps)) && (0, $j3cSI.hasChanged)(value, localValue)) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, options.set ? options.set(value) : value);
            }
        };
    });
    const modifierKey = name === "modelValue" ? "modelModifiers" : `${name}Modifiers`;
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? props[modifierKey] || {} : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
function $6d932106fee366bf$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $j3cSI.isObject)(propsOrChildren) && !(0, $j3cSI.isArray)(propsOrChildren)) {
            if ($6d932106fee366bf$export$3868d13f8734ae81(propsOrChildren)) return $6d932106fee366bf$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $6d932106fee366bf$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $6d932106fee366bf$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $6d932106fee366bf$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $6d932106fee366bf$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $6d932106fee366bf$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $Dz4HH.toRaw)(instance.props)));
        if (instance.setupState !== (0, $j3cSI.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $j3cSI.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $Dz4HH.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $j3cSI.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $j3cSI.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $Dz4HH.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $j3cSI.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $j3cSI.isArray)(opts) && opts.includes(key) || (0, $j3cSI.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $Dz4HH.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $6d932106fee366bf$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $6d932106fee366bf$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $6d932106fee366bf$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $j3cSI.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($6d932106fee366bf$var$isBlockTreeEnabled > 0 && $6d932106fee366bf$var$currentBlock) $6d932106fee366bf$var$currentBlock.push(cached);
    return true;
}
const $6d932106fee366bf$export$83d89fbfd8236492 = "3.4.21";
const $6d932106fee366bf$export$c106dd0671a0fc2d = (0, $j3cSI.NOOP);
const $6d932106fee366bf$export$795e0ad4a0e2ed30 = $6d932106fee366bf$var$ErrorTypeStrings$1;
const $6d932106fee366bf$export$6922d3b3a607469e = $6d932106fee366bf$var$devtools$1;
const $6d932106fee366bf$export$b0c258b32c26c785 = $6d932106fee366bf$var$setDevtoolsHook$1;
const $6d932106fee366bf$var$_ssrUtils = {
    createComponentInstance: $6d932106fee366bf$var$createComponentInstance,
    setupComponent: $6d932106fee366bf$var$setupComponent,
    renderComponentRoot: $6d932106fee366bf$var$renderComponentRoot,
    setCurrentRenderingInstance: $6d932106fee366bf$var$setCurrentRenderingInstance,
    isVNode: $6d932106fee366bf$export$3868d13f8734ae81,
    normalizeVNode: $6d932106fee366bf$var$normalizeVNode
};
const $6d932106fee366bf$export$a9679033567b336d = $6d932106fee366bf$var$_ssrUtils;
const $6d932106fee366bf$export$83cf26e06ea620e1 = null;
const $6d932106fee366bf$export$dc678eddf276286e = null;
const $6d932106fee366bf$export$22072a82865312f6 = null;

});
parcelRegister("Dz4HH", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $076ed9c5817fdbc5$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $076ed9c5817fdbc5$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $076ed9c5817fdbc5$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "onScopeDispose", function () { return $076ed9c5817fdbc5$export$a780418acd4762da; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $076ed9c5817fdbc5$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $076ed9c5817fdbc5$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $076ed9c5817fdbc5$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "effect", function () { return $076ed9c5817fdbc5$export$dc573d8a6576cdb3; });
$parcel$export(module.exports, "stop", function () { return $076ed9c5817fdbc5$export$fa6813432f753b0d; });
$parcel$export(module.exports, "track", function () { return $076ed9c5817fdbc5$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $076ed9c5817fdbc5$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $076ed9c5817fdbc5$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $076ed9c5817fdbc5$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "readonly", function () { return $076ed9c5817fdbc5$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "reactive", function () { return $076ed9c5817fdbc5$export$90a44edba14e47be; });
$parcel$export(module.exports, "isReadonly", function () { return $076ed9c5817fdbc5$export$92d09b48637741e7; });
$parcel$export(module.exports, "isShallow", function () { return $076ed9c5817fdbc5$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $076ed9c5817fdbc5$export$8d81cefd22d22260; });
$parcel$export(module.exports, "shallowReadonly", function () { return $076ed9c5817fdbc5$export$7c4b5f2b50f09f6b; });
$parcel$export(module.exports, "isReactive", function () { return $076ed9c5817fdbc5$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $076ed9c5817fdbc5$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $076ed9c5817fdbc5$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "computed", function () { return $076ed9c5817fdbc5$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "ref", function () { return $076ed9c5817fdbc5$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $076ed9c5817fdbc5$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "triggerRef", function () { return $076ed9c5817fdbc5$export$f402f86588575ccc; });
$parcel$export(module.exports, "unref", function () { return $076ed9c5817fdbc5$export$a239a76781616204; });
$parcel$export(module.exports, "toValue", function () { return $076ed9c5817fdbc5$export$30bdcc2218aa9458; });
$parcel$export(module.exports, "proxyRefs", function () { return $076ed9c5817fdbc5$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $076ed9c5817fdbc5$export$a20c2dd6199824cb; });
$parcel$export(module.exports, "toRefs", function () { return $076ed9c5817fdbc5$export$2e9533675e5e70e0; });
$parcel$export(module.exports, "toRef", function () { return $076ed9c5817fdbc5$export$1f60508e4f47b4b7; });
$parcel$export(module.exports, "TrackOpTypes", function () { return $076ed9c5817fdbc5$export$2ac2bd0a56e04551; });
$parcel$export(module.exports, "TriggerOpTypes", function () { return $076ed9c5817fdbc5$export$1e8941c92696a26; });
/**
* @vue/reactivity v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $j3cSI = parcelRequire("j3cSI");
function $076ed9c5817fdbc5$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $076ed9c5817fdbc5$var$activeEffectScope;
class $076ed9c5817fdbc5$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $076ed9c5817fdbc5$var$activeEffectScope;
        if (!detached && $076ed9c5817fdbc5$var$activeEffectScope) this.index = ($076ed9c5817fdbc5$var$activeEffectScope.scopes || ($076ed9c5817fdbc5$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $076ed9c5817fdbc5$var$activeEffectScope;
            try {
                $076ed9c5817fdbc5$var$activeEffectScope = this;
                return fn();
            } finally{
                $076ed9c5817fdbc5$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $076ed9c5817fdbc5$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $076ed9c5817fdbc5$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function $076ed9c5817fdbc5$export$7056603ea81600be(detached) {
    return new $076ed9c5817fdbc5$export$1168ed9dbc71ddbd(detached);
}
function $076ed9c5817fdbc5$var$recordEffectScope(effect, scope = $076ed9c5817fdbc5$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $076ed9c5817fdbc5$export$c7be4b0125a10cba() {
    return $076ed9c5817fdbc5$var$activeEffectScope;
}
function $076ed9c5817fdbc5$export$a780418acd4762da(fn) {
    if ($076ed9c5817fdbc5$var$activeEffectScope) $076ed9c5817fdbc5$var$activeEffectScope.cleanups.push(fn);
}
let $076ed9c5817fdbc5$var$activeEffect;
class $076ed9c5817fdbc5$export$28352bb4dd362521 {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        $076ed9c5817fdbc5$var$recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            $076ed9c5817fdbc5$export$938a971395fef855();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    $076ed9c5817fdbc5$var$triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            $076ed9c5817fdbc5$export$c39176b1babaa8b8();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = $076ed9c5817fdbc5$var$shouldTrack;
        let lastEffect = $076ed9c5817fdbc5$var$activeEffect;
        try {
            $076ed9c5817fdbc5$var$shouldTrack = true;
            $076ed9c5817fdbc5$var$activeEffect = this;
            this._runnings++;
            $076ed9c5817fdbc5$var$preCleanupEffect(this);
            return this.fn();
        } finally{
            $076ed9c5817fdbc5$var$postCleanupEffect(this);
            this._runnings--;
            $076ed9c5817fdbc5$var$activeEffect = lastEffect;
            $076ed9c5817fdbc5$var$shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        var _a;
        if (this.active) {
            $076ed9c5817fdbc5$var$preCleanupEffect(this);
            $076ed9c5817fdbc5$var$postCleanupEffect(this);
            (_a = this.onStop) == null || _a.call(this);
            this.active = false;
        }
    }
}
function $076ed9c5817fdbc5$var$triggerComputed(computed) {
    return computed.value;
}
function $076ed9c5817fdbc5$var$preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function $076ed9c5817fdbc5$var$postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)$076ed9c5817fdbc5$var$cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function $076ed9c5817fdbc5$var$cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function $076ed9c5817fdbc5$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $076ed9c5817fdbc5$export$28352bb4dd362521) fn = fn.effect.fn;
    const _effect = new $076ed9c5817fdbc5$export$28352bb4dd362521(fn, (0, $j3cSI.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, $j3cSI.extend)(_effect, options);
        if (options.scope) $076ed9c5817fdbc5$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $076ed9c5817fdbc5$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $076ed9c5817fdbc5$var$shouldTrack = true;
let $076ed9c5817fdbc5$var$pauseScheduleStack = 0;
const $076ed9c5817fdbc5$var$trackStack = [];
function $076ed9c5817fdbc5$export$938a971395fef855() {
    $076ed9c5817fdbc5$var$trackStack.push($076ed9c5817fdbc5$var$shouldTrack);
    $076ed9c5817fdbc5$var$shouldTrack = false;
}
function $076ed9c5817fdbc5$export$1f8ffc6fd33b1d16() {
    $076ed9c5817fdbc5$var$trackStack.push($076ed9c5817fdbc5$var$shouldTrack);
    $076ed9c5817fdbc5$var$shouldTrack = true;
}
function $076ed9c5817fdbc5$export$c39176b1babaa8b8() {
    const last = $076ed9c5817fdbc5$var$trackStack.pop();
    $076ed9c5817fdbc5$var$shouldTrack = last === void 0 ? true : last;
}
function $076ed9c5817fdbc5$export$262a949f95482a17() {
    $076ed9c5817fdbc5$var$pauseScheduleStack++;
}
function $076ed9c5817fdbc5$export$3539fa10306ef581() {
    $076ed9c5817fdbc5$var$pauseScheduleStack--;
    while(!$076ed9c5817fdbc5$var$pauseScheduleStack && $076ed9c5817fdbc5$var$queueEffectSchedulers.length)$076ed9c5817fdbc5$var$queueEffectSchedulers.shift()();
}
function $076ed9c5817fdbc5$var$trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) $076ed9c5817fdbc5$var$cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const $076ed9c5817fdbc5$var$queueEffectSchedulers = [];
function $076ed9c5817fdbc5$var$triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    $076ed9c5817fdbc5$export$262a949f95482a17();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) $076ed9c5817fdbc5$var$queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    $076ed9c5817fdbc5$export$3539fa10306ef581();
}
const $076ed9c5817fdbc5$var$createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const $076ed9c5817fdbc5$var$targetMap = /* @__PURE__ */ new WeakMap();
const $076ed9c5817fdbc5$export$3c41b1a4e06acc14 = Symbol("");
const $076ed9c5817fdbc5$var$MAP_KEY_ITERATE_KEY = Symbol("");
function $076ed9c5817fdbc5$export$6b2a7d5132615086(target, type, key) {
    if ($076ed9c5817fdbc5$var$shouldTrack && $076ed9c5817fdbc5$var$activeEffect) {
        let depsMap = $076ed9c5817fdbc5$var$targetMap.get(target);
        if (!depsMap) $076ed9c5817fdbc5$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $076ed9c5817fdbc5$var$createDep(()=>depsMap.delete(key)));
        $076ed9c5817fdbc5$var$trackEffect($076ed9c5817fdbc5$var$activeEffect, dep, void 0);
    }
}
function $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $076ed9c5817fdbc5$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $j3cSI.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, $j3cSI.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $j3cSI.isArray)(target)) {
                    deps.push(depsMap.get($076ed9c5817fdbc5$export$3c41b1a4e06acc14));
                    if ((0, $j3cSI.isMap)(target)) deps.push(depsMap.get($076ed9c5817fdbc5$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $j3cSI.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $j3cSI.isArray)(target)) {
                    deps.push(depsMap.get($076ed9c5817fdbc5$export$3c41b1a4e06acc14));
                    if ((0, $j3cSI.isMap)(target)) deps.push(depsMap.get($076ed9c5817fdbc5$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $j3cSI.isMap)(target)) deps.push(depsMap.get($076ed9c5817fdbc5$export$3c41b1a4e06acc14));
                break;
        }
    }
    $076ed9c5817fdbc5$export$262a949f95482a17();
    for (const dep of deps)if (dep) $076ed9c5817fdbc5$var$triggerEffects(dep, 4, void 0);
    $076ed9c5817fdbc5$export$3539fa10306ef581();
}
function $076ed9c5817fdbc5$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $076ed9c5817fdbc5$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $076ed9c5817fdbc5$var$isNonTrackableKeys = /* @__PURE__ */ (0, $j3cSI.makeMap)(`__proto__,__v_isRef,__isVue`);
const $076ed9c5817fdbc5$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $j3cSI.isSymbol)));
const $076ed9c5817fdbc5$var$arrayInstrumentations = /* @__PURE__ */ $076ed9c5817fdbc5$var$createArrayInstrumentations();
function $076ed9c5817fdbc5$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$076ed9c5817fdbc5$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($076ed9c5817fdbc5$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $076ed9c5817fdbc5$export$938a971395fef855();
            $076ed9c5817fdbc5$export$262a949f95482a17();
            const res = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $076ed9c5817fdbc5$export$3539fa10306ef581();
            $076ed9c5817fdbc5$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $076ed9c5817fdbc5$var$hasOwnProperty(key) {
    const obj = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(this);
    $076ed9c5817fdbc5$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $076ed9c5817fdbc5$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $076ed9c5817fdbc5$var$shallowReadonlyMap : $076ed9c5817fdbc5$var$readonlyMap : isShallow2 ? $076ed9c5817fdbc5$var$shallowReactiveMap : $076ed9c5817fdbc5$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the reciever is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $j3cSI.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $j3cSI.hasOwn)($076ed9c5817fdbc5$var$arrayInstrumentations, key)) return Reflect.get($076ed9c5817fdbc5$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $076ed9c5817fdbc5$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $j3cSI.isSymbol)(key) ? $076ed9c5817fdbc5$var$builtInSymbols.has(key) : $076ed9c5817fdbc5$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $076ed9c5817fdbc5$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($076ed9c5817fdbc5$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $j3cSI.isIntegerKey)(key) ? res : res.value;
        if ((0, $j3cSI.isObject)(res)) return isReadonly2 ? $076ed9c5817fdbc5$export$6ec456bd5b7b3c51(res) : $076ed9c5817fdbc5$export$90a44edba14e47be(res);
        return res;
    }
}
class $076ed9c5817fdbc5$var$MutableReactiveHandler extends $076ed9c5817fdbc5$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $076ed9c5817fdbc5$export$92d09b48637741e7(oldValue);
            if (!$076ed9c5817fdbc5$export$7f3fe6025abfa26e(value) && !$076ed9c5817fdbc5$export$92d09b48637741e7(value)) {
                oldValue = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(oldValue);
                value = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $j3cSI.isArray)(target) && $076ed9c5817fdbc5$export$4f9f5282de18fc69(oldValue) && !$076ed9c5817fdbc5$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $j3cSI.isArray)(target) && (0, $j3cSI.isIntegerKey)(key) ? Number(key) < target.length : (0, $j3cSI.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $076ed9c5817fdbc5$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $j3cSI.hasChanged)(value, oldValue)) $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $j3cSI.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $j3cSI.isSymbol)(key) || !$076ed9c5817fdbc5$var$builtInSymbols.has(key)) $076ed9c5817fdbc5$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $076ed9c5817fdbc5$export$6b2a7d5132615086(target, "iterate", (0, $j3cSI.isArray)(target) ? "length" : $076ed9c5817fdbc5$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $076ed9c5817fdbc5$var$ReadonlyReactiveHandler extends $076ed9c5817fdbc5$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $076ed9c5817fdbc5$var$mutableHandlers = /* @__PURE__ */ new $076ed9c5817fdbc5$var$MutableReactiveHandler();
const $076ed9c5817fdbc5$var$readonlyHandlers = /* @__PURE__ */ new $076ed9c5817fdbc5$var$ReadonlyReactiveHandler();
const $076ed9c5817fdbc5$var$shallowReactiveHandlers = /* @__PURE__ */ new $076ed9c5817fdbc5$var$MutableReactiveHandler(true);
const $076ed9c5817fdbc5$var$shallowReadonlyHandlers = /* @__PURE__ */ new $076ed9c5817fdbc5$var$ReadonlyReactiveHandler(true);
const $076ed9c5817fdbc5$var$toShallow = (value)=>value;
const $076ed9c5817fdbc5$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $076ed9c5817fdbc5$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(target);
    const rawKey = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $j3cSI.hasChanged)(key, rawKey)) $076ed9c5817fdbc5$export$6b2a7d5132615086(rawTarget, "get", key);
        $076ed9c5817fdbc5$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $076ed9c5817fdbc5$var$getProto(rawTarget);
    const wrap = isShallow ? $076ed9c5817fdbc5$var$toShallow : isReadonly ? $076ed9c5817fdbc5$var$toReadonly : $076ed9c5817fdbc5$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $076ed9c5817fdbc5$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(target);
    const rawKey = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if ((0, $j3cSI.hasChanged)(key, rawKey)) $076ed9c5817fdbc5$export$6b2a7d5132615086(rawTarget, "has", key);
        $076ed9c5817fdbc5$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $076ed9c5817fdbc5$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $076ed9c5817fdbc5$export$6b2a7d5132615086($076ed9c5817fdbc5$export$ab18938b9fc5f28e(target), "iterate", $076ed9c5817fdbc5$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $076ed9c5817fdbc5$var$add(value) {
    value = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(value);
    const target = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(this);
    const proto = $076ed9c5817fdbc5$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $076ed9c5817fdbc5$var$set(key, value) {
    value = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(value);
    const target = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $076ed9c5817fdbc5$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $j3cSI.hasChanged)(value, oldValue)) $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $076ed9c5817fdbc5$var$deleteEntry(key) {
    const target = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $076ed9c5817fdbc5$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $076ed9c5817fdbc5$var$clear() {
    const target = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $076ed9c5817fdbc5$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $076ed9c5817fdbc5$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $076ed9c5817fdbc5$var$toShallow : isReadonly ? $076ed9c5817fdbc5$var$toReadonly : $076ed9c5817fdbc5$var$toReactive;
        !isReadonly && $076ed9c5817fdbc5$export$6b2a7d5132615086(rawTarget, "iterate", $076ed9c5817fdbc5$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $076ed9c5817fdbc5$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $j3cSI.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $076ed9c5817fdbc5$var$toShallow : isReadonly ? $076ed9c5817fdbc5$var$toReadonly : $076ed9c5817fdbc5$var$toReactive;
        !isReadonly && $076ed9c5817fdbc5$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $076ed9c5817fdbc5$var$MAP_KEY_ITERATE_KEY : $076ed9c5817fdbc5$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $076ed9c5817fdbc5$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $076ed9c5817fdbc5$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $076ed9c5817fdbc5$var$get(this, key);
        },
        get size () {
            return $076ed9c5817fdbc5$var$size(this);
        },
        has: $076ed9c5817fdbc5$var$has,
        add: $076ed9c5817fdbc5$var$add,
        set: $076ed9c5817fdbc5$var$set,
        delete: $076ed9c5817fdbc5$var$deleteEntry,
        clear: $076ed9c5817fdbc5$var$clear,
        forEach: $076ed9c5817fdbc5$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $076ed9c5817fdbc5$var$get(this, key, false, true);
        },
        get size () {
            return $076ed9c5817fdbc5$var$size(this);
        },
        has: $076ed9c5817fdbc5$var$has,
        add: $076ed9c5817fdbc5$var$add,
        set: $076ed9c5817fdbc5$var$set,
        delete: $076ed9c5817fdbc5$var$deleteEntry,
        clear: $076ed9c5817fdbc5$var$clear,
        forEach: $076ed9c5817fdbc5$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $076ed9c5817fdbc5$var$get(this, key, true);
        },
        get size () {
            return $076ed9c5817fdbc5$var$size(this, true);
        },
        has (key) {
            return $076ed9c5817fdbc5$var$has.call(this, key, true);
        },
        add: $076ed9c5817fdbc5$var$createReadonlyMethod("add"),
        set: $076ed9c5817fdbc5$var$createReadonlyMethod("set"),
        delete: $076ed9c5817fdbc5$var$createReadonlyMethod("delete"),
        clear: $076ed9c5817fdbc5$var$createReadonlyMethod("clear"),
        forEach: $076ed9c5817fdbc5$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $076ed9c5817fdbc5$var$get(this, key, true, true);
        },
        get size () {
            return $076ed9c5817fdbc5$var$size(this, true);
        },
        has (key) {
            return $076ed9c5817fdbc5$var$has.call(this, key, true);
        },
        add: $076ed9c5817fdbc5$var$createReadonlyMethod("add"),
        set: $076ed9c5817fdbc5$var$createReadonlyMethod("set"),
        delete: $076ed9c5817fdbc5$var$createReadonlyMethod("delete"),
        clear: $076ed9c5817fdbc5$var$createReadonlyMethod("clear"),
        forEach: $076ed9c5817fdbc5$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $076ed9c5817fdbc5$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $076ed9c5817fdbc5$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $076ed9c5817fdbc5$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $076ed9c5817fdbc5$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$076ed9c5817fdbc5$var$mutableInstrumentations, $076ed9c5817fdbc5$var$readonlyInstrumentations, $076ed9c5817fdbc5$var$shallowInstrumentations, $076ed9c5817fdbc5$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $076ed9c5817fdbc5$var$createInstrumentations();
function $076ed9c5817fdbc5$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $076ed9c5817fdbc5$var$shallowReadonlyInstrumentations : $076ed9c5817fdbc5$var$shallowInstrumentations : isReadonly ? $076ed9c5817fdbc5$var$readonlyInstrumentations : $076ed9c5817fdbc5$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $j3cSI.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $076ed9c5817fdbc5$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $076ed9c5817fdbc5$var$createInstrumentationGetter(false, false)
};
const $076ed9c5817fdbc5$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $076ed9c5817fdbc5$var$createInstrumentationGetter(false, true)
};
const $076ed9c5817fdbc5$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $076ed9c5817fdbc5$var$createInstrumentationGetter(true, false)
};
const $076ed9c5817fdbc5$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $076ed9c5817fdbc5$var$createInstrumentationGetter(true, true)
};
function $076ed9c5817fdbc5$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $j3cSI.toRawType)(target);
        $076ed9c5817fdbc5$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $076ed9c5817fdbc5$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $076ed9c5817fdbc5$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $076ed9c5817fdbc5$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $076ed9c5817fdbc5$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $076ed9c5817fdbc5$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $076ed9c5817fdbc5$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $076ed9c5817fdbc5$var$targetTypeMap((0, $j3cSI.toRawType)(value));
}
function $076ed9c5817fdbc5$export$90a44edba14e47be(target) {
    if ($076ed9c5817fdbc5$export$92d09b48637741e7(target)) return target;
    return $076ed9c5817fdbc5$var$createReactiveObject(target, false, $076ed9c5817fdbc5$var$mutableHandlers, $076ed9c5817fdbc5$var$mutableCollectionHandlers, $076ed9c5817fdbc5$var$reactiveMap);
}
function $076ed9c5817fdbc5$export$8d81cefd22d22260(target) {
    return $076ed9c5817fdbc5$var$createReactiveObject(target, false, $076ed9c5817fdbc5$var$shallowReactiveHandlers, $076ed9c5817fdbc5$var$shallowCollectionHandlers, $076ed9c5817fdbc5$var$shallowReactiveMap);
}
function $076ed9c5817fdbc5$export$6ec456bd5b7b3c51(target) {
    return $076ed9c5817fdbc5$var$createReactiveObject(target, true, $076ed9c5817fdbc5$var$readonlyHandlers, $076ed9c5817fdbc5$var$readonlyCollectionHandlers, $076ed9c5817fdbc5$var$readonlyMap);
}
function $076ed9c5817fdbc5$export$7c4b5f2b50f09f6b(target) {
    return $076ed9c5817fdbc5$var$createReactiveObject(target, true, $076ed9c5817fdbc5$var$shallowReadonlyHandlers, $076ed9c5817fdbc5$var$shallowReadonlyCollectionHandlers, $076ed9c5817fdbc5$var$shallowReadonlyMap);
}
function $076ed9c5817fdbc5$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $j3cSI.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $076ed9c5817fdbc5$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $076ed9c5817fdbc5$export$352205f445242f02(value) {
    if ($076ed9c5817fdbc5$export$92d09b48637741e7(value)) return $076ed9c5817fdbc5$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $076ed9c5817fdbc5$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $076ed9c5817fdbc5$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $076ed9c5817fdbc5$export$5f3ca29d057519b3(value) {
    return $076ed9c5817fdbc5$export$352205f445242f02(value) || $076ed9c5817fdbc5$export$92d09b48637741e7(value);
}
function $076ed9c5817fdbc5$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $076ed9c5817fdbc5$export$ab18938b9fc5f28e(raw) : observed;
}
function $076ed9c5817fdbc5$export$995ab8b13ad7a9d0(value) {
    if (Object.isExtensible(value)) (0, $j3cSI.def)(value, "__v_skip", true);
    return value;
}
const $076ed9c5817fdbc5$var$toReactive = (value)=>(0, $j3cSI.isObject)(value) ? $076ed9c5817fdbc5$export$90a44edba14e47be(value) : value;
const $076ed9c5817fdbc5$var$toReadonly = (value)=>(0, $j3cSI.isObject)(value) ? $076ed9c5817fdbc5$export$6ec456bd5b7b3c51(value) : value;
const $076ed9c5817fdbc5$var$COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class $076ed9c5817fdbc5$var$ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new $076ed9c5817fdbc5$export$28352bb4dd362521(()=>getter(this._value), ()=>$076ed9c5817fdbc5$var$triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(this);
        if ((!self._cacheable || self.effect.dirty) && (0, $j3cSI.hasChanged)(self._value, self._value = self.effect.run())) $076ed9c5817fdbc5$var$triggerRefValue(self, 4);
        $076ed9c5817fdbc5$var$trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) $076ed9c5817fdbc5$var$triggerRefValue(self, 2);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function $076ed9c5817fdbc5$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $j3cSI.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $j3cSI.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $076ed9c5817fdbc5$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function $076ed9c5817fdbc5$var$trackRefValue(ref2) {
    var _a;
    if ($076ed9c5817fdbc5$var$shouldTrack && $076ed9c5817fdbc5$var$activeEffect) {
        ref2 = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(ref2);
        $076ed9c5817fdbc5$var$trackEffect($076ed9c5817fdbc5$var$activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = $076ed9c5817fdbc5$var$createDep(()=>ref2.dep = void 0, ref2 instanceof $076ed9c5817fdbc5$var$ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function $076ed9c5817fdbc5$var$triggerRefValue(ref2, dirtyLevel = 4, newVal) {
    ref2 = $076ed9c5817fdbc5$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $076ed9c5817fdbc5$var$triggerEffects(dep, dirtyLevel, void 0);
}
function $076ed9c5817fdbc5$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $076ed9c5817fdbc5$export$eff4d24c3ff7876e(value) {
    return $076ed9c5817fdbc5$var$createRef(value, false);
}
function $076ed9c5817fdbc5$export$9b7bc5fe3b17c8b3(value) {
    return $076ed9c5817fdbc5$var$createRef(value, true);
}
function $076ed9c5817fdbc5$var$createRef(rawValue, shallow) {
    if ($076ed9c5817fdbc5$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $076ed9c5817fdbc5$var$RefImpl(rawValue, shallow);
}
class $076ed9c5817fdbc5$var$RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $076ed9c5817fdbc5$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $076ed9c5817fdbc5$var$toReactive(value);
    }
    get value() {
        $076ed9c5817fdbc5$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $076ed9c5817fdbc5$export$7f3fe6025abfa26e(newVal) || $076ed9c5817fdbc5$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $076ed9c5817fdbc5$export$ab18938b9fc5f28e(newVal);
        if ((0, $j3cSI.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $076ed9c5817fdbc5$var$toReactive(newVal);
            $076ed9c5817fdbc5$var$triggerRefValue(this, 4, newVal);
        }
    }
}
function $076ed9c5817fdbc5$export$f402f86588575ccc(ref2) {
    $076ed9c5817fdbc5$var$triggerRefValue(ref2, 4, void 0);
}
function $076ed9c5817fdbc5$export$a239a76781616204(ref2) {
    return $076ed9c5817fdbc5$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $076ed9c5817fdbc5$export$30bdcc2218aa9458(source) {
    return (0, $j3cSI.isFunction)(source) ? source() : $076ed9c5817fdbc5$export$a239a76781616204(source);
}
const $076ed9c5817fdbc5$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$076ed9c5817fdbc5$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($076ed9c5817fdbc5$export$4f9f5282de18fc69(oldValue) && !$076ed9c5817fdbc5$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $076ed9c5817fdbc5$export$f353fd1b97db3fa0(objectWithRefs) {
    return $076ed9c5817fdbc5$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $076ed9c5817fdbc5$var$shallowUnwrapHandlers);
}
class $076ed9c5817fdbc5$var$CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$076ed9c5817fdbc5$var$trackRefValue(this), ()=>$076ed9c5817fdbc5$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $076ed9c5817fdbc5$export$a20c2dd6199824cb(factory) {
    return new $076ed9c5817fdbc5$var$CustomRefImpl(factory);
}
function $076ed9c5817fdbc5$export$2e9533675e5e70e0(object) {
    const ret = (0, $j3cSI.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $076ed9c5817fdbc5$var$propertyToRef(object, key);
    return ret;
}
class $076ed9c5817fdbc5$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $076ed9c5817fdbc5$var$getDepFromReactive($076ed9c5817fdbc5$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $076ed9c5817fdbc5$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function $076ed9c5817fdbc5$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($076ed9c5817fdbc5$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $j3cSI.isFunction)(source)) return new $076ed9c5817fdbc5$var$GetterRefImpl(source);
    else if ((0, $j3cSI.isObject)(source) && arguments.length > 1) return $076ed9c5817fdbc5$var$propertyToRef(source, key, defaultValue);
    else return $076ed9c5817fdbc5$export$eff4d24c3ff7876e(source);
}
function $076ed9c5817fdbc5$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $076ed9c5817fdbc5$export$4f9f5282de18fc69(val) ? val : new $076ed9c5817fdbc5$var$ObjectRefImpl(source, key, defaultValue);
}
const $076ed9c5817fdbc5$export$483264c4ec4c46ce = $076ed9c5817fdbc5$export$2983e091f1a1e8e2;
const $076ed9c5817fdbc5$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $076ed9c5817fdbc5$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $076ed9c5817fdbc5$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

});
parcelRegister("j3cSI", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $dde84a1dcd51f438$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $dde84a1dcd51f438$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $dde84a1dcd51f438$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $dde84a1dcd51f438$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $dde84a1dcd51f438$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $dde84a1dcd51f438$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $dde84a1dcd51f438$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $dde84a1dcd51f438$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $dde84a1dcd51f438$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $dde84a1dcd51f438$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $dde84a1dcd51f438$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $dde84a1dcd51f438$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $dde84a1dcd51f438$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $dde84a1dcd51f438$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $dde84a1dcd51f438$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $dde84a1dcd51f438$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $dde84a1dcd51f438$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $dde84a1dcd51f438$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $dde84a1dcd51f438$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $dde84a1dcd51f438$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $dde84a1dcd51f438$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $dde84a1dcd51f438$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $dde84a1dcd51f438$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $dde84a1dcd51f438$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $dde84a1dcd51f438$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $dde84a1dcd51f438$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $dde84a1dcd51f438$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $dde84a1dcd51f438$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $dde84a1dcd51f438$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $dde84a1dcd51f438$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $dde84a1dcd51f438$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $dde84a1dcd51f438$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $dde84a1dcd51f438$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $dde84a1dcd51f438$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $dde84a1dcd51f438$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $dde84a1dcd51f438$export$8756898546458274; });
$parcel$export(module.exports, "stringifyStyle", function () { return $dde84a1dcd51f438$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $dde84a1dcd51f438$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $dde84a1dcd51f438$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $dde84a1dcd51f438$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $dde84a1dcd51f438$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $dde84a1dcd51f438$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $dde84a1dcd51f438$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $dde84a1dcd51f438$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $dde84a1dcd51f438$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $dde84a1dcd51f438$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $dde84a1dcd51f438$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $dde84a1dcd51f438$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "looseEqual", function () { return $dde84a1dcd51f438$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $dde84a1dcd51f438$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $dde84a1dcd51f438$export$b5b1545233b45293; });
/**
* @vue/shared v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ function $dde84a1dcd51f438$export$b41394a5437791c8(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const $dde84a1dcd51f438$export$cf583d23ab39677c = {};
const $dde84a1dcd51f438$export$6bd8558f433f1cc1 = [];
const $dde84a1dcd51f438$export$5702a91a6f42969f = ()=>{};
const $dde84a1dcd51f438$export$c01351c0af048e39 = ()=>false;
const $dde84a1dcd51f438$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $dde84a1dcd51f438$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $dde84a1dcd51f438$export$8b58be045bf06082 = Object.assign;
const $dde84a1dcd51f438$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $dde84a1dcd51f438$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $dde84a1dcd51f438$export$b5a638e9b3fff9f3 = (val, key)=>$dde84a1dcd51f438$var$hasOwnProperty.call(val, key);
const $dde84a1dcd51f438$export$43bee75e5e14138e = Array.isArray;
const $dde84a1dcd51f438$export$5c90113a285f2241 = (val)=>$dde84a1dcd51f438$export$1dccc787cc36538b(val) === "[object Map]";
const $dde84a1dcd51f438$export$6750766a7c7ec627 = (val)=>$dde84a1dcd51f438$export$1dccc787cc36538b(val) === "[object Set]";
const $dde84a1dcd51f438$export$871608497c498473 = (val)=>$dde84a1dcd51f438$export$1dccc787cc36538b(val) === "[object Date]";
const $dde84a1dcd51f438$export$49841c62b9eff15 = (val)=>$dde84a1dcd51f438$export$1dccc787cc36538b(val) === "[object RegExp]";
const $dde84a1dcd51f438$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $dde84a1dcd51f438$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $dde84a1dcd51f438$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $dde84a1dcd51f438$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $dde84a1dcd51f438$export$4369c812aac99591 = (val)=>{
    return ($dde84a1dcd51f438$export$a6cdc56e425d0d0a(val) || $dde84a1dcd51f438$export$f6e2535fb5126e54(val)) && $dde84a1dcd51f438$export$f6e2535fb5126e54(val.then) && $dde84a1dcd51f438$export$f6e2535fb5126e54(val.catch);
};
const $dde84a1dcd51f438$export$830c053460e5ddf6 = Object.prototype.toString;
const $dde84a1dcd51f438$export$1dccc787cc36538b = (value)=>$dde84a1dcd51f438$export$830c053460e5ddf6.call(value);
const $dde84a1dcd51f438$export$5ad0a3c360b8fbb5 = (value)=>{
    return $dde84a1dcd51f438$export$1dccc787cc36538b(value).slice(8, -1);
};
const $dde84a1dcd51f438$export$53b83ca8eaab0383 = (val)=>$dde84a1dcd51f438$export$1dccc787cc36538b(val) === "[object Object]";
const $dde84a1dcd51f438$export$e2a2b93446ec9fe = (key)=>$dde84a1dcd51f438$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $dde84a1dcd51f438$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $dde84a1dcd51f438$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $dde84a1dcd51f438$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $dde84a1dcd51f438$var$camelizeRE = /-(\w)/g;
const $dde84a1dcd51f438$export$161d051f5dd25de7 = $dde84a1dcd51f438$var$cacheStringFunction((str)=>{
    return str.replace($dde84a1dcd51f438$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $dde84a1dcd51f438$var$hyphenateRE = /\B([A-Z])/g;
const $dde84a1dcd51f438$export$6e6a0a3676c4b8bb = $dde84a1dcd51f438$var$cacheStringFunction((str)=>str.replace($dde84a1dcd51f438$var$hyphenateRE, "-$1").toLowerCase());
const $dde84a1dcd51f438$export$9a00dee1beb8f576 = $dde84a1dcd51f438$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $dde84a1dcd51f438$export$8c022799eeaaefcd = $dde84a1dcd51f438$var$cacheStringFunction((str)=>{
    const s = str ? `on${$dde84a1dcd51f438$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $dde84a1dcd51f438$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $dde84a1dcd51f438$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $dde84a1dcd51f438$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $dde84a1dcd51f438$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $dde84a1dcd51f438$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $dde84a1dcd51f438$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $dde84a1dcd51f438$var$_globalThis;
const $dde84a1dcd51f438$export$ff5f2eeb11fc7e14 = ()=>{
    return $dde84a1dcd51f438$var$_globalThis || ($dde84a1dcd51f438$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $dde84a1dcd51f438$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $dde84a1dcd51f438$export$53d5e12f9a1d3cde(name) {
    return $dde84a1dcd51f438$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $dde84a1dcd51f438$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $dde84a1dcd51f438$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $dde84a1dcd51f438$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $dde84a1dcd51f438$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $dde84a1dcd51f438$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $dde84a1dcd51f438$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const $dde84a1dcd51f438$export$f73b8c13b7f97ebf = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$GLOBALS_ALLOWED);
const $dde84a1dcd51f438$export$d6571a1911e4f27e = $dde84a1dcd51f438$export$f73b8c13b7f97ebf;
const $dde84a1dcd51f438$var$range = 2;
function $dde84a1dcd51f438$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $dde84a1dcd51f438$var$range; j <= i + $dde84a1dcd51f438$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $dde84a1dcd51f438$export$8756898546458274(value) {
    if ($dde84a1dcd51f438$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $dde84a1dcd51f438$export$844ec244b1367d54(item) ? $dde84a1dcd51f438$export$76a205ce979d066a(item) : $dde84a1dcd51f438$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($dde84a1dcd51f438$export$844ec244b1367d54(value) || $dde84a1dcd51f438$export$a6cdc56e425d0d0a(value)) return value;
}
const $dde84a1dcd51f438$var$listDelimiterRE = /;(?![^(]*\))/g;
const $dde84a1dcd51f438$var$propertyDelimiterRE = /:([^]+)/;
const $dde84a1dcd51f438$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $dde84a1dcd51f438$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($dde84a1dcd51f438$var$styleCommentRE, "").split($dde84a1dcd51f438$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($dde84a1dcd51f438$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $dde84a1dcd51f438$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $dde84a1dcd51f438$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $dde84a1dcd51f438$export$6e6a0a3676c4b8bb(key);
        if ($dde84a1dcd51f438$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $dde84a1dcd51f438$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($dde84a1dcd51f438$export$844ec244b1367d54(value)) res = value;
    else if ($dde84a1dcd51f438$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $dde84a1dcd51f438$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($dde84a1dcd51f438$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $dde84a1dcd51f438$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$dde84a1dcd51f438$export$844ec244b1367d54(klass)) props.class = $dde84a1dcd51f438$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $dde84a1dcd51f438$export$8756898546458274(style);
    return props;
}
const $dde84a1dcd51f438$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $dde84a1dcd51f438$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $dde84a1dcd51f438$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $dde84a1dcd51f438$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $dde84a1dcd51f438$export$1ccf854a0984f890 = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$HTML_TAGS);
const $dde84a1dcd51f438$export$6328ce7565ea1049 = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$SVG_TAGS);
const $dde84a1dcd51f438$export$4a46ca4c5be17b20 = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$MATH_TAGS);
const $dde84a1dcd51f438$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$VOID_TAGS);
const $dde84a1dcd51f438$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $dde84a1dcd51f438$export$d186f5eb2e810715 = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$specialBooleanAttrs);
const $dde84a1dcd51f438$export$f763ba3b84e9cd8c = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8($dde84a1dcd51f438$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $dde84a1dcd51f438$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $dde84a1dcd51f438$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $dde84a1dcd51f438$var$attrValidationCache = {};
function $dde84a1dcd51f438$export$d55ef77660f30d12(name) {
    if ($dde84a1dcd51f438$var$attrValidationCache.hasOwnProperty(name)) return $dde84a1dcd51f438$var$attrValidationCache[name];
    const isUnsafe = $dde84a1dcd51f438$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $dde84a1dcd51f438$var$attrValidationCache[name] = !isUnsafe;
}
const $dde84a1dcd51f438$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $dde84a1dcd51f438$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $dde84a1dcd51f438$export$80da416f43933831 = /* @__PURE__ */ $dde84a1dcd51f438$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $dde84a1dcd51f438$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $dde84a1dcd51f438$var$escapeRE = /["'&<>]/;
function $dde84a1dcd51f438$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $dde84a1dcd51f438$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $dde84a1dcd51f438$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $dde84a1dcd51f438$export$7b105034a53bde5f(src) {
    return src.replace($dde84a1dcd51f438$var$commentStripRE, "");
}
function $dde84a1dcd51f438$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $dde84a1dcd51f438$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $dde84a1dcd51f438$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $dde84a1dcd51f438$export$871608497c498473(a);
    let bValidType = $dde84a1dcd51f438$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $dde84a1dcd51f438$export$a244864fd9645c7f(a);
    bValidType = $dde84a1dcd51f438$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $dde84a1dcd51f438$export$43bee75e5e14138e(a);
    bValidType = $dde84a1dcd51f438$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $dde84a1dcd51f438$var$looseCompareArrays(a, b) : false;
    aValidType = $dde84a1dcd51f438$export$a6cdc56e425d0d0a(a);
    bValidType = $dde84a1dcd51f438$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$dde84a1dcd51f438$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $dde84a1dcd51f438$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$dde84a1dcd51f438$export$ae8015769846262c(item, val));
}
const $dde84a1dcd51f438$export$b5b1545233b45293 = (val)=>{
    return $dde84a1dcd51f438$export$844ec244b1367d54(val) ? val : val == null ? "" : $dde84a1dcd51f438$export$43bee75e5e14138e(val) || $dde84a1dcd51f438$export$a6cdc56e425d0d0a(val) && (val.toString === $dde84a1dcd51f438$export$830c053460e5ddf6 || !$dde84a1dcd51f438$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $dde84a1dcd51f438$var$replacer, 2) : String(val);
};
const $dde84a1dcd51f438$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $dde84a1dcd51f438$var$replacer(_key, val.value);
    else if ($dde84a1dcd51f438$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$dde84a1dcd51f438$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($dde84a1dcd51f438$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$dde84a1dcd51f438$var$stringifySymbol(v))
    };
    else if ($dde84a1dcd51f438$export$a244864fd9645c7f(val)) return $dde84a1dcd51f438$var$stringifySymbol(val);
    else if ($dde84a1dcd51f438$export$a6cdc56e425d0d0a(val) && !$dde84a1dcd51f438$export$43bee75e5e14138e(val) && !$dde84a1dcd51f438$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $dde84a1dcd51f438$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return $dde84a1dcd51f438$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v;
};

});





parcelRegister("35roy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $23f716cfedb0a4e1$export$2e2bcd8739ae039; });
parcelRequire("1FCkY");
var $aPlzd = parcelRequire("aPlzd");
parcelRequire("8h94B");
var $9FG0d = parcelRequire("9FG0d");
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $Dz4HH = parcelRequire("Dz4HH");

var $59lkq = parcelRequire("59lkq");

var $gmBfx = parcelRequire("gmBfx");

var $k56Uj = parcelRequire("k56Uj");

const $23f716cfedb0a4e1$var$perPage = 12;
const $23f716cfedb0a4e1$var$minPrice = 50000;
const $23f716cfedb0a4e1$var$maxPrice = 10000000;
var $23f716cfedb0a4e1$export$2e2bcd8739ae039 = {
    __name: "App",
    setup (__props, { expose: __expose }) {
        __expose();
        const router = (0, $59lkq.useRouter)();
        const mainPaginationArray = (0, $Dz4HH.ref)([]);
        const showDesc = (0, $Dz4HH.ref)(true);
        const filtersActive = (0, $Dz4HH.ref)(false);
        const currentPage = (0, $Dz4HH.ref)(1);
        const swiperInstances = (0, $Dz4HH.ref)([]);
        const params = (0, $Dz4HH.ref)({
            currentPage: "",
            initial: "",
            city: "",
            size: "",
            plotSize: "",
            yearBuiltStart: "",
            yearBuiltEnd: "",
            order: "",
            bathrooms: "",
            bedrooms: "",
            type: "",
            sTerm: "",
            priceRange: "",
            seaView: "",
            seaFront: "",
            waterFront: "",
            nearTheSea: "",
            beachFront: "",
            mountainView: "",
            riverView: "",
            lakeView: "",
            nearTown: "",
            village: "",
            heatedPool: "",
            outdoorPool: "",
            indoorPool: "",
            boatMooring: "",
            garage: "",
            hotTub: "",
            vineyard: "",
            gym: "",
            sauna: "",
            wineCellar: "",
            tennisCourt: "",
            gameRoom: "",
            garden: "",
            terrace: "",
            balcony: "",
            outdoorKitchen: "",
            elevator: ""
        });
        let properties = (0, $Dz4HH.ref)({});
        let showBtn = (0, $Dz4HH.ref)(false);
        let categories = (0, $Dz4HH.ref)({});
        let regions = (0, $Dz4HH.ref)({});
        let pageContent = (0, $Dz4HH.ref)({});
        let termCity = (0, $Dz4HH.ref)("not-selected");
        let order = (0, $Dz4HH.ref)("not-selected");
        let min = (0, $Dz4HH.ref)("");
        let max = (0, $Dz4HH.ref)("");
        let searchTerm = (0, $Dz4HH.ref)("");
        const minSize = (0, $Dz4HH.ref)(0);
        const maxSize = (0, $Dz4HH.ref)(2000);
        let minPlotSize = (0, $Dz4HH.ref)(0);
        let maxPlotSize = (0, $Dz4HH.ref)(200000);
        let termSubCity = (0, $Dz4HH.ref)("not-selected");
        let termSubCityList = (0, $Dz4HH.ref)([]);
        let propertyTypeList = (0, $Dz4HH.ref)([]);
        let propertyType = (0, $Dz4HH.ref)("not-selected");
        let bedrooms = (0, $Dz4HH.ref)("not-selected");
        let bathrooms = (0, $Dz4HH.ref)("not-selected");
        let seaView = (0, $Dz4HH.ref)(false);
        let waterFront = (0, $Dz4HH.ref)(false);
        let nearTheSea = (0, $Dz4HH.ref)(false);
        let beachFront = (0, $Dz4HH.ref)(false);
        let mountainView = (0, $Dz4HH.ref)(false);
        let riverView = (0, $Dz4HH.ref)(false);
        let lakeView = (0, $Dz4HH.ref)(false);
        let nearTown = (0, $Dz4HH.ref)(false);
        let village = (0, $Dz4HH.ref)(false);
        let heatedPool = (0, $Dz4HH.ref)(false);
        let outdoorPool = (0, $Dz4HH.ref)(false);
        let indoorPool = (0, $Dz4HH.ref)(false);
        let boatMooring = (0, $Dz4HH.ref)(false);
        let garage = (0, $Dz4HH.ref)(false);
        let hotTub = (0, $Dz4HH.ref)(false);
        let vineyard = (0, $Dz4HH.ref)(false);
        let gym = (0, $Dz4HH.ref)(false);
        let sauna = (0, $Dz4HH.ref)(false);
        let wineCellar = (0, $Dz4HH.ref)(false);
        let tennisCourt = (0, $Dz4HH.ref)(false);
        let gameRoom = (0, $Dz4HH.ref)(false);
        let garden = (0, $Dz4HH.ref)(false);
        let terrace = (0, $Dz4HH.ref)(false);
        let balcony = (0, $Dz4HH.ref)(false);
        let outdoorKitchen = (0, $Dz4HH.ref)(false);
        let elevator = (0, $Dz4HH.ref)(false);
        let yearBuiltStart = (0, $Dz4HH.ref)("");
        let yearBuiltEnd = (0, $Dz4HH.ref)("");
        let initial = (0, $Dz4HH.ref)(false);
        let loading = (0, $Dz4HH.ref)(false);
        const translations = (0, $gmBfx.getTranslation)(getLangCode);
        // PRICE RANGE
        const priceRange = (0, $Dz4HH.ref)([
            $23f716cfedb0a4e1$var$minPrice,
            $23f716cfedb0a4e1$var$maxPrice
        ]);
        const sizeRange = (0, $Dz4HH.ref)([
            minSize.value,
            maxSize.value
        ]);
        const tempMinSize = (0, $Dz4HH.ref)(minSize.value);
        const tempMaxSize = (0, $Dz4HH.ref)(maxSize.value);
        const plotSizeData = [
            0,
            100,
            200,
            300,
            400,
            500,
            600,
            700,
            800,
            900,
            1000,
            1500,
            2000,
            2500,
            3000,
            3500,
            4000,
            5000,
            10000,
            20000,
            30000,
            40000,
            50000,
            75000,
            100000,
            150000,
            200000
        ];
        const plotSizeMarks = {
            0: "0",
            400: "400",
            800: "800",
            1000: "1k",
            5000: "5k",
            10000: "10k",
            200000: "200k"
        };
        const plotSizeRange = (0, $Dz4HH.ref)([
            minPlotSize.value,
            maxPlotSize.value
        ]);
        const tempMinPlotSize = (0, $Dz4HH.ref)(plotSizeRange.value[0]);
        const tempMaxPlotSize = (0, $Dz4HH.ref)(plotSizeRange.value[1]);
        let contents = new URL(MyScriptVars.rest_url + "contents");
        // Object.keys(params.value).forEach(key => url.searchParams.append(key, params.value[key]));
        const maxPages = (0, $9pglz.computed)(()=>{
            return Math.ceil(properties.value.count / $23f716cfedb0a4e1$var$perPage);
        });
        (0, $9pglz.watch)(termCity, (after)=>{
            if (initial.value !== false) {
                termSubCity.value = "not-selected";
                termSubCityList.value = properties.value.city.filter((city)=>{
                    return parseInt(city.parent) === parseInt(after);
                });
            }
        });
        // Input changes → update slider
        (0, $9pglz.watch)([
            tempMinSize,
            tempMaxSize
        ], ([newMin, newMax])=>{
            sizeRange.value = [
                newMin,
                newMax
            ];
        });
        // Slider changes → update input
        (0, $9pglz.watch)(sizeRange, ([minVal, maxVal])=>{
            if (minVal > maxVal) // Prevent weird slider behavior
            sizeRange.value = [
                maxVal,
                maxVal
            ];
            tempMinSize.value = minVal;
            tempMaxSize.value = maxVal;
        });
        (0, $9pglz.watch)([
            tempMinPlotSize,
            tempMaxPlotSize
        ], ([newMin, newMax])=>{
            plotSizeRange.value = [
                newMin,
                newMax
            ];
        });
        (0, $9pglz.watch)(plotSizeRange, ([minVal, maxVal])=>{
            if (minVal > maxVal) plotSizeRange.value = [
                maxVal,
                maxVal
            ];
            tempMinPlotSize.value = minVal;
            tempMaxPlotSize.value = maxVal;
        });
        const userContent = (0, $Dz4HH.ref)({
            firstPart: "",
            secondPart: ""
        });
        async function fetchData() {
            try {
                loading.value = true;
                let url = new URL(MyScriptVars.rest_url + "properties");
                params.value.initial = "true";
                params.value.croatiaPropertyID = croatiaPageID;
                Object.keys(params.value).forEach((key)=>url.searchParams.append(key, params.value[key]));
                const propertiesResponse = await fetch(url, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!propertiesResponse.ok) throw new Error("Network response was not ok for properties");
                properties.value = await propertiesResponse.json();
                setRegions();
                loading.value = false;
            } catch (error) {
                console.error("Fetch operation failed:", error);
            }
        }
        const showText = ()=>{
            showDesc.value = true;
            showBtn.value = false;
            userContent.value.firstPart = properties.value.content;
        };
        const setRegions = ()=>{
            regions.value = properties.value.city.filter((city)=>{
                return !city.parent;
            });
            console.log("dela", regions.value);
            propertyTypeList.value = properties.value.type;
            console.log("del2a", propertyTypeList.value);
            console.log("del3333", properties.value.selectedTerm);
            if (properties.value.selectedTerm) {
                if (properties.value.selectedTerm.parent) {
                    termCity.value = properties.value.selectedTerm.parent;
                    termSubCityList.value = properties.value.city.filter((city)=>{
                        return parseInt(city.parent) === parseInt(properties.value.selectedTerm.parent);
                    });
                    termSubCity.value = properties.value.selectedTerm.term_id;
                } else termCity.value = properties.value.selectedTerm.term_id;
            }
            if (properties.value.selectedType) propertyType.value = properties.value.selectedType.term_id;
            console.log("termCity", termCity.value);
            console.log("sub", termSubCity.value);
        };
        const wordCount = (str)=>{
            if (str) return str.split(" ").length;
            return 0;
        };
        const cutSentence = (str, start, end)=>{
            return str.split(" ").splice(start, end).join(" ") + "...";
        };
        const showMoreFilters = ()=>{
            document.body.classList.add("overflow");
            filtersActive.value = true;
        };
        const hideMoreFilters = ()=>{
            document.body.classList.remove("overflow");
            filtersActive.value = false;
        };
        const getPropertyPermalink = (property)=>{
            if (!property) return "";
            if (getLangCode == "de") return property.permalink_de;
            if (getLangCode == "hr") return property.permalink_hr;
            if (getLangCode == "cs") return property.permalink_cs;
            if (getLangCode == "es") return property.permalink_es;
            if (getLangCode == "fr") return property.permalink_fr;
            if (getLangCode == "sl") return property.permalink_sl;
            if (getLangCode == "hu") return property.permalink_hu;
            if (getLangCode == "pl") return property.permalink_pl;
            if (getLangCode == "fi") return property.permalink_fi;
            if (getLangCode == "no") return property.permalink_no;
            if (getLangCode == "sv") return property.permalink_sv;
            if (getLangCode == "sk") return property.permalink_sk;
            if (getLangCode == "it") return property.permalink_it;
            if (getLangCode == "uk") return property.permalink_uk;
            if (getLangCode == "nl") return property.permalink_nl;
            return property.permalink;
        };
        const getPropertyTitle = (property)=>{
            if (!property) return "";
            if (getLangCode == "de") return property.title_de;
            if (getLangCode == "hr") return property.title_hr;
            if (getLangCode == "cs") return property.title_cs;
            if (getLangCode == "es") return property.title_es;
            if (getLangCode == "fr") return property.title_fr;
            if (getLangCode == "sl") return property.title_sl;
            if (getLangCode == "hu") return property.title_hu;
            if (getLangCode == "pl") return property.title_pl;
            if (getLangCode == "fi") return property.title_fi;
            if (getLangCode == "no") return property.title_no;
            if (getLangCode == "sv") return property.title_sv;
            if (getLangCode == "sk") return property.title_sk;
            if (getLangCode == "it") return property.title_it;
            if (getLangCode == "uk") return property.title_uk;
            if (getLangCode == "nl") return property.title_nl;
            return property.title;
        };
        const getPropertyCategory = (termCategory)=>{
            if (!termCategory) return "";
            if (getLangCode == "de") return termCategory.name_de;
            if (getLangCode == "hr") return termCategory.name_hr;
            if (getLangCode == "cs") return termCategory.name_cs;
            if (getLangCode == "es") return termCategory.name_es;
            if (getLangCode == "fr") return termCategory.name_fr;
            if (getLangCode == "sl") return termCategory.name_sl;
            if (getLangCode == "hu") return termCategory.name_hu;
            if (getLangCode == "pl") return termCategory.name_pl;
            if (getLangCode == "fi") return termCategory.name_fi;
            if (getLangCode == "no") return termCategory.name_no;
            if (getLangCode == "sv") return termCategory.name_sv;
            if (getLangCode == "sk") return termCategory.name_sk;
            if (getLangCode == "it") return termCategory.name_it;
            if (getLangCode == "uk") return termCategory.name_uk;
            if (getLangCode == "nl") return termCategory.name_nl;
            return termCategory.name;
        };
        const getCategoryPermalink = (category)=>{
            if (!category) return "";
            if (getLangCode == "de") return category.permalink_de;
            if (getLangCode == "hr") return category.permalink_hr;
            if (getLangCode == "cs") return category.permalink_cs;
            if (getLangCode == "es") return category.permalink_es;
            return category.permalink;
        };
        const getBasePrice = (price)=>{
            let basePrice = price.replaceAll(",", "");
            basePrice = basePrice.replaceAll(".", "");
            return basePrice;
        };
        const updateVisibleImageSources = (swiper)=>{
            const slides = swiper.slides;
            const activeIndex = swiper.activeIndex;
            const prevIndex = activeIndex - 1;
            const nextIndex = activeIndex + 1;
            [
                activeIndex,
                prevIndex,
                nextIndex
            ].forEach((index)=>{
                if (index >= 0 && index < slides.length) {
                    const img = slides[index].querySelector("img");
                    if (img && !img.src && img.dataset.src) img.src = img.dataset.src;
                }
            });
        };
        const initSwipers = ()=>{
            swiperInstances.value.forEach((swiper)=>{
                swiper.destroy(true, true);
            });
            swiperInstances.value = [];
            (0, $9pglz.nextTick)(()=>{
                const swiperElements = document.querySelectorAll(".swiper-property");
                swiperElements.forEach((el)=>{
                    const swiper = new (0, $aPlzd.S)(el, {
                        modules: [
                            (0, $9FG0d.default)
                        ],
                        speed: 600,
                        slidesPerView: 1,
                        lazy: true,
                        preloadImages: false,
                        spaceBetween: 0,
                        navigation: {
                            prevEl: el.querySelector(".swiper-button-prev"),
                            nextEl: el.querySelector(".swiper-button-next")
                        },
                        on: {
                            slideChange: function() {
                                updateVisibleImageSources(this);
                            }
                        }
                    });
                    const prevButton = el.querySelector(".swiper-button-prev");
                    const nextButton = el.querySelector(".swiper-button-next");
                    if (prevButton) prevButton.addEventListener("click", ()=>updateVisibleImageSources(swiper));
                    if (nextButton) nextButton.addEventListener("click", ()=>updateVisibleImageSources(swiper));
                    swiperInstances.value.push(swiper);
                });
            });
        };
        const calculatePaginationArray = (currentPage, totalPages)=>{
            const _currentPage = parseInt(currentPage);
            const _totalPages = parseInt(totalPages);
            const paginationArray = [];
            const contextCount = 2; // Number of pages before and after the current page
            // If there are less than 12 pages, return [1]
            if (_totalPages === 0) {
                mainPaginationArray.value = [
                    1
                ];
                return;
            }
            if (_totalPages < 2) {
                mainPaginationArray.value = [
                    1
                ];
                return;
            }
            // Always include the first page
            paginationArray.push(1);
            // Calculate the range of pages to display around the current page
            let startPage = Math.max(2, _currentPage - contextCount);
            let endPage = Math.min(_totalPages - 1, _currentPage + contextCount);
            // Determine if ellipses are needed before the context pages
            if (startPage > 2) paginationArray.push("...");
            // Add the context pages
            for(let i = startPage; i <= endPage; i++)paginationArray.push(i);
            // Determine if ellipses are needed after the context pages
            if (endPage < _totalPages - 1) paginationArray.push("...");
            // Always include the last page if more than one page
            if (_totalPages > 1) paginationArray.push(_totalPages);
            mainPaginationArray.value = paginationArray;
        };
        const setWidth = ()=>{
            const overflowText = document.querySelectorAll(".overflow-calc");
            overflowText.forEach((text)=>{
                const width = text.parentElement.offsetWidth;
                text.style.maxWidth = `${width - 1}px`;
                text.style.whiteSpace = "nowrap";
            });
        };
        (0, $9pglz.onMounted)(async ()=>{
            await (0, $9pglz.nextTick)();
            setTimeout(async ()=>{
                if (Object.keys(router?.currentRoute?.value?.query).length > 0) {
                    setParamsFromRouteQuery(router.currentRoute.value.query);
                    await filterProperties();
                } else await fetchData();
                initial.value = true;
                calculatePaginationArray(currentPage.value, maxPages.value);
                initSwipers();
                hideDescription();
                setWidth();
                window.addEventListener("resize", setWidth);
                checkIfFavorite();
            }, 500);
        });
        const hideDescription = ()=>{
            let contentLength = wordCount(properties.value.content);
            if (contentLength > 70) {
                userContent.value.firstPart = cutSentence(properties.value.content, 0, 70);
                showBtn.value = true;
            } else userContent.value.firstPart = properties.value.content;
        };
        const changePage = async (page)=>{
            loading.value = true;
            currentPage.value = page;
            const changeUrl = setUrl();
            if (initial.value) addRouteQuery();
            calculatePaginationArray(currentPage.value, maxPages.value);
            scrollToPropertiesScroll();
            try {
                const propertiesResponse = await fetch(changeUrl, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!propertiesResponse.ok) throw new Error("Network response was not ok for properties");
                properties.value = await propertiesResponse.json();
                initSwipers();
                setTimeout(()=>{
                    updatePrices();
                }, 300);
                loading.value = false;
            } catch (e) {
                console.log(e);
            }
        };
        const updatePrices = ()=>{
            const conversionRates = {
                euro: 1,
                dollar: 1.1,
                pound: 0.85
            };
            const prices = document.querySelectorAll(".change-price");
            const currency = document.querySelector('select[data-function="changeCurrency"]');
            prices.forEach((priceElement)=>{
                const basePrice = priceElement.getAttribute("data-base-price");
                // Check if base price is a number, ignore if it's a string like "Price upon request"
                if (!isNaN(basePrice)) {
                    const convertedPrice = parseFloat(basePrice) * conversionRates[currency.value];
                    priceElement.textContent = formatCurrency(convertedPrice, currency.value);
                } else // If the base price is not a number, leave it as is
                priceElement.textContent = basePrice;
            });
        };
        const formatCurrency = (value, currency)=>{
            const currencySymbols = {
                euro: "\u20AC",
                dollar: "$",
                pound: "\xa3"
            };
            const symbol = currencySymbols[currency.toLowerCase()] || "\u20AC";
            // Custom formatter for the number
            const formattedNumber = value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return `${symbol} ${formattedNumber}`;
        };
        const scrollToTop = ()=>{
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        };
        const scrollToPropertiesScroll = ()=>{
            const element = document.getElementById("properties-scroll");
            const elementRect = element.getBoundingClientRect(); // Get the position of the element relative to the viewport
            const absoluteElementTop = elementRect.top + window.pageYOffset; // Calculate the absolute top position
            const offsetPosition = absoluteElementTop - 50; // Subtract 50 pixels to apply the offset
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        };
        const filterClick = ()=>{
            currentPage.value = 1;
            hideMoreFilters();
            filterProperties();
        };
        const filterProperties = async ()=>{
            // currentPage.value = 1;
            loading.value = true;
            const changeUrl = setUrl();
            scrollToPropertiesScroll();
            if (initial.value) addRouteQuery();
            try {
                const propertiesResponse = await fetch(changeUrl, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!propertiesResponse.ok) throw new Error("Network response was not ok for properties");
                properties.value = await propertiesResponse.json();
                setRegions();
                if (termCity !== "not-selected" && !initial.value) termSubCityList.value = properties.value.city.filter((city)=>{
                    return parseInt(city.parent) === parseInt(termCity.value);
                });
                if (properties.value.count === 0) mainPaginationArray.value = [];
                else calculatePaginationArray(currentPage.value, maxPages.value);
                hideMoreFilters();
                initSwipers();
                setTimeout(()=>{
                    updatePrices();
                    updateLanguageUrls();
                }, 300);
                loading.value = false;
            } catch (e) {
                console.log(e);
            }
        };
        const addRouteQuery = ()=>{
            const queryParams = {};
            Object.entries(params.value).forEach(([key, value])=>{
                if (value !== "" && value !== undefined && value !== null) queryParams[key] = value;
            });
            router.push({
                query: queryParams
            });
        };
        const setParamsFromRouteQuery = (routerParam)=>{
            if (routerParam.minPrice && routerParam.maxPrice) priceRange.value = [
                routerParam.minPrice,
                routerParam.maxPrice
            ];
            params.value.croatiaPropertyID = croatiaPageID;
            currentPage.value = parseInt(routerParam.currentPage) ?? 1;
            termCity.value = routerParam.filterCityId || "not-selected";
            termSubCity.value = routerParam.filterSubCityId || "not-selected";
            if (routerParam.size) {
                const [min, max] = routerParam.size.split("-");
                const minNum = Number(min);
                const maxNum = Number(max);
                if (!isNaN(minNum) && !isNaN(maxNum)) sizeRange.value = [
                    minNum,
                    maxNum
                ];
            }
            if (routerParam.plotSize) {
                const [minPlot, maxPlot] = routerParam.plotSize.split("-");
                const minPlotNum = Number(minPlot);
                const maxPlotNum = Number(maxPlot);
                if (!isNaN(minPlotNum) && !isNaN(maxPlotNum)) {
                    plotSizeRange.value = [
                        minPlotNum,
                        maxPlotNum
                    ];
                    tempMinPlotSize.value = minPlotNum;
                    tempMaxPlotSize.value = maxPlotNum;
                }
            }
            order.value = routerParam.order || "not-selected";
            propertyType.value = routerParam.type || "not-selected";
            searchTerm.value = routerParam.sTerm || "";
            bedrooms.value = routerParam.bedrooms || "not-selected";
            bathrooms.value = routerParam.bathrooms || "not-selected";
            seaView.value = !!routerParam.seaView;
            waterFront.value = !!routerParam.waterFront;
            nearTheSea.value = !!routerParam.nearTheSea;
            beachFront.value = !!routerParam.beachFront;
            mountainView.value = !!routerParam.mountainView;
            riverView.value = !!routerParam.riverView;
            lakeView.value = !!routerParam.lakeView;
            nearTown.value = !!routerParam.nearTown;
            village.value = !!routerParam.village;
            heatedPool.value = !!routerParam.heatedPool;
            outdoorKitchen.value = !!routerParam.outdoorKitchen;
            outdoorPool.value = !!routerParam.outdoorPool;
            indoorPool.value = !!routerParam.indoorPool;
            boatMooring.value = !!routerParam.boatMooring;
            garage.value = !!routerParam.garage;
            hotTub.value = !!routerParam.hotTub;
            vineyard.value = !!routerParam.vineyard;
            gym.value = !!routerParam.gym;
            sauna.value = !!routerParam.sauna;
            wineCellar.value = !!routerParam.wineCellar;
            tennisCourt.value = !!routerParam.tennisCourt;
            garden.value = !!routerParam.garden;
            terrace.value = !!routerParam.terrace;
            elevator.value = !!routerParam.elevator;
            yearBuiltStart.value = routerParam.yearBuiltStart || "";
            yearBuiltEnd.value = routerParam.yearBuiltStart || "";
        };
        const clearFilters = ()=>{
            params.value = {
                currentPage: currentPage.value,
                city: "",
                size: "",
                plotSize: "",
                yearBuiltStart: "",
                yearBuiltEnd: "",
                order: "",
                bathrooms: "",
                bedrooms: "",
                type: "",
                sTerm: "",
                priceRange: "",
                seaView: "",
                seaFront: "",
                waterFront: "",
                nearTheSea: "",
                beachFront: "",
                mountainView: "",
                riverView: "",
                lakeView: "",
                nearTown: "",
                village: "",
                heatedPool: "",
                outdoorPool: "",
                indoorPool: "",
                boatMooring: "",
                garage: "",
                hotTub: "",
                vineyard: "",
                gym: "",
                sauna: "",
                wineCellar: "",
                tennisCourt: "",
                gameRoom: "",
                garden: "",
                terrace: "",
                balcony: "",
                outdoorKitchen: "",
                elevator: ""
            };
            termCity.value = "not-selected";
            order.value = "not-selected";
            min.value = "";
            max.value = "";
            sizeRange.value = [
                minSize.value,
                maxSize.value
            ];
            searchTerm.value = "";
            minSize.value = sizeRange.value[0];
            maxSize.value = sizeRange.value[1];
            plotSizeRange.value = [
                minPlotSize,
                maxPlotSize
            ];
            tempMinPlotSize.value = 0;
            tempMaxPlotSize.value = 200000;
            minPlotSize.value = 0;
            maxPlotSize.value = 200000;
            termSubCity.value = "not-selected";
            termSubCityList.value = [];
            propertyType.value = "not-selected";
            bedrooms.value = "not-selected";
            bathrooms.value = "not-selected";
            seaView.value = false;
            waterFront.value = false;
            nearTheSea.value = false;
            beachFront.value = false;
            mountainView.value = false;
            riverView.value = false;
            lakeView.value = false;
            nearTown.value = false;
            village.value = false;
            heatedPool.value = false;
            outdoorPool.value = false;
            indoorPool.value = false;
            boatMooring.value = false;
            garage.value = false;
            hotTub.value = false;
            vineyard.value = false;
            gym.value = false;
            sauna.value = false;
            wineCellar.value = false;
            tennisCourt.value = false;
            gameRoom.value = false;
            garden.value = false;
            terrace.value = false;
            balcony.value = false;
            outdoorKitchen.value = false;
            elevator.value = false;
            yearBuiltStart.value = "";
            yearBuiltEnd.value = "";
            filterProperties();
        };
        const setUrl = ()=>{
            const minPrice = priceRange.value[0];
            const maxPrice = priceRange.value[1];
            let size = sizeRange.value ? `${sizeRange.value[0]}-${sizeRange.value[1]}` : "";
            let plotSize = `${plotSizeRange.value[0]}-${plotSizeRange.value[1]}`;
            const orderParam = order.value !== "not-selected" ? order.value : "";
            const cityId = termSubCity.value !== "not-selected" ? termSubCity.value : termCity.value;
            const filterCityId = termCity.value !== "not-selected" ? termCity.value : "";
            const filterSubCityId = termSubCity.value !== "not-selected" ? termSubCity.value : "";
            const city = cityId !== "not-selected" ? cityId : "";
            const type = propertyType.value !== "not-selected" ? propertyType.value : "";
            const bedroomsCount = bedrooms.value !== "not-selected" ? bedrooms.value : "";
            const bathroomsCount = bathrooms.value !== "not-selected" ? bathrooms.value : "";
            const seaViewParam = seaView.value === true ? 1 : "";
            const searchTermParam = searchTerm.value || "";
            const seaFrontParam = waterFront.value === true ? 1 : "";
            const waterFrontParam = waterFront.value === true ? 1 : "";
            const nearTheSeaParam = nearTheSea.value === true ? 1 : "";
            const beachFrontParam = beachFront.value === true ? 1 : "";
            const mountainViewParam = mountainView.value === true ? 1 : "";
            const riverViewParam = riverView.value === true ? 1 : "";
            const lakeViewParam = lakeView.value === true ? 1 : "";
            const nearTownParam = nearTown.value === true ? 1 : "";
            const villageParam = village.value === true ? 1 : "";
            const heatedPoolParam = heatedPool.value === true ? 1 : "";
            const outdoorPoolParam = outdoorPool.value === true ? 1 : "";
            const indoorPoolParam = indoorPool.value === true ? 1 : "";
            const boatMooringParam = boatMooring.value === true ? 1 : "";
            const garageParam = garage.value === true ? 1 : "";
            const hotTubParam = hotTub.value === true ? 1 : "";
            const vineyardParam = vineyard.value === true ? 1 : "";
            const gymParam = gym.value === true ? 1 : "";
            const saunaParam = sauna.value === true ? 1 : "";
            const wineCellarParam = wineCellar.value === true ? 1 : "";
            const tennisCourtParam = tennisCourt.value === true ? 1 : "";
            const gameRoomParam = gameRoom.value === true ? 1 : "";
            const gardenParam = garden.value === true ? 1 : "";
            const terraceParam = terrace.value === true ? 1 : "";
            const balconyParam = balcony.value === true ? 1 : "";
            const outdoorKitchenParam = outdoorKitchen.value === true ? 1 : "";
            const elevatorParam = elevator.value === true ? 1 : "";
            const yearBuiltStartParam = yearBuiltStart.value;
            const yearBuiltEndParam = yearBuiltEnd.value;
            params.value = {
                croatiaPropertyID: croatiaPageID,
                currentPage: currentPage.value,
                city: city,
                filterCityId: filterCityId,
                filterSubCityId: filterSubCityId,
                size: size,
                plotSize: plotSize,
                yearBuiltStart: yearBuiltStartParam,
                yearBuiltEnd: yearBuiltEndParam,
                order: orderParam,
                bathrooms: bathroomsCount,
                bedrooms: bedroomsCount,
                type: type,
                sTerm: searchTermParam,
                minPrice: minPrice,
                maxPrice: maxPrice,
                seaView: seaViewParam,
                seaFront: seaFrontParam,
                waterFront: waterFrontParam,
                nearTheSea: nearTheSeaParam,
                beachFront: beachFrontParam,
                mountainView: mountainViewParam,
                riverView: riverViewParam,
                lakeView: lakeViewParam,
                nearTown: nearTownParam,
                village: villageParam,
                heatedPool: heatedPoolParam,
                outdoorPool: outdoorPoolParam,
                indoorPool: indoorPoolParam,
                boatMooring: boatMooringParam,
                garage: garageParam,
                hotTub: hotTubParam,
                vineyard: vineyardParam,
                gym: gymParam,
                sauna: saunaParam,
                wineCellar: wineCellarParam,
                tennisCourt: tennisCourtParam,
                gameRoom: gameRoomParam,
                garden: gardenParam,
                terrace: terraceParam,
                balcony: balconyParam,
                outdoorKitchen: outdoorKitchenParam,
                elevator: elevatorParam
            };
            let changeUrl = new URL(MyScriptVars.rest_url + "properties");
            console.log("new232");
            Object.entries(params.value).forEach(([key, value])=>{
                if (value !== "" && value !== undefined && value !== null) changeUrl.searchParams.append(key, value);
            });
            console.log("Final URL:", changeUrl.toString());
            return changeUrl;
        };
        const favorites = JSON.parse(localStorage.getItem("favorites")) ?? [];
        const toggleFavorite = (property, id)=>{
            const index = favorites.indexOf(id);
            if (index === -1) favorites.push(id);
            else favorites.splice(index, 1);
            localStorage.setItem("favorites", JSON.stringify(favorites));
            if (localStorage.getItem("favorites") !== null) {
                const storage = JSON.parse(localStorage.getItem("favorites"));
                if (storage.includes(id)) property.favorite = true;
                else property.favorite = false;
            }
        };
        const checkIfFavorite = ()=>{
            if (localStorage.getItem("favorites") !== null) properties.value.posts.forEach((property)=>{
                const id = property.id;
                const favorites = JSON.parse(localStorage.getItem("favorites"));
                return property.favorite = favorites.includes(id);
            });
        };
        const priceTranslations = (price, perRequest)=>{
            if (price.toLowerCase() === "price upon request" || perRequest) {
                if (getLangCode === "de") return "Preis auf Anfrage";
                if (getLangCode === "hr") return "Cijena na upit";
                if (getLangCode === "cs") return "Cen\xedk na vy\u017E\xe1d\xe1n\xed";
                if (getLangCode === "es") return "Precio a demanda";
                if (getLangCode === "fr") return "Prix sur demande";
                if (getLangCode === "sl") return "Cena na povpra\u0161evanje";
                if (getLangCode === "pl") return "Cena na zapytanie";
                if (getLangCode === "hu") return "\xc1r k\xe9r\xe9sre";
                if (getLangCode === "sv") return "Pris p\xe5 f\xf6rfr\xe5gan";
                if (getLangCode === "nl") return "Prijs op aanvraag";
                if (getLangCode === "fi") return "Hinta pyynn\xf6st\xe4";
                if (getLangCode === "it") return "Prezzo su richiesta";
                if (getLangCode === "uk") return "\u0426\u0456\u043D\u0430 \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C";
                if (getLangCode === "sk") return "Cena na vy\u017Eiadanie";
                if (getLangCode === "no") return "Pris p\xe5 foresp\xf8rsel";
                if (getLangCode === "en") return "Price Upon Request";
                return price;
            }
            return price;
        };
        const updateLanguageUrls = ()=>{
            // Get the current URL's query string
            const queryString = window.location.search;
            // Get all elements with the class 'lang-dropdown-item'
            const languageLinks = document.getElementsByClassName("lang-dropdown-item");
            // Function to remove duplicates from query string
            const removeDuplicateParams = (baseUrl, queryString)=>{
                // Create a URL object to help parse and manipulate the URL
                const url = new URL(baseUrl, window.location.origin);
                const currentParams = new URLSearchParams(url.search);
                const newParams = new URLSearchParams(queryString);
                // Remove any duplicate params
                newParams.forEach((value, key)=>{
                    if (currentParams.has(key)) currentParams.delete(key); // Avoid duplicating the param
                    currentParams.append(key, value); // Add the new param
                });
                return `${url.pathname}?${currentParams.toString()}`;
            };
            // Loop through each element and update its href attribute
            for(let i = 0; i < languageLinks.length; i++){
                const link = languageLinks[i];
                const baseUrl = link.getAttribute("href");
                // If there's a query string, append it, ensuring no duplicates
                const updatedUrl = queryString ? removeDuplicateParams(baseUrl, queryString) : baseUrl;
                // Set the updated URL as the new href value
                link.setAttribute("href", updatedUrl);
            }
        };
        (0, $9pglz.onBeforeUnmount)(()=>{
            swiperInstances.value.forEach((swiper)=>{
                swiper.destroy(true, true);
            });
            window.removeEventListener("resize", setWidth);
        });
        // Computed properties for formatted price inputs
        const formattedMinPrice = (0, $9pglz.computed)({
            get () {
                return "\u20AC " + priceRange.value[0].toLocaleString("de-DE", {
                    style: "currency",
                    currency: "EUR",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).replace("\u20AC", "").trim();
            },
            set (value) {
                const numericValue = parseFloat(value.replace(/[^\d]/g, ""));
                if (!isNaN(numericValue)) priceRange.value = [
                    numericValue,
                    priceRange.value[1]
                ];
            }
        });
        const formattedMaxPrice = (0, $9pglz.computed)({
            get () {
                return "\u20AC " + priceRange.value[1].toLocaleString("de-DE", {
                    style: "currency",
                    currency: "EUR",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).replace("\u20AC", "").trim();
            },
            set (value) {
                const numericValue = parseFloat(value.replace(/[^\d]/g, ""));
                if (!isNaN(numericValue)) priceRange.value = [
                    priceRange.value[0],
                    numericValue
                ];
            }
        });
        const formatPrice = (value)=>{
            return value.toLocaleString("de-DE");
        };
        const onMinPriceInput = (event)=>{
            formattedMinPrice.value = event.target.value;
        };
        const onMaxPriceInput = (event)=>{
            formattedMaxPrice.value = event.target.value;
        };
        const clearMinPrice = ()=>{
            priceRange.value = [
                $23f716cfedb0a4e1$var$minPrice,
                priceRange.value[1]
            ];
        };
        const clearMinSize = ()=>{
            tempMinSize.value = minSize.value;
        };
        const clearMaxSize = ()=>{
            tempMaxSize.value = maxSize.value;
        };
        const clearMinPlotSize = ()=>{
            tempMinPlotSize.value = 0;
        };
        const clearMaxPlotSize = ()=>{
            tempMaxPlotSize.value = 200000;
        };
        const clearMaxPrice = ()=>{
            priceRange.value = [
                priceRange.value[0],
                $23f716cfedb0a4e1$var$maxPrice
            ];
        };
        const __returned__ = {
            router: router,
            mainPaginationArray: mainPaginationArray,
            showDesc: showDesc,
            filtersActive: filtersActive,
            perPage: $23f716cfedb0a4e1$var$perPage,
            currentPage: currentPage,
            swiperInstances: swiperInstances,
            params: params,
            get properties () {
                return properties;
            },
            set properties (v){
                properties = v;
            },
            get showBtn () {
                return showBtn;
            },
            set showBtn (v){
                showBtn = v;
            },
            get categories () {
                return categories;
            },
            set categories (v){
                categories = v;
            },
            get regions () {
                return regions;
            },
            set regions (v){
                regions = v;
            },
            get pageContent () {
                return pageContent;
            },
            set pageContent (v){
                pageContent = v;
            },
            get termCity () {
                return termCity;
            },
            set termCity (v){
                termCity = v;
            },
            get order () {
                return order;
            },
            set order (v){
                order = v;
            },
            get min () {
                return min;
            },
            set min (v){
                min = v;
            },
            get max () {
                return max;
            },
            set max (v){
                max = v;
            },
            get searchTerm () {
                return searchTerm;
            },
            set searchTerm (v){
                searchTerm = v;
            },
            minSize: minSize,
            maxSize: maxSize,
            get minPlotSize () {
                return minPlotSize;
            },
            set minPlotSize (v){
                minPlotSize = v;
            },
            get maxPlotSize () {
                return maxPlotSize;
            },
            set maxPlotSize (v){
                maxPlotSize = v;
            },
            get termSubCity () {
                return termSubCity;
            },
            set termSubCity (v){
                termSubCity = v;
            },
            get termSubCityList () {
                return termSubCityList;
            },
            set termSubCityList (v){
                termSubCityList = v;
            },
            get propertyTypeList () {
                return propertyTypeList;
            },
            set propertyTypeList (v){
                propertyTypeList = v;
            },
            get propertyType () {
                return propertyType;
            },
            set propertyType (v){
                propertyType = v;
            },
            get bedrooms () {
                return bedrooms;
            },
            set bedrooms (v){
                bedrooms = v;
            },
            get bathrooms () {
                return bathrooms;
            },
            set bathrooms (v){
                bathrooms = v;
            },
            get seaView () {
                return seaView;
            },
            set seaView (v){
                seaView = v;
            },
            get waterFront () {
                return waterFront;
            },
            set waterFront (v){
                waterFront = v;
            },
            get nearTheSea () {
                return nearTheSea;
            },
            set nearTheSea (v){
                nearTheSea = v;
            },
            get beachFront () {
                return beachFront;
            },
            set beachFront (v){
                beachFront = v;
            },
            get mountainView () {
                return mountainView;
            },
            set mountainView (v){
                mountainView = v;
            },
            get riverView () {
                return riverView;
            },
            set riverView (v){
                riverView = v;
            },
            get lakeView () {
                return lakeView;
            },
            set lakeView (v){
                lakeView = v;
            },
            get nearTown () {
                return nearTown;
            },
            set nearTown (v){
                nearTown = v;
            },
            get village () {
                return village;
            },
            set village (v){
                village = v;
            },
            get heatedPool () {
                return heatedPool;
            },
            set heatedPool (v){
                heatedPool = v;
            },
            get outdoorPool () {
                return outdoorPool;
            },
            set outdoorPool (v){
                outdoorPool = v;
            },
            get indoorPool () {
                return indoorPool;
            },
            set indoorPool (v){
                indoorPool = v;
            },
            get boatMooring () {
                return boatMooring;
            },
            set boatMooring (v){
                boatMooring = v;
            },
            get garage () {
                return garage;
            },
            set garage (v){
                garage = v;
            },
            get hotTub () {
                return hotTub;
            },
            set hotTub (v){
                hotTub = v;
            },
            get vineyard () {
                return vineyard;
            },
            set vineyard (v){
                vineyard = v;
            },
            get gym () {
                return gym;
            },
            set gym (v){
                gym = v;
            },
            get sauna () {
                return sauna;
            },
            set sauna (v){
                sauna = v;
            },
            get wineCellar () {
                return wineCellar;
            },
            set wineCellar (v){
                wineCellar = v;
            },
            get tennisCourt () {
                return tennisCourt;
            },
            set tennisCourt (v){
                tennisCourt = v;
            },
            get gameRoom () {
                return gameRoom;
            },
            set gameRoom (v){
                gameRoom = v;
            },
            get garden () {
                return garden;
            },
            set garden (v){
                garden = v;
            },
            get terrace () {
                return terrace;
            },
            set terrace (v){
                terrace = v;
            },
            get balcony () {
                return balcony;
            },
            set balcony (v){
                balcony = v;
            },
            get outdoorKitchen () {
                return outdoorKitchen;
            },
            set outdoorKitchen (v){
                outdoorKitchen = v;
            },
            get elevator () {
                return elevator;
            },
            set elevator (v){
                elevator = v;
            },
            get yearBuiltStart () {
                return yearBuiltStart;
            },
            set yearBuiltStart (v){
                yearBuiltStart = v;
            },
            get yearBuiltEnd () {
                return yearBuiltEnd;
            },
            set yearBuiltEnd (v){
                yearBuiltEnd = v;
            },
            get initial () {
                return initial;
            },
            set initial (v){
                initial = v;
            },
            get loading () {
                return loading;
            },
            set loading (v){
                loading = v;
            },
            translations: translations,
            minPrice: $23f716cfedb0a4e1$var$minPrice,
            maxPrice: $23f716cfedb0a4e1$var$maxPrice,
            priceRange: priceRange,
            sizeRange: sizeRange,
            tempMinSize: tempMinSize,
            tempMaxSize: tempMaxSize,
            plotSizeData: plotSizeData,
            plotSizeMarks: plotSizeMarks,
            plotSizeRange: plotSizeRange,
            tempMinPlotSize: tempMinPlotSize,
            tempMaxPlotSize: tempMaxPlotSize,
            get contents () {
                return contents;
            },
            set contents (v){
                contents = v;
            },
            maxPages: maxPages,
            userContent: userContent,
            fetchData: fetchData,
            showText: showText,
            setRegions: setRegions,
            wordCount: wordCount,
            cutSentence: cutSentence,
            showMoreFilters: showMoreFilters,
            hideMoreFilters: hideMoreFilters,
            getPropertyPermalink: getPropertyPermalink,
            getPropertyTitle: getPropertyTitle,
            getPropertyCategory: getPropertyCategory,
            getCategoryPermalink: getCategoryPermalink,
            getBasePrice: getBasePrice,
            updateVisibleImageSources: updateVisibleImageSources,
            initSwipers: initSwipers,
            calculatePaginationArray: calculatePaginationArray,
            setWidth: setWidth,
            hideDescription: hideDescription,
            changePage: changePage,
            updatePrices: updatePrices,
            formatCurrency: formatCurrency,
            scrollToTop: scrollToTop,
            scrollToPropertiesScroll: scrollToPropertiesScroll,
            filterClick: filterClick,
            filterProperties: filterProperties,
            addRouteQuery: addRouteQuery,
            setParamsFromRouteQuery: setParamsFromRouteQuery,
            clearFilters: clearFilters,
            setUrl: setUrl,
            favorites: favorites,
            toggleFavorite: toggleFavorite,
            checkIfFavorite: checkIfFavorite,
            priceTranslations: priceTranslations,
            updateLanguageUrls: updateLanguageUrls,
            formattedMinPrice: formattedMinPrice,
            formattedMaxPrice: formattedMaxPrice,
            formatPrice: formatPrice,
            onMinPriceInput: onMinPriceInput,
            onMaxPriceInput: onMaxPriceInput,
            clearMinPrice: clearMinPrice,
            clearMinSize: clearMinSize,
            clearMaxSize: clearMaxSize,
            clearMinPlotSize: clearMinPlotSize,
            clearMaxPlotSize: clearMaxPlotSize,
            clearMaxPrice: clearMaxPrice,
            get Swiper () {
                return 0, $aPlzd.S;
            },
            get Navigation () {
                return 0, $9FG0d.default;
            },
            ref: $Dz4HH.ref,
            onMounted: $9pglz.onMounted,
            computed: $9pglz.computed,
            watch: $9pglz.watch,
            nextTick: $9pglz.nextTick,
            onBeforeUnmount: $9pglz.onBeforeUnmount,
            get useRoute () {
                return 0, $59lkq.useRoute;
            },
            get useRouter () {
                return 0, $59lkq.useRouter;
            },
            get getTranslation () {
                return 0, $gmBfx.getTranslation;
            },
            get VueSlider () {
                return 0, (/*@__PURE__*/$parcel$interopDefault($k56Uj));
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});
parcelRegister("1FCkY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("aPlzd")).S; });
/**
 * Swiper 11.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */ 
var $aPlzd = parcelRequire("aPlzd");

});
parcelRegister("aPlzd", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $029bc59d811a92d7$export$25ce5a424b770e84; });

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");
let $029bc59d811a92d7$var$support;
function $029bc59d811a92d7$var$calcSupport() {
    const window1 = (0, $keBYm.a)();
    const document1 = (0, $keBYm.g)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $029bc59d811a92d7$var$getSupport() {
    if (!$029bc59d811a92d7$var$support) $029bc59d811a92d7$var$support = $029bc59d811a92d7$var$calcSupport();
    return $029bc59d811a92d7$var$support;
}
let $029bc59d811a92d7$var$deviceCached;
function $029bc59d811a92d7$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $029bc59d811a92d7$var$getSupport();
    const window1 = (0, $keBYm.a)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $029bc59d811a92d7$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$029bc59d811a92d7$var$deviceCached) $029bc59d811a92d7$var$deviceCached = $029bc59d811a92d7$var$calcDevice(overrides);
    return $029bc59d811a92d7$var$deviceCached;
}
let $029bc59d811a92d7$var$browser;
function $029bc59d811a92d7$var$calcBrowser() {
    const window1 = (0, $keBYm.a)();
    const device = $029bc59d811a92d7$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $029bc59d811a92d7$var$getBrowser() {
    if (!$029bc59d811a92d7$var$browser) $029bc59d811a92d7$var$browser = $029bc59d811a92d7$var$calcBrowser();
    return $029bc59d811a92d7$var$browser;
}
function $029bc59d811a92d7$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $keBYm.a)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $029bc59d811a92d7$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $keBYm.a)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $6mOJw.a)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $029bc59d811a92d7$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $029bc59d811a92d7$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $6mOJw.o)(el, "padding-left") || 0, 10) - parseInt((0, $6mOJw.o)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $6mOJw.o)(el, "padding-top") || 0, 10) - parseInt((0, $6mOJw.o)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $029bc59d811a92d7$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $6mOJw.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $6mOJw.s)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $6mOJw.s)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $6mOJw.o)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $6mOJw.f)(slide, "width", true) : (0, $6mOJw.f)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $6mOJw.s)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $6mOJw.s)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $029bc59d811a92d7$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $029bc59d811a92d7$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
function $029bc59d811a92d7$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        if (isFullyVisible) slides[i].classList.add(params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $029bc59d811a92d7$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
const $029bc59d811a92d7$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $029bc59d811a92d7$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $6mOJw.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        nextSlide = slides.filter((slideEl)=>slideEl.column === activeIndex + 1)[0];
        prevSlide = slides.filter((slideEl)=>slideEl.column === activeIndex - 1)[0];
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $6mOJw.p)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $6mOJw.q)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $029bc59d811a92d7$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $029bc59d811a92d7$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $029bc59d811a92d7$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $029bc59d811a92d7$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $029bc59d811a92d7$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $029bc59d811a92d7$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $029bc59d811a92d7$var$unlazy(swiper, i);
    }
};
function $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $029bc59d811a92d7$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $029bc59d811a92d7$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $029bc59d811a92d7$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function $029bc59d811a92d7$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $029bc59d811a92d7$var$update = {
    updateSize: $029bc59d811a92d7$var$updateSize,
    updateSlides: $029bc59d811a92d7$var$updateSlides,
    updateAutoHeight: $029bc59d811a92d7$var$updateAutoHeight,
    updateSlidesOffset: $029bc59d811a92d7$var$updateSlidesOffset,
    updateSlidesProgress: $029bc59d811a92d7$var$updateSlidesProgress,
    updateProgress: $029bc59d811a92d7$var$updateProgress,
    updateSlidesClasses: $029bc59d811a92d7$var$updateSlidesClasses,
    updateActiveIndex: $029bc59d811a92d7$var$updateActiveIndex,
    updateClickedSlide: $029bc59d811a92d7$var$updateClickedSlide
};
function $029bc59d811a92d7$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $6mOJw.j)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $029bc59d811a92d7$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $029bc59d811a92d7$var$minTranslate() {
    return -this.snapGrid[0];
}
function $029bc59d811a92d7$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $029bc59d811a92d7$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $6mOJw.r)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $029bc59d811a92d7$var$translate = {
    getTranslate: $029bc59d811a92d7$var$getSwiperTranslate,
    setTranslate: $029bc59d811a92d7$var$setTranslate,
    minTranslate: $029bc59d811a92d7$var$minTranslate,
    maxTranslate: $029bc59d811a92d7$var$maxTranslate,
    translateTo: $029bc59d811a92d7$var$translateTo
};
function $029bc59d811a92d7$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $029bc59d811a92d7$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $029bc59d811a92d7$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $029bc59d811a92d7$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $029bc59d811a92d7$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $029bc59d811a92d7$var$transition = {
    setTransition: $029bc59d811a92d7$var$setTransition,
    transitionStart: $029bc59d811a92d7$var$transitionStart,
    transitionEnd: $029bc59d811a92d7$var$transitionEnd
};
function $029bc59d811a92d7$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $6mOJw.r)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $029bc59d811a92d7$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $029bc59d811a92d7$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $029bc59d811a92d7$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $6mOJw.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $6mOJw.n)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $6mOJw.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $6mOJw.n)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $029bc59d811a92d7$var$slide = {
    slideTo: $029bc59d811a92d7$var$slideTo,
    slideToLoop: $029bc59d811a92d7$var$slideToLoop,
    slideNext: $029bc59d811a92d7$var$slideNext,
    slidePrev: $029bc59d811a92d7$var$slidePrev,
    slideReset: $029bc59d811a92d7$var$slideReset,
    slideToClosest: $029bc59d811a92d7$var$slideToClosest,
    slideToClickedSlide: $029bc59d811a92d7$var$slideToClickedSlide
};
function $029bc59d811a92d7$var$loopCreate(slideRealIndex) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $6mOJw.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $6mOJw.c)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, $6mOJw.c)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $6mOJw.t)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $6mOJw.t)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $029bc59d811a92d7$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides) (0, $6mOJw.t)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, $6mOJw.t)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function $029bc59d811a92d7$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $029bc59d811a92d7$var$loop = {
    loopCreate: $029bc59d811a92d7$var$loopCreate,
    loopFix: $029bc59d811a92d7$var$loopFix,
    loopDestroy: $029bc59d811a92d7$var$loopDestroy
};
function $029bc59d811a92d7$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $029bc59d811a92d7$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $029bc59d811a92d7$var$grabCursor = {
    setGrabCursor: $029bc59d811a92d7$var$setGrabCursor,
    unsetGrabCursor: $029bc59d811a92d7$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $029bc59d811a92d7$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $keBYm.g)() || el === (0, $keBYm.a)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $029bc59d811a92d7$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $keBYm.a)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $029bc59d811a92d7$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $keBYm.g)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        $029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $029bc59d811a92d7$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$029bc59d811a92d7$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $6mOJw.d)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $029bc59d811a92d7$var$onTouchMove(event) {
    const document1 = (0, $keBYm.g)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $6mOJw.d)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    new Date().getTime();
    if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $029bc59d811a92d7$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $6mOJw.d)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $6mOJw.d)();
    (0, $6mOJw.n)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $029bc59d811a92d7$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $029bc59d811a92d7$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $029bc59d811a92d7$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $029bc59d811a92d7$var$onLoad(e) {
    const swiper = this;
    $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function $029bc59d811a92d7$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
const $029bc59d811a92d7$var$events = (swiper, method)=>{
    const document1 = (0, $keBYm.g)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $029bc59d811a92d7$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $029bc59d811a92d7$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $029bc59d811a92d7$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $029bc59d811a92d7$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $029bc59d811a92d7$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $029bc59d811a92d7$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $029bc59d811a92d7$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $029bc59d811a92d7$var$onScroll.bind(swiper);
    swiper.onClick = $029bc59d811a92d7$var$onClick.bind(swiper);
    swiper.onLoad = $029bc59d811a92d7$var$onLoad.bind(swiper);
    $029bc59d811a92d7$var$events(swiper, "on");
}
function $029bc59d811a92d7$var$detachEvents() {
    const swiper = this;
    $029bc59d811a92d7$var$events(swiper, "off");
}
var $029bc59d811a92d7$var$events$1 = {
    attachEvents: $029bc59d811a92d7$var$attachEvents,
    detachEvents: $029bc59d811a92d7$var$detachEvents
};
const $029bc59d811a92d7$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $029bc59d811a92d7$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, params);
    const isMultiRow = $029bc59d811a92d7$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $6mOJw.u)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $029bc59d811a92d7$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $keBYm.a)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $029bc59d811a92d7$var$breakpoints = {
    setBreakpoint: $029bc59d811a92d7$var$setBreakpoint,
    getBreakpoint: $029bc59d811a92d7$var$getBreakpoint
};
function $029bc59d811a92d7$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $029bc59d811a92d7$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $029bc59d811a92d7$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $029bc59d811a92d7$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $029bc59d811a92d7$var$classes = {
    addClasses: $029bc59d811a92d7$var$addClasses,
    removeClasses: $029bc59d811a92d7$var$removeClasses
};
function $029bc59d811a92d7$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $029bc59d811a92d7$var$checkOverflow$1 = {
    checkOverflow: $029bc59d811a92d7$var$checkOverflow
};
var $029bc59d811a92d7$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $6mOJw.u)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $6mOJw.u)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $6mOJw.u)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $029bc59d811a92d7$var$prototypes = {
    eventsEmitter: $029bc59d811a92d7$var$eventsEmitter,
    update: $029bc59d811a92d7$var$update,
    translate: $029bc59d811a92d7$var$translate,
    transition: $029bc59d811a92d7$var$transition,
    slide: $029bc59d811a92d7$var$slide,
    loop: $029bc59d811a92d7$var$loop,
    grabCursor: $029bc59d811a92d7$var$grabCursor,
    events: $029bc59d811a92d7$var$events$1,
    breakpoints: $029bc59d811a92d7$var$breakpoints,
    checkOverflow: $029bc59d811a92d7$var$checkOverflow$1,
    classes: $029bc59d811a92d7$var$classes
};
const $029bc59d811a92d7$var$extendedDefaults = {};
class $029bc59d811a92d7$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $6mOJw.u)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $keBYm.g)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $6mOJw.u)({}, params, {
                    el: containerEl
                });
                swipers.push(new $029bc59d811a92d7$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $029bc59d811a92d7$var$getSupport();
        swiper.device = $029bc59d811a92d7$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $029bc59d811a92d7$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $029bc59d811a92d7$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $6mOJw.u)({}, $029bc59d811a92d7$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $6mOJw.u)({}, swiperParams, $029bc59d811a92d7$var$extendedDefaults, params);
        swiper.originalParams = (0, $6mOJw.u)({}, swiper.params);
        swiper.passedParams = (0, $6mOJw.u)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $6mOJw.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $6mOJw.h)(slides[0]);
        return (0, $6mOJw.h)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $6mOJw.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $6mOJw.e)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $6mOJw.c)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $6mOJw.e)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $6mOJw.o)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $6mOJw.o)(el, "direction") === "rtl"),
            wrongRTL: (0, $6mOJw.o)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $029bc59d811a92d7$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $029bc59d811a92d7$var$processLazyPreloader(swiper, e.target);
            });
        });
        $029bc59d811a92d7$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $029bc59d811a92d7$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            el.removeAttribute("style");
            wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.el.swiper = null;
            (0, $6mOJw.v)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $6mOJw.u)($029bc59d811a92d7$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $029bc59d811a92d7$var$extendedDefaults;
    }
    static get defaults() {
        return $029bc59d811a92d7$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__) $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $029bc59d811a92d7$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$029bc59d811a92d7$export$25ce5a424b770e84.installModule(m));
            return $029bc59d811a92d7$export$25ce5a424b770e84;
        }
        $029bc59d811a92d7$export$25ce5a424b770e84.installModule(module);
        return $029bc59d811a92d7$export$25ce5a424b770e84;
    }
}
Object.keys($029bc59d811a92d7$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($029bc59d811a92d7$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $029bc59d811a92d7$export$25ce5a424b770e84.prototype[protoMethod] = $029bc59d811a92d7$var$prototypes[prototypeGroup][protoMethod];
    });
});
$029bc59d811a92d7$export$25ce5a424b770e84.use([
    $029bc59d811a92d7$var$Resize,
    $029bc59d811a92d7$var$Observer
]);

});
parcelRegister("keBYm", function(module, exports) {

$parcel$export(module.exports, "g", function () { return $6b317c2177284918$export$39b482c5e57630a8; });
$parcel$export(module.exports, "a", function () { return $6b317c2177284918$export$407448d2b89b1813; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $6b317c2177284918$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $6b317c2177284918$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($6b317c2177284918$var$isObject(src[key]) && $6b317c2177284918$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $6b317c2177284918$var$extend(target[key], src[key]);
    });
}
const $6b317c2177284918$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $6b317c2177284918$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $6b317c2177284918$var$extend(doc, $6b317c2177284918$var$ssrDocument);
    return doc;
}
const $6b317c2177284918$var$ssrWindow = {
    document: $6b317c2177284918$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $6b317c2177284918$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $6b317c2177284918$var$extend(win, $6b317c2177284918$var$ssrWindow);
    return win;
}

});

parcelRegister("6mOJw", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $36f917fbf2efdd6b$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "v", function () { return $36f917fbf2efdd6b$export$90a7f3efeed30595; });
$parcel$export(module.exports, "n", function () { return $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "d", function () { return $36f917fbf2efdd6b$export$4368d992c4eafac0; });
$parcel$export(module.exports, "j", function () { return $36f917fbf2efdd6b$export$35e795649ee09318; });
$parcel$export(module.exports, "l", function () { return $36f917fbf2efdd6b$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $36f917fbf2efdd6b$export$3b14a55fb2447963; });
$parcel$export(module.exports, "s", function () { return $36f917fbf2efdd6b$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "r", function () { return $36f917fbf2efdd6b$export$43caf9889c228507; });
$parcel$export(module.exports, "g", function () { return $36f917fbf2efdd6b$export$39b482c5e57630a8; });
$parcel$export(module.exports, "e", function () { return $36f917fbf2efdd6b$export$f1e1789686576879; });
$parcel$export(module.exports, "t", function () { return $36f917fbf2efdd6b$export$625550452a3fa3ec; });
$parcel$export(module.exports, "c", function () { return $36f917fbf2efdd6b$export$db3b6bfb95261072; });
$parcel$export(module.exports, "b", function () { return $36f917fbf2efdd6b$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "q", function () { return $36f917fbf2efdd6b$export$9e5f44173e64f162; });
$parcel$export(module.exports, "p", function () { return $36f917fbf2efdd6b$export$ffb5f4729a158638; });
$parcel$export(module.exports, "o", function () { return $36f917fbf2efdd6b$export$ae1af26003f05816; });
$parcel$export(module.exports, "h", function () { return $36f917fbf2efdd6b$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a", function () { return $36f917fbf2efdd6b$export$407448d2b89b1813; });
$parcel$export(module.exports, "k", function () { return $36f917fbf2efdd6b$export$342063e11d6c3cad; });
$parcel$export(module.exports, "f", function () { return $36f917fbf2efdd6b$export$2d1720544b23b823; });
$parcel$export(module.exports, "m", function () { return $36f917fbf2efdd6b$export$953cecd6e717a553; });

var $keBYm = parcelRequire("keBYm");
function $36f917fbf2efdd6b$export$23f2a1d2818174ef(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter((c)=>!!c.trim());
}
function $36f917fbf2efdd6b$export$90a7f3efeed30595(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $36f917fbf2efdd6b$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $36f917fbf2efdd6b$export$4368d992c4eafac0() {
    return Date.now();
}
function $36f917fbf2efdd6b$var$getComputedStyle(el) {
    const window1 = (0, $keBYm.a)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $36f917fbf2efdd6b$export$35e795649ee09318(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $keBYm.a)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $36f917fbf2efdd6b$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $36f917fbf2efdd6b$export$882b5998b3b9117c(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $36f917fbf2efdd6b$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $36f917fbf2efdd6b$export$3b14a55fb2447963() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$36f917fbf2efdd6b$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($36f917fbf2efdd6b$export$882b5998b3b9117c(to[nextKey]) && $36f917fbf2efdd6b$export$882b5998b3b9117c(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$3b14a55fb2447963(to[nextKey], nextSource[nextKey]);
                    } else if (!$36f917fbf2efdd6b$export$882b5998b3b9117c(to[nextKey]) && $36f917fbf2efdd6b$export$882b5998b3b9117c(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $36f917fbf2efdd6b$export$3b14a55fb2447963(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $36f917fbf2efdd6b$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $36f917fbf2efdd6b$export$43caf9889c228507(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $keBYm.a)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $36f917fbf2efdd6b$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $36f917fbf2efdd6b$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    return [
        ...element.children
    ].filter((el)=>el.matches(selector));
}
function $36f917fbf2efdd6b$export$625550452a3fa3ec(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $36f917fbf2efdd6b$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $36f917fbf2efdd6b$export$23f2a1d2818174ef(classes));
    return el;
}
function $36f917fbf2efdd6b$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $keBYm.a)();
    const document1 = (0, $keBYm.g)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $36f917fbf2efdd6b$export$9e5f44173e64f162(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $36f917fbf2efdd6b$export$ffb5f4729a158638(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $36f917fbf2efdd6b$export$ae1af26003f05816(el, prop) {
    const window1 = (0, $keBYm.a)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $36f917fbf2efdd6b$export$dda1d9f60106f0e9(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $36f917fbf2efdd6b$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $36f917fbf2efdd6b$export$342063e11d6c3cad(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $36f917fbf2efdd6b$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $keBYm.a)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}
function $36f917fbf2efdd6b$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}

});



parcelRegister("8h94B", function(module, exports) {

$parcel$export(module.exports, "Navigation", function () { return (parcelRequire("9FG0d")).default; });
$parcel$export(module.exports, "Autoplay", function () { return (parcelRequire("lKF2X")).default; });

var $dw53c = parcelRequire("dw53c");

var $f6Nek = parcelRequire("f6Nek");

var $jXxoF = parcelRequire("jXxoF");

var $9FG0d = parcelRequire("9FG0d");

var $9kKA1 = parcelRequire("9kKA1");

var $ljzZZ = parcelRequire("ljzZZ");

var $vYcDc = parcelRequire("vYcDc");

var $jQfWT = parcelRequire("jQfWT");

var $l7FuI = parcelRequire("l7FuI");

var $3MOG2 = parcelRequire("3MOG2");

var $a41Wm = parcelRequire("a41Wm");

var $e6EHS = parcelRequire("e6EHS");

var $lKF2X = parcelRequire("lKF2X");

var $1zGTp = parcelRequire("1zGTp");

var $cHxst = parcelRequire("cHxst");

var $4ctZd = parcelRequire("4ctZd");

var $5vDQW = parcelRequire("5vDQW");

var $epATu = parcelRequire("epATu");

var $5eek6 = parcelRequire("5eek6");

var $2RW4W = parcelRequire("2RW4W");

var $1pnXP = parcelRequire("1pnXP");

var $5wwjx = parcelRequire("5wwjx");

var $9L1uq = parcelRequire("9L1uq");

});
parcelRegister("dw53c", function(module, exports) {

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");
function $33834d902fe381ab$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $keBYm.g)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $6mOJw.c)("swiper-slide");
        else slideEl = (0, $6mOJw.c)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $6mOJw.e)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $6mOJw.s)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}

});

parcelRegister("f6Nek", function(module, exports) {

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");
/* eslint-disable consistent-return */ function $52e509fb8653e0d9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $keBYm.g)();
    const window = (0, $keBYm.a)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $6mOJw.a)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $6mOJw.a)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $6mOJw.b)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("jXxoF", function(module, exports) {

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");
/* eslint-disable consistent-return */ function $05e7c97b57a34c96$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $keBYm.a)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $6mOJw.d)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $6mOJw.d)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $6mOJw.d)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $6mOJw.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $6mOJw.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $6mOJw.n)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $6mOJw.n)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}

});

parcelRegister("9FG0d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dcb69c205fd1703$export$2e2bcd8739ae039; });

var $2iWbd = parcelRequire("2iWbd");

var $6mOJw = parcelRequire("6mOJw");
function $9dcb69c205fd1703$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $2iWbd.c)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $6mOJw.m)(nextEl);
        prevEl = (0, $6mOJw.m)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $6mOJw.m)(nextEl);
        prevEl = (0, $6mOJw.m)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $6mOJw.m)(nextEl);
        prevEl = (0, $6mOJw.m)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $6mOJw.m)(nextEl);
        prevEl = (0, $6mOJw.m)(prevEl);
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("2iWbd", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $756cc3b72a05f628$export$db3b6bfb95261072; });

var $6mOJw = parcelRequire("6mOJw");
function $756cc3b72a05f628$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $6mOJw.e)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $6mOJw.c)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

});


parcelRegister("9kKA1", function(module, exports) {

var $dVowW = parcelRequire("dVowW");

var $2iWbd = parcelRequire("2iWbd");

var $6mOJw = parcelRequire("6mOJw");
function $69d1e0b9767b27dd$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $dVowW.c)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $6mOJw.h)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $6mOJw.m)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $6mOJw.f)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $6mOJw.h)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $dVowW.c)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $dVowW.c)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $dVowW.c)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $6mOJw.m)(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $dVowW.c)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $2iWbd.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter((subEl)=>{
                if ((0, $6mOJw.a)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $6mOJw.m)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $6mOJw.m)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $6mOJw.m)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $6mOJw.m)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $6mOJw.m)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}

});
parcelRegister("dVowW", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $781a64a6db1a7446$export$db3b6bfb95261072; });
function $781a64a6db1a7446$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}

});


parcelRegister("ljzZZ", function(module, exports) {

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");

var $2iWbd = parcelRequire("2iWbd");

var $dVowW = parcelRequire("dVowW");
function $c7252c6c2cf4bba7$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $keBYm.g)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $6mOJw.b)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $6mOJw.n)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $2iWbd.c)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $dVowW.c)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $6mOJw.c)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $6mOJw.i)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $6mOJw.i)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on("changeDirection", ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock changeDirection", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $6mOJw.i)(swiper.params.scrollbar.lockClass));
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $6mOJw.i)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $6mOJw.i)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $6mOJw.i)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $6mOJw.i)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}

});

parcelRegister("vYcDc", function(module, exports) {

var $6mOJw = parcelRequire("6mOJw");
function $c36b71b742710ea0$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $6mOJw.e)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $6mOJw.e)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

});

parcelRegister("jQfWT", function(module, exports) {

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");
function $401de11e8a126d45$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $keBYm.a)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $6mOJw.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $6mOJw.j)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $6mOJw.j)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) {
            allowTouchMove();
            return;
        }
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $6mOJw.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $6mOJw.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $6mOJw.b)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $6mOJw.b)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $6mOJw.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $6mOJw.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

});

parcelRegister("l7FuI", function(module, exports) {

var $6mOJw = parcelRequire("6mOJw");
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $411c83a941bc1076$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $6mOJw.n)(()=>{
                    c.updateAutoHeight();
                });
                (0, $6mOJw.k)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElement = document.querySelector(swiper.params.controller.control);
            if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
            else if (controlElement) {
                const onControllerSwiper = (e)=>{
                    swiper.controller.control = e.detail[0];
                    swiper.update();
                    controlElement.removeEventListener("init", onControllerSwiper);
                };
                controlElement.addEventListener("init", onControllerSwiper);
            }
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}

});

parcelRegister("3MOG2", function(module, exports) {

var $keBYm = parcelRequire("keBYm");

var $dVowW = parcelRequire("dVowW");

var $6mOJw = parcelRequire("6mOJw");
function $9649bf9a787c3914$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = (0, $6mOJw.m)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $dVowW.c)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $6mOJw.m)(swiper.navigation.prevEl);
            const nextEls = (0, $6mOJw.m)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $dVowW.c)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $6mOJw.h)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $dVowW.c)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $6mOJw.m)(nextEl);
        prevEl = (0, $6mOJw.m)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $6mOJw.m)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $keBYm.g)();
        document.addEventListener("visibilitychange", onVisibilityChange);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $6mOJw.m)(nextEl);
        prevEl = (0, $6mOJw.m)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $6mOJw.m)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        const document = (0, $keBYm.g)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
        // Tab focus
        swiper.el.removeEventListener("focus", handleFocus, true);
        swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
        swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $6mOJw.c)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

});

parcelRegister("a41Wm", function(module, exports) {

var $keBYm = parcelRequire("keBYm");
function $38bb61499ef50fab$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $keBYm.a)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $keBYm.a)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $keBYm.a)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $keBYm.a)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

});

parcelRegister("e6EHS", function(module, exports) {

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");
function $87b0baa371d09db8$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $keBYm.g)();
    const window = (0, $keBYm.a)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-hash") === hash)[0];
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $6mOJw.e)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

});

parcelRegister("lKF2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1783ac9556c9fef$export$2e2bcd8739ae039; });

var $keBYm = parcelRequire("keBYm");
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $c1783ac9556c9fef$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        if (pausedByPointerEnter) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl)=>slideEl.classList.contains("swiper-slide-active"))[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $keBYm.g)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $keBYm.g)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $keBYm.g)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("_freeModeStaticRelease", ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on("_freeModeNoMomentumRelease", ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}

});

parcelRegister("1zGTp", function(module, exports) {

var $keBYm = parcelRequire("keBYm");

var $6mOJw = parcelRequire("6mOJw");
function $21e2f533778c20f0$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $6mOJw.l)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $6mOJw.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $keBYm.g)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener("init", onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}

});

parcelRegister("cHxst", function(module, exports) {

var $6mOJw = parcelRequire("6mOJw");
function $49f3fa363ac09256$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $6mOJw.d)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $6mOJw.d)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $6mOJw.d)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $6mOJw.k)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $6mOJw.k)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $6mOJw.k)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit("_freeModeStaticRelease");
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}

});

parcelRegister("4ctZd", function(module, exports) {
function $3e2c28ea1ae0e231$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = "";
                slide.style[swiper.getDirectionLabel("margin-top")] = "";
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}

});

parcelRegister("5vDQW", function(module, exports) {
function $eb2d45639f1e8538$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $eb2d45639f1e8538$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $eb2d45639f1e8538$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $eb2d45639f1e8538$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $eb2d45639f1e8538$var$appendSlide.bind(swiper),
        prependSlide: $eb2d45639f1e8538$var$prependSlide.bind(swiper),
        addSlide: $eb2d45639f1e8538$var$addSlide.bind(swiper),
        removeSlide: $eb2d45639f1e8538$var$removeSlide.bind(swiper),
        removeAllSlides: $eb2d45639f1e8538$var$removeAllSlides.bind(swiper)
    });
}

});

parcelRegister("epATu", function(module, exports) {

var $kM9Dn = parcelRequire("kM9Dn");

var $jF0D4 = parcelRequire("jF0D4");

var $aV5Ef = parcelRequire("aV5Ef");

var $6mOJw = parcelRequire("6mOJw");
function $5d17e4afe2f572c9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $jF0D4.e)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $6mOJw.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $aV5Ef.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $kM9Dn.e)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("kM9Dn", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $6be88bfc4d238db6$export$f1e1789686576879; });
function $6be88bfc4d238db6$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

});

parcelRegister("jF0D4", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $b32fc4882a084e0d$export$f1e1789686576879; });

var $6mOJw = parcelRequire("6mOJw");
function $b32fc4882a084e0d$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $6mOJw.g)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}

});

parcelRegister("aV5Ef", function(module, exports) {

$parcel$export(module.exports, "e", function () { return $8cd9c8d5770c3e4b$export$f1e1789686576879; });

var $6mOJw = parcelRequire("6mOJw");
function $8cd9c8d5770c3e4b$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.filter((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $6mOJw.k)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}

});


parcelRegister("5eek6", function(module, exports) {

var $kM9Dn = parcelRequire("kM9Dn");

var $6mOJw = parcelRequire("6mOJw");
function $7a34974922f14d54$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $6mOJw.c)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $6mOJw.c)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $6mOJw.c)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $6mOJw.c)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
                if (swiper.browser && swiper.browser.need3dFix && Math.abs(wrapperRotate) / 90 % 2 === 1) wrapperRotate += 0.001;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $kM9Dn.e)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

});

parcelRegister("2RW4W", function(module, exports) {

var $cf0yz = parcelRequire("cf0yz");

var $kM9Dn = parcelRequire("kM9Dn");

var $jF0D4 = parcelRequire("jF0D4");

var $aV5Ef = parcelRequire("aV5Ef");

var $6mOJw = parcelRequire("6mOJw");
function $68ca3c9f22027c47$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $cf0yz.c)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $cf0yz.c)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            if (swiper.browser && swiper.browser.need3dFix) {
                if (Math.abs(rotateY) / 90 % 2 === 1) rotateY += 0.001;
                if (Math.abs(rotateX) / 90 % 2 === 1) rotateX += 0.001;
            }
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const targetEl = (0, $jF0D4.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $6mOJw.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $aV5Ef.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $kM9Dn.e)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});
parcelRegister("cf0yz", function(module, exports) {

$parcel$export(module.exports, "c", function () { return $fab3d8cd791e5fc7$export$db3b6bfb95261072; });

var $6mOJw = parcelRequire("6mOJw");
function $fab3d8cd791e5fc7$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, $6mOJw.g)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, $6mOJw.c)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}

});


parcelRegister("1pnXP", function(module, exports) {

var $cf0yz = parcelRequire("cf0yz");

var $kM9Dn = parcelRequire("kM9Dn");

var $jF0D4 = parcelRequire("jF0D4");

var $6mOJw = parcelRequire("6mOJw");
function $983c76c349961a02$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            if (swiper.browser && swiper.browser.need3dFix) {
                if (Math.abs(rotateY) / 90 % 2 === 1) rotateY += 0.001;
                if (Math.abs(rotateX) / 90 % 2 === 1) rotateX += 0.001;
            }
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const targetEl = (0, $jF0D4.e)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $cf0yz.c)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $cf0yz.c)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $6mOJw.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $kM9Dn.e)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

});

parcelRegister("5wwjx", function(module, exports) {

var $cf0yz = parcelRequire("cf0yz");

var $kM9Dn = parcelRequire("kM9Dn");

var $jF0D4 = parcelRequire("jF0D4");

var $aV5Ef = parcelRequire("aV5Ef");

var $6mOJw = parcelRequire("6mOJw");
function $ed2173e49aa32019$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                if (swiper.browser && swiper.browser.need3dFix && Math.abs(val) / 90 % 2 === 1) val += 0.001;
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $cf0yz.c)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $jF0D4.e)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $6mOJw.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $aV5Ef.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $kM9Dn.e)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});

parcelRegister("9L1uq", function(module, exports) {

var $cf0yz = parcelRequire("cf0yz");

var $kM9Dn = parcelRequire("kM9Dn");

var $jF0D4 = parcelRequire("jF0D4");

var $aV5Ef = parcelRequire("aV5Ef");

var $6mOJw = parcelRequire("6mOJw");
function $e7abdc2d61949d3e$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $cf0yz.c)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $jF0D4.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $6mOJw.g)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $aV5Ef.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $kM9Dn.e)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

});


parcelRegister("59lkq", function(module, exports) {

$parcel$export(module.exports, "createWebHistory", function () { return $7c53a1bfa09ab63e$export$7b4942f78e7b8a49; });
$parcel$export(module.exports, "createRouter", function () { return $7c53a1bfa09ab63e$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "useRouter", function () { return $7c53a1bfa09ab63e$export$9a302a45f65d0572; });
$parcel$export(module.exports, "useRoute", function () { return $7c53a1bfa09ab63e$export$3f79f0b98112cf57; });
/*!
  * vue-router v4.3.0
  * (c) 2024 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $Dz4HH = parcelRequire("Dz4HH");

var $e26ba = parcelRequire("e26ba");
const $7c53a1bfa09ab63e$var$isBrowser = typeof document !== "undefined";
function $7c53a1bfa09ab63e$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module";
}
const $7c53a1bfa09ab63e$var$assign = Object.assign;
function $7c53a1bfa09ab63e$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $7c53a1bfa09ab63e$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $7c53a1bfa09ab63e$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $7c53a1bfa09ab63e$var$isArray = Array.isArray;
function $7c53a1bfa09ab63e$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
/**
 * Encoding Rules ␣ = Space Path: ␣ " < > # ? { } Query: ␣ " < > # & = Hash: ␣ "
 * < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $7c53a1bfa09ab63e$var$HASH_RE = /#/g; // %23
const $7c53a1bfa09ab63e$var$AMPERSAND_RE = /&/g; // %26
const $7c53a1bfa09ab63e$var$SLASH_RE = /\//g; // %2F
const $7c53a1bfa09ab63e$var$EQUAL_RE = /=/g; // %3D
const $7c53a1bfa09ab63e$var$IM_RE = /\?/g; // %3F
const $7c53a1bfa09ab63e$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $7c53a1bfa09ab63e$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $7c53a1bfa09ab63e$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $7c53a1bfa09ab63e$var$ENC_CARET_RE = /%5E/g; // ^
const $7c53a1bfa09ab63e$var$ENC_BACKTICK_RE = /%60/g; // `
const $7c53a1bfa09ab63e$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $7c53a1bfa09ab63e$var$ENC_PIPE_RE = /%7C/g; // |
const $7c53a1bfa09ab63e$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $7c53a1bfa09ab63e$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $7c53a1bfa09ab63e$var$commonEncode(text) {
    return encodeURI("" + text).replace($7c53a1bfa09ab63e$var$ENC_PIPE_RE, "|").replace($7c53a1bfa09ab63e$var$ENC_BRACKET_OPEN_RE, "[").replace($7c53a1bfa09ab63e$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $7c53a1bfa09ab63e$var$encodeHash(text) {
    return $7c53a1bfa09ab63e$var$commonEncode(text).replace($7c53a1bfa09ab63e$var$ENC_CURLY_OPEN_RE, "{").replace($7c53a1bfa09ab63e$var$ENC_CURLY_CLOSE_RE, "}").replace($7c53a1bfa09ab63e$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $7c53a1bfa09ab63e$var$encodeQueryValue(text) {
    return $7c53a1bfa09ab63e$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($7c53a1bfa09ab63e$var$PLUS_RE, "%2B").replace($7c53a1bfa09ab63e$var$ENC_SPACE_RE, "+").replace($7c53a1bfa09ab63e$var$HASH_RE, "%23").replace($7c53a1bfa09ab63e$var$AMPERSAND_RE, "%26").replace($7c53a1bfa09ab63e$var$ENC_BACKTICK_RE, "`").replace($7c53a1bfa09ab63e$var$ENC_CURLY_OPEN_RE, "{").replace($7c53a1bfa09ab63e$var$ENC_CURLY_CLOSE_RE, "}").replace($7c53a1bfa09ab63e$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $7c53a1bfa09ab63e$var$encodeQueryKey(text) {
    return $7c53a1bfa09ab63e$var$encodeQueryValue(text).replace($7c53a1bfa09ab63e$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $7c53a1bfa09ab63e$var$encodePath(text) {
    return $7c53a1bfa09ab63e$var$commonEncode(text).replace($7c53a1bfa09ab63e$var$HASH_RE, "%23").replace($7c53a1bfa09ab63e$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $7c53a1bfa09ab63e$var$encodeParam(text) {
    return text == null ? "" : $7c53a1bfa09ab63e$var$encodePath(text).replace($7c53a1bfa09ab63e$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $7c53a1bfa09ab63e$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
const $7c53a1bfa09ab63e$var$TRAILING_SLASH_RE = /\/$/;
const $7c53a1bfa09ab63e$var$removeTrailingSlash = (path)=>path.replace($7c53a1bfa09ab63e$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $7c53a1bfa09ab63e$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $7c53a1bfa09ab63e$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: $7c53a1bfa09ab63e$var$decode(hash)
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $7c53a1bfa09ab63e$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $7c53a1bfa09ab63e$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $7c53a1bfa09ab63e$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $7c53a1bfa09ab63e$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $7c53a1bfa09ab63e$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $7c53a1bfa09ab63e$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $7c53a1bfa09ab63e$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$7c53a1bfa09ab63e$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $7c53a1bfa09ab63e$var$isSameRouteLocationParamsValue(a, b) {
    return $7c53a1bfa09ab63e$var$isArray(a) ? $7c53a1bfa09ab63e$var$isEquivalentArray(a, b) : $7c53a1bfa09ab63e$var$isArray(b) ? $7c53a1bfa09ab63e$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $7c53a1bfa09ab63e$var$isEquivalentArray(a, b) {
    return $7c53a1bfa09ab63e$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $7c53a1bfa09ab63e$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
var $7c53a1bfa09ab63e$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($7c53a1bfa09ab63e$var$NavigationType || ($7c53a1bfa09ab63e$var$NavigationType = {}));
var $7c53a1bfa09ab63e$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($7c53a1bfa09ab63e$var$NavigationDirection || ($7c53a1bfa09ab63e$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $7c53a1bfa09ab63e$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $7c53a1bfa09ab63e$var$normalizeBase(base) {
    if (!base) {
        if ($7c53a1bfa09ab63e$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $7c53a1bfa09ab63e$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $7c53a1bfa09ab63e$var$BEFORE_HASH_RE = /^[^#]+#/;
function $7c53a1bfa09ab63e$var$createHref(base, location1) {
    return base.replace($7c53a1bfa09ab63e$var$BEFORE_HASH_RE, "#") + location1;
}
function $7c53a1bfa09ab63e$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $7c53a1bfa09ab63e$var$computeScrollPosition = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $7c53a1bfa09ab63e$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $7c53a1bfa09ab63e$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $7c53a1bfa09ab63e$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $7c53a1bfa09ab63e$var$scrollPositions = new Map();
function $7c53a1bfa09ab63e$var$saveScrollPosition(key, scrollPosition) {
    $7c53a1bfa09ab63e$var$scrollPositions.set(key, scrollPosition);
}
function $7c53a1bfa09ab63e$var$getSavedScrollPosition(key) {
    const scroll = $7c53a1bfa09ab63e$var$scrollPositions.get(key);
    // consume it so it's not used again
    $7c53a1bfa09ab63e$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $7c53a1bfa09ab63e$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $7c53a1bfa09ab63e$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $7c53a1bfa09ab63e$var$stripBase(pathFromHash, "");
    }
    const path = $7c53a1bfa09ab63e$var$stripBase(pathname, base);
    return path + search + hash;
}
function $7c53a1bfa09ab63e$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $7c53a1bfa09ab63e$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $7c53a1bfa09ab63e$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $7c53a1bfa09ab63e$var$NavigationDirection.forward : $7c53a1bfa09ab63e$var$NavigationDirection.back : $7c53a1bfa09ab63e$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($7c53a1bfa09ab63e$var$assign({}, history1.state, {
            scroll: $7c53a1bfa09ab63e$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener("beforeunload", beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $7c53a1bfa09ab63e$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $7c53a1bfa09ab63e$var$computeScrollPosition() : null
    };
}
function $7c53a1bfa09ab63e$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $7c53a1bfa09ab63e$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $7c53a1bfa09ab63e$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $7c53a1bfa09ab63e$var$assign({}, history1.state, $7c53a1bfa09ab63e$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $7c53a1bfa09ab63e$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $7c53a1bfa09ab63e$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $7c53a1bfa09ab63e$var$assign({}, $7c53a1bfa09ab63e$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $7c53a1bfa09ab63e$export$7b4942f78e7b8a49(base) {
    base = $7c53a1bfa09ab63e$var$normalizeBase(base);
    const historyNavigation = $7c53a1bfa09ab63e$var$useHistoryStateNavigation(base);
    const historyListeners = $7c53a1bfa09ab63e$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $7c53a1bfa09ab63e$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $7c53a1bfa09ab63e$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $7c53a1bfa09ab63e$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $7c53a1bfa09ab63e$var$START
    ];
    let position = 0;
    base = $7c53a1bfa09ab63e$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position !== queue.length) // we are in the middle, we remove everything from here in the queue
        queue.splice(position);
        queue.push(location1);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $7c53a1bfa09ab63e$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $7c53a1bfa09ab63e$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $7c53a1bfa09ab63e$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $7c53a1bfa09ab63e$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $7c53a1bfa09ab63e$var$NavigationDirection.back : $7c53a1bfa09ab63e$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $7c53a1bfa09ab63e$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $7c53a1bfa09ab63e$export$7b4942f78e7b8a49(base);
}
function $7c53a1bfa09ab63e$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $7c53a1bfa09ab63e$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $7c53a1bfa09ab63e$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $7c53a1bfa09ab63e$var$NavigationFailureSymbol = Symbol("");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $7c53a1bfa09ab63e$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($7c53a1bfa09ab63e$export$35710516f95d6a57 || ($7c53a1bfa09ab63e$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $7c53a1bfa09ab63e$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$7c53a1bfa09ab63e$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
 * Creates a typed NavigationFailure object.
 * @internal
 * @param type - NavigationFailureType
 * @param params - { from, to }
 */ function $7c53a1bfa09ab63e$var$createRouterError(type, params) {
    return $7c53a1bfa09ab63e$var$assign(new Error(), {
        type: type,
        [$7c53a1bfa09ab63e$var$NavigationFailureSymbol]: true
    }, params);
}
function $7c53a1bfa09ab63e$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $7c53a1bfa09ab63e$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $7c53a1bfa09ab63e$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $7c53a1bfa09ab63e$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location1 = {};
    for (const key of $7c53a1bfa09ab63e$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $7c53a1bfa09ab63e$var$BASE_PARAM_PATTERN = "[^/]+?";
const $7c53a1bfa09ab63e$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $7c53a1bfa09ab63e$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $7c53a1bfa09ab63e$var$tokensToParser(segments, extraOptions) {
    const options = $7c53a1bfa09ab63e$var$assign({}, $7c53a1bfa09ab63e$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($7c53a1bfa09ab63e$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $7c53a1bfa09ab63e$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $7c53a1bfa09ab63e$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($7c53a1bfa09ab63e$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $7c53a1bfa09ab63e$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $7c53a1bfa09ab63e$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $7c53a1bfa09ab63e$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $7c53a1bfa09ab63e$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($7c53a1bfa09ab63e$var$isLastScoreNegative(aScore)) return 1;
        if ($7c53a1bfa09ab63e$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $7c53a1bfa09ab63e$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $7c53a1bfa09ab63e$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $7c53a1bfa09ab63e$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $7c53a1bfa09ab63e$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $7c53a1bfa09ab63e$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($7c53a1bfa09ab63e$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $7c53a1bfa09ab63e$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $7c53a1bfa09ab63e$var$tokensToParser($7c53a1bfa09ab63e$var$tokenizePath(record.path), options);
    const matcher = $7c53a1bfa09ab63e$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $7c53a1bfa09ab63e$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $7c53a1bfa09ab63e$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $7c53a1bfa09ab63e$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $7c53a1bfa09ab63e$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($7c53a1bfa09ab63e$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $7c53a1bfa09ab63e$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$7c53a1bfa09ab63e$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if (matcher.record.components && Object.keys(matcher.record.components).length || matcher.record.name || matcher.record.redirect) insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $7c53a1bfa09ab63e$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($7c53a1bfa09ab63e$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $7c53a1bfa09ab63e$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$7c53a1bfa09ab63e$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$7c53a1bfa09ab63e$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $7c53a1bfa09ab63e$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $7c53a1bfa09ab63e$var$assign(// paramsFromLocation is a new object
            $7c53a1bfa09ab63e$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $7c53a1bfa09ab63e$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $7c53a1bfa09ab63e$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $7c53a1bfa09ab63e$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $7c53a1bfa09ab63e$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $7c53a1bfa09ab63e$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $7c53a1bfa09ab63e$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $7c53a1bfa09ab63e$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $7c53a1bfa09ab63e$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $7c53a1bfa09ab63e$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $7c53a1bfa09ab63e$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$7c53a1bfa09ab63e$var$assign(meta, record.meta), {});
}
function $7c53a1bfa09ab63e$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $7c53a1bfa09ab63e$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $7c53a1bfa09ab63e$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($7c53a1bfa09ab63e$var$isSameParam.bind(null, key))) return $7c53a1bfa09ab63e$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($7c53a1bfa09ab63e$var$isSameParam.bind(null, key))) return $7c53a1bfa09ab63e$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $7c53a1bfa09ab63e$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $7c53a1bfa09ab63e$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $7c53a1bfa09ab63e$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($7c53a1bfa09ab63e$var$isSameParam.bind(null, key))) return $7c53a1bfa09ab63e$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $7c53a1bfa09ab63e$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $7c53a1bfa09ab63e$var$isRecordChildOf(record, child));
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $7c53a1bfa09ab63e$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($7c53a1bfa09ab63e$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $7c53a1bfa09ab63e$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $7c53a1bfa09ab63e$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$7c53a1bfa09ab63e$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $7c53a1bfa09ab63e$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $7c53a1bfa09ab63e$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $7c53a1bfa09ab63e$var$isArray(value) ? value.map((v)=>v && $7c53a1bfa09ab63e$var$encodeQueryValue(v)) : [
            value && $7c53a1bfa09ab63e$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $7c53a1bfa09ab63e$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $7c53a1bfa09ab63e$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $7c53a1bfa09ab63e$export$7f4879db1558672d = Symbol("");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $7c53a1bfa09ab63e$export$9b3825c34ca1427a = Symbol("");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $7c53a1bfa09ab63e$export$b6c0da8b9dae491f = Symbol("");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $7c53a1bfa09ab63e$export$3aca783e9a3e6e9e = Symbol("");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $7c53a1bfa09ab63e$export$54c8124bead129f8 = Symbol("");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $7c53a1bfa09ab63e$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
function $7c53a1bfa09ab63e$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $9pglz.onUnmounted)(removeFromList);
    (0, $9pglz.onDeactivated)(removeFromList);
    (0, $9pglz.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $7c53a1bfa09ab63e$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $9pglz.inject)($7c53a1bfa09ab63e$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $7c53a1bfa09ab63e$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $7c53a1bfa09ab63e$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $9pglz.inject)($7c53a1bfa09ab63e$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $7c53a1bfa09ab63e$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $7c53a1bfa09ab63e$var$guardToPromiseFn(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($7c53a1bfa09ab63e$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($7c53a1bfa09ab63e$var$isRouteLocation(valid)) reject($7c53a1bfa09ab63e$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $7c53a1bfa09ab63e$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $7c53a1bfa09ab63e$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $7c53a1bfa09ab63e$var$extractComponentsGuards(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($7c53a1bfa09ab63e$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($7c53a1bfa09ab63e$var$guardToPromiseFn(guard, to, from, record, name, runWithContext));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = $7c53a1bfa09ab63e$var$isESModule(resolved) ? resolved.default : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $7c53a1bfa09ab63e$var$guardToPromiseFn(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $7c53a1bfa09ab63e$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $7c53a1bfa09ab63e$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $7c53a1bfa09ab63e$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $7c53a1bfa09ab63e$export$dcf14c9974fe2767(props) {
    const router = (0, $9pglz.inject)($7c53a1bfa09ab63e$export$b6c0da8b9dae491f);
    const currentRoute = (0, $9pglz.inject)($7c53a1bfa09ab63e$export$3aca783e9a3e6e9e);
    const route = (0, $9pglz.computed)(()=>router.resolve((0, $Dz4HH.unref)(props.to)));
    const activeRecordIndex = (0, $9pglz.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($7c53a1bfa09ab63e$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $7c53a1bfa09ab63e$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $7c53a1bfa09ab63e$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($7c53a1bfa09ab63e$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $9pglz.computed)(()=>activeRecordIndex.value > -1 && $7c53a1bfa09ab63e$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $9pglz.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $7c53a1bfa09ab63e$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($7c53a1bfa09ab63e$var$guardEvent(e)) return router[(0, $Dz4HH.unref)(props.replace) ? "replace" : "push"]((0, $Dz4HH.unref)(props.to)).catch($7c53a1bfa09ab63e$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $7c53a1bfa09ab63e$var$isBrowser) {
        const instance = (0, $9pglz.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $9pglz.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $9pglz.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $7c53a1bfa09ab63e$var$RouterLinkImpl = /*#__PURE__*/ (0, $9pglz.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $7c53a1bfa09ab63e$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $Dz4HH.reactive)($7c53a1bfa09ab63e$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $9pglz.inject)($7c53a1bfa09ab63e$export$b6c0da8b9dae491f);
        const elClass = (0, $9pglz.computed)(()=>({
                [$7c53a1bfa09ab63e$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$7c53a1bfa09ab63e$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $9pglz.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $7c53a1bfa09ab63e$export$fce709ebdac448ed = $7c53a1bfa09ab63e$var$RouterLinkImpl;
function $7c53a1bfa09ab63e$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $7c53a1bfa09ab63e$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$7c53a1bfa09ab63e$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $7c53a1bfa09ab63e$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $7c53a1bfa09ab63e$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $7c53a1bfa09ab63e$var$RouterViewImpl = /*#__PURE__*/ (0, $9pglz.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $9pglz.inject)($7c53a1bfa09ab63e$export$54c8124bead129f8);
        const routeToDisplay = (0, $9pglz.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $9pglz.inject)($7c53a1bfa09ab63e$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $9pglz.computed)(()=>{
            let initialDepth = (0, $Dz4HH.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $9pglz.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $9pglz.provide)($7c53a1bfa09ab63e$export$9b3825c34ca1427a, (0, $9pglz.computed)(()=>depth.value + 1));
        (0, $9pglz.provide)($7c53a1bfa09ab63e$export$7f4879db1558672d, matchedRouteRef);
        (0, $9pglz.provide)($7c53a1bfa09ab63e$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $Dz4HH.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $9pglz.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$7c53a1bfa09ab63e$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $7c53a1bfa09ab63e$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $9pglz.h)(ViewComponent, $7c53a1bfa09ab63e$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $7c53a1bfa09ab63e$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $7c53a1bfa09ab63e$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $7c53a1bfa09ab63e$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $7c53a1bfa09ab63e$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $7c53a1bfa09ab63e$export$d941f00e9b9a537 = $7c53a1bfa09ab63e$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $7c53a1bfa09ab63e$var$warnDeprecatedUsage() {
    const instance = (0, $9pglz.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $7c53a1bfa09ab63e$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $7c53a1bfa09ab63e$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $7c53a1bfa09ab63e$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$7c53a1bfa09ab63e$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $7c53a1bfa09ab63e$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $7c53a1bfa09ab63e$var$routerId = 0;
function $7c53a1bfa09ab63e$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $7c53a1bfa09ab63e$var$routerId++;
    (0, $e26ba.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $7c53a1bfa09ab63e$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $7c53a1bfa09ab63e$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($7c53a1bfa09ab63e$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let backgroundColor = $7c53a1bfa09ab63e$var$ORANGE_400;
                    let tooltip = "";
                    if (devtoolsData.isExactActive) {
                        backgroundColor = $7c53a1bfa09ab63e$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $7c53a1bfa09ab63e$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: devtoolsData.route.path,
                        textColor: 0,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $9pglz.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $7c53a1bfa09ab63e$var$formatDisplay("beforeEach"),
                from: $7c53a1bfa09ab63e$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $7c53a1bfa09ab63e$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $7c53a1bfa09ab63e$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $7c53a1bfa09ab63e$var$formatDisplay("\u274C");
            } else data.status = $7c53a1bfa09ab63e$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $7c53a1bfa09ab63e$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $7c53a1bfa09ab63e$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent || // these routes have a parent with no component which will not appear in the view
                // therefore we still need to include them
                !route.parent.record.components);
            // reset match state to false
            routes.forEach($7c53a1bfa09ab63e$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $7c53a1bfa09ab63e$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$7c53a1bfa09ab63e$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($7c53a1bfa09ab63e$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $7c53a1bfa09ab63e$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $7c53a1bfa09ab63e$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $7c53a1bfa09ab63e$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$7c53a1bfa09ab63e$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $7c53a1bfa09ab63e$var$PINK_500 = 0xec4899;
const $7c53a1bfa09ab63e$var$BLUE_600 = 0x2563eb;
const $7c53a1bfa09ab63e$var$LIME_500 = 0x84cc16;
const $7c53a1bfa09ab63e$var$CYAN_400 = 0x22d3ee;
const $7c53a1bfa09ab63e$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $7c53a1bfa09ab63e$var$DARK = 0x666666;
function $7c53a1bfa09ab63e$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $7c53a1bfa09ab63e$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $7c53a1bfa09ab63e$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $7c53a1bfa09ab63e$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $7c53a1bfa09ab63e$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $7c53a1bfa09ab63e$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $7c53a1bfa09ab63e$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($7c53a1bfa09ab63e$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($7c53a1bfa09ab63e$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $7c53a1bfa09ab63e$var$routeRecordId = 0;
const $7c53a1bfa09ab63e$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $7c53a1bfa09ab63e$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $7c53a1bfa09ab63e$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$7c53a1bfa09ab63e$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$7c53a1bfa09ab63e$var$markRouteRecordActive(childRoute, currentRoute));
}
function $7c53a1bfa09ab63e$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($7c53a1bfa09ab63e$var$resetMatchStateOnRouteRecord);
}
function $7c53a1bfa09ab63e$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($7c53a1bfa09ab63e$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$7c53a1bfa09ab63e$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $7c53a1bfa09ab63e$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$7c53a1bfa09ab63e$var$isRouteMatching(child, filter));
}
function $7c53a1bfa09ab63e$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $7c53a1bfa09ab63e$export$baddd0131ee8c05b(options) {
    const matcher = $7c53a1bfa09ab63e$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $7c53a1bfa09ab63e$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $7c53a1bfa09ab63e$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $7c53a1bfa09ab63e$var$useCallbacks();
    const beforeResolveGuards = $7c53a1bfa09ab63e$var$useCallbacks();
    const afterGuards = $7c53a1bfa09ab63e$var$useCallbacks();
    const currentRoute = (0, $Dz4HH.shallowRef)($7c53a1bfa09ab63e$export$e44be9a9779c480b);
    let pendingLocation = $7c53a1bfa09ab63e$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($7c53a1bfa09ab63e$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $7c53a1bfa09ab63e$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $7c53a1bfa09ab63e$var$applyToParams.bind(null, $7c53a1bfa09ab63e$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $7c53a1bfa09ab63e$var$applyToParams.bind(null, $7c53a1bfa09ab63e$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($7c53a1bfa09ab63e$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $7c53a1bfa09ab63e$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $7c53a1bfa09ab63e$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $7c53a1bfa09ab63e$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $7c53a1bfa09ab63e$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if (rawLocation.path != null) matcherLocation = $7c53a1bfa09ab63e$var$assign({}, rawLocation, {
            path: $7c53a1bfa09ab63e$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $7c53a1bfa09ab63e$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $7c53a1bfa09ab63e$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $7c53a1bfa09ab63e$var$stringifyURL(stringifyQuery$1, $7c53a1bfa09ab63e$var$assign({}, rawLocation, {
            hash: $7c53a1bfa09ab63e$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $7c53a1bfa09ab63e$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $7c53a1bfa09ab63e$export$d33b45a8f796a30 ? $7c53a1bfa09ab63e$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $7c53a1bfa09ab63e$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $7c53a1bfa09ab63e$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $7c53a1bfa09ab63e$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($7c53a1bfa09ab63e$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $7c53a1bfa09ab63e$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($7c53a1bfa09ab63e$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $7c53a1bfa09ab63e$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $7c53a1bfa09ab63e$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $7c53a1bfa09ab63e$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$7c53a1bfa09ab63e$export$873de56207a30e5a(error) ? $7c53a1bfa09ab63e$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($7c53a1bfa09ab63e$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $7c53a1bfa09ab63e$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? $7c53a1bfa09ab63e$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $7c53a1bfa09ab63e$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $7c53a1bfa09ab63e$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($7c53a1bfa09ab63e$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($7c53a1bfa09ab63e$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $7c53a1bfa09ab63e$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($7c53a1bfa09ab63e$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of enteringRecords)// do not trigger beforeEnter on reused views
            if (record.beforeEnter) {
                if ($7c53a1bfa09ab63e$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($7c53a1bfa09ab63e$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($7c53a1bfa09ab63e$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $7c53a1bfa09ab63e$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($7c53a1bfa09ab63e$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$7c53a1bfa09ab63e$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $7c53a1bfa09ab63e$export$e44be9a9779c480b;
        const state = !$7c53a1bfa09ab63e$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $7c53a1bfa09ab63e$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($7c53a1bfa09ab63e$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($7c53a1bfa09ab63e$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($7c53a1bfa09ab63e$var$isBrowser) $7c53a1bfa09ab63e$var$saveScrollPosition($7c53a1bfa09ab63e$var$getScrollKey(from.fullPath, info.delta), $7c53a1bfa09ab63e$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($7c53a1bfa09ab63e$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($7c53a1bfa09ab63e$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($7c53a1bfa09ab63e$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $7c53a1bfa09ab63e$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($7c53a1bfa09ab63e$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$7c53a1bfa09ab63e$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $7c53a1bfa09ab63e$var$NavigationType.pop && $7c53a1bfa09ab63e$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            })// avoid warnings in the console about uncaught rejections, they are logged by triggerErrors
            .catch($7c53a1bfa09ab63e$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $7c53a1bfa09ab63e$var$useCallbacks();
    let errorListeners = $7c53a1bfa09ab63e$var$useCallbacks();
    let ready;
    /**
     * Trigger errorListeners added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        // reject the error no matter there were error listeners or not
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $7c53a1bfa09ab63e$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$7c53a1bfa09ab63e$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $7c53a1bfa09ab63e$var$getSavedScrollPosition($7c53a1bfa09ab63e$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $9pglz.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $7c53a1bfa09ab63e$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $7c53a1bfa09ab63e$export$fce709ebdac448ed);
            app.component("RouterView", $7c53a1bfa09ab63e$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $Dz4HH.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($7c53a1bfa09ab63e$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $7c53a1bfa09ab63e$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $7c53a1bfa09ab63e$export$e44be9a9779c480b)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide($7c53a1bfa09ab63e$export$b6c0da8b9dae491f, router);
            app.provide($7c53a1bfa09ab63e$export$3aca783e9a3e6e9e, (0, $Dz4HH.shallowReactive)(reactiveRoute));
            app.provide($7c53a1bfa09ab63e$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $7c53a1bfa09ab63e$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $7c53a1bfa09ab63e$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $7c53a1bfa09ab63e$var$isBrowser) $7c53a1bfa09ab63e$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $7c53a1bfa09ab63e$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$7c53a1bfa09ab63e$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$7c53a1bfa09ab63e$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $7c53a1bfa09ab63e$export$9a302a45f65d0572() {
    return (0, $9pglz.inject)($7c53a1bfa09ab63e$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $7c53a1bfa09ab63e$export$3f79f0b98112cf57() {
    return (0, $9pglz.inject)($7c53a1bfa09ab63e$export$3aca783e9a3e6e9e);
}

});
parcelRegister("e26ba", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", function () { return $a3760ba8d19c2470$export$63b9a9bba9f20f3e; });

var $8Cglu = parcelRequire("8Cglu");

var $qPG30 = parcelRequire("qPG30");

var $aLuTV = parcelRequire("aLuTV");



function $a3760ba8d19c2470$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $8Cglu.getTarget)();
    const hook = (0, $8Cglu.getDevtoolsGlobalHook)();
    const enableProxy = (0, $8Cglu.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $qPG30.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $aLuTV.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("8Cglu", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", function () { return $645e8d3b6ab1cfbf$export$5a2d366b2d9f38f6; });
$parcel$export(module.exports, "getTarget", function () { return $645e8d3b6ab1cfbf$export$c22522a4dfa48e9c; });
$parcel$export(module.exports, "isProxyAvailable", function () { return $645e8d3b6ab1cfbf$export$bc32a04c49ed7464; });
function $645e8d3b6ab1cfbf$export$5a2d366b2d9f38f6() {
    return $645e8d3b6ab1cfbf$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $645e8d3b6ab1cfbf$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const $645e8d3b6ab1cfbf$export$bc32a04c49ed7464 = typeof Proxy === "function";

});

parcelRegister("qPG30", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", function () { return $050a83d5dc1e2c41$export$b1499c3bd2a3f4df; });
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", function () { return $050a83d5dc1e2c41$export$a0897f44accbe922; });
const $050a83d5dc1e2c41$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $050a83d5dc1e2c41$export$a0897f44accbe922 = "plugin:settings:set";

});

parcelRegister("aLuTV", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", function () { return $7d66437c79dc7eea$export$5728f3776e9b2ac1; });

var $qPG30 = parcelRequire("qPG30");

var $c2duz = parcelRequire("c2duz");
class $7d66437c79dc7eea$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $c2duz.now)();
            }
        };
        if (hook) hook.on((0, $qPG30.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("c2duz", function(module, exports) {

$parcel$export(module.exports, "now", function () { return $8c302333d64f2a22$export$461939dd4422153; });
let $8c302333d64f2a22$var$supported;
let $8c302333d64f2a22$var$perf;
function $8c302333d64f2a22$export$70d26280bc1ca547() {
    var _a;
    if ($8c302333d64f2a22$var$supported !== undefined) return $8c302333d64f2a22$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $8c302333d64f2a22$var$supported = true;
        $8c302333d64f2a22$var$perf = window.performance;
    } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $8c302333d64f2a22$var$supported = true;
        $8c302333d64f2a22$var$perf = globalThis.perf_hooks.performance;
    } else $8c302333d64f2a22$var$supported = false;
    return $8c302333d64f2a22$var$supported;
}
function $8c302333d64f2a22$export$461939dd4422153() {
    return $8c302333d64f2a22$export$70d26280bc1ca547() ? $8c302333d64f2a22$var$perf.now() : Date.now();
}

});




parcelRegister("gmBfx", function(module, exports) {

$parcel$export(module.exports, "getTranslation", function () { return $be9b986789153ce0$export$202e99f82f7f0395; });
const $be9b986789153ce0$var$translations = {
    en: {
        show_more: "Show more",
        category: "Category",
        search_word: "Search by Word",
        region: "Region",
        select: "Select...",
        price: "Price",
        over: "Over 2.5M",
        low: "Low to High",
        high: "High to Low",
        newest: "Newest To Oldest",
        oldest: "Oldest To Newest",
        city: "City",
        sort_by: "Sort by",
        search: "Search",
        more_filters: "More Filters",
        filters: "Filters",
        type: "Property Type",
        bedrooms: "Bedrooms",
        more: "More than 8",
        bathrooms: "Bathrooms",
        inside: "Inside Size",
        less_inside: "Less than 100",
        more_inside: "More than 500",
        plot: "Plot Size",
        less_plot: "Less than 500",
        more_plot: "More than 2500",
        location: "Location",
        sea_view: "Sea View",
        waterfront: "Waterfront",
        near_the_sea: "Near the Sea",
        beachfront: "Beachfront",
        mountain_view: "Mountain View",
        river_view: "River View",
        lake_view: "Lake View",
        near_town: "Near Town",
        village: "Village",
        facilities: "Facilities",
        year_built: "Year Built",
        clear: "Clear All",
        show: "Show Properties",
        heated_pool: "Heated Pool",
        outdoor_pool: "Outdoor Pool",
        indoor_pool: "Indoor Pool",
        boat_mooring: "Boat Mooring",
        garage: "Garage",
        hot_tub: "Hot Tub",
        vineyard: "Vineyard",
        gym: "Gym",
        sauna: "Sauna",
        wine_cellar: "Wine Cellar",
        tennis_court: "Tennis Court",
        game_room: "Game Room",
        garden: "Garden",
        terrace: "Terrace",
        balcony: "Balcony",
        outdoor_kitchen: "Outdoor Kitchen",
        elevator: "Elevator",
        popular_destinations: "Popular Destinations",
        popular: "Popular",
        price_range: "Price Range",
        min_price: "Min price",
        max_price: "Max price",
        min_size: "Min size",
        max_size: "Max size"
    },
    hr: {
        show_more: "Prika\u017Ei vi\u0161e",
        category: "Kategorija",
        search_word: "Pretra\u017Ei po rije\u010Di",
        region: "Regija",
        select: "Odaberi...",
        price: "Cijena",
        over: "Vi\u0161e od 2.5M",
        low: "Od najni\u017Ee do najvi\u0161e",
        high: "Od najvi\u0161e do najni\u017Ee",
        newest: "Od najnovijeg do najstarijeg",
        oldest: "Od najstarijeg do najnovijeg",
        city: "Grad",
        sort_by: "Sortiraj po",
        search: "Pretra\u017Ei",
        more_filters: "Vi\u0161e filtera",
        filters: "Filteri",
        type: "Tip nekretnine",
        bedrooms: "Spava\u0107e sobe",
        more: "Vi\u0161e od 8",
        bathrooms: "Kupaonice",
        inside: "Unutarnja veli\u010Dina",
        less_inside: "Manje od 100",
        more_inside: "Vi\u0161e od 500",
        plot: "Veli\u010Dina parcele",
        less_plot: "Manje od 500",
        more_plot: "Vi\u0161e od 2500",
        location: "Lokacija",
        sea_view: "Pogled na more",
        waterfront: "Na obali",
        near_the_sea: "Blizu mora",
        beachfront: "Na pla\u017Ei",
        mountain_view: "Pogled na planine",
        river_view: "Pogled na rijeku",
        lake_view: "Pogled na jezero",
        near_town: "Blizu grada",
        village: "Selo",
        facilities: "Sadr\u017Eaji",
        year_built: "Godina izgradnje",
        clear: "O\u010Disti sve",
        show: "Prika\u017Ei nekretnine",
        heated_pool: "Grijani bazen",
        outdoor_pool: "Vanjski bazen",
        indoor_pool: "Unutarnji bazen",
        boat_mooring: "Veza za brod",
        garage: "Gara\u017Ea",
        hot_tub: "Vru\u0107a kada",
        vineyard: "Vinograd",
        gym: "Teretana",
        sauna: "Sauna",
        wine_cellar: "Vinska podrum",
        tennis_court: "Teniski teren",
        game_room: "Igraonica",
        garden: "Vrt",
        terrace: "Terasa",
        balcony: "Balkon",
        outdoor_kitchen: "Vanjska kuhinja",
        elevator: "Dizalo",
        popular_destinations: "Popularne destinacije",
        popular: "Popularno",
        price_range: "Raspon cijena",
        min_price: "Minimalna cijena",
        max_price: "Maksimalna cijena",
        min_size: "Minimalna veli\u010Dina",
        max_size: "Maksimalna veli\u010Dina"
    },
    de: {
        show_more: "Mehr anzeigen",
        category: "Kategorie",
        search_word: "Nach Wort suchen",
        region: "Region",
        select: "Ausw\xe4hlen...",
        price: "Preis",
        over: "\xdcber 2.5M",
        low: "Von niedrig bis hoch",
        high: "Von hoch bis niedrig",
        newest: "Von neu nach alt",
        oldest: "Von alt nach neu",
        city: "Stadt",
        sort_by: "Sortieren nach",
        search: "Suchen",
        more_filters: "Mehr Filter",
        filters: "Filter",
        type: "Immobilientyp",
        bedrooms: "Schlafzimmer",
        more: "Mehr als 8",
        bathrooms: "Badezimmer",
        inside: "Innengr\xf6\xdfe",
        less_inside: "Weniger als 100",
        more_inside: "Mehr als 500",
        plot: "Grundst\xfccksgr\xf6\xdfe",
        less_plot: "Weniger als 500",
        more_plot: "Mehr als 2500",
        location: "Standort",
        sea_view: "Meerblick",
        waterfront: "Am Wasser",
        near_the_sea: "In der N\xe4he des Meeres",
        beachfront: "Strandfront",
        mountain_view: "Bergblick",
        river_view: "Flussblick",
        lake_view: "Seeblick",
        near_town: "In der N\xe4he der Stadt",
        village: "Dorf",
        facilities: "Einrichtungen",
        year_built: "Baujahr",
        clear: "Alles l\xf6schen",
        show: "Immobilien anzeigen",
        heated_pool: "Beheizter Pool",
        outdoor_pool: "Au\xdfenpool",
        indoor_pool: "Innenpool",
        boat_mooring: "Bootsanleger",
        garage: "Garage",
        hot_tub: "Whirlpool",
        vineyard: "Weinberg",
        gym: "Fitnessstudio",
        sauna: "Sauna",
        wine_cellar: "Weinkeller",
        tennis_court: "Tennisplatz",
        game_room: "Spielzimmer",
        garden: "Garten",
        terrace: "Terrasse",
        balcony: "Balkon",
        outdoor_kitchen: "Au\xdfenk\xfcche",
        elevator: "Aufzug",
        popular_destinations: "Beliebte Reiseziele",
        popular: "Beliebt",
        price_range: "Preisspanne",
        min_price: "Mindestpreis",
        max_price: "H\xf6chstpreis",
        min_size: "Mindestgr\xf6\xdfe",
        max_size: "H\xf6chstgr\xf6\xdfe"
    },
    cs: {
        show_more: "Zobrazit v\xedce",
        category: "Kategorie",
        search_word: "Hledat podle slova",
        region: "Region",
        select: "Vybrat...",
        price: "Cena",
        over: "P\u0159es 2.5M",
        low: "Od nejni\u017E\u0161\xedho k nejvy\u0161\u0161\xedmu",
        high: "Od nejvy\u0161\u0161\xedho k nejni\u017E\u0161\xedmu",
        newest: "Od nejnov\u011Bj\u0161\xedho k nejstar\u0161\xedmu",
        oldest: "Od nejstar\u0161\xedho k nejnov\u011Bj\u0161\xedmu",
        city: "M\u011Bsto",
        sort_by: "Se\u0159adit podle",
        search: "Hledat",
        more_filters: "V\xedce filtr\u016F",
        filters: "Filtry",
        type: "Typ nemovitosti",
        bedrooms: "Lo\u017Enice",
        more: "V\xedce ne\u017E 8",
        bathrooms: "Koupelny",
        inside: "Velikost uvnit\u0159",
        less_inside: "M\xe9n\u011B ne\u017E 100",
        more_inside: "V\xedce ne\u017E 500",
        plot: "Velikost pozemku",
        less_plot: "M\xe9n\u011B ne\u017E 500",
        more_plot: "V\xedce ne\u017E 2500",
        location: "Poloha",
        sea_view: "V\xfdhled na mo\u0159e",
        waterfront: "Na n\xe1b\u0159e\u017E\xed",
        near_the_sea: "Bl\xedzko mo\u0159e",
        beachfront: "Na pl\xe1\u017Ei",
        mountain_view: "V\xfdhled na hory",
        river_view: "V\xfdhled na \u0159eku",
        lake_view: "V\xfdhled na jezero",
        near_town: "Bl\xedzko m\u011Bsta",
        village: "Vesnice",
        facilities: "Za\u0159\xedzen\xed",
        year_built: "Rok v\xfdstavby",
        clear: "Vymazat v\u0161e",
        show: "Zobrazit nemovitosti",
        heated_pool: "Vyh\u0159\xedvan\xfd baz\xe9n",
        outdoor_pool: "Venkovn\xed baz\xe9n",
        indoor_pool: "Kryt\xfd baz\xe9n",
        boat_mooring: "P\u0159\xedstav pro lod\u011B",
        garage: "Gar\xe1\u017E",
        hot_tub: "V\xed\u0159ivka",
        vineyard: "Vinice",
        gym: "Posilovna",
        sauna: "Sauna",
        wine_cellar: "Vinn\xfd sklep",
        tennis_court: "Tenisov\xfd kurt",
        game_room: "Hern\xed m\xedstnost",
        garden: "Zahrada",
        terrace: "Terasa",
        balcony: "Balkon",
        outdoor_kitchen: "Venkovn\xed kuchyn\u011B",
        elevator: "V\xfdtah",
        popular_destinations: "Popul\xe1rn\xed destinace",
        popular: "Obl\xedben\xfd",
        price_range: "Cenov\xe9 rozp\u011Bt\xed",
        min_price: "Minim\xe1ln\xed cena",
        max_price: "Maxim\xe1ln\xed cena",
        min_size: "Minim\xe1ln\xed velikost",
        max_size: "Maxim\xe1ln\xed velikost"
    },
    es: {
        show_more: "Mostrar m\xe1s",
        category: "Categor\xeda",
        search_word: "Buscar por palabra",
        region: "Regi\xf3n",
        select: "Seleccionar...",
        price: "Precio",
        over: "M\xe1s de 2.5M",
        low: "De menor a mayor",
        high: "De mayor a menor",
        newest: "De m\xe1s nuevo a m\xe1s viejo",
        oldest: "De m\xe1s viejo a m\xe1s nuevo",
        city: "Ciudad",
        sort_by: "Ordenar por",
        search: "Buscar",
        more_filters: "M\xe1s filtros",
        filters: "Filtros",
        type: "Tipo de propiedad",
        bedrooms: "Dormitorios",
        more: "M\xe1s de 8",
        bathrooms: "Ba\xf1os",
        inside: "Tama\xf1o interior",
        less_inside: "Menos de 100",
        more_inside: "M\xe1s de 500",
        plot: "Tama\xf1o del terreno",
        less_plot: "Menos de 500",
        more_plot: "M\xe1s de 2500",
        location: "Ubicaci\xf3n",
        sea_view: "Vista al mar",
        waterfront: "Frente al agua",
        near_the_sea: "Cerca del mar",
        beachfront: "Frente a la playa",
        mountain_view: "Vista a la monta\xf1a",
        river_view: "Vista al r\xedo",
        lake_view: "Vista al lago",
        near_town: "Cerca del pueblo",
        village: "Pueblo",
        facilities: "Instalaciones",
        year_built: "A\xf1o de construcci\xf3n",
        clear: "Borrar todo",
        show: "Mostrar propiedades",
        heated_pool: "Piscina climatizada",
        outdoor_pool: "Piscina exterior",
        indoor_pool: "Piscina interior",
        boat_mooring: "Amarre para barcos",
        garage: "Garaje",
        hot_tub: "Jacuzzi",
        vineyard: "Vi\xf1edo",
        gym: "Gimnasio",
        sauna: "Sauna",
        wine_cellar: "Bodega",
        tennis_court: "Pista de tenis",
        game_room: "Sala de juegos",
        garden: "Jard\xedn",
        terrace: "Terraza",
        balcony: "Balc\xf3n",
        outdoor_kitchen: "Cocina exterior",
        elevator: "Ascensor",
        popular_destinations: "Destinos populares",
        popular: "Popular",
        price_range: "Rango de precios",
        min_price: "Precio m\xednimo",
        max_price: "Precio m\xe1ximo",
        min_size: "Tama\xf1o m\xednimo",
        max_size: "Tama\xf1o m\xe1ximo"
    },
    fr: {
        "show_more": "Afficher plus",
        "category": "Cat\xe9gorie",
        "search_word": "Rechercher par mot",
        "region": "R\xe9gion",
        "select": "S\xe9lectionner...",
        "price": "Prix",
        "over": "Plus de 2.5M",
        "low": "Du moins cher au plus cher",
        "high": "Du plus cher au moins cher",
        "newest": "Du plus r\xe9cent au plus ancien",
        "oldest": "Du plus ancien au plus r\xe9cent",
        "city": "Ville",
        "sort_by": "Trier par",
        "search": "Rechercher",
        "more_filters": "Plus de filtres",
        "filters": "Filtres",
        "type": "Type de propri\xe9t\xe9",
        "bedrooms": "Chambres",
        "more": "Plus de 8",
        "bathrooms": "Salles de bain",
        "inside": "Taille int\xe9rieure",
        "less_inside": "Moins de 100",
        "more_inside": "Plus de 500",
        "plot": "Taille du terrain",
        "less_plot": "Moins de 500",
        "more_plot": "Plus de 2500",
        "location": "Emplacement",
        "sea_view": "Vue sur mer",
        "waterfront": "Bord de l'eau",
        "near_the_sea": "Proche de la mer",
        "beachfront": "Front de mer",
        "mountain_view": "Vue sur montagne",
        "river_view": "Vue sur rivi\xe8re",
        "lake_view": "Vue sur lac",
        "near_town": "Proche de la ville",
        "village": "Village",
        "facilities": "Installations",
        "year_built": "Ann\xe9e de construction",
        "clear": "Tout effacer",
        "show": "Afficher les propri\xe9t\xe9s",
        "heated_pool": "Piscine chauff\xe9e",
        "outdoor_pool": "Piscine ext\xe9rieure",
        "indoor_pool": "Piscine int\xe9rieure",
        "boat_mooring": "Amarrage pour bateaux",
        "garage": "Garage",
        "hot_tub": "Jacuzzi",
        "vineyard": "Vignoble",
        "gym": "Salle de sport",
        "sauna": "Sauna",
        "wine_cellar": "Cave \xe0 vin",
        "tennis_court": "Court de tennis",
        "game_room": "Salle de jeux",
        "garden": "Jardin",
        "terrace": "Terrasse",
        "balcony": "Balcon",
        "outdoor_kitchen": "Cuisine ext\xe9rieure",
        "elevator": "Ascenseur",
        "popular_destinations": "Destinations populaires",
        popular: "Populaire",
        price_range: "Fourchette de prix",
        min_price: "Prix minimum",
        max_price: "Prix maximum",
        min_size: "Taille minimale",
        max_size: "Taille maximale"
    },
    hu: {
        "show_more": "T\xf6bbet mutat",
        "category": "Kateg\xf3ria",
        "search_word": "Keres\xe9s sz\xf3 alapj\xe1n",
        "region": "R\xe9gi\xf3",
        "select": "V\xe1lasszon...",
        "price": "\xc1r",
        "over": "2.5M felett",
        "low": "N\xf6vekv\u0151 sorrend",
        "high": "Cs\xf6kken\u0151 sorrend",
        "newest": "Leg\xfajabb el\xf6l",
        "oldest": "Legr\xe9gebbi el\xf6l",
        "city": "V\xe1ros",
        "sort_by": "Rendez\xe9s",
        "search": "Keres\xe9s",
        "more_filters": "T\xf6bb sz\u0171r\u0151",
        "filters": "Sz\u0171r\u0151k",
        "type": "Ingatlan t\xedpusa",
        "bedrooms": "H\xe1l\xf3szob\xe1k",
        "more": "T\xf6bb mint 8",
        "bathrooms": "F\xfcrd\u0151szob\xe1k",
        "inside": "Bels\u0151 m\xe9ret",
        "less_inside": "Kevesebb mint 100",
        "more_inside": "T\xf6bb mint 500",
        "plot": "Telek m\xe9rete",
        "less_plot": "Kevesebb mint 500",
        "more_plot": "T\xf6bb mint 2500",
        "location": "Elhelyezked\xe9s",
        "sea_view": "Tengerre n\xe9z\u0151",
        "waterfront": "V\xedzparti",
        "near_the_sea": "Tenger k\xf6zel\xe9ben",
        "beachfront": "Tengerparti",
        "mountain_view": "Hegyre n\xe9z\u0151",
        "river_view": "Foly\xf3ra n\xe9z\u0151",
        "lake_view": "T\xf3ra n\xe9z\u0151",
        "near_town": "V\xe1ros k\xf6zel\xe9ben",
        "village": "Falu",
        "facilities": "L\xe9tes\xedtm\xe9nyek",
        "year_built": "\xc9p\xedt\xe9s \xe9ve",
        "clear": "\xd6sszes t\xf6rl\xe9se",
        "show": "Ingatlanok megjelen\xedt\xe9se",
        "heated_pool": "F\u0171t\xf6tt medence",
        "outdoor_pool": "K\xfclt\xe9ri medence",
        "indoor_pool": "Belt\xe9ri medence",
        "boat_mooring": "Haj\xf3kik\xf6t\u0151",
        "garage": "Gar\xe1zs",
        "hot_tub": "Jacuzzi",
        "vineyard": "Sz\u0151l\u0151\xfcltetv\xe9ny",
        "gym": "Edz\u0151terem",
        "sauna": "Szauna",
        "wine_cellar": "Borpince",
        "tennis_court": "Teniszp\xe1lya",
        "game_room": "J\xe1t\xe9kszoba",
        "garden": "Kert",
        "terrace": "Terasz",
        "balcony": "Erk\xe9ly",
        "outdoor_kitchen": "K\xfclt\xe9ri konyha",
        "elevator": "Lift",
        "popular_destinations": "N\xe9pszer\u0171 \xfati c\xe9lok",
        popular: "N\xe9pszer\u0171",
        price_range: "\xc1rtartom\xe1ny",
        min_price: "Minim\xe1lis \xe1r",
        max_price: "Maxim\xe1lis \xe1r",
        min_size: "Minim\xe1lis m\xe9ret",
        max_size: "Maxim\xe1lis m\xe9ret"
    },
    sl: {
        "show_more": "Poka\u017Ei ve\u010D",
        "category": "Kategorija",
        "search_word": "I\u0161\u010Di po besedi",
        "region": "Regija",
        "select": "Izberite...",
        "price": "Cena",
        "over": "Ve\u010D kot 2.5M",
        "low": "Od najni\u017Eje do najvi\u0161je",
        "high": "Od najvi\u0161je do najni\u017Eje",
        "newest": "Od najnovej\u0161ega do najstarej\u0161ega",
        "oldest": "Od najstarej\u0161ega do najnovej\u0161ega",
        "city": "Mesto",
        "sort_by": "Razvrsti po",
        "search": "I\u0161\u010Di",
        "more_filters": "Ve\u010D filtrov",
        "filters": "Filtri",
        "type": "Vrsta nepremi\u010Dnine",
        "bedrooms": "Spalnice",
        "more": "Ve\u010D kot 8",
        "bathrooms": "Kopalnice",
        "inside": "Notranja velikost",
        "less_inside": "Manj kot 100",
        "more_inside": "Ve\u010D kot 500",
        "plot": "Velikost zemlji\u0161\u010Da",
        "less_plot": "Manj kot 500",
        "more_plot": "Ve\u010D kot 2500",
        "location": "Lokacija",
        "sea_view": "Pogled na morje",
        "waterfront": "Ob vodi",
        "near_the_sea": "Blizu morja",
        "beachfront": "Ob obali",
        "mountain_view": "Pogled na gore",
        "river_view": "Pogled na reko",
        "lake_view": "Pogled na jezero",
        "near_town": "Blizu mesta",
        "village": "Vas",
        "facilities": "Objekti",
        "year_built": "Leto izgradnje",
        "clear": "Po\u010Disti vse",
        "show": "Poka\u017Ei nepremi\u010Dnine",
        "heated_pool": "Ogrevan bazen",
        "outdoor_pool": "Zunanji bazen",
        "indoor_pool": "Notranji bazen",
        "boat_mooring": "Privezi\u0161\u010De za \u010Dolne",
        "garage": "Gara\u017Ea",
        "hot_tub": "Jacuzzi",
        "vineyard": "Vinograd",
        "gym": "Fitnes",
        "sauna": "Savna",
        "wine_cellar": "Vinska klet",
        "tennis_court": "Tenis igri\u0161\u010De",
        "game_room": "Igralnica",
        "garden": "Vrt",
        "terrace": "Terasa",
        "balcony": "Balkon",
        "outdoor_kitchen": "Zunanja kuhinja",
        "elevator": "Dvigalo",
        "popular_destinations": "Priljubljene destinacije",
        popular: "Priljubljeno",
        price_range: "Cenovni razpon",
        min_price: "Najni\u017Eja cena",
        max_price: "Najvi\u0161ja cena",
        min_size: "Najmanj\u0161a velikost",
        max_size: "Najve\u010Dja velikost"
    },
    pl: {
        "show_more": "Poka\u017C wi\u0119cej",
        "category": "Kategoria",
        "search_word": "Szukaj wed\u0142ug s\u0142owa",
        "region": "Region",
        "select": "Wybierz...",
        "price": "Cena",
        "over": "Ponad 2.5M",
        "low": "Od najmniejszej do najwi\u0119kszej",
        "high": "Od najwi\u0119kszej do najmniejszej",
        "newest": "Od najnowszych do najstarszych",
        "oldest": "Od najstarszych do najnowszych",
        "city": "Miasto",
        "sort_by": "Sortuj wed\u0142ug",
        "search": "Szukaj",
        "more_filters": "Wi\u0119cej filtr\xf3w",
        "filters": "Filtry",
        "type": "Rodzaj nieruchomo\u015Bci",
        "bedrooms": "Sypialnie",
        "more": "Wi\u0119cej ni\u017C 8",
        "bathrooms": "\u0141azienki",
        "inside": "Wielko\u015B\u0107 wewn\u0119trzna",
        "less_inside": "Mniej ni\u017C 100",
        "more_inside": "Wi\u0119cej ni\u017C 500",
        "plot": "Wielko\u015B\u0107 dzia\u0142ki",
        "less_plot": "Mniej ni\u017C 500",
        "more_plot": "Wi\u0119cej ni\u017C 2500",
        "location": "Lokalizacja",
        "sea_view": "Widok na morze",
        "waterfront": "Przy wodzie",
        "near_the_sea": "Blisko morza",
        "beachfront": "Przy pla\u017Cy",
        "mountain_view": "Widok na g\xf3ry",
        "river_view": "Widok na rzek\u0119",
        "lake_view": "Widok na jezioro",
        "near_town": "Blisko miasta",
        "village": "Wie\u015B",
        "facilities": "Udogodnienia",
        "year_built": "Rok budowy",
        "clear": "Wyczy\u015B\u0107 wszystko",
        "show": "Poka\u017C nieruchomo\u015Bci",
        "heated_pool": "Podgrzewany basen",
        "outdoor_pool": "Basen zewn\u0119trzny",
        "indoor_pool": "Basen kryty",
        "boat_mooring": "Przysta\u0144 dla \u0142odzi",
        "garage": "Gara\u017C",
        "hot_tub": "Jacuzzi",
        "vineyard": "Winnica",
        "gym": "Si\u0142ownia",
        "sauna": "Sauna",
        "wine_cellar": "Piwnica na wino",
        "tennis_court": "Kort tenisowy",
        "game_room": "Pok\xf3j gier",
        "garden": "Ogr\xf3d",
        "terrace": "Taras",
        "balcony": "Balkon",
        "outdoor_kitchen": "Kuchnia zewn\u0119trzna",
        "elevator": "Winda",
        "popular_destinations": "Popularne miejsca",
        popular: "Popularny",
        price_range: "Przedzia\u0142 cenowy",
        min_price: "Cena minimalna",
        max_price: "Cena maksymalna",
        min_size: "Minimalny rozmiar",
        max_size: "Maksymalny rozmiar"
    },
    fi: {
        show_more: "N\xe4yt\xe4 lis\xe4\xe4",
        category: "Kategoria",
        search_word: "Etsi sanalla",
        region: "Alue",
        select: "Valitse...",
        price: "Hinta",
        over: "Yli 2,5M",
        low: "Alin ensin",
        high: "Korkein ensin",
        newest: "Uusin ensin",
        oldest: "Vanhin ensin",
        city: "Kaupunki",
        sort_by: "Lajittele",
        search: "Etsi",
        more_filters: "Lis\xe4\xe4 suodattimia",
        filters: "Suodattimet",
        type: "Kiinteist\xf6n tyyppi",
        bedrooms: "Makuuhuoneet",
        more: "Yli 8",
        bathrooms: "Kylpyhuoneet",
        inside: "Sis\xe4pinta-ala",
        less_inside: "Alle 100",
        more_inside: "Yli 500",
        plot: "Tontin koko",
        less_plot: "Alle 500",
        more_plot: "Yli 2500",
        location: "Sijainti",
        sea_view: "Merin\xe4k\xf6ala",
        waterfront: "Rantaviiva",
        near_the_sea: "L\xe4hell\xe4 merta",
        beachfront: "Rantaviiva",
        mountain_view: "Vuoriston\xe4kym\xe4",
        river_view: "Jokin\xe4kym\xe4",
        lake_view: "J\xe4rvin\xe4kym\xe4",
        near_town: "L\xe4hell\xe4 kaupunkia",
        village: "Kyl\xe4",
        facilities: "Mukavuudet",
        year_built: "Rakennusvuosi",
        clear: "Tyhjenn\xe4 kaikki",
        show: "N\xe4yt\xe4 kiinteist\xf6t",
        heated_pool: "L\xe4mmitetty uima-allas",
        outdoor_pool: "Ulkouima-allas",
        indoor_pool: "Sis\xe4uima-allas",
        boat_mooring: "Veneen kiinnityspaikka",
        garage: "Autotalli",
        hot_tub: "Poreallas",
        vineyard: "Viinitarha",
        gym: "Kuntosali",
        sauna: "Sauna",
        wine_cellar: "Viinikellari",
        tennis_court: "Tenniskentt\xe4",
        game_room: "Peliaula",
        garden: "Puutarha",
        terrace: "Terassi",
        balcony: "Parveke",
        outdoor_kitchen: "Ulkokeitti\xf6",
        elevator: "Hissi",
        popular_destinations: "Suositut kohteet",
        popular: "Suosittu",
        price_range: "Hintahaarukka",
        min_price: "Minimihinta",
        max_price: "Maksimihinta",
        min_size: "Pienin koko",
        max_size: "Suurin koko"
    },
    no: {
        show_more: "Vis mer",
        category: "Kategori",
        search_word: "S\xf8k etter ord",
        region: "Region",
        select: "Velg...",
        price: "Pris",
        over: "Over 2,5M",
        low: "Lav til h\xf8y",
        high: "H\xf8y til lav",
        newest: "Nyeste til eldste",
        oldest: "Eldste til nyeste",
        city: "By",
        sort_by: "Sorter etter",
        search: "S\xf8k",
        more_filters: "Flere filtre",
        filters: "Filtre",
        type: "Eiendomstype",
        bedrooms: "Soverom",
        more: "Mer enn 8",
        bathrooms: "Bad",
        inside: "Innvendig st\xf8rrelse",
        less_inside: "Mindre enn 100",
        more_inside: "Mer enn 500",
        plot: "Tomtest\xf8rrelse",
        less_plot: "Mindre enn 500",
        more_plot: "Mer enn 2500",
        location: "Beliggenhet",
        sea_view: "Sj\xf8utsikt",
        waterfront: "Vannkanten",
        near_the_sea: "N\xe6r sj\xf8en",
        beachfront: "Strandlinje",
        mountain_view: "Fjellutsikt",
        river_view: "Elveutsikt",
        lake_view: "Innsj\xf8utsikt",
        near_town: "N\xe6r byen",
        village: "Landsby",
        facilities: "Fasiliteter",
        year_built: "Bygge\xe5r",
        clear: "T\xf8m alle",
        show: "Vis eiendommer",
        heated_pool: "Oppvarmet basseng",
        outdoor_pool: "Utend\xf8rs basseng",
        indoor_pool: "Innend\xf8rs basseng",
        boat_mooring: "B\xe5tplass",
        garage: "Garasje",
        hot_tub: "Boblebad",
        vineyard: "Ving\xe5rd",
        gym: "Treningsrom",
        sauna: "Badstue",
        wine_cellar: "Vinkjeller",
        tennis_court: "Tennisbane",
        game_room: "Spillerom",
        garden: "Hage",
        terrace: "Terrasse",
        balcony: "Balkong",
        outdoor_kitchen: "Utekj\xf8kken",
        elevator: "Heis",
        popular_destinations: "Popul\xe6re destinasjoner",
        popular: "Popul\xe6r",
        price_range: "Prisspenn",
        min_price: "Minste pris",
        max_price: "Maksimal pris",
        min_size: "Minste st\xf8rrelse",
        max_size: "St\xf8rste st\xf8rrelse"
    },
    sv: {
        show_more: "Visa mer",
        category: "Kategori",
        search_word: "S\xf6k efter ord",
        region: "Region",
        select: "V\xe4lj...",
        price: "Pris",
        over: "\xd6ver 2,5M",
        low: "L\xe5gt till h\xf6gt",
        high: "H\xf6gt till l\xe5gt",
        newest: "Nyast till \xe4ldst",
        oldest: "\xc4ldst till nyast",
        city: "Stad",
        sort_by: "Sortera efter",
        search: "S\xf6k",
        more_filters: "Fler filter",
        filters: "Filter",
        type: "Fastighetstyp",
        bedrooms: "Sovrum",
        more: "Mer \xe4n 8",
        bathrooms: "Badrum",
        inside: "Innerv\xe5ning",
        less_inside: "Mindre \xe4n 100",
        more_inside: "Mer \xe4n 500",
        plot: "Tomtstorlek",
        less_plot: "Mindre \xe4n 500",
        more_plot: "Mer \xe4n 2500",
        location: "Plats",
        sea_view: "Havsutsikt",
        waterfront: "Vid vattnet",
        near_the_sea: "N\xe4ra havet",
        beachfront: "Strandlinje",
        mountain_view: "Bergsutsikt",
        river_view: "Flodutsikt",
        lake_view: "Sj\xf6\xf6versikt",
        near_town: "N\xe4ra stan",
        village: "By",
        facilities: "Faciliteter",
        year_built: "Byggnads\xe5r",
        clear: "Rensa alla",
        show: "Visa fastigheter",
        heated_pool: "Uppv\xe4rmd pool",
        outdoor_pool: "Utomhuspool",
        indoor_pool: "Inomhuspool",
        boat_mooring: "B\xe5tplats",
        garage: "Garage",
        hot_tub: "Bubbelpool",
        vineyard: "Ving\xe5rd",
        gym: "Gym",
        sauna: "Bastu",
        wine_cellar: "Vink\xe4llare",
        tennis_court: "Tennisbana",
        game_room: "Spelrum",
        garden: "Tr\xe4dg\xe5rd",
        terrace: "Terrass",
        balcony: "Balkong",
        outdoor_kitchen: "Utek\xf6k",
        elevator: "Hiss",
        popular_destinations: "Popul\xe4ra destinationer",
        popular: "Popul\xe4r",
        price_range: "Prisklass",
        min_price: "L\xe4gsta pris",
        max_price: "H\xf6gsta pris",
        min_size: "Minsta storlek",
        max_size: "St\xf6rsta storlek"
    },
    it: {
        show_more: "Mostra di pi\xf9",
        category: "Categoria",
        search_word: "Cerca per Parola",
        region: "Regione",
        select: "Seleziona...",
        price: "Prezzo",
        over: "Oltre 2.5M",
        low: "Dal Basso all'Alto",
        high: "Dall'Alto al Basso",
        newest: "Dal Pi\xf9 Recente al Pi\xf9 Vecchio",
        oldest: "Dal Pi\xf9 Vecchio al Pi\xf9 Recente",
        city: "Citt\xe0",
        sort_by: "Ordina per",
        search: "Cerca",
        more_filters: "Altri Filtri",
        filters: "Filtri",
        type: "Tipo di Propriet\xe0",
        bedrooms: "Camere da Letto",
        more: "Pi\xf9 di 8",
        bathrooms: "Bagni",
        inside: "Dimensione Interna",
        less_inside: "Meno di 100",
        more_inside: "Pi\xf9 di 500",
        plot: "Dimensione del Terreno",
        less_plot: "Meno di 500",
        more_plot: "Pi\xf9 di 2500",
        location: "Posizione",
        sea_view: "Vista Mare",
        waterfront: "Fronte Mare",
        near_the_sea: "Vicino al Mare",
        beachfront: "Fronte Spiaggia",
        mountain_view: "Vista Montagna",
        river_view: "Vista Fiume",
        lake_view: "Vista Lago",
        near_town: "Vicino alla Citt\xe0",
        village: "Villaggio",
        facilities: "Servizi",
        year_built: "Anno di Costruzione",
        clear: "Cancella Tutto",
        show: "Mostra Propriet\xe0",
        heated_pool: "Piscina Riscaldata",
        outdoor_pool: "Piscina All'Aperto",
        indoor_pool: "Piscina Coperta",
        boat_mooring: "Ormeggio",
        garage: "Garage",
        hot_tub: "Vasca Idromassaggio",
        vineyard: "Vigneto",
        gym: "Palestra",
        sauna: "Sauna",
        wine_cellar: "Cantina",
        tennis_court: "Campo da Tennis",
        game_room: "Sala Giochi",
        garden: "Giardino",
        terrace: "Terrazza",
        balcony: "Balcone",
        outdoor_kitchen: "Cucina All'Aperto",
        elevator: "Ascensore",
        popular_destinations: "Destinazioni Popolari",
        popular: "Popolare",
        price_range: "Fascia di prezzo",
        min_price: "Prezzo minimo",
        max_price: "Prezzo massimo",
        min_size: "Dimensione minima",
        max_size: "Dimensione massima"
    },
    uk: {
        show_more: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
        category: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        search_word: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0441\u043B\u043E\u0432\u043E\u043C",
        region: "\u0420\u0435\u0433\u0456\u043E\u043D",
        select: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C...",
        price: "\u0426\u0456\u043D\u0430",
        over: "\u0411\u0456\u043B\u044C\u0448\u0435 2.5M",
        low: "\u0412\u0456\u0434 \u043D\u0438\u0436\u0447\u043E\u0433\u043E \u0434\u043E \u0432\u0438\u0449\u043E\u0433\u043E",
        high: "\u0412\u0456\u0434 \u0432\u0438\u0449\u043E\u0433\u043E \u0434\u043E \u043D\u0438\u0436\u0447\u043E\u0433\u043E",
        newest: "\u0412\u0456\u0434 \u043D\u0430\u0439\u043D\u043E\u0432\u0456\u0448\u0438\u0445 \u0434\u043E \u043D\u0430\u0439\u0441\u0442\u0430\u0440\u0456\u0448\u0438\u0445",
        oldest: "\u0412\u0456\u0434 \u043D\u0430\u0439\u0441\u0442\u0430\u0440\u0456\u0448\u0438\u0445 \u0434\u043E \u043D\u0430\u0439\u043D\u043E\u0432\u0456\u0448\u0438\u0445",
        city: "\u041C\u0456\u0441\u0442\u043E",
        sort_by: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430",
        search: "\u041F\u043E\u0448\u0443\u043A",
        more_filters: "\u0411\u0456\u043B\u044C\u0448\u0435 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432",
        filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
        type: "\u0422\u0438\u043F \u043D\u0435\u0440\u0443\u0445\u043E\u043C\u043E\u0441\u0442\u0456",
        bedrooms: "\u0421\u043F\u0430\u043B\u044C\u043D\u0456",
        more: "\u0411\u0456\u043B\u044C\u0448\u0435 8",
        bathrooms: "\u0412\u0430\u043D\u043D\u0456 \u043A\u0456\u043C\u043D\u0430\u0442\u0438",
        inside: "\u0420\u043E\u0437\u043C\u0456\u0440 \u043F\u0440\u0438\u043C\u0456\u0449\u0435\u043D\u043D\u044F",
        less_inside: "\u041C\u0435\u043D\u0448\u0435 100",
        more_inside: "\u0411\u0456\u043B\u044C\u0448\u0435 500",
        plot: "\u0420\u043E\u0437\u043C\u0456\u0440 \u0434\u0456\u043B\u044F\u043D\u043A\u0438",
        less_plot: "\u041C\u0435\u043D\u0448\u0435 500",
        more_plot: "\u0411\u0456\u043B\u044C\u0448\u0435 2500",
        location: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
        sea_view: "\u0412\u0438\u0434 \u043D\u0430 \u043C\u043E\u0440\u0435",
        waterfront: "\u041D\u0430 \u0431\u0435\u0440\u0435\u0437\u0456 \u0432\u043E\u0434\u0438",
        near_the_sea: "\u0411\u0456\u043B\u044F \u043C\u043E\u0440\u044F",
        beachfront: "\u041D\u0430 \u0431\u0435\u0440\u0435\u0437\u0456",
        mountain_view: "\u0412\u0438\u0434 \u043D\u0430 \u0433\u043E\u0440\u0438",
        river_view: "\u0412\u0438\u0434 \u043D\u0430 \u0440\u0456\u0447\u043A\u0443",
        lake_view: "\u0412\u0438\u0434 \u043D\u0430 \u043E\u0437\u0435\u0440\u043E",
        near_town: "\u0411\u0456\u043B\u044F \u043C\u0456\u0441\u0442\u0430",
        village: "\u0421\u0435\u043B\u043E",
        facilities: "\u0417\u0440\u0443\u0447\u043D\u043E\u0441\u0442\u0456",
        year_built: "\u0420\u0456\u043A \u043F\u043E\u0431\u0443\u0434\u043E\u0432\u0438",
        clear: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0432\u0441\u0435",
        show: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043D\u0435\u0440\u0443\u0445\u043E\u043C\u0456\u0441\u0442\u044C",
        heated_pool: "\u041F\u0456\u0434\u0456\u0433\u0440\u0456\u0442\u0438\u0439 \u0431\u0430\u0441\u0435\u0439\u043D",
        outdoor_pool: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0439 \u0431\u0430\u0441\u0435\u0439\u043D",
        indoor_pool: "\u041A\u0440\u0438\u0442\u0438\u0439 \u0431\u0430\u0441\u0435\u0439\u043D",
        boat_mooring: "\u041F\u0440\u0438\u0447\u0430\u043B \u0434\u043B\u044F \u0447\u043E\u0432\u043D\u0456\u0432",
        garage: "\u0413\u0430\u0440\u0430\u0436",
        hot_tub: "\u0413\u0430\u0440\u044F\u0447\u0430 \u0432\u0430\u043D\u043D\u0430",
        vineyard: "\u0412\u0438\u043D\u043E\u0433\u0440\u0430\u0434\u043D\u0438\u043A",
        gym: "\u0422\u0440\u0435\u043D\u0430\u0436\u0435\u0440\u043D\u0438\u0439 \u0437\u0430\u043B",
        sauna: "\u0421\u0430\u0443\u043D\u0430",
        wine_cellar: "\u0412\u0438\u043D\u043D\u0438\u0439 \u043F\u0456\u0434\u0432\u0430\u043B",
        tennis_court: "\u0422\u0435\u043D\u0456\u0441\u043D\u0438\u0439 \u043A\u043E\u0440\u0442",
        game_room: "\u0406\u0433\u0440\u043E\u0432\u0430 \u043A\u0456\u043C\u043D\u0430\u0442\u0430",
        garden: "\u0421\u0430\u0434",
        terrace: "\u0422\u0435\u0440\u0430\u0441\u0430",
        balcony: "\u0411\u0430\u043B\u043A\u043E\u043D",
        outdoor_kitchen: "\u041A\u0443\u0445\u043D\u044F \u043D\u0430 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E\u043C\u0443 \u043F\u043E\u0432\u0456\u0442\u0440\u0456",
        elevator: "\u041B\u0456\u0444\u0442",
        popular_destinations: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0456 \u043C\u0456\u0441\u0446\u044F",
        popular: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u0438\u0439",
        price_range: "\u0426\u0456\u043D\u043E\u0432\u0438\u0439 \u0434\u0456\u0430\u043F\u0430\u0437\u043E\u043D",
        min_price: "\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0430 \u0446\u0456\u043D\u0430",
        max_price: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430 \u0446\u0456\u043D\u0430",
        min_size: "\u041C\u0456\u043D\u0456\u043C\u0430\u043B\u044C\u043D\u0438\u0439 \u0440\u043E\u0437\u043C\u0456\u0440",
        max_size: "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0438\u0439 \u0440\u043E\u0437\u043C\u0456\u0440"
    },
    sk: {
        show_more: "Uk\xe1za\u0165 viac",
        category: "Kateg\xf3ria",
        search_word: "H\u013Eada\u0165 pod\u013Ea slova",
        region: "Regi\xf3n",
        select: "Vyberte...",
        price: "Cena",
        over: "Nad 2.5M",
        low: "Od najni\u017E\u0161ej po najvy\u0161\u0161iu",
        high: "Od najvy\u0161\u0161ej po najni\u017E\u0161iu",
        newest: "Od najnov\u0161\xedch po najstar\u0161ie",
        oldest: "Od najstar\u0161\xedch po najnov\u0161ie",
        city: "Mesto",
        sort_by: "Triedi\u0165 pod\u013Ea",
        search: "Vyh\u013Ead\xe1vanie",
        more_filters: "Viac filtrov",
        filters: "Filtre",
        type: "Typ nehnute\u013Enosti",
        bedrooms: "Sp\xe1lne",
        more: "Viac ako 8",
        bathrooms: "K\xfape\u013Ene",
        inside: "Ve\u013Ekos\u0165 vn\xfatri",
        less_inside: "Menej ako 100",
        more_inside: "Viac ako 500",
        plot: "Ve\u013Ekos\u0165 pozemku",
        less_plot: "Menej ako 500",
        more_plot: "Viac ako 2500",
        location: "Poloha",
        sea_view: "V\xfdh\u013Ead na more",
        waterfront: "Na n\xe1bre\u017E\xed",
        near_the_sea: "Bl\xedzko mora",
        beachfront: "Na pl\xe1\u017Ei",
        mountain_view: "V\xfdh\u013Ead na hory",
        river_view: "V\xfdh\u013Ead na rieku",
        lake_view: "V\xfdh\u013Ead na jazero",
        near_town: "Bl\xedzko mesta",
        village: "Dedina",
        facilities: "Vybavenie",
        year_built: "Rok v\xfdstavby",
        clear: "Vy\u010Disti\u0165 v\u0161etko",
        show: "Zobrazi\u0165 nehnute\u013Enosti",
        heated_pool: "Vyhrievan\xfd baz\xe9n",
        outdoor_pool: "Vonkaj\u0161\xed baz\xe9n",
        indoor_pool: "Vn\xfatorn\xfd baz\xe9n",
        boat_mooring: "Pr\xedstavisko pre \u010Dlny",
        garage: "Gar\xe1\u017E",
        hot_tub: "Hor\xfaca va\u0148a",
        vineyard: "Vinica",
        gym: "Posil\u0148ov\u0148a",
        sauna: "Sauna",
        wine_cellar: "V\xednna pivnica",
        tennis_court: "Tenisov\xfd kurt",
        game_room: "Hern\xe1 miestnos\u0165",
        garden: "Z\xe1hrada",
        terrace: "Terasa",
        balcony: "Balk\xf3n",
        outdoor_kitchen: "Vonkaj\u0161ia kuchy\u0148a",
        elevator: "V\xfd\u0165ah",
        popular_destinations: "Popul\xe1rne destin\xe1cie",
        popular: "Popul\xe1rny",
        price_range: "Cenov\xe9 rozp\xe4tie",
        min_price: "Minim\xe1lna cena",
        max_price: "Maxim\xe1lna cena",
        min_size: "Minim\xe1lna ve\u013Ekos\u0165",
        max_size: "Maxim\xe1lna ve\u013Ekos\u0165"
    },
    nl: {
        show_more: "Meer weergeven",
        category: "Categorie",
        search_word: "Zoeken op woord",
        region: "Regio",
        select: "Selecteer...",
        price: "Prijs",
        over: "Meer dan 2.5M",
        low: "Laag naar hoog",
        high: "Hoog naar laag",
        newest: "Nieuwste naar oudste",
        oldest: "Oudste naar nieuwste",
        city: "Stad",
        sort_by: "Sorteren op",
        search: "Zoeken",
        more_filters: "Meer filters",
        filters: "Filters",
        type: "Type eigendom",
        bedrooms: "Slaapkamers",
        more: "Meer dan 8",
        bathrooms: "Badkamers",
        inside: "Binnenmaat",
        less_inside: "Minder dan 100",
        more_inside: "Meer dan 500",
        plot: "Perceelgrootte",
        less_plot: "Minder dan 500",
        more_plot: "Meer dan 2500",
        location: "Locatie",
        sea_view: "Zeezicht",
        waterfront: "Aan het water",
        near_the_sea: "Dicht bij de zee",
        beachfront: "Aan het strand",
        mountain_view: "Uitzicht op de bergen",
        river_view: "Uitzicht op de rivier",
        lake_view: "Uitzicht op het meer",
        near_town: "Dicht bij de stad",
        village: "Dorp",
        facilities: "Voorzieningen",
        year_built: "Bouwjaar",
        clear: "Alles wissen",
        show: "Toon eigendommen",
        heated_pool: "Verwarmd zwembad",
        outdoor_pool: "Buitenzwembad",
        indoor_pool: "Binnenzwembad",
        boat_mooring: "Bootaanlegplaats",
        garage: "Garage",
        hot_tub: "Hottub",
        vineyard: "Wijngaard",
        gym: "Sportschool",
        sauna: "Sauna",
        wine_cellar: "Wijnkelder",
        tennis_court: "Tennisbaan",
        game_room: "Spelkamer",
        garden: "Tuin",
        terrace: "Terras",
        balcony: "Balkon",
        outdoor_kitchen: "Buitenkeuken",
        elevator: "Lift",
        popular_destinations: "Populaire bestemmingen",
        popular: "Populair",
        price_range: "Prijsklasse",
        min_price: "Minimale prijs",
        max_price: "Maximale prijs",
        min_size: "Minimale grootte",
        max_size: "Maximale grootte"
    }
};
function $be9b986789153ce0$export$202e99f82f7f0395(langCode) {
    return $be9b986789153ce0$var$translations[langCode];
}

});

parcelRegister("k56Uj", function(module, exports) {

(function(t, e) {
    module.exports = e((parcelRequire("hrKNH")));
})("undefined" !== typeof self ? self : module.exports, function(t) {
    return function() {
        var e = {
            388: function(t, e) {
                var r, n, i;
                (function(o, a) {
                    n = [], r = a, i = "function" === typeof r ? r.apply(e, n) : r, void 0 === i || (t.exports = i);
                })("undefined" !== typeof self && self, function() {
                    function t() {
                        var e = Object.getOwnPropertyDescriptor(document, "currentScript");
                        if (!e && "currentScript" in document && document.currentScript) return document.currentScript;
                        if (e && e.get !== t && document.currentScript) return document.currentScript;
                        try {
                            throw new Error;
                        } catch (f) {
                            var r, n, i, o = /.*at [^(]*\((.*):(.+):(.+)\)$/gi, a = /@([^@]*):(\d+):(\d+)\s*$/gi, s = o.exec(f.stack) || a.exec(f.stack), l = s && s[1] || !1, u = s && s[2] || !1, c = document.location.href.replace(document.location.hash, ""), d = document.getElementsByTagName("script");
                            l === c && (r = document.documentElement.outerHTML, n = new RegExp("(?:[^\\n]+?\\n){0," + (u - 2) + "}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*", "i"), i = r.replace(n, "$1").trim());
                            for(var h = 0; h < d.length; h++){
                                if ("interactive" === d[h].readyState) return d[h];
                                if (d[h].src === l) return d[h];
                                if (l === c && d[h].innerHTML && d[h].innerHTML.trim() === i) return d[h];
                            }
                            return null;
                        }
                    }
                    return t;
                });
            },
            905: function(t, e, r) {
                "use strict";
                r.r(e);
                var n = r(117), i = r.n(n), o = r(488), a = r.n(o), s = a()(i());
                s.push([
                    t.id,
                    ".vue-slider-dot{position:absolute;-webkit-transition:all 0s;transition:all 0s;z-index:5}.vue-slider-dot:focus{outline:none}.vue-slider-dot-tooltip{position:absolute;visibility:hidden}.vue-slider-dot-hover:hover .vue-slider-dot-tooltip,.vue-slider-dot-tooltip-show{visibility:visible}.vue-slider-dot-tooltip-top{top:-10px;left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.vue-slider-dot-tooltip-bottom{bottom:-10px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.vue-slider-dot-tooltip-left{left:-10px;top:50%;-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.vue-slider-dot-tooltip-right{right:-10px;top:50%;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}",
                    ""
                ]), e["default"] = s;
            },
            121: function(t, e, r) {
                "use strict";
                r.r(e);
                var n = r(117), i = r.n(n), o = r(488), a = r.n(o), s = a()(i());
                s.push([
                    t.id,
                    ".vue-slider-marks{position:relative;width:100%;height:100%}.vue-slider-mark{position:absolute;z-index:1}.vue-slider-ltr .vue-slider-mark,.vue-slider-rtl .vue-slider-mark{width:0;height:100%;top:50%}.vue-slider-ltr .vue-slider-mark-step,.vue-slider-rtl .vue-slider-mark-step{top:0}.vue-slider-ltr .vue-slider-mark-label,.vue-slider-rtl .vue-slider-mark-label{top:100%;margin-top:10px}.vue-slider-ltr .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ltr .vue-slider-mark-step{left:0}.vue-slider-ltr .vue-slider-mark-label{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.vue-slider-rtl .vue-slider-mark{-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%)}.vue-slider-rtl .vue-slider-mark-step{right:0}.vue-slider-rtl .vue-slider-mark-label{right:50%;-webkit-transform:translateX(50%);transform:translateX(50%)}.vue-slider-btt .vue-slider-mark,.vue-slider-ttb .vue-slider-mark{width:100%;height:0;left:50%}.vue-slider-btt .vue-slider-mark-step,.vue-slider-ttb .vue-slider-mark-step{left:0}.vue-slider-btt .vue-slider-mark-label,.vue-slider-ttb .vue-slider-mark-label{left:100%;margin-left:10px}.vue-slider-btt .vue-slider-mark{-webkit-transform:translate(-50%,50%);transform:translate(-50%,50%)}.vue-slider-btt .vue-slider-mark-step{top:0}.vue-slider-btt .vue-slider-mark-label{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-ttb .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ttb .vue-slider-mark-step{bottom:0}.vue-slider-ttb .vue-slider-mark-label{bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%)}.vue-slider-mark-label,.vue-slider-mark-step{position:absolute}",
                    ""
                ]), e["default"] = s;
            },
            207: function(t, e, r) {
                "use strict";
                r.r(e);
                var n = r(117), i = r.n(n), o = r(488), a = r.n(o), s = a()(i());
                s.push([
                    t.id,
                    ".vue-slider{position:relative;-webkit-box-sizing:content-box;box-sizing:content-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;-webkit-tap-highlight-color:rgba(0,0,0,0)}.vue-slider-rail{position:relative;width:100%;height:100%;-webkit-transition-property:width,height,left,right,top,bottom;transition-property:width,height,left,right,top,bottom}.vue-slider-process{position:absolute;z-index:1}",
                    ""
                ]), e["default"] = s;
            },
            488: function(t) {
                "use strict";
                t.exports = function(t) {
                    var e = [];
                    return e.toString = function() {
                        return this.map(function(e) {
                            var r = "", n = "undefined" !== typeof e[5];
                            return e[4] && (r += "@supports (".concat(e[4], ") {")), e[2] && (r += "@media ".concat(e[2], " {")), n && (r += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), r += t(e), n && (r += "}"), e[2] && (r += "}"), e[4] && (r += "}"), r;
                        }).join("");
                    }, e.i = function(t, r, n, i, o) {
                        "string" === typeof t && (t = [
                            [
                                null,
                                t,
                                void 0
                            ]
                        ]);
                        var a = {};
                        if (n) for(var s = 0; s < this.length; s++){
                            var l = this[s][0];
                            null != l && (a[l] = !0);
                        }
                        for(var u = 0; u < t.length; u++){
                            var c = [].concat(t[u]);
                            n && a[c[0]] || ("undefined" !== typeof o && ("undefined" === typeof c[5] || (c[1] = "@layer".concat(c[5].length > 0 ? " ".concat(c[5]) : "", " {").concat(c[1], "}")), c[5] = o), r && (c[2] ? (c[1] = "@media ".concat(c[2], " {").concat(c[1], "}"), c[2] = r) : c[2] = r), i && (c[4] ? (c[1] = "@supports (".concat(c[4], ") {").concat(c[1], "}"), c[4] = i) : c[4] = "".concat(i)), e.push(c));
                        }
                    }, e;
                };
            },
            117: function(t) {
                "use strict";
                t.exports = function(t) {
                    return t[1];
                };
            },
            831: function(t, e) {
                "use strict";
                e.Z = (t, e)=>{
                    const r = t.__vccOpts || t;
                    for (const [n, i] of e)r[n] = i;
                    return r;
                };
            },
            466: function(t, e, r) {
                var n = r(905);
                n.__esModule && (n = n.default), "string" === typeof n && (n = [
                    [
                        t.id,
                        n,
                        ""
                    ]
                ]), n.locals && (t.exports = n.locals);
                var i = r(959).Z;
                i("50bc1720", n, !0, {
                    sourceMap: !1,
                    shadowMode: !1
                });
            },
            18: function(t, e, r) {
                var n = r(121);
                n.__esModule && (n = n.default), "string" === typeof n && (n = [
                    [
                        t.id,
                        n,
                        ""
                    ]
                ]), n.locals && (t.exports = n.locals);
                var i = r(959).Z;
                i("10aa5f36", n, !0, {
                    sourceMap: !1,
                    shadowMode: !1
                });
            },
            631: function(t, e, r) {
                var n = r(207);
                n.__esModule && (n = n.default), "string" === typeof n && (n = [
                    [
                        t.id,
                        n,
                        ""
                    ]
                ]), n.locals && (t.exports = n.locals);
                var i = r(959).Z;
                i("1772934e", n, !0, {
                    sourceMap: !1,
                    shadowMode: !1
                });
            },
            959: function(t, e, r) {
                "use strict";
                function n(t, e) {
                    for(var r = [], n = {}, i = 0; i < e.length; i++){
                        var o = e[i], a = o[0], s = o[1], l = o[2], u = o[3], c = {
                            id: t + ":" + i,
                            css: s,
                            media: l,
                            sourceMap: u
                        };
                        n[a] ? n[a].parts.push(c) : r.push(n[a] = {
                            id: a,
                            parts: [
                                c
                            ]
                        });
                    }
                    return r;
                }
                r.d(e, {
                    Z: function() {
                        return p;
                    }
                });
                var i = "undefined" !== typeof document;
                if ("undefined" !== typeof DEBUG && DEBUG && !i) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");
                var o = {}, a = i && (document.head || document.getElementsByTagName("head")[0]), s = null, l = 0, u = !1, c = function() {}, d = null, h = "data-vue-ssr-id", f = "undefined" !== typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());
                function p(t, e, r, i) {
                    u = r, d = i || {};
                    var a = n(t, e);
                    return m(a), function(e) {
                        for(var r = [], i = 0; i < a.length; i++){
                            var s = a[i], l = o[s.id];
                            l.refs--, r.push(l);
                        }
                        e ? (a = n(t, e), m(a)) : a = [];
                        for(i = 0; i < r.length; i++){
                            l = r[i];
                            if (0 === l.refs) {
                                for(var u = 0; u < l.parts.length; u++)l.parts[u]();
                                delete o[l.id];
                            }
                        }
                    };
                }
                function m(t) {
                    for(var e = 0; e < t.length; e++){
                        var r = t[e], n = o[r.id];
                        if (n) {
                            n.refs++;
                            for(var i = 0; i < n.parts.length; i++)n.parts[i](r.parts[i]);
                            for(; i < r.parts.length; i++)n.parts.push(y(r.parts[i]));
                            n.parts.length > r.parts.length && (n.parts.length = r.parts.length);
                        } else {
                            var a = [];
                            for(i = 0; i < r.parts.length; i++)a.push(y(r.parts[i]));
                            o[r.id] = {
                                id: r.id,
                                refs: 1,
                                parts: a
                            };
                        }
                    }
                }
                function v() {
                    var t = document.createElement("style");
                    return t.type = "text/css", a.appendChild(t), t;
                }
                function y(t) {
                    var e, r, n = document.querySelector("style[" + h + '~="' + t.id + '"]');
                    if (n) {
                        if (u) return c;
                        n.parentNode.removeChild(n);
                    }
                    if (f) {
                        var i = l++;
                        n = s || (s = v()), e = g.bind(null, n, i, !1), r = g.bind(null, n, i, !0);
                    } else n = v(), e = k.bind(null, n), r = function() {
                        n.parentNode.removeChild(n);
                    };
                    return e(t), function(n) {
                        if (n) {
                            if (n.css === t.css && n.media === t.media && n.sourceMap === t.sourceMap) return;
                            e(t = n);
                        } else r();
                    };
                }
                var b = function() {
                    var t = [];
                    return function(e, r) {
                        return t[e] = r, t.filter(Boolean).join("\n");
                    };
                }();
                function g(t, e, r, n) {
                    var i = r ? "" : n.css;
                    if (t.styleSheet) t.styleSheet.cssText = b(e, i);
                    else {
                        var o = document.createTextNode(i), a = t.childNodes;
                        a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(o, a[e]) : t.appendChild(o);
                    }
                }
                function k(t, e) {
                    var r = e.css, n = e.media, i = e.sourceMap;
                    if (n && t.setAttribute("media", n), d.ssrId && t.setAttribute(h, e.id), i && (r += "\n/*# sourceURL=" + i.sources[0] + " */", r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */"), t.styleSheet) t.styleSheet.cssText = r;
                    else {
                        while(t.firstChild)t.removeChild(t.firstChild);
                        t.appendChild(document.createTextNode(r));
                    }
                }
            },
            927: function(e) {
                "use strict";
                e.exports = t;
            }
        }, r = {};
        function n(t) {
            var i = r[t];
            if (void 0 !== i) return i.exports;
            var o = r[t] = {
                id: t,
                exports: {}
            };
            return e[t].call(o.exports, o, o.exports, n), o.exports;
        }
        !function() {
            n.n = function(t) {
                var e = t && t.__esModule ? function() {
                    return t["default"];
                } : function() {
                    return t;
                };
                return n.d(e, {
                    a: e
                }), e;
            };
        }(), function() {
            n.d = function(t, e) {
                for(var r in e)n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
                    enumerable: !0,
                    get: e[r]
                });
            };
        }(), function() {
            n.o = function(t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
            };
        }(), function() {
            n.r = function(t) {
                "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(t, "__esModule", {
                    value: !0
                });
            };
        }(), function() {
            n.p = "";
        }();
        var i = {};
        return function() {
            "use strict";
            if (n.d(i, {
                default: function() {
                    return St;
                }
            }), "undefined" !== typeof window) {
                var t = window.document.currentScript, e = n(388);
                t = e(), "currentScript" in document || Object.defineProperty(document, "currentScript", {
                    get: e
                });
                var r = t && t.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
                r && (n.p = r[1]);
            }
            var o = n(927);
            function a(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            var s = {
                key: 0,
                class: "vue-slider-marks"
            };
            function l(t, e, r, n, i, l) {
                var u = (0, o.resolveComponent)("vue-slider-mark"), c = (0, o.resolveComponent)("vue-slider-dot");
                return (0, o.openBlock)(), (0, o.createElementBlock)("div", (0, o.mergeProps)({
                    ref: "container",
                    class: t.containerClasses,
                    style: t.containerStyles,
                    onClick: e[2] || (e[2] = function() {
                        return t.clickHandle && t.clickHandle.apply(t, arguments);
                    }),
                    onTouchstartPassive: e[3] || (e[3] = function() {
                        return t.dragStartOnProcess && t.dragStartOnProcess.apply(t, arguments);
                    }),
                    onMousedownPassive: e[4] || (e[4] = function() {
                        return t.dragStartOnProcess && t.dragStartOnProcess.apply(t, arguments);
                    })
                }, t.$attrs), [
                    (0, o.createElementVNode)("div", {
                        class: "vue-slider-rail",
                        style: (0, o.normalizeStyle)(t.railStyle)
                    }, [
                        ((0, o.openBlock)(!0), (0, o.createElementBlock)(o.Fragment, null, (0, o.renderList)(t.processArray, function(e, r) {
                            return (0, o.renderSlot)(t.$slots, "process", (0, o.normalizeProps)((0, o.guardReactiveProps)(e)), function() {
                                return [
                                    ((0, o.openBlock)(), (0, o.createElementBlock)("div", {
                                        class: "vue-slider-process",
                                        key: "process-".concat(r),
                                        style: (0, o.normalizeStyle)(e.style)
                                    }, null, 4))
                                ];
                            });
                        }), 256)),
                        t.sliderMarks && t.control ? ((0, o.openBlock)(), (0, o.createElementBlock)("div", s, [
                            ((0, o.openBlock)(!0), (0, o.createElementBlock)(o.Fragment, null, (0, o.renderList)(t.control.markList, function(r, n) {
                                return (0, o.renderSlot)(t.$slots, "mark", (0, o.normalizeProps)((0, o.guardReactiveProps)(r)), function() {
                                    var i;
                                    return [
                                        ((0, o.openBlock)(), (0, o.createBlock)(u, {
                                            key: "mark-".concat(n),
                                            mark: r,
                                            hideLabel: t.hideLabel,
                                            style: (0, o.normalizeStyle)((i = {}, a(i, t.isHorizontal ? "height" : "width", "100%"), a(i, t.isHorizontal ? "width" : "height", t.tailSize), a(i, t.mainDirection, "".concat(r.pos, "%")), i)),
                                            stepStyle: t.stepStyle,
                                            stepActiveStyle: t.stepActiveStyle,
                                            labelStyle: t.labelStyle,
                                            labelActiveStyle: t.labelActiveStyle,
                                            onPressLabel: e[0] || (e[0] = function(e) {
                                                return t.clickable && t.setValueByPos(e);
                                            })
                                        }, {
                                            step: (0, o.withCtx)(function() {
                                                return [
                                                    (0, o.renderSlot)(t.$slots, "step", (0, o.normalizeProps)((0, o.guardReactiveProps)(r)))
                                                ];
                                            }),
                                            label: (0, o.withCtx)(function() {
                                                return [
                                                    (0, o.renderSlot)(t.$slots, "label", (0, o.normalizeProps)((0, o.guardReactiveProps)(r)))
                                                ];
                                            }),
                                            _: 2
                                        }, 1032, [
                                            "mark",
                                            "hideLabel",
                                            "style",
                                            "stepStyle",
                                            "stepActiveStyle",
                                            "labelStyle",
                                            "labelActiveStyle"
                                        ]))
                                    ];
                                });
                            }), 256))
                        ])) : (0, o.createCommentVNode)("", !0),
                        ((0, o.openBlock)(!0), (0, o.createElementBlock)(o.Fragment, null, (0, o.renderList)(t.dots, function(r, n) {
                            var i;
                            return (0, o.openBlock)(), (0, o.createBlock)(c, (0, o.mergeProps)({
                                ref_for: !0,
                                ref: "dot-".concat(n),
                                key: "dot-".concat(n),
                                value: r.value,
                                disabled: r.disabled,
                                focus: r.focus,
                                "dot-style": [
                                    r.style,
                                    r.disabled ? r.disabledStyle : null,
                                    r.focus ? r.focusStyle : null
                                ],
                                tooltip: r.tooltip || t.tooltip,
                                "tooltip-style": [
                                    t.tooltipStyle,
                                    r.tooltipStyle,
                                    r.disabled ? r.tooltipDisabledStyle : null,
                                    r.focus ? r.tooltipFocusStyle : null
                                ],
                                "tooltip-formatter": Array.isArray(t.sliderTooltipFormatter) ? t.sliderTooltipFormatter[n] : t.sliderTooltipFormatter,
                                "tooltip-placement": t.tooltipDirections[n],
                                style: [
                                    t.dotBaseStyle,
                                    (i = {}, a(i, t.mainDirection, "".concat(r.pos, "%")), a(i, "transition", "".concat(t.mainDirection, " ").concat(t.animateTime, "s")), i)
                                ],
                                onDragStart: function() {
                                    return t.dragStart(n);
                                },
                                role: "slider",
                                "aria-valuenow": r.value,
                                "aria-valuemin": t.min,
                                "aria-valuemax": t.max,
                                "aria-orientation": t.isHorizontal ? "horizontal" : "vertical",
                                tabindex: "0",
                                onFocus: function() {
                                    return t.focus(r, n);
                                },
                                onBlur: e[1] || (e[1] = function() {
                                    return t.blur();
                                })
                            }, t.dotAttrs), {
                                dot: (0, o.withCtx)(function() {
                                    return [
                                        (0, o.renderSlot)(t.$slots, "dot", (0, o.normalizeProps)((0, o.guardReactiveProps)(r)))
                                    ];
                                }),
                                tooltip: (0, o.withCtx)(function() {
                                    return [
                                        (0, o.renderSlot)(t.$slots, "tooltip", (0, o.normalizeProps)((0, o.guardReactiveProps)(r)))
                                    ];
                                }),
                                _: 2
                            }, 1040, [
                                "value",
                                "disabled",
                                "focus",
                                "dot-style",
                                "tooltip",
                                "tooltip-style",
                                "tooltip-formatter",
                                "tooltip-placement",
                                "style",
                                "onDragStart",
                                "aria-valuenow",
                                "aria-valuemin",
                                "aria-valuemax",
                                "aria-orientation",
                                "onFocus"
                            ]);
                        }), 128))
                    ], 4),
                    (0, o.renderSlot)(t.$slots, "default", {
                        value: t.getValue()
                    })
                ], 16);
            }
            var u = [
                "aria-valuetext"
            ], c = {
                class: "vue-slider-dot-tooltip-text"
            };
            function d(t, e, r, n, i, a) {
                var s;
                return (0, o.openBlock)(), (0, o.createElementBlock)("div", {
                    ref: "dot",
                    class: (0, o.normalizeClass)(t.dotClasses),
                    "aria-valuetext": null === (s = t.tooltipValue) || void 0 === s ? void 0 : s.toString(),
                    onMousedownPassive: e[0] || (e[0] = function() {
                        return t.dragStart && t.dragStart.apply(t, arguments);
                    }),
                    onTouchstartPassive: e[1] || (e[1] = function() {
                        return t.dragStart && t.dragStart.apply(t, arguments);
                    })
                }, [
                    (0, o.renderSlot)(t.$slots, "dot", {}, function() {
                        return [
                            (0, o.createElementVNode)("div", {
                                class: (0, o.normalizeClass)(t.handleClasses),
                                style: (0, o.normalizeStyle)(t.dotStyle)
                            }, null, 6)
                        ];
                    }),
                    "none" !== t.tooltip ? ((0, o.openBlock)(), (0, o.createElementBlock)("div", {
                        key: 0,
                        class: (0, o.normalizeClass)(t.tooltipClasses)
                    }, [
                        (0, o.renderSlot)(t.$slots, "tooltip", {}, function() {
                            return [
                                (0, o.createElementVNode)("div", {
                                    class: (0, o.normalizeClass)(t.tooltipInnerClasses),
                                    style: (0, o.normalizeStyle)(t.tooltipStyle)
                                }, [
                                    (0, o.createElementVNode)("span", c, (0, o.toDisplayString)(t.tooltipValue), 1)
                                ], 6)
                            ];
                        })
                    ], 2)) : (0, o.createCommentVNode)("", !0)
                ], 42, u);
            }
            n(466);
            var h = (0, o.defineComponent)({
                name: "VueSliderDot",
                emits: [
                    "drag-start"
                ],
                props: {
                    value: {
                        type: [
                            String,
                            Number
                        ],
                        default: 0
                    },
                    tooltip: {
                        type: String,
                        required: !0
                    },
                    tooltipPlacement: {
                        type: String,
                        validator: function(t) {
                            return [
                                "top",
                                "right",
                                "bottom",
                                "left"
                            ].indexOf(t) > -1;
                        },
                        required: !0
                    },
                    tooltipFormatter: {
                        type: [
                            String,
                            Function
                        ]
                    },
                    focus: {
                        type: Boolean,
                        default: !1
                    },
                    disabled: {
                        type: Boolean,
                        default: !1
                    },
                    dotStyle: {
                        type: Object
                    },
                    tooltipStyle: {
                        type: Object
                    }
                },
                computed: {
                    dotClasses: function() {
                        return [
                            "vue-slider-dot",
                            {
                                "vue-slider-dot-hover": "hover" === this.tooltip || "active" === this.tooltip,
                                "vue-slider-dot-disabled": this.disabled,
                                "vue-slider-dot-focus": this.focus
                            }
                        ];
                    },
                    handleClasses: function() {
                        return [
                            "vue-slider-dot-handle",
                            {
                                "vue-slider-dot-handle-disabled": this.disabled,
                                "vue-slider-dot-handle-focus": this.focus
                            }
                        ];
                    },
                    tooltipClasses: function() {
                        return [
                            "vue-slider-dot-tooltip",
                            [
                                "vue-slider-dot-tooltip-".concat(this.tooltipPlacement)
                            ],
                            {
                                "vue-slider-dot-tooltip-show": this.showTooltip
                            }
                        ];
                    },
                    tooltipInnerClasses: function() {
                        return [
                            "vue-slider-dot-tooltip-inner",
                            [
                                "vue-slider-dot-tooltip-inner-".concat(this.tooltipPlacement)
                            ],
                            {
                                "vue-slider-dot-tooltip-inner-disabled": this.disabled,
                                "vue-slider-dot-tooltip-inner-focus": this.focus
                            }
                        ];
                    },
                    showTooltip: function() {
                        switch(this.tooltip){
                            case "always":
                                return !0;
                            case "none":
                                return !1;
                            case "focus":
                            case "active":
                                return !!this.focus;
                            default:
                                return !1;
                        }
                    },
                    tooltipValue: function() {
                        return this.tooltipFormatter ? "string" === typeof this.tooltipFormatter ? this.tooltipFormatter.replace(/\{value\}/, String(this.value)) : this.tooltipFormatter(this.value) : this.value;
                    }
                },
                methods: {
                    dragStart: function() {
                        if (this.disabled) return !1;
                        this.$emit("drag-start");
                    }
                }
            }), f = n(831);
            const p = (0, f.Z)(h, [
                [
                    "render",
                    d
                ]
            ]);
            var m = p;
            function v(t, e, r, n, i, a) {
                return (0, o.openBlock)(), (0, o.createElementBlock)("div", {
                    class: (0, o.normalizeClass)(t.marksClasses)
                }, [
                    (0, o.renderSlot)(t.$slots, "step", {}, function() {
                        return [
                            (0, o.createElementVNode)("div", {
                                class: (0, o.normalizeClass)(t.stepClasses),
                                style: (0, o.normalizeStyle)([
                                    t.stepStyle,
                                    t.mark.style || {},
                                    t.mark.active && t.stepActiveStyle ? t.stepActiveStyle : {},
                                    t.mark.active && t.mark.activeStyle ? t.mark.activeStyle : {}
                                ])
                            }, null, 6)
                        ];
                    }),
                    t.hideLabel ? (0, o.createCommentVNode)("", !0) : (0, o.renderSlot)(t.$slots, "label", {
                        key: 0
                    }, function() {
                        return [
                            (0, o.createElementVNode)("div", {
                                class: (0, o.normalizeClass)(t.labelClasses),
                                style: (0, o.normalizeStyle)([
                                    t.labelStyle,
                                    t.mark.labelStyle || {},
                                    t.mark.active && t.labelActiveStyle ? t.labelActiveStyle : {},
                                    t.mark.active && t.mark.labelActiveStyle ? t.mark.labelActiveStyle : {}
                                ]),
                                onClick: e[0] || (e[0] = function() {
                                    return t.labelClickHandle && t.labelClickHandle.apply(t, arguments);
                                })
                            }, (0, o.toDisplayString)(t.mark.label), 7)
                        ];
                    })
                ], 2);
            }
            n(18);
            var y = (0, o.defineComponent)({
                name: "VueSliderMark",
                emits: [
                    "press-label"
                ],
                props: {
                    mark: {
                        type: Object,
                        required: !0
                    },
                    hideLabel: {
                        type: Boolean
                    },
                    stepStyle: {
                        type: Object,
                        default: function() {
                            return {};
                        }
                    },
                    stepActiveStyle: {
                        type: Object,
                        default: function() {
                            return {};
                        }
                    },
                    labelStyle: {
                        type: Object,
                        default: function() {
                            return {};
                        }
                    },
                    labelActiveStyle: {
                        type: Object,
                        default: function() {
                            return {};
                        }
                    }
                },
                computed: {
                    marksClasses: function() {
                        return [
                            "vue-slider-mark",
                            {
                                "vue-slider-mark-active": this.mark.active
                            }
                        ];
                    },
                    stepClasses: function() {
                        return [
                            "vue-slider-mark-step",
                            {
                                "vue-slider-mark-step-active": this.mark.active
                            }
                        ];
                    },
                    labelClasses: function() {
                        return [
                            "vue-slider-mark-label",
                            {
                                "vue-slider-mark-label-active": this.mark.active
                            }
                        ];
                    }
                },
                methods: {
                    labelClickHandle: function(t) {
                        t.stopPropagation(), this.$emit("press-label", this.mark.pos);
                    }
                }
            });
            const b = (0, f.Z)(y, [
                [
                    "render",
                    v
                ]
            ]);
            var g, k = b, S = function(t) {
                return "number" === typeof t ? "".concat(t, "px") : t;
            }, x = function(t) {
                var e = document.documentElement, r = document.body, n = t.getBoundingClientRect(), i = {
                    y: n.top + (window.pageYOffset || e.scrollTop) - (e.clientTop || r.clientTop || 0),
                    x: n.left + (window.pageXOffset || e.scrollLeft) - (e.clientLeft || r.clientLeft || 0)
                };
                return i;
            }, P = function(t, e, r) {
                var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, i = "targetTouches" in t ? t.targetTouches[0] : t, o = x(e), a = {
                    x: i.pageX - o.x,
                    y: i.pageY - o.y
                };
                return {
                    x: r ? e.offsetWidth * n - a.x : a.x,
                    y: r ? e.offsetHeight * n - a.y : a.y
                };
            };
            (function(t) {
                t[t["PAGE_UP"] = 33] = "PAGE_UP", t[t["PAGE_DOWN"] = 34] = "PAGE_DOWN", t[t["END"] = 35] = "END", t[t["HOME"] = 36] = "HOME", t[t["LEFT"] = 37] = "LEFT", t[t["UP"] = 38] = "UP", t[t["RIGHT"] = 39] = "RIGHT", t[t["DOWN"] = 40] = "DOWN";
            })(g || (g = {}));
            var w = function(t, e) {
                if (e.hook) {
                    var r = e.hook(t);
                    if ("function" === typeof r) return r;
                    if (!r) return null;
                }
                switch(t.keyCode){
                    case g.UP:
                        return function(t) {
                            return "ttb" === e.direction ? t - 1 : t + 1;
                        };
                    case g.RIGHT:
                        return function(t) {
                            return "rtl" === e.direction ? t - 1 : t + 1;
                        };
                    case g.DOWN:
                        return function(t) {
                            return "ttb" === e.direction ? t + 1 : t - 1;
                        };
                    case g.LEFT:
                        return function(t) {
                            return "rtl" === e.direction ? t + 1 : t - 1;
                        };
                    case g.END:
                        return function() {
                            return e.max;
                        };
                    case g.HOME:
                        return function() {
                            return e.min;
                        };
                    case g.PAGE_UP:
                        return function(t) {
                            return t + 10;
                        };
                    case g.PAGE_DOWN:
                        return function(t) {
                            return t - 10;
                        };
                    default:
                        return null;
                }
            };
            function O(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function D(t, e) {
                for(var r = 0; r < e.length; r++){
                    var n = e[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                }
            }
            function E(t, e, r) {
                return e && D(t.prototype, e), r && D(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }
            function R(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            var A, V, j = function() {
                function t(e) {
                    O(this, t), R(this, "num", void 0), this.num = e;
                }
                return E(t, [
                    {
                        key: "decimal",
                        value: function(t, e) {
                            var r = this.num, n = this.getDecimalLen(r), i = this.getDecimalLen(t), o = 0;
                            switch(e){
                                case "+":
                                    o = this.getExponent(n, i), this.num = (this.safeRoundUp(r, o) + this.safeRoundUp(t, o)) / o;
                                    break;
                                case "-":
                                    o = this.getExponent(n, i), this.num = (this.safeRoundUp(r, o) - this.safeRoundUp(t, o)) / o;
                                    break;
                                case "*":
                                    this.num = this.safeRoundUp(this.safeRoundUp(r, this.getExponent(n)), this.safeRoundUp(t, this.getExponent(i))) / this.getExponent(n + i);
                                    break;
                                case "/":
                                    o = this.getExponent(n, i), this.num = this.safeRoundUp(r, o) / this.safeRoundUp(t, o);
                                    break;
                                case "%":
                                    o = this.getExponent(n, i), this.num = this.safeRoundUp(r, o) % this.safeRoundUp(t, o) / o;
                                    break;
                            }
                            return this;
                        }
                    },
                    {
                        key: "plus",
                        value: function(t) {
                            return this.decimal(t, "+");
                        }
                    },
                    {
                        key: "minus",
                        value: function(t) {
                            return this.decimal(t, "-");
                        }
                    },
                    {
                        key: "multiply",
                        value: function(t) {
                            return this.decimal(t, "*");
                        }
                    },
                    {
                        key: "divide",
                        value: function(t) {
                            return this.decimal(t, "/");
                        }
                    },
                    {
                        key: "remainder",
                        value: function(t) {
                            return this.decimal(t, "%");
                        }
                    },
                    {
                        key: "toNumber",
                        value: function() {
                            return this.num;
                        }
                    },
                    {
                        key: "getDecimalLen",
                        value: function(t) {
                            var e = "".concat(t).split("e");
                            return ("".concat(e[0]).split(".")[1] || "").length - (e[1] ? +e[1] : 0);
                        }
                    },
                    {
                        key: "getExponent",
                        value: function(t, e) {
                            return Math.pow(10, void 0 !== e ? Math.max(t, e) : t);
                        }
                    },
                    {
                        key: "safeRoundUp",
                        value: function(t, e) {
                            return Math.round(t * e);
                        }
                    }
                ]), t;
            }();
            function C(t, e) {
                return L(t) || M(t, e) || H(t, e) || B();
            }
            function B() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function M(t, e) {
                var r = null == t ? null : "undefined" !== typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, i, o = [], a = !0, s = !1;
                    try {
                        for(r = r.call(t); !(a = (n = r.next()).done); a = !0)if (o.push(n.value), e && o.length === e) break;
                    } catch (l) {
                        s = !0, i = l;
                    } finally{
                        try {
                            a || null == r["return"] || r["return"]();
                        } finally{
                            if (s) throw i;
                        }
                    }
                    return o;
                }
            }
            function L(t) {
                if (Array.isArray(t)) return t;
            }
            function N(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function z(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? N(Object(r), !0).forEach(function(e) {
                        X(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : N(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }
            function I(t) {
                return $(t) || F(t) || H(t) || T();
            }
            function T() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function H(t, e) {
                if (t) {
                    if ("string" === typeof t) return U(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? U(t, e) : void 0;
                }
            }
            function F(t) {
                if ("undefined" !== typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }
            function $(t) {
                if (Array.isArray(t)) return U(t);
            }
            function U(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
                return n;
            }
            function _(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function W(t, e) {
                for(var r = 0; r < e.length; r++){
                    var n = e[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                }
            }
            function G(t, e, r) {
                return e && W(t.prototype, e), r && W(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }
            function X(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            (function(t) {
                t[t["VALUE"] = 1] = "VALUE", t[t["INTERVAL"] = 2] = "INTERVAL", t[t["MIN"] = 3] = "MIN", t[t["MAX"] = 4] = "MAX", t[t["ORDER"] = 5] = "ORDER";
            })(V || (V = {}));
            var q = (A = {}, X(A, V.VALUE, 'The type of the "value" is illegal'), X(A, V.INTERVAL, 'The prop "interval" is invalid, "(max - min)" must be divisible by "interval"'), X(A, V.MIN, 'The "value" must be greater than or equal to the "min".'), X(A, V.MAX, 'The "value" must be less than or equal to the "max".'), X(A, V.ORDER, 'When "order" is false, the parameters "minRange", "maxRange", "fixed", "enabled" are invalid.'), A), Z = function() {
                function t(e) {
                    _(this, t), X(this, "dotsPos", []), X(this, "dotsValue", []), X(this, "data", void 0), X(this, "enableCross", void 0), X(this, "fixed", void 0), X(this, "max", void 0), X(this, "min", void 0), X(this, "interval", void 0), X(this, "minRange", void 0), X(this, "maxRange", void 0), X(this, "order", void 0), X(this, "marks", void 0), X(this, "included", void 0), X(this, "process", void 0), X(this, "adsorb", void 0), X(this, "dotOptions", void 0), X(this, "onError", void 0), X(this, "cacheRangeDir", {}), this.data = e.data, this.max = e.max, this.min = e.min, this.interval = e.interval, this.order = e.order, this.marks = e.marks, this.included = e.included, this.process = e.process, this.adsorb = e.adsorb, this.dotOptions = e.dotOptions, this.onError = e.onError, this.order ? (this.minRange = e.minRange || 0, this.maxRange = e.maxRange || 0, this.enableCross = e.enableCross, this.fixed = e.fixed) : ((e.minRange || e.maxRange || !e.enableCross || e.fixed) && this.emitError(V.ORDER), this.minRange = 0, this.maxRange = 0, this.enableCross = !0, this.fixed = !1), this.setValue(e.value);
                }
                return G(t, [
                    {
                        key: "setValue",
                        value: function(t) {
                            this.setDotsValue(Array.isArray(t) ? I(t) : [
                                t
                            ], !0);
                        }
                    },
                    {
                        key: "setDotsValue",
                        value: function(t, e) {
                            this.dotsValue = t, e && this.syncDotsPos();
                        }
                    },
                    {
                        key: "setDotsPos",
                        value: function(t) {
                            var e = this, r = this.order ? I(t).sort(function(t, e) {
                                return t - e;
                            }) : t;
                            this.dotsPos = r, this.setDotsValue(r.map(function(t) {
                                return e.getValueByPos(t);
                            }), this.adsorb);
                        }
                    },
                    {
                        key: "getValueByPos",
                        value: function(t) {
                            var e = this.parsePos(t);
                            if (this.included) {
                                var r = 100;
                                this.markList.forEach(function(n) {
                                    var i = Math.abs(n.pos - t);
                                    i < r && (r = i, e = n.value);
                                });
                            }
                            return e;
                        }
                    },
                    {
                        key: "syncDotsPos",
                        value: function() {
                            var t = this;
                            this.dotsPos = this.dotsValue.map(function(e) {
                                return t.parseValue(e);
                            });
                        }
                    },
                    {
                        key: "markList",
                        get: function() {
                            var t = this;
                            if (!this.marks) return [];
                            var e = function(e, r) {
                                var n = t.parseValue(e);
                                return z({
                                    pos: n,
                                    value: e,
                                    label: e,
                                    active: t.isActiveByPos(n)
                                }, r);
                            };
                            return !0 === this.marks ? this.getValues().map(function(t) {
                                return e(t);
                            }) : "[object Object]" === Object.prototype.toString.call(this.marks) ? Object.keys(this.marks).sort(function(t, e) {
                                return +t - +e;
                            }).map(function(r) {
                                var n = t.marks[r];
                                return e(r, "string" !== typeof n ? n : {
                                    label: n
                                });
                            }) : Array.isArray(this.marks) ? this.marks.map(function(t) {
                                return e(t);
                            }) : "function" === typeof this.marks ? this.getValues().map(function(e) {
                                return {
                                    value: e,
                                    result: t.marks(e)
                                };
                            }).filter(function(t) {
                                var e = t.result;
                                return !!e;
                            }).map(function(t) {
                                var r = t.value, n = t.result;
                                return e(r, n);
                            }) : [];
                        }
                    },
                    {
                        key: "getRecentDot",
                        value: function(t) {
                            var e = this.dotsPos.map(function(e) {
                                return Math.abs(e - t);
                            });
                            return e.indexOf(Math.min.apply(Math, I(e)));
                        }
                    },
                    {
                        key: "getIndexByValue",
                        value: function(t) {
                            return this.data ? this.data.indexOf(t) : new j(+t).minus(this.min).divide(this.interval).toNumber();
                        }
                    },
                    {
                        key: "getValueByIndex",
                        value: function(t) {
                            return t < 0 ? t = 0 : t > this.total && (t = this.total), this.data ? this.data[t] : new j(t).multiply(this.interval).plus(this.min).toNumber();
                        }
                    },
                    {
                        key: "setDotPos",
                        value: function(t, e) {
                            t = this.getValidPos(t, e).pos;
                            var r = t - this.dotsPos[e];
                            if (r) {
                                var n = new Array(this.dotsPos.length);
                                this.fixed ? n = this.getFixedChangePosArr(r, e) : this.minRange || this.maxRange ? n = this.getLimitRangeChangePosArr(t, r, e) : n[e] = r, this.setDotsPos(this.dotsPos.map(function(t, e) {
                                    return t + (n[e] || 0);
                                }));
                            }
                        }
                    },
                    {
                        key: "getFixedChangePosArr",
                        value: function(t, e) {
                            var r = this;
                            return this.dotsPos.forEach(function(n, i) {
                                if (i !== e) {
                                    var o = r.getValidPos(n + t, i), a = o.pos, s = o.inRange;
                                    s || (t = Math.min(Math.abs(a - n), Math.abs(t)) * (t < 0 ? -1 : 1));
                                }
                            }), this.dotsPos.map(function(e) {
                                return t;
                            });
                        }
                    },
                    {
                        key: "getLimitRangeChangePosArr",
                        value: function(t, e, r) {
                            var n = this, i = [
                                {
                                    index: r,
                                    changePos: e
                                }
                            ], o = e;
                            return [
                                this.minRange,
                                this.maxRange
                            ].forEach(function(a, s) {
                                if (!a) return !1;
                                var l = 0 === s, u = e > 0, c = 0;
                                c = l ? u ? 1 : -1 : u ? -1 : 1;
                                var d = function(t, e) {
                                    var r = Math.abs(t - e);
                                    return l ? r < n.minRangeDir : r > n.maxRangeDir;
                                }, h = r + c, f = n.dotsPos[h], p = t;
                                while(n.isPos(f) && d(f, p)){
                                    var m = n.getValidPos(f + o, h), v = m.pos;
                                    i.push({
                                        index: h,
                                        changePos: v - f
                                    }), h += c, p = v, f = n.dotsPos[h];
                                }
                            }), this.dotsPos.map(function(t, e) {
                                var r = i.filter(function(t) {
                                    return t.index === e;
                                });
                                return r.length ? r[0].changePos : 0;
                            });
                        }
                    },
                    {
                        key: "isPos",
                        value: function(t) {
                            return "number" === typeof t;
                        }
                    },
                    {
                        key: "getValidPos",
                        value: function(t, e) {
                            var r = this.valuePosRange[e], n = !0;
                            return t < r[0] ? (t = r[0], n = !1) : t > r[1] && (t = r[1], n = !1), {
                                pos: t,
                                inRange: n
                            };
                        }
                    },
                    {
                        key: "parseValue",
                        value: function(t) {
                            if (this.data) t = this.data.indexOf(t);
                            else if ("number" === typeof t || "string" === typeof t) {
                                if (t = +t, t < this.min) return this.emitError(V.MIN), 0;
                                if (t > this.max) return this.emitError(V.MAX), 0;
                                if ("number" !== typeof t || t !== t) return this.emitError(V.VALUE), 0;
                                t = new j(t).minus(this.min).divide(this.interval).toNumber();
                            }
                            var e = new j(t).multiply(this.gap).toNumber();
                            return e < 0 ? 0 : e > 100 ? 100 : e;
                        }
                    },
                    {
                        key: "parsePos",
                        value: function(t) {
                            var e = Math.round(t / this.gap);
                            return this.getValueByIndex(e);
                        }
                    },
                    {
                        key: "isActiveByPos",
                        value: function(t) {
                            return this.processArray.some(function(e) {
                                var r = C(e, 2), n = r[0], i = r[1];
                                return t >= n && t <= i;
                            });
                        }
                    },
                    {
                        key: "getValues",
                        value: function() {
                            if (this.data) return this.data;
                            for(var t = [], e = 0; e <= this.total; e++)t.push(new j(e).multiply(this.interval).plus(this.min).toNumber());
                            return t;
                        }
                    },
                    {
                        key: "getRangeDir",
                        value: function(t) {
                            return t ? new j(t).divide(new j(this.data ? this.data.length - 1 : this.max).minus(this.data ? 0 : this.min).toNumber()).multiply(100).toNumber() : 100;
                        }
                    },
                    {
                        key: "emitError",
                        value: function(t) {
                            this.onError && this.onError(t, q[t]);
                        }
                    },
                    {
                        key: "processArray",
                        get: function() {
                            if (this.process) {
                                if ("function" === typeof this.process) return this.process(this.dotsPos);
                                if (1 === this.dotsPos.length) return [
                                    [
                                        0,
                                        this.dotsPos[0]
                                    ]
                                ];
                                if (this.dotsPos.length > 1) return [
                                    [
                                        Math.min.apply(Math, I(this.dotsPos)),
                                        Math.max.apply(Math, I(this.dotsPos))
                                    ]
                                ];
                            }
                            return [];
                        }
                    },
                    {
                        key: "total",
                        get: function() {
                            var t = 0;
                            return t = this.data ? this.data.length - 1 : new j(this.max).minus(this.min).divide(this.interval).toNumber(), t - Math.floor(t) !== 0 ? (this.emitError(V.INTERVAL), 0) : t;
                        }
                    },
                    {
                        key: "gap",
                        get: function() {
                            return 100 / this.total;
                        }
                    },
                    {
                        key: "minRangeDir",
                        get: function() {
                            return this.cacheRangeDir[this.minRange] ? this.cacheRangeDir[this.minRange] : this.cacheRangeDir[this.minRange] = this.getRangeDir(this.minRange);
                        }
                    },
                    {
                        key: "maxRangeDir",
                        get: function() {
                            return this.cacheRangeDir[this.maxRange] ? this.cacheRangeDir[this.maxRange] : this.cacheRangeDir[this.maxRange] = this.getRangeDir(this.maxRange);
                        }
                    },
                    {
                        key: "getDotRange",
                        value: function(t, e, r) {
                            if (!this.dotOptions) return r;
                            var n = Array.isArray(this.dotOptions) ? this.dotOptions[t] : this.dotOptions;
                            return n && void 0 !== n[e] ? this.parseValue(n[e]) : r;
                        }
                    },
                    {
                        key: "valuePosRange",
                        get: function() {
                            var t = this, e = this.dotsPos, r = [];
                            return e.forEach(function(n, i) {
                                r.push([
                                    Math.max(t.minRange ? t.minRangeDir * i : 0, t.enableCross ? 0 : e[i - 1] || 0, t.getDotRange(i, "min", 0)),
                                    Math.min(t.minRange ? 100 - t.minRangeDir * (e.length - 1 - i) : 100, t.enableCross ? 100 : e[i + 1] || 100, t.getDotRange(i, "max", 100))
                                ]);
                            }), r;
                        }
                    },
                    {
                        key: "dotsIndex",
                        get: function() {
                            var t = this;
                            return this.dotsValue.map(function(e) {
                                return t.getIndexByValue(e);
                            });
                        }
                    }
                ]), t;
            }();
            function Y(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function K(t, e) {
                for(var r = 0; r < e.length; r++){
                    var n = e[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
                }
            }
            function J(t, e, r) {
                return e && K(t.prototype, e), r && K(t, r), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t;
            }
            function Q(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            var tt = function() {
                function t(e) {
                    Y(this, t), Q(this, "map", void 0), Q(this, "states", 0), this.map = e;
                }
                return J(t, [
                    {
                        key: "add",
                        value: function(t) {
                            this.states |= t;
                        }
                    },
                    {
                        key: "delete",
                        value: function(t) {
                            this.states &= ~t;
                        }
                    },
                    {
                        key: "toggle",
                        value: function(t) {
                            this.has(t) ? this.delete(t) : this.add(t);
                        }
                    },
                    {
                        key: "has",
                        value: function(t) {
                            return !!(this.states & t);
                        }
                    }
                ]), t;
            }();
            n(631);
            function et(t) {
                return it(t) || nt(t) || dt(t) || rt();
            }
            function rt() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function nt(t) {
                if ("undefined" !== typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }
            function it(t) {
                if (Array.isArray(t)) return ht(t);
            }
            function ot(t) {
                return ot = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, ot(t);
            }
            function at(t, e) {
                var r = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(t);
                    e && (n = n.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function st(t) {
                for(var e = 1; e < arguments.length; e++){
                    var r = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? at(Object(r), !0).forEach(function(e) {
                        lt(t, e, r[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : at(Object(r)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
                    });
                }
                return t;
            }
            function lt(t, e, r) {
                return e in t ? Object.defineProperty(t, e, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = r, t;
            }
            function ut(t, e) {
                return pt(t) || ft(t, e) || dt(t, e) || ct();
            }
            function ct() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function dt(t, e) {
                if (t) {
                    if ("string" === typeof t) return ht(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? ht(t, e) : void 0;
                }
            }
            function ht(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var r = 0, n = new Array(e); r < e; r++)n[r] = t[r];
                return n;
            }
            function ft(t, e) {
                var r = null == t ? null : "undefined" !== typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (null != r) {
                    var n, i, o = [], a = !0, s = !1;
                    try {
                        for(r = r.call(t); !(a = (n = r.next()).done); a = !0)if (o.push(n.value), e && o.length === e) break;
                    } catch (l) {
                        s = !0, i = l;
                    } finally{
                        try {
                            a || null == r["return"] || r["return"]();
                        } finally{
                            if (s) throw i;
                        }
                    }
                    return o;
                }
            }
            function pt(t) {
                if (Array.isArray(t)) return t;
            }
            var mt = {
                None: 0,
                Drag: 2,
                Focus: 4
            }, vt = 4, yt = (0, o.defineComponent)({
                name: "VueSlider",
                components: {
                    VueSliderDot: m,
                    VueSliderMark: k
                },
                emits: [
                    "change",
                    "drag-start",
                    "dragging",
                    "drag-end",
                    "error",
                    "update:modelValue"
                ],
                data: function() {
                    return {
                        control: null,
                        states: new tt(mt),
                        scale: 1,
                        focusDotIndex: 0
                    };
                },
                props: {
                    modelValue: {
                        type: [
                            Number,
                            String,
                            Array
                        ],
                        default: 0
                    },
                    silent: {
                        type: Boolean,
                        default: !1
                    },
                    direction: {
                        type: String,
                        default: "ltr",
                        validator: function(t) {
                            return [
                                "ltr",
                                "rtl",
                                "ttb",
                                "btt"
                            ].indexOf(t) > -1;
                        }
                    },
                    width: {
                        type: [
                            Number,
                            String
                        ]
                    },
                    height: {
                        type: [
                            Number,
                            String
                        ]
                    },
                    dotSize: {
                        type: [
                            Number,
                            Array
                        ],
                        default: 14
                    },
                    contained: {
                        type: Boolean,
                        default: !1
                    },
                    min: {
                        type: Number,
                        default: 0
                    },
                    max: {
                        type: Number,
                        default: 100
                    },
                    interval: {
                        type: Number,
                        default: 1
                    },
                    disabled: {
                        type: Boolean,
                        default: !1
                    },
                    clickable: {
                        type: Boolean,
                        default: !0
                    },
                    dragOnClick: {
                        type: Boolean,
                        default: !1
                    },
                    duration: {
                        type: Number,
                        default: .5
                    },
                    data: {
                        type: [
                            Object,
                            Array
                        ]
                    },
                    dataValue: {
                        type: String,
                        default: "value"
                    },
                    dataLabel: {
                        type: String,
                        default: "label"
                    },
                    lazy: {
                        type: Boolean,
                        default: !1
                    },
                    tooltip: {
                        type: String,
                        default: "active",
                        validator: function(t) {
                            return [
                                "none",
                                "always",
                                "focus",
                                "hover",
                                "active"
                            ].indexOf(t) > -1;
                        }
                    },
                    tooltipPlacement: {
                        type: [
                            String,
                            Array
                        ],
                        validator: function(t) {
                            return (Array.isArray(t) ? t : [
                                t
                            ]).every(function(t) {
                                return [
                                    "top",
                                    "right",
                                    "bottom",
                                    "left"
                                ].indexOf(t) > -1;
                            });
                        }
                    },
                    tooltipFormatter: {
                        type: [
                            String,
                            Array,
                            Function
                        ]
                    },
                    useKeyboard: {
                        type: Boolean,
                        default: !0
                    },
                    keydownHook: {
                        type: Function
                    },
                    enableCross: {
                        type: Boolean,
                        default: !0
                    },
                    fixed: {
                        type: Boolean,
                        default: !1
                    },
                    order: {
                        type: Boolean,
                        default: !0
                    },
                    minRange: {
                        type: Number
                    },
                    maxRange: {
                        type: Number
                    },
                    marks: {
                        type: [
                            Boolean,
                            Object,
                            Array,
                            Function
                        ],
                        default: !1
                    },
                    process: {
                        type: [
                            Boolean,
                            Function
                        ],
                        default: !0
                    },
                    zoom: {
                        type: Number
                    },
                    included: {
                        type: Boolean
                    },
                    adsorb: {
                        type: Boolean
                    },
                    hideLabel: {
                        type: Boolean
                    },
                    dotOptions: {
                        type: [
                            Object,
                            Array
                        ]
                    },
                    dotAttrs: {
                        type: Object
                    },
                    railStyle: {
                        type: Object
                    },
                    processStyle: {
                        type: Object
                    },
                    dotStyle: {
                        type: Object
                    },
                    tooltipStyle: {
                        type: Object
                    },
                    stepStyle: {
                        type: Object
                    },
                    stepActiveStyle: {
                        type: Object
                    },
                    labelStyle: {
                        type: Object
                    },
                    labelActiveStyle: {
                        type: Object
                    }
                },
                computed: {
                    isHorizontal: function() {
                        return "ltr" === this.direction || "rtl" === this.direction;
                    },
                    isReverse: function() {
                        return "rtl" === this.direction || "btt" === this.direction;
                    },
                    tailSize: function() {
                        return S((this.isHorizontal ? this.height : this.width) || vt);
                    },
                    containerClasses: function() {
                        return [
                            "vue-slider",
                            [
                                "vue-slider-".concat(this.direction)
                            ],
                            {
                                "vue-slider-disabled": this.disabled
                            }
                        ];
                    },
                    containerStyles: function() {
                        var t = Array.isArray(this.dotSize) ? this.dotSize : [
                            this.dotSize,
                            this.dotSize
                        ], e = ut(t, 2), r = e[0], n = e[1], i = this.width ? S(this.width) : this.isHorizontal ? "auto" : S(vt), o = this.height ? S(this.height) : this.isHorizontal ? S(vt) : "auto";
                        return {
                            padding: this.contained ? "".concat(n / 2, "px ").concat(r / 2, "px") : this.isHorizontal ? "".concat(n / 2, "px 0") : "0 ".concat(r / 2, "px"),
                            width: i,
                            height: o
                        };
                    },
                    processArray: function() {
                        var t = this;
                        return this.control.processArray.map(function(e, r) {
                            var n, i = ut(e, 3), o = i[0], a = i[1], s = i[2];
                            if (o > a) {
                                var l = [
                                    a,
                                    o
                                ];
                                o = l[0], a = l[1];
                            }
                            var u = t.isHorizontal ? "width" : "height";
                            return {
                                start: o,
                                end: a,
                                index: r,
                                style: st(st((n = {}, lt(n, t.isHorizontal ? "height" : "width", "100%"), lt(n, t.isHorizontal ? "top" : "left", 0), lt(n, t.mainDirection, "".concat(o, "%")), lt(n, u, "".concat(a - o, "%")), lt(n, "transitionProperty", "".concat(u, ",").concat(t.mainDirection)), lt(n, "transitionDuration", "".concat(t.animateTime, "s")), n), t.processStyle), s)
                            };
                        });
                    },
                    dotBaseStyle: function() {
                        var t, e = Array.isArray(this.dotSize) ? this.dotSize : [
                            this.dotSize,
                            this.dotSize
                        ], r = ut(e, 2), n = r[0], i = r[1];
                        return t = this.isHorizontal ? lt({
                            transform: "translate(".concat(this.isReverse ? "50%" : "-50%", ", -50%)"),
                            WebkitTransform: "translate(".concat(this.isReverse ? "50%" : "-50%", ", -50%)"),
                            top: "50%"
                        }, "ltr" === this.direction ? "left" : "right", "0") : lt({
                            transform: "translate(-50%, ".concat(this.isReverse ? "50%" : "-50%", ")"),
                            WebkitTransform: "translate(-50%, ".concat(this.isReverse ? "50%" : "-50%", ")"),
                            left: "50%"
                        }, "btt" === this.direction ? "bottom" : "top", "0"), st({
                            width: "".concat(n, "px"),
                            height: "".concat(i, "px")
                        }, t);
                    },
                    mainDirection: function() {
                        switch(this.direction){
                            case "ltr":
                                return "left";
                            case "rtl":
                                return "right";
                            case "btt":
                                return "bottom";
                            case "ttb":
                                return "top";
                            default:
                                return "left";
                        }
                    },
                    tooltipDirections: function() {
                        var t = this.tooltipPlacement || (this.isHorizontal ? "top" : "left");
                        return Array.isArray(t) ? t : this.dots.map(function() {
                            return t;
                        });
                    },
                    dots: function() {
                        var t = this;
                        return this.control.dotsPos.map(function(e, r) {
                            return st({
                                pos: e,
                                index: r,
                                value: t.control.dotsValue[r],
                                focus: t.states.has(mt.Focus) && t.focusDotIndex === r,
                                disabled: t.disabled,
                                style: t.dotStyle
                            }, (Array.isArray(t.dotOptions) ? t.dotOptions[r] : t.dotOptions) || {});
                        });
                    },
                    animateTime: function() {
                        return this.states.has(mt.Drag) ? 0 : this.duration;
                    },
                    canSort: function() {
                        return this.order && !this.minRange && !this.maxRange && !this.fixed && this.enableCross;
                    },
                    sliderData: function() {
                        var t = this;
                        return this.isObjectArrayData(this.data) ? this.data.map(function(e) {
                            return e[t.dataValue];
                        }) : this.isObjectData(this.data) ? Object.keys(this.data) : this.data;
                    },
                    sliderMarks: function() {
                        var t = this;
                        return this.marks ? this.marks : this.isObjectArrayData(this.data) ? function(e) {
                            var r = {
                                label: e
                            };
                            return t.data.some(function(n) {
                                return n[t.dataValue] === e && (r.label = n[t.dataLabel], !0);
                            }), r;
                        } : this.isObjectData(this.data) ? this.data : void 0;
                    },
                    sliderTooltipFormatter: function() {
                        var t = this;
                        if (this.tooltipFormatter) return this.tooltipFormatter;
                        if (this.isObjectArrayData(this.data)) return function(e) {
                            var r = "" + e;
                            return t.data.some(function(n) {
                                return n[t.dataValue] === e && (r = n[t.dataLabel], !0);
                            }), r;
                        };
                        if (this.isObjectData(this.data)) {
                            var e = this.data;
                            return function(t) {
                                return e[t];
                            };
                        }
                    },
                    isNotSync: function() {
                        var t = this.control.dotsValue;
                        return Array.isArray(this.modelValue) ? this.modelValue.length !== t.length || this.modelValue.some(function(e, r) {
                            return e !== t[r];
                        }) : this.modelValue !== t[0];
                    },
                    dragRange: function() {
                        var t = this.dots[this.focusDotIndex - 1], e = this.dots[this.focusDotIndex + 1];
                        return [
                            t ? t.pos : -1 / 0,
                            e ? e.pos : 1 / 0
                        ];
                    }
                },
                watch: {
                    modelValue: function() {
                        this.control && !this.states.has(mt.Drag) && this.isNotSync && this.control.setValue(this.modelValue);
                    }
                },
                methods: {
                    isObjectData: function(t) {
                        return !!t && "[object Object]" === Object.prototype.toString.call(t);
                    },
                    isObjectArrayData: function(t) {
                        return !!t && Array.isArray(t) && t.length > 0 && "object" === ot(t[0]);
                    },
                    bindEvent: function() {
                        document.addEventListener("touchmove", this.dragMove, {
                            passive: !1
                        }), document.addEventListener("touchend", this.dragEnd, {
                            passive: !1
                        }), document.addEventListener("mousedown", this.blurHandle), document.addEventListener("mousemove", this.dragMove), document.addEventListener("mouseup", this.dragEnd), document.addEventListener("mouseleave", this.dragEnd), document.addEventListener("keydown", this.keydownHandle);
                    },
                    unbindEvent: function() {
                        document.removeEventListener("touchmove", this.dragMove), document.removeEventListener("touchend", this.dragEnd), document.removeEventListener("mousedown", this.blurHandle), document.removeEventListener("mousemove", this.dragMove), document.removeEventListener("mouseup", this.dragEnd), document.removeEventListener("mouseleave", this.dragEnd), document.removeEventListener("keydown", this.keydownHandle);
                    },
                    setScale: function() {
                        this.scale = new j(Math.floor(this.isHorizontal ? this.$el.offsetWidth : this.$el.offsetHeight)).multiply(this.zoom || 1).divide(100).toNumber();
                    },
                    initControl: function() {
                        var t = this;
                        this.control = new Z({
                            value: this.modelValue,
                            data: this.sliderData,
                            enableCross: this.enableCross,
                            fixed: this.fixed,
                            max: this.max,
                            min: this.min,
                            interval: this.interval,
                            minRange: this.minRange,
                            maxRange: this.maxRange,
                            order: this.order,
                            marks: this.sliderMarks,
                            included: this.included,
                            process: this.process,
                            adsorb: this.adsorb,
                            dotOptions: this.dotOptions,
                            onError: this.emitError
                        }), [
                            "data",
                            "enableCross",
                            "fixed",
                            "max",
                            "min",
                            "interval",
                            "minRange",
                            "maxRange",
                            "order",
                            "marks",
                            "process",
                            "adsorb",
                            "included",
                            "dotOptions"
                        ].forEach(function(e) {
                            t.$watch(e, function(r) {
                                if ("data" === e && Array.isArray(t.control.data) && Array.isArray(r) && t.control.data.length === r.length && r.every(function(e, r) {
                                    return e === t.control.data[r];
                                })) return !1;
                                switch(e){
                                    case "data":
                                    case "dataLabel":
                                    case "dataValue":
                                        t.control.data = t.sliderData;
                                        break;
                                    case "mark":
                                        t.control.marks = t.sliderMarks;
                                        break;
                                    default:
                                        t.control[e] = r;
                                }
                                [
                                    "data",
                                    "max",
                                    "min",
                                    "interval"
                                ].indexOf(e) > -1 && t.control.syncDotsPos();
                            });
                        });
                    },
                    syncValueByPos: function() {
                        var t = this.control.dotsValue;
                        if (this.isDiff(t, Array.isArray(this.modelValue) ? this.modelValue : [
                            this.modelValue
                        ])) {
                            var e = 1 === t.length ? t[0] : et(t);
                            this.$emit("change", e, this.focusDotIndex), this.$emit("update:modelValue", e);
                        }
                    },
                    isDiff: function(t, e) {
                        return t.length !== e.length || t.some(function(t, r) {
                            return t !== e[r];
                        });
                    },
                    emitError: function(t, e) {
                        this.silent || console.error("[VueSlider error]: ".concat(e)), this.$emit("error", t, e);
                    },
                    dragStartOnProcess: function(t) {
                        if (this.dragOnClick) {
                            this.setScale();
                            var e = this.getPosByEvent(t), r = this.control.getRecentDot(e);
                            if (this.dots[r].disabled) return;
                            this.dragStart(r), this.control.setDotPos(e, this.focusDotIndex), this.lazy || this.syncValueByPos();
                        }
                    },
                    dragStart: function(t) {
                        this.focusDotIndex = t, this.setScale(), this.states.add(mt.Drag), this.states.add(mt.Focus), this.$emit("drag-start", this.focusDotIndex);
                    },
                    dragMove: function(t) {
                        if (!this.states.has(mt.Drag)) return !1;
                        t.preventDefault();
                        var e = this.getPosByEvent(t);
                        this.isCrossDot(e), this.control.setDotPos(e, this.focusDotIndex), this.lazy || this.syncValueByPos();
                        var r = this.control.dotsValue;
                        this.$emit("dragging", 1 === r.length ? r[0] : et(r), this.focusDotIndex);
                    },
                    isCrossDot: function(t) {
                        if (this.canSort) {
                            var e = this.focusDotIndex, r = t;
                            if (r > this.dragRange[1] ? (r = this.dragRange[1], this.focusDotIndex++) : r < this.dragRange[0] && (r = this.dragRange[0], this.focusDotIndex--), e !== this.focusDotIndex) {
                                var n = this.$refs["dot-".concat(this.focusDotIndex)];
                                n && n.$el && n.$el.focus(), this.control.setDotPos(r, e);
                            }
                        }
                    },
                    dragEnd: function(t) {
                        var e = this;
                        if (!this.states.has(mt.Drag)) return !1;
                        setTimeout(function() {
                            e.lazy && e.syncValueByPos(), e.included && e.isNotSync ? e.control.setValue(e.modelValue) : e.control.syncDotsPos(), e.states.delete(mt.Drag), e.useKeyboard && !("targetTouches" in t) || e.states.delete(mt.Focus), e.$emit("drag-end", e.focusDotIndex);
                        });
                    },
                    blurHandle: function(t) {
                        if (!this.states.has(mt.Focus) || !this.$refs.container || this.$refs.container.contains(t.target)) return !1;
                        this.states.delete(mt.Focus);
                    },
                    clickHandle: function(t) {
                        if (!this.clickable || this.disabled) return !1;
                        if (!this.states.has(mt.Drag)) {
                            this.setScale();
                            var e = this.getPosByEvent(t);
                            this.setValueByPos(e);
                        }
                    },
                    focus: function(t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                        t.disabled || (this.states.add(mt.Focus), this.focusDotIndex = e);
                    },
                    blur: function() {
                        this.states.delete(mt.Focus);
                    },
                    getValue: function() {
                        var t = this.control.dotsValue;
                        return 1 === t.length ? t[0] : t;
                    },
                    getIndex: function() {
                        var t = this.control.dotsIndex;
                        return 1 === t.length ? t[0] : t;
                    },
                    setValue: function(t) {
                        this.control.setValue(Array.isArray(t) ? et(t) : [
                            t
                        ]), this.syncValueByPos();
                    },
                    setIndex: function(t) {
                        var e = this, r = Array.isArray(t) ? t.map(function(t) {
                            return e.control.getValueByIndex(t);
                        }) : this.control.getValueByIndex(t);
                        this.setValue(r);
                    },
                    setValueByPos: function(t) {
                        var e = this, r = this.control.getRecentDot(t);
                        if (this.disabled || this.dots[r].disabled) return !1;
                        this.focusDotIndex = r, this.control.setDotPos(t, r), this.syncValueByPos(), this.useKeyboard && this.states.add(mt.Focus), setTimeout(function() {
                            e.included && e.isNotSync ? e.control.setValue(e.modelValue) : e.control.syncDotsPos();
                        });
                    },
                    keydownHandle: function(t) {
                        var e = this;
                        if (!this.useKeyboard || !this.states.has(mt.Focus)) return !1;
                        var r = this.included && this.marks, n = w(t, {
                            direction: this.direction,
                            max: r ? this.control.markList.length - 1 : this.control.total,
                            min: 0,
                            hook: this.keydownHook
                        });
                        if (n) {
                            t.preventDefault();
                            var i = -1, o = 0;
                            r ? (this.control.markList.some(function(t, r) {
                                return t.value === e.control.dotsValue[e.focusDotIndex] && (i = n(r), !0);
                            }), i < 0 ? i = 0 : i > this.control.markList.length - 1 && (i = this.control.markList.length - 1), o = this.control.markList[i].pos) : (i = n(this.control.getIndexByValue(this.control.dotsValue[this.focusDotIndex])), o = this.control.parseValue(this.control.getValueByIndex(i))), this.isCrossDot(o), this.control.setDotPos(o, this.focusDotIndex), this.syncValueByPos();
                        }
                    },
                    getPosByEvent: function(t) {
                        return P(t, this.$el, this.isReverse, this.zoom)[this.isHorizontal ? "x" : "y"] / this.scale;
                    },
                    renderSlot: function(t, e, r) {
                        var n = this.$slots[t];
                        return n ? n(e) : r;
                    }
                },
                created: function() {
                    this.initControl();
                },
                mounted: function() {
                    this.bindEvent();
                },
                beforeUnmount: function() {
                    this.unbindEvent();
                }
            });
            const bt = (0, f.Z)(yt, [
                [
                    "render",
                    l
                ]
            ]);
            var gt = bt;
            gt.VueSliderMark = k, gt.VueSliderDot = m;
            var kt = gt, St = kt;
        }(), i = i["default"], i;
    }();
});

});


parcelRegister("7A8yi", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $5852877434f662d7$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $6zPDN = parcelRequire("6zPDN");
const $5852877434f662d7$var$_hoisted_1 = {
    class: "property-list-section"
};
const $5852877434f662d7$var$_hoisted_2 = {
    class: "container-4"
};
const $5852877434f662d7$var$_hoisted_3 = {
    class: "filter-item"
};
const $5852877434f662d7$var$_hoisted_4 = {
    class: "label-1"
};
const $5852877434f662d7$var$_hoisted_5 = {
    class: "filter-item"
};
const $5852877434f662d7$var$_hoisted_6 = {
    class: "label-1"
};
const $5852877434f662d7$var$_hoisted_7 = {
    value: "not-selected"
};
const $5852877434f662d7$var$_hoisted_8 = [
    "value"
];
const $5852877434f662d7$var$_hoisted_9 = {
    key: 0,
    class: "filter-item"
};
const $5852877434f662d7$var$_hoisted_10 = {
    class: "label-1"
};
const $5852877434f662d7$var$_hoisted_11 = {
    value: "not-selected"
};
const $5852877434f662d7$var$_hoisted_12 = [
    "value"
];
const $5852877434f662d7$var$_hoisted_13 = {
    class: "filter-item"
};
const $5852877434f662d7$var$_hoisted_14 = {
    class: "label-1"
};
const $5852877434f662d7$var$_hoisted_15 = {
    value: "not-selected"
};
const $5852877434f662d7$var$_hoisted_16 = {
    value: "popular"
};
const $5852877434f662d7$var$_hoisted_17 = {
    value: "price_low"
};
const $5852877434f662d7$var$_hoisted_18 = {
    value: "price_high"
};
const $5852877434f662d7$var$_hoisted_19 = {
    value: "newest"
};
const $5852877434f662d7$var$_hoisted_20 = {
    value: "oldest"
};
const $5852877434f662d7$var$_hoisted_21 = {
    id: "form_search_post",
    name: "form_search_post",
    value: "si",
    class: "btn-1 full-width"
};
const $5852877434f662d7$var$_hoisted_22 = {
    class: "btn-1 full-width"
};
const $5852877434f662d7$var$_hoisted_23 = {
    class: "filter-popup-inner"
};
const $5852877434f662d7$var$_hoisted_24 = {
    class: "filter-popup-header relative"
};
const $5852877434f662d7$var$_hoisted_25 = {
    class: "filter-popup-title center"
};
const $5852877434f662d7$var$_hoisted_26 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("svg", {
    viewBox: "0 0 32 32"
}, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("path", {
        d: "M26.6 6.80002L25.2 5.40002L16 14.6L6.80002 5.40002L5.40002 6.80002L14.6 16L5.40002 25.2L6.80002 26.6L16 17.4L25.2 26.6L26.6 25.2L17.4 16L26.6 6.80002Z"
    })
], -1);
const $5852877434f662d7$var$_hoisted_27 = [
    $5852877434f662d7$var$_hoisted_26
];
const $5852877434f662d7$var$_hoisted_28 = {
    class: "filter-popup-items-wrap"
};
const $5852877434f662d7$var$_hoisted_29 = {
    class: "filter-popup-item"
};
const $5852877434f662d7$var$_hoisted_30 = {
    class: "label-2 m-10"
};
const $5852877434f662d7$var$_hoisted_31 = {
    value: "not-selected"
};
const $5852877434f662d7$var$_hoisted_32 = [
    "value"
];
const $5852877434f662d7$var$_hoisted_33 = {
    class: "filter-popup-item"
};
const $5852877434f662d7$var$_hoisted_34 = {
    class: "label-2 m-10"
};
const $5852877434f662d7$var$_hoisted_35 = {
    value: "not-selected"
};
const $5852877434f662d7$var$_hoisted_36 = /*#__PURE__*/ (0, $9pglz.createStaticVNode)('<option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option>', 8);
const $5852877434f662d7$var$_hoisted_44 = {
    value: "9"
};
const $5852877434f662d7$var$_hoisted_45 = {
    class: "filter-popup-item"
};
const $5852877434f662d7$var$_hoisted_46 = {
    class: "label-2 m-10"
};
const $5852877434f662d7$var$_hoisted_47 = {
    class: "input-container"
};
const $5852877434f662d7$var$_hoisted_48 = {
    class: "slide-range-flex"
};
const $5852877434f662d7$var$_hoisted_49 = {
    "data-v-83aca2": "",
    class: "input"
};
const $5852877434f662d7$var$_hoisted_50 = {
    class: "input-slide-container"
};
const $5852877434f662d7$var$_hoisted_51 = {
    "data-v-83aca2": "",
    class: "input"
};
const $5852877434f662d7$var$_hoisted_52 = {
    class: "input-slide-container"
};
const $5852877434f662d7$var$_hoisted_53 = {
    class: "filter-popup-item"
};
const $5852877434f662d7$var$_hoisted_54 = {
    class: "label-2 m-10"
};
const $5852877434f662d7$var$_hoisted_55 = {
    value: "not-selected"
};
const $5852877434f662d7$var$_hoisted_56 = /*#__PURE__*/ (0, $9pglz.createStaticVNode)('<option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option>', 8);
const $5852877434f662d7$var$_hoisted_64 = {
    value: "9"
};
const $5852877434f662d7$var$_hoisted_65 = {
    class: "filter-popup-item"
};
const $5852877434f662d7$var$_hoisted_66 = {
    class: "label-2 m-10"
};
const $5852877434f662d7$var$_hoisted_67 = {
    class: "input-container"
};
const $5852877434f662d7$var$_hoisted_68 = {
    class: "slide-range-flex"
};
const $5852877434f662d7$var$_hoisted_69 = {
    "data-v-83aca2": "",
    class: "input"
};
const $5852877434f662d7$var$_hoisted_70 = {
    class: "input-slide-container"
};
const $5852877434f662d7$var$_hoisted_71 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("span", {
    class: "unit-suffix"
}, "m\xb2", -1);
const $5852877434f662d7$var$_hoisted_72 = {
    "data-v-83aca2": "",
    class: "input"
};
const $5852877434f662d7$var$_hoisted_73 = {
    class: "input-slide-container"
};
const $5852877434f662d7$var$_hoisted_74 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("span", {
    class: "unit-suffix"
}, "m\xb2", -1);
const $5852877434f662d7$var$_hoisted_75 = {
    class: "filter-popup-item"
};
const $5852877434f662d7$var$_hoisted_76 = {
    class: "label-2 m-10"
};
const $5852877434f662d7$var$_hoisted_77 = {
    class: "input-container"
};
const $5852877434f662d7$var$_hoisted_78 = {
    class: "slide-range-flex"
};
const $5852877434f662d7$var$_hoisted_79 = {
    class: "input"
};
const $5852877434f662d7$var$_hoisted_80 = {
    class: "input-slide-container"
};
const $5852877434f662d7$var$_hoisted_81 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("span", {
    class: "unit-suffix"
}, "m\xb2", -1);
const $5852877434f662d7$var$_hoisted_82 = {
    class: "input"
};
const $5852877434f662d7$var$_hoisted_83 = {
    class: "input-slide-container"
};
const $5852877434f662d7$var$_hoisted_84 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("span", {
    class: "unit-suffix"
}, "m\xb2", -1);
const $5852877434f662d7$var$_hoisted_85 = {
    class: "filter-popup-item group"
};
const $5852877434f662d7$var$_hoisted_86 = {
    class: "label-2 m-10 full-width"
};
const $5852877434f662d7$var$_hoisted_87 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_88 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_89 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_90 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_91 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_92 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_93 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_94 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_95 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_96 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_97 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_98 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_99 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_100 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_101 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_102 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_103 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_104 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_105 = {
    class: "filter-popup-item group group-2"
};
const $5852877434f662d7$var$_hoisted_106 = {
    class: "label-2 m-10 full-width"
};
const $5852877434f662d7$var$_hoisted_107 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_108 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_109 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_110 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_111 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_112 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_113 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_114 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_115 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_116 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_117 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_118 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_119 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_120 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_121 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_122 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_123 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_124 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_125 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_126 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_127 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_128 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_129 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_130 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_131 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_132 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_133 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_134 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_135 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_136 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_137 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_138 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_139 = {
    class: "checkbox"
};
const $5852877434f662d7$var$_hoisted_140 = {
    class: "checkbox-1"
};
const $5852877434f662d7$var$_hoisted_141 = {
    class: "filter-popup-item group"
};
const $5852877434f662d7$var$_hoisted_142 = {
    class: "label-2 m-10 full-width"
};
const $5852877434f662d7$var$_hoisted_143 = {
    class: "input"
};
const $5852877434f662d7$var$_hoisted_144 = {
    class: "input"
};
const $5852877434f662d7$var$_hoisted_145 = {
    class: "filter-popup-bottom flex space-between"
};
const $5852877434f662d7$var$_hoisted_146 = {
    class: "container-properties"
};
const $5852877434f662d7$var$_hoisted_147 = {
    key: 0,
    class: "property-list-destinations m-20"
};
const $5852877434f662d7$var$_hoisted_148 = {
    class: "m-20"
};
const $5852877434f662d7$var$_hoisted_149 = {
    class: "property-list-categories flex"
};
const $5852877434f662d7$var$_hoisted_150 = [
    "href"
];
const $5852877434f662d7$var$_hoisted_151 = {
    id: "properties-scroll"
};
const $5852877434f662d7$var$_hoisted_152 = {
    key: 0,
    class: "loader-wrap"
};
const $5852877434f662d7$var$_hoisted_153 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "loader"
}, null, -1);
const $5852877434f662d7$var$_hoisted_154 = [
    $5852877434f662d7$var$_hoisted_153
];
const $5852877434f662d7$var$_hoisted_155 = {
    key: 1,
    class: "property-list-grid grid m-30",
    "data-function": "overflowCalculate"
};
const $5852877434f662d7$var$_hoisted_156 = {
    class: "property-item"
};
const $5852877434f662d7$var$_hoisted_157 = [
    "onClick"
];
const $5852877434f662d7$var$_hoisted_158 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    viewBox: "0 0 471.701 471.701",
    "xml:space": "preserve"
}, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("path", {
        d: "M433.601,67.001c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7,13.6-92.4,38.3l-12.9,12.9l-13.1-13.1 c-24.7-24.7-57.6-38.4-92.5-38.4c-34.8,0-67.6,13.6-92.2,38.2c-24.7,24.7-38.3,57.5-38.2,92.4c0,34.9,13.7,67.6,38.4,92.3 l187.8,187.8c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-3.9l188.2-187.5c24.7-24.7,38.3-57.5,38.3-92.4 C471.801,124.501,458.301,91.701,433.601,67.001z M414.401,232.701l-178.7,178l-178.3-178.3c-19.6-19.6-30.4-45.6-30.4-73.3 s10.7-53.7,30.3-73.2c19.5-19.5,45.5-30.3,73.1-30.3c27.7,0,53.8,10.8,73.4,30.4l22.6,22.6c5.3,5.3,13.8,5.3,19.1,0l22.4-22.4 c19.6-19.6,45.7-30.4,73.3-30.4c27.6,0,53.6,10.8,73.2,30.3c19.6,19.6,30.3,45.6,30.3,73.3 C444.801,187.101,434.001,213.101,414.401,232.701z"
    })
], -1);
const $5852877434f662d7$var$_hoisted_159 = [
    $5852877434f662d7$var$_hoisted_158
];
const $5852877434f662d7$var$_hoisted_160 = [
    "href"
];
const $5852877434f662d7$var$_hoisted_161 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("img", {
    src: "https://croatiarealestates.com/wp-content/uploads/2024/04/video-camera.png"
}, null, -1);
const $5852877434f662d7$var$_hoisted_162 = [
    $5852877434f662d7$var$_hoisted_161
];
const $5852877434f662d7$var$_hoisted_163 = [
    "href"
];
const $5852877434f662d7$var$_hoisted_164 = {
    class: "property-item-slider m-15",
    id: "property-item-slider",
    "data-function": "propertyItemSlider"
};
const $5852877434f662d7$var$_hoisted_165 = {
    class: "swiper-wrapper"
};
const $5852877434f662d7$var$_hoisted_166 = {
    class: "swiper-slide"
};
const $5852877434f662d7$var$_hoisted_167 = {
    class: "slide-inner relative overflow"
};
const $5852877434f662d7$var$_hoisted_168 = [
    "src",
    "alt"
];
const $5852877434f662d7$var$_hoisted_169 = [
    "data-src",
    "alt"
];
const $5852877434f662d7$var$_hoisted_170 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "swiper-lazy-preloader"
}, null, -1);
const $5852877434f662d7$var$_hoisted_171 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "swiper-button-prev"
}, null, -1);
const $5852877434f662d7$var$_hoisted_172 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "swiper-button-next"
}, null, -1);
const $5852877434f662d7$var$_hoisted_173 = [
    "data-base-price"
];
const $5852877434f662d7$var$_hoisted_174 = {
    class: "list-card-location text-1 color-1 overflow-calc"
};
const $5852877434f662d7$var$_hoisted_175 = {
    class: "list-card-info text-1 color-3 overflow-calc"
};
const $5852877434f662d7$var$_hoisted_176 = {
    key: 0
};
const $5852877434f662d7$var$_hoisted_177 = {
    key: 1
};
const $5852877434f662d7$var$_hoisted_178 = {
    key: 2
};
const $5852877434f662d7$var$_hoisted_179 = {
    key: 2,
    class: "no-properties"
};
const $5852877434f662d7$var$_hoisted_180 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("h2", null, "No properties found", -1);
const $5852877434f662d7$var$_hoisted_181 = [
    $5852877434f662d7$var$_hoisted_180
];
const $5852877434f662d7$var$_hoisted_182 = {
    key: 1,
    class: "pagination ibf center"
};
const $5852877434f662d7$var$_hoisted_183 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("span", {
    class: "_prev",
    "data-page": "1"
}, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, [
        /*#__PURE__*/ (0, $9pglz.createElementVNode)("polygon", {
            points: "7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"
        })
    ])
], -1);
const $5852877434f662d7$var$_hoisted_184 = [
    $5852877434f662d7$var$_hoisted_183
];
const $5852877434f662d7$var$_hoisted_185 = /*#__PURE__*/ (0, $9pglz.createStaticVNode)('<span class="_prev" data-page="3"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g data-name="Double Arrow"><path d="M12 17a1 1 0 0 1-.707-1.707L14.586 12l-3.293-3.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 12 17z" style="fill:#1c1b1e;"></path><path d="M8 17a1 1 0 0 1-.707-1.707L10.586 12 7.293 8.707a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 8 17z" style="fill:#1c1b1e;"></path></g></svg></span>', 1);
const $5852877434f662d7$var$_hoisted_186 = [
    $5852877434f662d7$var$_hoisted_185
];
const $5852877434f662d7$var$_hoisted_187 = [
    "onClick"
];
const $5852877434f662d7$var$_hoisted_188 = [
    "data-page"
];
const $5852877434f662d7$var$_hoisted_189 = {
    key: 1
};
const $5852877434f662d7$var$_hoisted_190 = /*#__PURE__*/ (0, $9pglz.createStaticVNode)('<span class="_next" data-page="3"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g data-name="Double Arrow"><path d="M12 17a1 1 0 0 1-.707-1.707L14.586 12l-3.293-3.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 12 17z" style="fill:#1c1b1e;"></path><path d="M8 17a1 1 0 0 1-.707-1.707L10.586 12 7.293 8.707a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4A1 1 0 0 1 8 17z" style="fill:#1c1b1e;"></path></g></svg></span>', 1);
const $5852877434f662d7$var$_hoisted_191 = [
    $5852877434f662d7$var$_hoisted_190
];
const $5852877434f662d7$var$_hoisted_192 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("span", {
    class: "_next",
    "data-page": "3"
}, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, [
        /*#__PURE__*/ (0, $9pglz.createElementVNode)("polygon", {
            points: "7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"
        })
    ])
], -1);
const $5852877434f662d7$var$_hoisted_193 = [
    $5852877434f662d7$var$_hoisted_192
];
const $5852877434f662d7$var$_hoisted_194 = {
    class: "property-list-intro m-40"
};
const $5852877434f662d7$var$_hoisted_195 = {
    class: "section-title m-25"
};
const $5852877434f662d7$var$_hoisted_196 = [
    "innerHTML"
];
const $5852877434f662d7$var$_hoisted_197 = [
    "innerHTML"
];
const $5852877434f662d7$var$_hoisted_198 = {
    class: "center"
};
function $5852877434f662d7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("section", $5852877434f662d7$var$_hoisted_1, [
        (0, $9pglz.createElementVNode)("div", {
            class: (0, $j3cSI.normalizeClass)([
                "property-filters m-60",
                {
                    "more-filters-mobile": _ctx.moreFilters
                }
            ]),
            "data-facet-category": "real_estate",
            "data-fixed": ""
        }, [
            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_2, [
                (0, $9pglz.createElementVNode)("div", {
                    class: (0, $j3cSI.normalizeClass)([
                        "property-filters-wrap grid",
                        $setup.termCity !== "not-selected" ? "one-more" : ""
                    ])
                }, [
                    (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_3, [
                        (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_4, (0, $j3cSI.toDisplayString)($setup.translations.search_word), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                            class: "input-1",
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.searchTerm = $event)
                        }, null, 512), [
                            [
                                (0, $6zPDN.vModelText),
                                $setup.searchTerm
                            ]
                        ])
                    ]),
                    (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_5, [
                        (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_6, (0, $j3cSI.toDisplayString)($setup.translations.region), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                            name: "zona",
                            class: "input-1",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.termCity = $event)
                        }, [
                            (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_7, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                            ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.regions, (region)=>{
                                return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("option", {
                                    value: region.term_id
                                }, (0, $j3cSI.toDisplayString)(region.name), 9, $5852877434f662d7$var$_hoisted_8);
                            }), 256))
                        ], 512), [
                            [
                                (0, $6zPDN.vModelSelect),
                                $setup.termCity
                            ]
                        ])
                    ]),
                    $setup.termSubCityList.length > 0 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $5852877434f662d7$var$_hoisted_9, [
                        (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_10, (0, $j3cSI.toDisplayString)($setup.translations.city), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                            name: "zona",
                            class: "input-1",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.termSubCity = $event)
                        }, [
                            (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_11, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                            ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.termSubCityList, (city)=>{
                                return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("option", {
                                    value: city.term_id
                                }, (0, $j3cSI.toDisplayString)(city.name), 9, $5852877434f662d7$var$_hoisted_12);
                            }), 256))
                        ], 512), [
                            [
                                (0, $6zPDN.vModelSelect),
                                $setup.termSubCity
                            ]
                        ])
                    ])) : (0, $9pglz.createCommentVNode)("", true),
                    (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_13, [
                        (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_14, (0, $j3cSI.toDisplayString)($setup.translations.sort_by), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                            name: "prezzo",
                            class: "input-1",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.order = $event)
                        }, [
                            (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_15, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                            (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_16, (0, $j3cSI.toDisplayString)($setup.translations.popular), 1),
                            (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_17, (0, $j3cSI.toDisplayString)($setup.translations.low), 1),
                            (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_18, (0, $j3cSI.toDisplayString)($setup.translations.high), 1),
                            (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_19, (0, $j3cSI.toDisplayString)($setup.translations.newest), 1),
                            (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_20, (0, $j3cSI.toDisplayString)($setup.translations.oldest), 1)
                        ], 512), [
                            [
                                (0, $6zPDN.vModelSelect),
                                $setup.order
                            ]
                        ])
                    ]),
                    (0, $9pglz.createElementVNode)("div", {
                        class: "filter-item",
                        onClick: _cache[4] || (_cache[4] = (0, $6zPDN.withModifiers)(($event)=>$setup.filterClick(), [
                            "prevent"
                        ]))
                    }, [
                        (0, $9pglz.createElementVNode)("button", $5852877434f662d7$var$_hoisted_21, (0, $j3cSI.toDisplayString)($setup.translations.search), 1)
                    ]),
                    (0, $9pglz.createElementVNode)("div", {
                        class: "filter-item show-more-filters",
                        onClick: _cache[5] || (_cache[5] = (0, $6zPDN.withModifiers)(($event)=>$setup.showMoreFilters(), [
                            "prevent"
                        ]))
                    }, [
                        (0, $9pglz.createElementVNode)("button", $5852877434f662d7$var$_hoisted_22, (0, $j3cSI.toDisplayString)($setup.translations.more_filters), 1)
                    ])
                ], 2),
                (0, $9pglz.createElementVNode)("div", {
                    class: (0, $j3cSI.normalizeClass)([
                        $setup.filtersActive ? "active" : "",
                        "filter-popup fixed"
                    ])
                }, [
                    (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_23, [
                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_24, [
                            (0, $9pglz.createElementVNode)("p", $5852877434f662d7$var$_hoisted_25, (0, $j3cSI.toDisplayString)($setup.translations.filters), 1),
                            (0, $9pglz.createElementVNode)("a", {
                                href: "#",
                                "aria-label": "Close",
                                class: "popup-close absolute",
                                onClick: _cache[6] || (_cache[6] = ($event)=>$setup.hideMoreFilters())
                            }, $5852877434f662d7$var$_hoisted_27)
                        ]),
                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_28, [
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_29, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_30, (0, $j3cSI.toDisplayString)($setup.translations.type), 1),
                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                                    name: "property-type",
                                    class: "input-1",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.propertyType = $event)
                                }, [
                                    (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_31, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                                    ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.propertyTypeList, (type)=>{
                                        return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("option", {
                                            value: type.term_id
                                        }, (0, $j3cSI.toDisplayString)($setup.getPropertyCategory(type)), 9, $5852877434f662d7$var$_hoisted_32);
                                    }), 256))
                                ], 512), [
                                    [
                                        (0, $6zPDN.vModelSelect),
                                        $setup.propertyType
                                    ]
                                ])
                            ]),
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_33, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_34, (0, $j3cSI.toDisplayString)($setup.translations.bedrooms), 1),
                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                                    name: "prezzo",
                                    class: "input-1",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.bedrooms = $event)
                                }, [
                                    (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_35, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                                    $5852877434f662d7$var$_hoisted_36,
                                    (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_44, (0, $j3cSI.toDisplayString)($setup.translations.more), 1)
                                ], 512), [
                                    [
                                        (0, $6zPDN.vModelSelect),
                                        $setup.bedrooms
                                    ]
                                ])
                            ]),
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_45, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_46, (0, $j3cSI.toDisplayString)($setup.translations.price_range), 1),
                                (0, $9pglz.createVNode)($setup["VueSlider"], {
                                    modelValue: $setup.priceRange,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.priceRange = $event),
                                    min: $setup.minPrice,
                                    max: $setup.maxPrice,
                                    interval: 10000,
                                    tooltip: "never",
                                    "use-keyboard": true,
                                    formatter: $setup.formatPrice,
                                    range: true,
                                    "process-style": {
                                        backgroundColor: "#000"
                                    },
                                    "dot-style": {
                                        backgroundColor: "#000",
                                        border: "2px solid white"
                                    }
                                }, null, 8, [
                                    "modelValue"
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_47, [
                                    (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_48, [
                                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_49, [
                                            (0, $9pglz.createElementVNode)("label", null, (0, $j3cSI.toDisplayString)($setup.translations.min_price), 1),
                                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_50, [
                                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                                    "data-v-83aca2": "",
                                                    class: "input-1",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.formattedMinPrice = $event),
                                                    onInput: $setup.onMinPriceInput,
                                                    placeholder: "\u20AC100,000"
                                                }, null, 544), [
                                                    [
                                                        (0, $6zPDN.vModelText),
                                                        $setup.formattedMinPrice
                                                    ]
                                                ]),
                                                $setup.formattedMinPrice ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", {
                                                    key: 0,
                                                    class: "clear-icon",
                                                    onClick: $setup.clearMinPrice
                                                }, "\xd7")) : (0, $9pglz.createCommentVNode)("", true)
                                            ])
                                        ]),
                                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_51, [
                                            (0, $9pglz.createElementVNode)("label", null, (0, $j3cSI.toDisplayString)($setup.translations.max_price), 1),
                                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_52, [
                                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                                    "data-v-83aca2": "",
                                                    class: "input-1",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.formattedMaxPrice = $event),
                                                    onInput: $setup.onMaxPriceInput,
                                                    placeholder: "\u20AC20,000,000"
                                                }, null, 544), [
                                                    [
                                                        (0, $6zPDN.vModelText),
                                                        $setup.formattedMaxPrice
                                                    ]
                                                ]),
                                                $setup.formattedMaxPrice ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", {
                                                    key: 0,
                                                    class: "clear-icon",
                                                    onClick: $setup.clearMaxPrice
                                                }, "\xd7")) : (0, $9pglz.createCommentVNode)("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_53, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_54, (0, $j3cSI.toDisplayString)($setup.translations.bathrooms), 1),
                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                                    name: "prezzo",
                                    class: "input-1",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$setup.bathrooms = $event)
                                }, [
                                    (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_55, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                                    $5852877434f662d7$var$_hoisted_56,
                                    (0, $9pglz.createElementVNode)("option", $5852877434f662d7$var$_hoisted_64, (0, $j3cSI.toDisplayString)($setup.translations.more), 1)
                                ], 512), [
                                    [
                                        (0, $6zPDN.vModelSelect),
                                        $setup.bathrooms
                                    ]
                                ])
                            ]),
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_65, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_66, (0, $j3cSI.toDisplayString)($setup.translations.inside), 1),
                                (0, $9pglz.createVNode)($setup["VueSlider"], {
                                    modelValue: $setup.sizeRange,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$setup.sizeRange = $event),
                                    min: $setup.minSize,
                                    max: $setup.maxSize,
                                    interval: 10,
                                    tooltip: "never",
                                    "use-keyboard": true,
                                    range: true,
                                    "process-style": {
                                        backgroundColor: "#000"
                                    },
                                    "dot-style": {
                                        backgroundColor: "#000",
                                        border: "2px solid white"
                                    }
                                }, null, 8, [
                                    "modelValue",
                                    "min",
                                    "max"
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_67, [
                                    (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_68, [
                                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_69, [
                                            (0, $9pglz.createElementVNode)("label", null, (0, $j3cSI.toDisplayString)($setup.translations.min_size), 1),
                                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_70, [
                                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                                    "data-v-83aca2": "",
                                                    class: "input-1",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event)=>$setup.tempMinSize = $event),
                                                    placeholder: "100"
                                                }, null, 512), [
                                                    [
                                                        (0, $6zPDN.vModelText),
                                                        $setup.tempMinSize
                                                    ]
                                                ]),
                                                $5852877434f662d7$var$_hoisted_71,
                                                $setup.tempMinSize ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", {
                                                    key: 0,
                                                    class: "clear-icon",
                                                    onClick: $setup.clearMinSize
                                                }, "\xd7")) : (0, $9pglz.createCommentVNode)("", true)
                                            ])
                                        ]),
                                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_72, [
                                            (0, $9pglz.createElementVNode)("label", null, (0, $j3cSI.toDisplayString)($setup.translations.max_size), 1),
                                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_73, [
                                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                                    "data-v-83aca2": "",
                                                    class: "input-1",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event)=>$setup.tempMaxSize = $event),
                                                    placeholder: "2500"
                                                }, null, 512), [
                                                    [
                                                        (0, $6zPDN.vModelText),
                                                        $setup.tempMaxSize
                                                    ]
                                                ]),
                                                $5852877434f662d7$var$_hoisted_74,
                                                $setup.tempMaxSize ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", {
                                                    key: 0,
                                                    class: "clear-icon",
                                                    onClick: $setup.clearMaxSize
                                                }, "\xd7")) : (0, $9pglz.createCommentVNode)("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_75, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_76, (0, $j3cSI.toDisplayString)($setup.translations.plot), 1),
                                (0, $9pglz.createVNode)($setup["VueSlider"], {
                                    modelValue: $setup.plotSizeRange,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event)=>$setup.plotSizeRange = $event),
                                    min: 0,
                                    max: 200000,
                                    interval: 100,
                                    tooltip: "never",
                                    "use-keyboard": true,
                                    marks: $setup.plotSizeMarks,
                                    data: $setup.plotSizeData,
                                    range: true,
                                    "process-style": {
                                        backgroundColor: "#000"
                                    },
                                    "dot-style": {
                                        backgroundColor: "#000",
                                        border: "2px solid white"
                                    }
                                }, null, 8, [
                                    "modelValue"
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_77, [
                                    (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_78, [
                                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_79, [
                                            (0, $9pglz.createElementVNode)("label", null, (0, $j3cSI.toDisplayString)($setup.translations.min_plot), 1),
                                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_80, [
                                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                                    class: "input-1",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event)=>$setup.tempMinPlotSize = $event),
                                                    placeholder: "100"
                                                }, null, 512), [
                                                    [
                                                        (0, $6zPDN.vModelText),
                                                        $setup.tempMinPlotSize
                                                    ]
                                                ]),
                                                $5852877434f662d7$var$_hoisted_81,
                                                $setup.tempMinPlotSize ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", {
                                                    key: 0,
                                                    class: "clear-icon",
                                                    onClick: $setup.clearMinPlotSize
                                                }, "\xd7")) : (0, $9pglz.createCommentVNode)("", true)
                                            ])
                                        ]),
                                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_82, [
                                            (0, $9pglz.createElementVNode)("label", null, (0, $j3cSI.toDisplayString)($setup.translations.max_plot), 1),
                                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_83, [
                                                (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                                    class: "input-1",
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event)=>$setup.tempMaxPlotSize = $event),
                                                    placeholder: "200000"
                                                }, null, 512), [
                                                    [
                                                        (0, $6zPDN.vModelText),
                                                        $setup.tempMaxPlotSize
                                                    ]
                                                ]),
                                                $5852877434f662d7$var$_hoisted_84,
                                                $setup.tempMaxPlotSize ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", {
                                                    key: 0,
                                                    class: "clear-icon",
                                                    onClick: $setup.clearMaxPlotSize
                                                }, "\xd7")) : (0, $9pglz.createCommentVNode)("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_85, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_86, (0, $j3cSI.toDisplayString)($setup.translations.location), 1),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_87, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_88, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event)=>$setup.seaView = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.seaView
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.sea_view), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_89, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_90, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event)=>$setup.waterFront = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.waterFront
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.waterfront), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_91, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_92, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event)=>$setup.nearTheSea = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.nearTheSea
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.near_the_sea), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_93, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_94, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event)=>$setup.beachFront = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.beachFront
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.beachfront), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_95, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_96, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event)=>$setup.mountainView = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.mountainView
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.mountain_view), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_97, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_98, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event)=>$setup.riverView = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.riverView
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.river_view), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_99, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_100, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event)=>$setup.lakeView = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.lakeView
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.lake_view), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_101, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_102, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event)=>$setup.nearTown = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.nearTown
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.near_town), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_103, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_104, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event)=>$setup.village = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.village
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.village), 1)
                                    ])
                                ])
                            ]),
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_105, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_106, (0, $j3cSI.toDisplayString)($setup.translations.facilities), 1),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_107, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_108, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event)=>$setup.heatedPool = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.heatedPool
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.heated_pool), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_109, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_110, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event)=>$setup.outdoorPool = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.outdoorPool
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.outdoor_pool), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_111, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_112, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event)=>$setup.indoorPool = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.indoorPool
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.indoor_pool), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_113, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_114, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event)=>$setup.boatMooring = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.boatMooring
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.boat_mooring), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_115, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_116, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event)=>$setup.garage = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.garage
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.garage), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_117, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_118, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event)=>$setup.hotTub = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.hotTub
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.hot_tub), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_119, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_120, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event)=>$setup.vineyard = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.vineyard
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.vineyard), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_121, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_122, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event)=>$setup.gym = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.gym
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.gym), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_123, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_124, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event)=>$setup.sauna = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.sauna
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.sauna), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_125, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_126, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event)=>$setup.wineCellar = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.wineCellar
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.wine_cellar), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_127, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_128, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event)=>$setup.tennisCourt = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.tennisCourt
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.tennis_court), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_129, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_130, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event)=>$setup.gameRoom = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.gameRoom
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.game_room), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_131, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_132, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event)=>$setup.garden = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.garden
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.garden), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_133, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_134, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event)=>$setup.terrace = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.terrace
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.terrace), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_135, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_136, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event)=>$setup.balcony = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.balcony
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.balcony), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_137, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_138, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event)=>$setup.outdoorKitchen = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.outdoorKitchen
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.outdoor_kitchen), 1)
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_139, [
                                    (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_140, [
                                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                            class: "checkbox-filter",
                                            type: "checkbox",
                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event)=>$setup.elevator = $event)
                                        }, null, 512), [
                                            [
                                                (0, $6zPDN.vModelCheckbox),
                                                $setup.elevator
                                            ]
                                        ]),
                                        (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)($setup.translations.elevator), 1)
                                    ])
                                ])
                            ]),
                            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_141, [
                                (0, $9pglz.createElementVNode)("label", $5852877434f662d7$var$_hoisted_142, (0, $j3cSI.toDisplayString)($setup.translations.year_built), 1),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_143, [
                                    (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                        class: "input-1",
                                        type: "text",
                                        placeholder: "1500",
                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event)=>$setup.yearBuiltStart = $event)
                                    }, null, 512), [
                                        [
                                            (0, $6zPDN.vModelText),
                                            $setup.yearBuiltStart
                                        ]
                                    ])
                                ]),
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_144, [
                                    (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                                        class: "input-1",
                                        type: "text",
                                        placeholder: "2024",
                                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event)=>$setup.yearBuiltEnd = $event)
                                    }, null, 512), [
                                        [
                                            (0, $6zPDN.vModelText),
                                            $setup.yearBuiltEnd
                                        ]
                                    ])
                                ])
                            ])
                        ]),
                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_145, [
                            (0, $9pglz.createElementVNode)("button", {
                                onClick: (0, $6zPDN.withModifiers)($setup.clearFilters, [
                                    "prevent"
                                ]),
                                class: "btn-1"
                            }, (0, $j3cSI.toDisplayString)($setup.translations.clear), 1),
                            (0, $9pglz.createElementVNode)("button", {
                                onClick: _cache[47] || (_cache[47] = (0, $6zPDN.withModifiers)(($event)=>$setup.filterClick(), [
                                    "prevent"
                                ])),
                                class: "btn-1"
                            }, (0, $j3cSI.toDisplayString)($setup.translations.show), 1)
                        ])
                    ])
                ], 2)
            ])
        ], 2),
        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_146, [
            $setup.properties.destinations && $setup.properties.destinations.length > 0 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $5852877434f662d7$var$_hoisted_147, [
                (0, $9pglz.createElementVNode)("h2", $5852877434f662d7$var$_hoisted_148, (0, $j3cSI.toDisplayString)($setup.translations.popular_destinations), 1),
                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_149, [
                    ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.properties.destinations, (destination)=>{
                        return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("a", {
                            href: destination.permalink,
                            class: "category-link"
                        }, (0, $j3cSI.toDisplayString)(destination.post_title), 9, $5852877434f662d7$var$_hoisted_150);
                    }), 256))
                ])
            ])) : (0, $9pglz.createCommentVNode)("", true),
            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_151, [
                $setup.loading ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $5852877434f662d7$var$_hoisted_152, $5852877434f662d7$var$_hoisted_154)) : $setup.properties.posts && $setup.properties.posts.length > 0 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $5852877434f662d7$var$_hoisted_155, [
                    ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.properties.posts, (property)=>{
                        return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $5852877434f662d7$var$_hoisted_156, [
                            (0, $9pglz.createElementVNode)("div", {
                                class: (0, $j3cSI.normalizeClass)([
                                    "favorite-btn",
                                    {
                                        "active": property.favorite
                                    }
                                ]),
                                onClick: (0, $6zPDN.withModifiers)(($event)=>$setup.toggleFavorite(property, property.id), [
                                    "prevent"
                                ])
                            }, $5852877434f662d7$var$_hoisted_159, 10, $5852877434f662d7$var$_hoisted_157),
                            property.youtube ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("a", {
                                key: 0,
                                href: property.youtube,
                                target: "_blank",
                                class: "video-link"
                            }, $5852877434f662d7$var$_hoisted_162, 8, $5852877434f662d7$var$_hoisted_160)) : (0, $9pglz.createCommentVNode)("", true),
                            (0, $9pglz.createElementVNode)("a", {
                                href: $setup.getPropertyPermalink(property),
                                class: "block"
                            }, [
                                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_164, [
                                    (0, $9pglz.createElementVNode)("div", {
                                        class: "swiper swiper-property",
                                        ref_for: true,
                                        ref: "setSwiper"
                                    }, [
                                        (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_165, [
                                            ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)(property.gallery, (image, index)=>{
                                                return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $5852877434f662d7$var$_hoisted_166, [
                                                    (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_167, [
                                                        index === 0 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("img", {
                                                            key: 0,
                                                            src: image.url,
                                                            class: "object-fit-cover",
                                                            alt: image.title
                                                        }, null, 8, $5852877434f662d7$var$_hoisted_168)) : ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), {
                                                            key: 1
                                                        }, [
                                                            (0, $9pglz.createElementVNode)("img", {
                                                                "data-src": image.url,
                                                                class: "object-fit-cover swiper-lazy swiper-hide-drag",
                                                                alt: image.title
                                                            }, null, 8, $5852877434f662d7$var$_hoisted_169),
                                                            $5852877434f662d7$var$_hoisted_170
                                                        ], 64))
                                                    ])
                                                ]);
                                            }), 256))
                                        ]),
                                        $5852877434f662d7$var$_hoisted_171,
                                        $5852877434f662d7$var$_hoisted_172
                                    ], 512)
                                ]),
                                (0, $9pglz.createElementVNode)("p", {
                                    class: "list-card-price text-8 color-1 medium change-price",
                                    "data-base-price": $setup.priceTranslations($setup.getBasePrice(property.price), property.price_upon_request)
                                }, " \u20AC " + (0, $j3cSI.toDisplayString)($setup.priceTranslations(property.price, property.price_upon_request)), 9, $5852877434f662d7$var$_hoisted_173),
                                (0, $9pglz.createElementVNode)("p", $5852877434f662d7$var$_hoisted_174, (0, $j3cSI.toDisplayString)($setup.getPropertyTitle(property)), 1),
                                (0, $9pglz.createElementVNode)("p", $5852877434f662d7$var$_hoisted_175, [
                                    property.bedrooms ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", $5852877434f662d7$var$_hoisted_176, (0, $j3cSI.toDisplayString)(property.bedrooms) + " " + (0, $j3cSI.toDisplayString)($setup.translations.bedrooms), 1)) : (0, $9pglz.createCommentVNode)("", true),
                                    property.bathrooms ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", $5852877434f662d7$var$_hoisted_177, (0, $j3cSI.toDisplayString)(property.bathrooms) + " " + (0, $j3cSI.toDisplayString)($setup.translations.bathrooms), 1)) : (0, $9pglz.createCommentVNode)("", true),
                                    property.size ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", $5852877434f662d7$var$_hoisted_178, (0, $j3cSI.toDisplayString)(property.size) + " \u33A1 ", 1)) : (0, $9pglz.createCommentVNode)("", true)
                                ])
                            ], 8, $5852877434f662d7$var$_hoisted_163)
                        ]);
                    }), 256))
                ])) : ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $5852877434f662d7$var$_hoisted_179, $5852877434f662d7$var$_hoisted_181))
            ]),
            $setup.mainPaginationArray.length > 1 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $5852877434f662d7$var$_hoisted_182, [
                (0, $9pglz.createElementVNode)("a", {
                    "aria-label": "1",
                    href: "#",
                    onClick: _cache[48] || (_cache[48] = (0, $6zPDN.withModifiers)(($event)=>$setup.changePage($setup.currentPage - 1, false), [
                        "prevent"
                    ]))
                }, $5852877434f662d7$var$_hoisted_184),
                (0, $9pglz.createElementVNode)("a", {
                    "aria-label": "3",
                    href: "#",
                    onClick: _cache[49] || (_cache[49] = (0, $6zPDN.withModifiers)(($event)=>$setup.changePage($setup.currentPage - 3, false), [
                        "prevent"
                    ]))
                }, $5852877434f662d7$var$_hoisted_186),
                ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.mainPaginationArray, (pagination)=>{
                    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, [
                        pagination !== "..." ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("a", {
                            key: 0,
                            class: (0, $j3cSI.normalizeClass)(pagination === $setup.currentPage ? "active-page" : ""),
                            "aria-label": "pagination",
                            href: "#",
                            onClick: (0, $6zPDN.withModifiers)(($event)=>$setup.changePage(Number(pagination), false), [
                                "prevent"
                            ])
                        }, [
                            (0, $9pglz.createElementVNode)("span", {
                                class: (0, $j3cSI.normalizeClass)(pagination === $setup.currentPage ? "_active" : ""),
                                "data-page": pagination
                            }, (0, $j3cSI.toDisplayString)(pagination), 11, $5852877434f662d7$var$_hoisted_188)
                        ], 10, $5852877434f662d7$var$_hoisted_187)) : ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("span", $5852877434f662d7$var$_hoisted_189, "\u2026"))
                    ], 64);
                }), 256)),
                (0, $9pglz.createElementVNode)("a", {
                    "aria-label": "3",
                    href: "#",
                    onClick: _cache[50] || (_cache[50] = (0, $6zPDN.withModifiers)(($event)=>$setup.changePage($setup.currentPage + 3, false), [
                        "prevent"
                    ]))
                }, $5852877434f662d7$var$_hoisted_191),
                (0, $9pglz.createElementVNode)("a", {
                    "aria-label": "3",
                    href: "#",
                    onClick: _cache[51] || (_cache[51] = (0, $6zPDN.withModifiers)(($event)=>$setup.changePage($setup.currentPage + 1, false), [
                        "prevent"
                    ]))
                }, $5852877434f662d7$var$_hoisted_193)
            ])) : (0, $9pglz.createCommentVNode)("", true),
            (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_194, [
                (0, $9pglz.createElementVNode)("h1", $5852877434f662d7$var$_hoisted_195, (0, $j3cSI.toDisplayString)($setup.properties.title), 1),
                (0, $9pglz.createElementVNode)("div", {
                    class: "user-content",
                    innerHTML: $setup.userContent.firstPart
                }, null, 8, $5852877434f662d7$var$_hoisted_196),
                (0, $9pglz.createElementVNode)("div", {
                    class: (0, $j3cSI.normalizeClass)([
                        "user-content hidden",
                        $setup.showDesc ? "active" : ""
                    ]),
                    innerHTML: $setup.userContent.secondPart
                }, null, 10, $5852877434f662d7$var$_hoisted_197),
                (0, $9pglz.createElementVNode)("div", $5852877434f662d7$var$_hoisted_198, [
                    $setup.showBtn ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("a", {
                        key: 0,
                        onClick: (0, $6zPDN.withModifiers)($setup.showText, [
                            "prevent"
                        ]),
                        class: "btn-1 type-2 toggle-intro-content",
                        href: "#",
                        rel: "noreferrer"
                    }, (0, $j3cSI.toDisplayString)($setup.translations.show_more), 1)) : (0, $9pglz.createCommentVNode)("", true)
                ])
            ])
        ])
    ]);
}

});

parcelRegister("4IVhq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3707b41a905bd742$export$2e2bcd8739ae039; });
let $3707b41a905bd742$var$NOOP = ()=>{};
var $3707b41a905bd742$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("8eZGI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5fff7b78bae9de22$export$2e2bcd8739ae039; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $Dz4HH = parcelRequire("Dz4HH");

var $gmBfx = parcelRequire("gmBfx");
var $5fff7b78bae9de22$export$2e2bcd8739ae039 = {
    __name: "Faq",
    setup (__props, { expose: __expose }) {
        __expose();
        let faqs = (0, $Dz4HH.ref)([]);
        let categories = (0, $Dz4HH.ref)([]);
        let params = (0, $Dz4HH.ref)({
            page: 1,
            sTerm: "",
            category: ""
        });
        let category = (0, $Dz4HH.ref)("not-selected");
        let sTerm = (0, $Dz4HH.ref)("");
        let page = (0, $Dz4HH.ref)(1);
        let active = (0, $Dz4HH.ref)("");
        const translations = (0, $gmBfx.getTranslation)(getLangCode);
        async function fetchData() {
            try {
                let faqUrl = new URL(MyScriptVars.rest_url + "faq");
                Object.keys(params.value).forEach((key)=>faqUrl.searchParams.append(key, params.value[key]));
                const faqResponse = await fetch(faqUrl, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!faqResponse.ok) throw new Error("Network response was not ok for categories");
                faqs.value = await faqResponse.json();
            } catch (error) {
                console.error("Fetch operation failed:", error);
            }
        }
        const setPage = ()=>{
            page.value++;
            loadMore();
        };
        const filterProperties = async ()=>{
            page.value = 1;
            try {
                const changeUrl = setUrl();
                const faqResponse = await fetch(changeUrl, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!faqResponse.ok) throw new Error("Network response was not ok for properties");
                faqs.value = await faqResponse.json();
            } catch (e) {
                console.log(e);
            }
        };
        const loadMore = async ()=>{
            try {
                const changeUrl = setUrl();
                const faqResponse = await fetch(changeUrl, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!faqResponse.ok) throw new Error("Network response was not ok for properties");
                const data = await faqResponse.json();
                faqs.value.posts = [
                    ...faqs.value.posts,
                    ...data.posts
                ];
            } catch (e) {
                console.log(e);
            }
        };
        const setUrl = ()=>{
            const categoryValue = category.value !== "not-selected" ? category.value : "";
            params.value = {
                page: page.value,
                category: categoryValue,
                sTerm: sTerm
            };
            let changeUrl = new URL(MyScriptVars.rest_url + "faq");
            Object.keys(params.value).forEach((key)=>changeUrl.searchParams.append(key, params.value[key]));
            return changeUrl;
        };
        const setActive = (id)=>{
            active.value = id;
        };
        (0, $9pglz.onMounted)(async ()=>{
            await fetchData();
        });
        const __returned__ = {
            get faqs () {
                return faqs;
            },
            set faqs (v){
                faqs = v;
            },
            get categories () {
                return categories;
            },
            set categories (v){
                categories = v;
            },
            get params () {
                return params;
            },
            set params (v){
                params = v;
            },
            get category () {
                return category;
            },
            set category (v){
                category = v;
            },
            get sTerm () {
                return sTerm;
            },
            set sTerm (v){
                sTerm = v;
            },
            get page () {
                return page;
            },
            set page (v){
                page = v;
            },
            get active () {
                return active;
            },
            set active (v){
                active = v;
            },
            translations: translations,
            fetchData: fetchData,
            setPage: setPage,
            filterProperties: filterProperties,
            loadMore: loadMore,
            setUrl: setUrl,
            setActive: setActive,
            onMounted: $9pglz.onMounted,
            ref: $Dz4HH.ref,
            get getTranslation () {
                return 0, $gmBfx.getTranslation;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("4XptS", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $39c07012a8095542$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $6zPDN = parcelRequire("6zPDN");
const $39c07012a8095542$var$_hoisted_1 = {
    class: "filters-section"
};
const $39c07012a8095542$var$_hoisted_2 = {
    class: "container-3"
};
const $39c07012a8095542$var$_hoisted_3 = {
    class: "filters-wrap grid"
};
const $39c07012a8095542$var$_hoisted_4 = {
    class: "filter-item"
};
const $39c07012a8095542$var$_hoisted_5 = {
    class: "label-1"
};
const $39c07012a8095542$var$_hoisted_6 = {
    value: "not-selected",
    selected: ""
};
const $39c07012a8095542$var$_hoisted_7 = [
    "value"
];
const $39c07012a8095542$var$_hoisted_8 = {
    class: "filter-item"
};
const $39c07012a8095542$var$_hoisted_9 = {
    class: "label-1"
};
const $39c07012a8095542$var$_hoisted_10 = {
    class: "filter-item"
};
const $39c07012a8095542$var$_hoisted_11 = {
    class: "faq-section"
};
const $39c07012a8095542$var$_hoisted_12 = {
    class: "container-1"
};
const $39c07012a8095542$var$_hoisted_13 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "faq-intro center m-20"
}, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("h1", {
        class: "section-title title-2"
    }, " Faq ")
], -1);
const $39c07012a8095542$var$_hoisted_14 = {
    class: "faq-wrap"
};
const $39c07012a8095542$var$_hoisted_15 = [
    "onClick"
];
const $39c07012a8095542$var$_hoisted_16 = {
    class: "expander-main expander-trigger relative pointer"
};
const $39c07012a8095542$var$_hoisted_17 = {
    class: "expander-title title-3"
};
const $39c07012a8095542$var$_hoisted_18 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "expander-btn absolute"
}, null, -1);
const $39c07012a8095542$var$_hoisted_19 = {
    class: "expander-hidden"
};
const $39c07012a8095542$var$_hoisted_20 = {
    class: "expander-content"
};
const $39c07012a8095542$var$_hoisted_21 = {
    class: "expander-text text-6"
};
const $39c07012a8095542$var$_hoisted_22 = {
    key: 0,
    class: "btn-wrapper-faq"
};
function $39c07012a8095542$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, [
        (0, $9pglz.createElementVNode)("section", $39c07012a8095542$var$_hoisted_1, [
            (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_2, [
                (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_3, [
                    (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_4, [
                        (0, $9pglz.createElementVNode)("label", $39c07012a8095542$var$_hoisted_5, (0, $j3cSI.toDisplayString)($setup.translations.category), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.category = $event),
                            class: "input-1"
                        }, [
                            (0, $9pglz.createElementVNode)("option", $39c07012a8095542$var$_hoisted_6, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                            ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.faqs.category, (category)=>{
                                return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("option", {
                                    value: category.term_id
                                }, (0, $j3cSI.toDisplayString)(category.name), 9, $39c07012a8095542$var$_hoisted_7);
                            }), 256))
                        ], 512), [
                            [
                                (0, $6zPDN.vModelSelect),
                                $setup.category
                            ]
                        ])
                    ]),
                    (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_8, [
                        (0, $9pglz.createElementVNode)("label", $39c07012a8095542$var$_hoisted_9, (0, $j3cSI.toDisplayString)($setup.translations.search_word), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.sTerm = $event),
                            type: "text",
                            class: "input-1"
                        }, null, 512), [
                            [
                                (0, $6zPDN.vModelText),
                                $setup.sTerm
                            ]
                        ])
                    ]),
                    (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_10, [
                        (0, $9pglz.createElementVNode)("button", {
                            onClick: _cache[2] || (_cache[2] = (0, $6zPDN.withModifiers)(($event)=>$setup.filterProperties(), [
                                "prevent"
                            ])),
                            type: "submit",
                            class: "btn-1 full-width"
                        }, (0, $j3cSI.toDisplayString)($setup.translations.search), 1)
                    ])
                ])
            ])
        ]),
        (0, $9pglz.createElementVNode)("section", $39c07012a8095542$var$_hoisted_11, [
            (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_12, [
                $39c07012a8095542$var$_hoisted_13,
                (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_14, [
                    ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.faqs.posts, (faq)=>{
                        return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", {
                            class: (0, $j3cSI.normalizeClass)([
                                "expander",
                                faq.ID === $setup.active ? "active" : ""
                            ]),
                            onClick: ($event)=>$setup.setActive(faq.ID)
                        }, [
                            (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_16, [
                                (0, $9pglz.createElementVNode)("h2", $39c07012a8095542$var$_hoisted_17, (0, $j3cSI.toDisplayString)(faq.post_title), 1),
                                $39c07012a8095542$var$_hoisted_18
                            ]),
                            (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_19, [
                                (0, $9pglz.createElementVNode)("div", $39c07012a8095542$var$_hoisted_20, [
                                    (0, $9pglz.createElementVNode)("p", $39c07012a8095542$var$_hoisted_21, (0, $j3cSI.toDisplayString)(faq.post_content), 1)
                                ])
                            ])
                        ], 10, $39c07012a8095542$var$_hoisted_15);
                    }), 256))
                ]),
                $setup.faqs.count >= 10 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $39c07012a8095542$var$_hoisted_22, [
                    (0, $9pglz.createElementVNode)("a", {
                        href: "#",
                        onClick: (0, $6zPDN.withModifiers)($setup.setPage, [
                            "prevent"
                        ]),
                        rel: "noreferrer",
                        class: "btn-1 no-properties"
                    }, (0, $j3cSI.toDisplayString)($setup.translations.show_more), 1)
                ])) : (0, $9pglz.createCommentVNode)("", true)
            ])
        ])
    ], 64);
}

});

parcelRegister("dKQv4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0384bab9a855364$export$2e2bcd8739ae039; });
let $a0384bab9a855364$var$NOOP = ()=>{};
var $a0384bab9a855364$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("exlpo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a954c10dcd2009f7$export$2e2bcd8739ae039; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $Dz4HH = parcelRequire("Dz4HH");

var $gmBfx = parcelRequire("gmBfx");
var $a954c10dcd2009f7$export$2e2bcd8739ae039 = {
    __name: "Blog",
    setup (__props, { expose: __expose }) {
        __expose();
        let posts = (0, $Dz4HH.ref)([]);
        let categories = (0, $Dz4HH.ref)([]);
        let params = (0, $Dz4HH.ref)({
            page: 1,
            sTerm: "",
            category: "",
            order: ""
        });
        let category = (0, $Dz4HH.ref)("not-selected");
        let sTerm = (0, $Dz4HH.ref)("");
        let page = (0, $Dz4HH.ref)(1);
        let active = (0, $Dz4HH.ref)("");
        let order = (0, $Dz4HH.ref)("not-selected");
        const translations = (0, $gmBfx.getTranslation)(getLangCode);
        async function fetchData() {
            try {
                let postsUrl = new URL(MyScriptVars.rest_url + "posts");
                Object.keys(params.value).forEach((key)=>postsUrl.searchParams.append(key, params.value[key]));
                const postsResponse = await fetch(postsUrl, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!postsResponse.ok) throw new Error("Network response was not ok for categories");
                posts.value = await postsResponse.json();
                console.log("faqs", faqs.value);
            } catch (error) {
                console.error("Fetch operation failed:", error);
            }
        }
        const setPage = ()=>{
            console.log(page.value);
            page.value++;
            console.log(page.value);
            loadMore();
        };
        const filterProperties = async ()=>{
            page.value = 1;
            try {
                const changeUrl = setUrl();
                const postsResponse = await fetch(changeUrl, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!postsResponse.ok) throw new Error("Network response was not ok for properties");
                posts.value = await postsResponse.json();
            } catch (e) {
                console.log(e);
            }
        };
        const loadMore = async ()=>{
            try {
                const changeUrl = setUrl();
                const faqResponse = await fetch(changeUrl, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!faqResponse.ok) throw new Error("Network response was not ok for properties");
                const data = await faqResponse.json();
                posts.value.posts = [
                    ...posts.value.posts,
                    ...data.posts
                ];
            } catch (e) {
                console.log(e);
            }
        };
        const setUrl = ()=>{
            const categoryValue = category.value !== "not-selected" ? category.value : "";
            const orderValue = order.value !== "not-selected" ? order.value : "";
            params.value = {
                page: page.value,
                category: categoryValue,
                sTerm: sTerm,
                order: orderValue
            };
            let changeUrl = new URL(MyScriptVars.rest_url + "posts");
            Object.keys(params.value).forEach((key)=>changeUrl.searchParams.append(key, params.value[key]));
            return changeUrl;
        };
        (0, $9pglz.onMounted)(async ()=>{
            await fetchData();
        });
        const __returned__ = {
            get posts () {
                return posts;
            },
            set posts (v){
                posts = v;
            },
            get categories () {
                return categories;
            },
            set categories (v){
                categories = v;
            },
            get params () {
                return params;
            },
            set params (v){
                params = v;
            },
            get category () {
                return category;
            },
            set category (v){
                category = v;
            },
            get sTerm () {
                return sTerm;
            },
            set sTerm (v){
                sTerm = v;
            },
            get page () {
                return page;
            },
            set page (v){
                page = v;
            },
            get active () {
                return active;
            },
            set active (v){
                active = v;
            },
            get order () {
                return order;
            },
            set order (v){
                order = v;
            },
            translations: translations,
            fetchData: fetchData,
            setPage: setPage,
            filterProperties: filterProperties,
            loadMore: loadMore,
            setUrl: setUrl,
            onMounted: $9pglz.onMounted,
            ref: $Dz4HH.ref,
            get getTranslation () {
                return 0, $gmBfx.getTranslation;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("eglVL", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $a62392489b69f090$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $6zPDN = parcelRequire("6zPDN");
const $a62392489b69f090$var$_hoisted_1 = {
    class: "filters-section"
};
const $a62392489b69f090$var$_hoisted_2 = {
    class: "container-3"
};
const $a62392489b69f090$var$_hoisted_3 = {
    class: "filters-wrap grid"
};
const $a62392489b69f090$var$_hoisted_4 = {
    class: "filter-item"
};
const $a62392489b69f090$var$_hoisted_5 = {
    class: "label-1"
};
const $a62392489b69f090$var$_hoisted_6 = {
    value: "not-selected",
    selected: ""
};
const $a62392489b69f090$var$_hoisted_7 = [
    "value"
];
const $a62392489b69f090$var$_hoisted_8 = {
    class: "filter-item"
};
const $a62392489b69f090$var$_hoisted_9 = {
    class: "label-1"
};
const $a62392489b69f090$var$_hoisted_10 = {
    value: "not-selected"
};
const $a62392489b69f090$var$_hoisted_11 = {
    value: "popular"
};
const $a62392489b69f090$var$_hoisted_12 = {
    value: "newest"
};
const $a62392489b69f090$var$_hoisted_13 = {
    value: "oldest"
};
const $a62392489b69f090$var$_hoisted_14 = {
    class: "filter-item"
};
const $a62392489b69f090$var$_hoisted_15 = {
    class: "label-1"
};
const $a62392489b69f090$var$_hoisted_16 = {
    class: "filter-item"
};
const $a62392489b69f090$var$_hoisted_17 = {
    class: "blog-grid-section"
};
const $a62392489b69f090$var$_hoisted_18 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "faq-intro center m-20"
}, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("h1", {
        class: "section-title title-2"
    }, " Blog ")
], -1);
const $a62392489b69f090$var$_hoisted_19 = {
    class: "container-3"
};
const $a62392489b69f090$var$_hoisted_20 = {
    class: "blog-grid grid"
};
const $a62392489b69f090$var$_hoisted_21 = [
    "href"
];
const $a62392489b69f090$var$_hoisted_22 = {
    class: "blog-grid-pic relative overflow m-15"
};
const $a62392489b69f090$var$_hoisted_23 = [
    "src"
];
const $a62392489b69f090$var$_hoisted_24 = {
    class: "blog-grid-content"
};
const $a62392489b69f090$var$_hoisted_25 = {
    class: "blog-grid-title m-15"
};
const $a62392489b69f090$var$_hoisted_26 = {
    class: "blog-grid-text"
};
const $a62392489b69f090$var$_hoisted_27 = {
    key: 0,
    class: "btn-wrapper-faq"
};
function $a62392489b69f090$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, [
        (0, $9pglz.createElementVNode)("section", $a62392489b69f090$var$_hoisted_1, [
            (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_2, [
                (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_3, [
                    (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_4, [
                        (0, $9pglz.createElementVNode)("label", $a62392489b69f090$var$_hoisted_5, (0, $j3cSI.toDisplayString)($setup.translations.category), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.category = $event),
                            class: "input-1"
                        }, [
                            (0, $9pglz.createElementVNode)("option", $a62392489b69f090$var$_hoisted_6, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                            ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.posts.category, (category)=>{
                                return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("option", {
                                    value: category.term_id
                                }, (0, $j3cSI.toDisplayString)(category.name), 9, $a62392489b69f090$var$_hoisted_7);
                            }), 256))
                        ], 512), [
                            [
                                (0, $6zPDN.vModelSelect),
                                $setup.category
                            ]
                        ])
                    ]),
                    (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_8, [
                        (0, $9pglz.createElementVNode)("label", $a62392489b69f090$var$_hoisted_9, (0, $j3cSI.toDisplayString)($setup.translations.sort_by), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("select", {
                            name: "prezzo",
                            class: "input-1",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.order = $event)
                        }, [
                            (0, $9pglz.createElementVNode)("option", $a62392489b69f090$var$_hoisted_10, (0, $j3cSI.toDisplayString)($setup.translations.select), 1),
                            (0, $9pglz.createElementVNode)("option", $a62392489b69f090$var$_hoisted_11, (0, $j3cSI.toDisplayString)($setup.translations.popular), 1),
                            (0, $9pglz.createElementVNode)("option", $a62392489b69f090$var$_hoisted_12, (0, $j3cSI.toDisplayString)($setup.translations.newest), 1),
                            (0, $9pglz.createElementVNode)("option", $a62392489b69f090$var$_hoisted_13, (0, $j3cSI.toDisplayString)($setup.translations.oldest), 1)
                        ], 512), [
                            [
                                (0, $6zPDN.vModelSelect),
                                $setup.order
                            ]
                        ])
                    ]),
                    (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_14, [
                        (0, $9pglz.createElementVNode)("label", $a62392489b69f090$var$_hoisted_15, (0, $j3cSI.toDisplayString)($setup.translations.search_word), 1),
                        (0, $9pglz.withDirectives)((0, $9pglz.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.sTerm = $event),
                            type: "text",
                            class: "input-1"
                        }, null, 512), [
                            [
                                (0, $6zPDN.vModelText),
                                $setup.sTerm
                            ]
                        ])
                    ]),
                    (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_16, [
                        (0, $9pglz.createElementVNode)("button", {
                            onClick: _cache[3] || (_cache[3] = (0, $6zPDN.withModifiers)(($event)=>$setup.filterProperties(), [
                                "prevent"
                            ])),
                            type: "submit",
                            class: "btn-1 full-width"
                        }, (0, $j3cSI.toDisplayString)($setup.translations.search), 1)
                    ])
                ])
            ])
        ]),
        (0, $9pglz.createElementVNode)("section", $a62392489b69f090$var$_hoisted_17, [
            $a62392489b69f090$var$_hoisted_18,
            (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_19, [
                (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_20, [
                    ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.posts.posts, (single)=>{
                        return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("a", {
                            href: single.permalink,
                            class: "blog-grid-item"
                        }, [
                            (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_22, [
                                (0, $9pglz.createElementVNode)("img", {
                                    src: single.image,
                                    class: "object-fit-cover",
                                    alt: ""
                                }, null, 8, $a62392489b69f090$var$_hoisted_23)
                            ]),
                            (0, $9pglz.createElementVNode)("div", $a62392489b69f090$var$_hoisted_24, [
                                (0, $9pglz.createElementVNode)("p", $a62392489b69f090$var$_hoisted_25, (0, $j3cSI.toDisplayString)(single.title), 1),
                                (0, $9pglz.createElementVNode)("p", $a62392489b69f090$var$_hoisted_26, (0, $j3cSI.toDisplayString)(single.description), 1)
                            ])
                        ], 8, $a62392489b69f090$var$_hoisted_21);
                    }), 256))
                ])
            ]),
            $setup.posts.count >= 12 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $a62392489b69f090$var$_hoisted_27, [
                (0, $9pglz.createElementVNode)("a", {
                    href: "#",
                    onClick: (0, $6zPDN.withModifiers)($setup.setPage, [
                        "prevent"
                    ]),
                    rel: "noreferrer",
                    class: "btn-1 no-properties"
                }, (0, $j3cSI.toDisplayString)($setup.translations.show_more), 1)
            ])) : (0, $9pglz.createCommentVNode)("", true)
        ])
    ], 64);
}

});

parcelRegister("6QMo9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fcd2258fa4ffdfc$export$2e2bcd8739ae039; });
let $4fcd2258fa4ffdfc$var$NOOP = ()=>{};
var $4fcd2258fa4ffdfc$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("acvta", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $76d36f8c1f2ea748$export$2e2bcd8739ae039; });
parcelRequire("1FCkY");
var $aPlzd = parcelRequire("aPlzd");
parcelRequire("8h94B");
var $9FG0d = parcelRequire("9FG0d");
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $Dz4HH = parcelRequire("Dz4HH");

var $59lkq = parcelRequire("59lkq");

var $gmBfx = parcelRequire("gmBfx");
var $76d36f8c1f2ea748$export$2e2bcd8739ae039 = {
    __name: "Favorites",
    setup (__props, { expose: __expose }) {
        __expose();
        const router = (0, $59lkq.useRouter)();
        const swiperInstances = (0, $Dz4HH.ref)([]);
        let properties = (0, $Dz4HH.ref)({});
        let initial = (0, $Dz4HH.ref)(false);
        let loading = (0, $Dz4HH.ref)(false);
        const translations = (0, $gmBfx.getTranslation)(getLangCode);
        const favorites = JSON.parse(localStorage.getItem("favorites")) ?? [];
        const toggleFavorite = (property, id)=>{
            console.log("property", property);
            console.log("property", id);
            const index = favorites.indexOf(id);
            if (index === -1) favorites.push(id);
            else favorites.splice(index, 1);
            localStorage.setItem("favorites", JSON.stringify(favorites));
            if (localStorage.getItem("favorites") !== null) {
                const storage = JSON.parse(localStorage.getItem("favorites"));
                if (storage.includes(id)) property.favorite = true;
                else property.favorite = false;
            }
        };
        const checkIfFavorite = ()=>{
            if (localStorage.getItem("favorites") !== null) properties.value.posts.forEach((property)=>{
                const id = property.id;
                const favorites = JSON.parse(localStorage.getItem("favorites"));
                return property.favorite = favorites.includes(id);
            });
        };
        async function fetchData() {
            if (localStorage.getItem("favorites") === null) {
                loading.value = false;
                return;
            }
            try {
                loading.value = true;
                let url = new URL(MyScriptVars.rest_url + "favorites?properties=" + localStorage.getItem("favorites").replace(/[\[\]']+/g, ""));
                const propertiesResponse = await fetch(url, {
                    method: "GET",
                    credentials: "same-origin",
                    headers: new Headers({
                        "X-WP-Nonce": MyScriptVars.nonce
                    })
                });
                if (!propertiesResponse.ok) throw new Error("Network response was not ok for properties");
                properties.value = await propertiesResponse.json();
                loading.value = false;
            } catch (error) {
                console.error("Fetch operation failed:", error);
            }
        }
        const getPropertyPermalink = (property)=>{
            if (!property) return "";
            if (getLangCode == "de") return property.permalink_de;
            if (getLangCode == "hr") return property.permalink_hr;
            if (getLangCode == "cs") return property.permalink_cs;
            if (getLangCode == "es") return property.permalink_es;
            if (getLangCode == "fr") return property.permalink_fr;
            if (getLangCode == "sl") return property.permalink_sl;
            if (getLangCode == "hu") return property.permalink_hu;
            if (getLangCode == "pl") return property.permalink_pl;
            if (getLangCode == "fi") return property.permalink_fi;
            if (getLangCode == "no") return property.permalink_no;
            if (getLangCode == "sv") return property.permalink_sv;
            if (getLangCode == "sk") return property.permalink_sk;
            if (getLangCode == "it") return property.permalink_it;
            if (getLangCode == "uk") return property.permalink_uk;
            if (getLangCode == "nl") return property.permalink_nl;
            return property.permalink;
        };
        const getPropertyTitle = (property)=>{
            if (!property) return "";
            if (getLangCode == "de") return property.title_de;
            if (getLangCode == "hr") return property.title_hr;
            if (getLangCode == "cs") return property.title_cs;
            if (getLangCode == "es") return property.title_es;
            if (getLangCode == "fr") return property.title_fr;
            if (getLangCode == "sl") return property.title_sl;
            if (getLangCode == "hu") return property.title_hu;
            if (getLangCode == "pl") return property.title_pl;
            if (getLangCode == "fi") return property.title_fi;
            if (getLangCode == "no") return property.title_no;
            if (getLangCode == "sv") return property.title_sv;
            if (getLangCode == "sk") return property.title_sk;
            if (getLangCode == "it") return property.title_it;
            if (getLangCode == "uk") return property.title_nl;
            if (getLangCode == "nl") return property.title_nl;
            return property.title;
        };
        const initSwipers = ()=>{
            swiperInstances.value.forEach((swiper)=>{
                swiper.destroy(true, true);
            });
            swiperInstances.value = [];
            (0, $9pglz.nextTick)(()=>{
                const swiperElements = document.querySelectorAll(".swiper-property");
                swiperElements.forEach((el)=>{
                    const swiper = new (0, $aPlzd.S)(el, {
                        modules: [
                            (0, $9FG0d.default)
                        ],
                        speed: 600,
                        slidesPerView: 1,
                        lazy: true,
                        preloadImages: false,
                        spaceBetween: 0,
                        navigation: {
                            prevEl: el.querySelector(".swiper-button-prev"),
                            nextEl: el.querySelector(".swiper-button-next")
                        }
                    });
                    swiperInstances.value.push(swiper);
                });
            });
        };
        const setWidth = ()=>{
            const overflowText = document.querySelectorAll(".overflow-calc");
            overflowText.forEach((text)=>{
                const width = text.parentElement.offsetWidth;
                text.style.maxWidth = `${width - 1}px`;
                text.style.whiteSpace = "nowrap";
            });
        };
        (0, $9pglz.onMounted)(async ()=>{
            await (0, $9pglz.nextTick)();
            setTimeout(async ()=>{
                await fetchData();
                initial.value = true;
                initSwipers();
                setWidth();
                window.addEventListener("resize", setWidth);
                checkIfFavorite();
            }, 500);
        });
        (0, $9pglz.onBeforeUnmount)(()=>{
            swiperInstances.value.forEach((swiper)=>{
                swiper.destroy(true, true);
            });
            window.removeEventListener("resize", setWidth);
        });
        const __returned__ = {
            router: router,
            swiperInstances: swiperInstances,
            get properties () {
                return properties;
            },
            set properties (v){
                properties = v;
            },
            get initial () {
                return initial;
            },
            set initial (v){
                initial = v;
            },
            get loading () {
                return loading;
            },
            set loading (v){
                loading = v;
            },
            translations: translations,
            favorites: favorites,
            toggleFavorite: toggleFavorite,
            checkIfFavorite: checkIfFavorite,
            fetchData: fetchData,
            getPropertyPermalink: getPropertyPermalink,
            getPropertyTitle: getPropertyTitle,
            initSwipers: initSwipers,
            setWidth: setWidth,
            get Swiper () {
                return 0, $aPlzd.S;
            },
            get Navigation () {
                return 0, $9FG0d.default;
            },
            ref: $Dz4HH.ref,
            onMounted: $9pglz.onMounted,
            computed: $9pglz.computed,
            watch: $9pglz.watch,
            nextTick: $9pglz.nextTick,
            onBeforeUnmount: $9pglz.onBeforeUnmount,
            get useRoute () {
                return 0, $59lkq.useRoute;
            },
            get useRouter () {
                return 0, $59lkq.useRouter;
            },
            get getTranslation () {
                return 0, $gmBfx.getTranslation;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

});

parcelRegister("dz0KA", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $9dff20440cbf0230$export$b3890eb0ae9dca99; });
parcelRequire("hrKNH");
var $9pglz = parcelRequire("9pglz");
var $j3cSI = parcelRequire("j3cSI");
var $6zPDN = parcelRequire("6zPDN");
const $9dff20440cbf0230$var$_hoisted_1 = {
    class: "property-list-section"
};
const $9dff20440cbf0230$var$_hoisted_2 = {
    class: "container-properties"
};
const $9dff20440cbf0230$var$_hoisted_3 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "property-list-intro m-40"
}, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("h1", {
        class: "section-title"
    }, " Favorites ")
], -1);
const $9dff20440cbf0230$var$_hoisted_4 = {
    id: "properties-scroll"
};
const $9dff20440cbf0230$var$_hoisted_5 = {
    key: 0,
    class: "loader-wrap"
};
const $9dff20440cbf0230$var$_hoisted_6 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "loader"
}, null, -1);
const $9dff20440cbf0230$var$_hoisted_7 = [
    $9dff20440cbf0230$var$_hoisted_6
];
const $9dff20440cbf0230$var$_hoisted_8 = {
    key: 1,
    class: "property-list-grid grid m-30",
    "data-function": "overflowCalculate"
};
const $9dff20440cbf0230$var$_hoisted_9 = {
    class: "property-item"
};
const $9dff20440cbf0230$var$_hoisted_10 = [
    "onClick"
];
const $9dff20440cbf0230$var$_hoisted_11 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    viewBox: "0 0 471.701 471.701",
    "xml:space": "preserve"
}, [
    /*#__PURE__*/ (0, $9pglz.createElementVNode)("path", {
        d: "M433.601,67.001c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7,13.6-92.4,38.3l-12.9,12.9l-13.1-13.1 c-24.7-24.7-57.6-38.4-92.5-38.4c-34.8,0-67.6,13.6-92.2,38.2c-24.7,24.7-38.3,57.5-38.2,92.4c0,34.9,13.7,67.6,38.4,92.3 l187.8,187.8c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-3.9l188.2-187.5c24.7-24.7,38.3-57.5,38.3-92.4 C471.801,124.501,458.301,91.701,433.601,67.001z M414.401,232.701l-178.7,178l-178.3-178.3c-19.6-19.6-30.4-45.6-30.4-73.3 s10.7-53.7,30.3-73.2c19.5-19.5,45.5-30.3,73.1-30.3c27.7,0,53.8,10.8,73.4,30.4l22.6,22.6c5.3,5.3,13.8,5.3,19.1,0l22.4-22.4 c19.6-19.6,45.7-30.4,73.3-30.4c27.6,0,53.6,10.8,73.2,30.3c19.6,19.6,30.3,45.6,30.3,73.3 C444.801,187.101,434.001,213.101,414.401,232.701z"
    })
], -1);
const $9dff20440cbf0230$var$_hoisted_12 = [
    $9dff20440cbf0230$var$_hoisted_11
];
const $9dff20440cbf0230$var$_hoisted_13 = [
    "href"
];
const $9dff20440cbf0230$var$_hoisted_14 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("img", {
    src: "https://croatiarealestates.com/wp-content/uploads/2024/04/video-camera.png"
}, null, -1);
const $9dff20440cbf0230$var$_hoisted_15 = [
    $9dff20440cbf0230$var$_hoisted_14
];
const $9dff20440cbf0230$var$_hoisted_16 = [
    "href"
];
const $9dff20440cbf0230$var$_hoisted_17 = {
    class: "property-item-slider m-15",
    id: "property-item-slider",
    "data-function": "propertyItemSlider"
};
const $9dff20440cbf0230$var$_hoisted_18 = {
    class: "swiper-wrapper"
};
const $9dff20440cbf0230$var$_hoisted_19 = {
    class: "swiper-slide"
};
const $9dff20440cbf0230$var$_hoisted_20 = {
    class: "slide-inner relative overflow"
};
const $9dff20440cbf0230$var$_hoisted_21 = [
    "src",
    "alt"
];
const $9dff20440cbf0230$var$_hoisted_22 = [
    "src",
    "alt"
];
const $9dff20440cbf0230$var$_hoisted_23 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "swiper-lazy-preloader"
}, null, -1);
const $9dff20440cbf0230$var$_hoisted_24 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "swiper-button-prev"
}, null, -1);
const $9dff20440cbf0230$var$_hoisted_25 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("div", {
    class: "swiper-button-next"
}, null, -1);
const $9dff20440cbf0230$var$_hoisted_26 = {
    class: "list-card-price text-8 color-1 medium"
};
const $9dff20440cbf0230$var$_hoisted_27 = {
    class: "list-card-location text-1 color-1 overflow-calc"
};
const $9dff20440cbf0230$var$_hoisted_28 = {
    class: "list-card-info text-1 color-3 overflow-calc"
};
const $9dff20440cbf0230$var$_hoisted_29 = {
    key: 2,
    class: "no-properties"
};
const $9dff20440cbf0230$var$_hoisted_30 = /*#__PURE__*/ (0, $9pglz.createElementVNode)("h2", null, "No favorites found", -1);
const $9dff20440cbf0230$var$_hoisted_31 = [
    $9dff20440cbf0230$var$_hoisted_30
];
function $9dff20440cbf0230$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("section", $9dff20440cbf0230$var$_hoisted_1, [
        (0, $9pglz.createElementVNode)("div", $9dff20440cbf0230$var$_hoisted_2, [
            $9dff20440cbf0230$var$_hoisted_3,
            (0, $9pglz.createElementVNode)("div", $9dff20440cbf0230$var$_hoisted_4, [
                $setup.loading ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $9dff20440cbf0230$var$_hoisted_5, $9dff20440cbf0230$var$_hoisted_7)) : $setup.properties.posts && $setup.properties.posts.length > 0 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $9dff20440cbf0230$var$_hoisted_8, [
                    ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)($setup.properties.posts, (property)=>{
                        return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $9dff20440cbf0230$var$_hoisted_9, [
                            (0, $9pglz.createElementVNode)("div", {
                                class: (0, $j3cSI.normalizeClass)([
                                    "favorite-btn",
                                    {
                                        "active": property.favorite
                                    }
                                ]),
                                onClick: (0, $6zPDN.withModifiers)(($event)=>$setup.toggleFavorite(property, property.id), [
                                    "prevent"
                                ])
                            }, $9dff20440cbf0230$var$_hoisted_12, 10, $9dff20440cbf0230$var$_hoisted_10),
                            property.youtube ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("a", {
                                key: 0,
                                href: property.youtube,
                                target: "_blank",
                                class: "video-link"
                            }, $9dff20440cbf0230$var$_hoisted_15, 8, $9dff20440cbf0230$var$_hoisted_13)) : (0, $9pglz.createCommentVNode)("", true),
                            (0, $9pglz.createElementVNode)("a", {
                                href: $setup.getPropertyPermalink(property),
                                class: "block"
                            }, [
                                (0, $9pglz.createElementVNode)("div", $9dff20440cbf0230$var$_hoisted_17, [
                                    (0, $9pglz.createElementVNode)("div", {
                                        class: "swiper swiper-property",
                                        ref_for: true,
                                        ref: "setSwiper"
                                    }, [
                                        (0, $9pglz.createElementVNode)("div", $9dff20440cbf0230$var$_hoisted_18, [
                                            ((0, $9pglz.openBlock)(true), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), null, (0, $9pglz.renderList)(property.gallery, (image, index)=>{
                                                return (0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $9dff20440cbf0230$var$_hoisted_19, [
                                                    (0, $9pglz.createElementVNode)("div", $9dff20440cbf0230$var$_hoisted_20, [
                                                        index === 0 ? ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("img", {
                                                            key: 0,
                                                            src: image.url,
                                                            class: "object-fit-cover",
                                                            alt: image.title
                                                        }, null, 8, $9dff20440cbf0230$var$_hoisted_21)) : ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)((0, $9pglz.Fragment), {
                                                            key: 1
                                                        }, [
                                                            (0, $9pglz.createElementVNode)("img", {
                                                                src: image.url,
                                                                class: "object-fit-cover",
                                                                alt: image.title,
                                                                loading: "lazy"
                                                            }, null, 8, $9dff20440cbf0230$var$_hoisted_22),
                                                            $9dff20440cbf0230$var$_hoisted_23
                                                        ], 64))
                                                    ])
                                                ]);
                                            }), 256))
                                        ]),
                                        $9dff20440cbf0230$var$_hoisted_24,
                                        $9dff20440cbf0230$var$_hoisted_25
                                    ], 512)
                                ]),
                                (0, $9pglz.createElementVNode)("p", $9dff20440cbf0230$var$_hoisted_26, " \u20AC " + (0, $j3cSI.toDisplayString)(property.price), 1),
                                (0, $9pglz.createElementVNode)("p", $9dff20440cbf0230$var$_hoisted_27, (0, $j3cSI.toDisplayString)($setup.getPropertyTitle(property)), 1),
                                (0, $9pglz.createElementVNode)("p", $9dff20440cbf0230$var$_hoisted_28, [
                                    (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)(property.bedrooms) + " " + (0, $j3cSI.toDisplayString)($setup.translations.bedrooms), 1),
                                    (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)(property.bathrooms) + " " + (0, $j3cSI.toDisplayString)($setup.translations.bathrooms), 1),
                                    (0, $9pglz.createElementVNode)("span", null, (0, $j3cSI.toDisplayString)(property.size) + " \u33A1 ", 1)
                                ])
                            ], 8, $9dff20440cbf0230$var$_hoisted_16)
                        ]);
                    }), 256))
                ])) : ((0, $9pglz.openBlock)(), (0, $9pglz.createElementBlock)("div", $9dff20440cbf0230$var$_hoisted_29, $9dff20440cbf0230$var$_hoisted_31))
            ])
        ])
    ]);
}

});

parcelRegister("85hT2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e2caa47a300205e$export$2e2bcd8739ae039; });
let $5e2caa47a300205e$var$NOOP = ()=>{};
var $5e2caa47a300205e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire("hrKNH");
var $6zPDN = parcelRequire("6zPDN");

var $59lkq = parcelRequire("59lkq");
let $27e2160a7c3a8629$var$script;



let $27e2160a7c3a8629$var$initialize = ()=>{
    $27e2160a7c3a8629$var$script = (parcelRequire("35roy"));
    if ($27e2160a7c3a8629$var$script.__esModule) $27e2160a7c3a8629$var$script = $27e2160a7c3a8629$var$script.default;
    $27e2160a7c3a8629$var$script.render = (parcelRequire("7A8yi")).render;
    (parcelRequire("4IVhq")).default($27e2160a7c3a8629$var$script);
    $27e2160a7c3a8629$var$script.__scopeId = "data-v-cfa8dc";
    $27e2160a7c3a8629$var$script.__file = "App.vue";
};
$27e2160a7c3a8629$var$initialize();
var $27e2160a7c3a8629$export$2e2bcd8739ae039 = $27e2160a7c3a8629$var$script;


let $0687840166c2cf07$var$script;



let $0687840166c2cf07$var$initialize = ()=>{
    $0687840166c2cf07$var$script = (parcelRequire("8eZGI"));
    if ($0687840166c2cf07$var$script.__esModule) $0687840166c2cf07$var$script = $0687840166c2cf07$var$script.default;
    $0687840166c2cf07$var$script.render = (parcelRequire("4XptS")).render;
    (parcelRequire("dKQv4")).default($0687840166c2cf07$var$script);
    $0687840166c2cf07$var$script.__scopeId = "data-v-12dbab";
    $0687840166c2cf07$var$script.__file = "Faq.vue";
};
$0687840166c2cf07$var$initialize();
var $0687840166c2cf07$export$2e2bcd8739ae039 = $0687840166c2cf07$var$script;


let $34aa403184cfd4ec$var$script;



let $34aa403184cfd4ec$var$initialize = ()=>{
    $34aa403184cfd4ec$var$script = (parcelRequire("exlpo"));
    if ($34aa403184cfd4ec$var$script.__esModule) $34aa403184cfd4ec$var$script = $34aa403184cfd4ec$var$script.default;
    $34aa403184cfd4ec$var$script.render = (parcelRequire("eglVL")).render;
    (parcelRequire("6QMo9")).default($34aa403184cfd4ec$var$script);
    $34aa403184cfd4ec$var$script.__scopeId = "data-v-71719c";
    $34aa403184cfd4ec$var$script.__file = "Blog.vue";
};
$34aa403184cfd4ec$var$initialize();
var $34aa403184cfd4ec$export$2e2bcd8739ae039 = $34aa403184cfd4ec$var$script;


let $2a55205248174ca0$var$script;



let $2a55205248174ca0$var$initialize = ()=>{
    $2a55205248174ca0$var$script = (parcelRequire("acvta"));
    if ($2a55205248174ca0$var$script.__esModule) $2a55205248174ca0$var$script = $2a55205248174ca0$var$script.default;
    $2a55205248174ca0$var$script.render = (parcelRequire("dz0KA")).render;
    (parcelRequire("85hT2")).default($2a55205248174ca0$var$script);
    $2a55205248174ca0$var$script.__scopeId = "data-v-7a67ce";
    $2a55205248174ca0$var$script.__file = "Favorites.vue";
};
$2a55205248174ca0$var$initialize();
var $2a55205248174ca0$export$2e2bcd8739ae039 = $2a55205248174ca0$var$script;


const $46b2dffdb64e485a$var$BC = {
    Methods: {},
    loadFunction (methodName, context) {
        try {
            const method = methodName.split("(");
            let payload;
            if (method.length > 1) {
                const rawPayload = method[1].slice(0, method[1].length - 1);
                if (rawPayload.length > 0) payload = JSON.parse(rawPayload);
            }
            $46b2dffdb64e485a$var$BC.Methods[method[0]](context, payload);
        } catch (e) {
            console.error(methodName, e);
        }
    },
    loadFunctions () {
        const elems = document.querySelectorAll("*[data-function]");
        elems.forEach((el)=>{
            const methods = el.getAttribute("data-function").split("|");
            methods.forEach((method)=>this.loadFunction(method.trim(), el));
        });
    }
};
var $46b2dffdb64e485a$export$2e2bcd8739ae039 = $46b2dffdb64e485a$var$BC;



var $c335481759cd5d3b$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.testMethod = ($this)=>{
    const el = $this;
    console.log("data function", $this);
};



var $d05fd01bd18637f0$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.headerScroll = ()=>{
    const header = document.querySelector(".header");
    const introSection = document.querySelector(".intro-section");
    const introSliderSection = document.querySelector(".intro-slider-section");
    const onScroll = ()=>{
        const scroll = document.documentElement.scrollTop;
        if (scroll > 0) header.classList.add("scrolled");
        else header.classList.remove("scrolled");
    };
    const onLoad = ()=>{
        if (introSection === null && introSliderSection === null) header.classList.add("constant");
    };
    onLoad();
    window.addEventListener("scroll", onScroll);
};



var $497bfbdfb0d6d8e9$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.mobileMenu = ()=>{
    const btn = document.querySelector(".hamburger-btn");
    const toggleMenu = ()=>{
        document.body.classList.toggle("menu-open");
    };
    btn.addEventListener("click", toggleMenu);
};



parcelRequire("1FCkY");
var $aPlzd = parcelRequire("aPlzd");
parcelRequire("8h94B");
var $lKF2X = parcelRequire("lKF2X");
var $10d21cad5bd71659$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.introSlider = ($this)=>{
    const swiperEl = $this.querySelector(".swiper");
    new (0, $aPlzd.S)(swiperEl, {
        modules: [
            (0, $lKF2X.default)
        ],
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        loop: true,
        autoplay: {
            delay: 5000
        }
    });
};



parcelRequire("1FCkY");
var $aPlzd = parcelRequire("aPlzd");
var $592dc70d5170c66b$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.gridSlider = ($this)=>{
    const slider = $this.querySelector(".swiper");
    const breakpoint = window.matchMedia("(min-width: 1200px)");
    let gridSwiper;
    const breakpointChecker = function() {
        if (breakpoint.matches) {
            if (gridSwiper !== undefined) gridSwiper.destroy(true, true);
            return;
        } else if (!breakpoint.matches) return enableSwiper();
    };
    const enableSwiper = function() {
        gridSwiper = new (0, $aPlzd.S)(slider, {
            speed: 1000,
            slidesPerView: 1.7,
            spaceBetween: 10,
            allowTouchMove: true,
            breakpoints: {
                768: {
                    slidesPerView: 3.05,
                    spaceBetween: 12
                }
            }
        });
    };
    breakpoint.addEventListener("change", breakpointChecker);
    breakpointChecker();
};



var $b79946667acf5360$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.expanderControl = ($this)=>{
    const expanders = $this.querySelectorAll(".expander-trigger");
    expanders.forEach((expander)=>{
        expander.addEventListener("click", (event)=>{
            event.preventDefault();
            const siblings = Array.from(expander.parentElement.parentElement.children);
            if (expander.parentElement.classList.contains("active")) siblings.forEach((sibling)=>{
                sibling.classList.remove("active");
            });
            else {
                siblings.forEach((sibling)=>{
                    sibling.classList.remove("active");
                });
                expander.parentElement.classList.add("active");
            }
        });
    });
};



parcelRequire("1FCkY");
var $aPlzd = parcelRequire("aPlzd");
parcelRequire("8h94B");
var $9FG0d = parcelRequire("9FG0d");
var $1aa2617455baea58$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.propertySlider = ($this)=>{
    const swiperEl = $this.querySelector(".swiper");
    const prev = $this.querySelector(".swiper-button-prev");
    const next = $this.querySelector(".swiper-button-next");
    new (0, $aPlzd.S)(swiperEl, {
        modules: [
            (0, $9FG0d.default)
        ],
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: true,
            enabled: true
        },
        navigation: {
            prevEl: prev,
            nextEl: next
        }
    });
};



parcelRequire("1FCkY");
var $aPlzd = parcelRequire("aPlzd");
var $61b91f53b75ab7a8$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.propertiesSimilarSlider = ($this)=>{
    const slider = $this.querySelector(".swiper");
    const breakpoint = window.matchMedia("(min-width: 1200px)");
    let gridSwiper;
    const breakpointChecker = function() {
        if (breakpoint.matches) {
            if (gridSwiper !== undefined) gridSwiper.destroy(true, true);
            return;
        } else if (!breakpoint.matches) return enableSwiper();
    };
    const enableSwiper = function() {
        gridSwiper = new (0, $aPlzd.S)(slider, {
            speed: 1000,
            slidesPerView: 1.4,
            spaceBetween: 10,
            allowTouchMove: true,
            breakpoints: {
                768: {
                    slidesPerView: 2.4,
                    spaceBetween: 10
                }
            }
        });
    };
    breakpoint.addEventListener("change", breakpointChecker);
    breakpointChecker();
};



var $5c79fceddec73092$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.overflowCalculate = ($this)=>{
    const items = $this.querySelectorAll(".overflow-calc");
    const setWidth = ()=>{
        items.forEach((item)=>{
            const width = item.parentElement.offsetWidth;
            item.style.maxWidth = `${width - 1}px`;
            item.style.whiteSpace = "nowrap";
        });
    };
    setWidth();
    window.addEventListener("resize", setWidth);
};



var $dab2a7c52e97174a$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.toggleContent = ($this)=>{
    const btn = $this.querySelector(".toggle-content");
    const hidden = $this.querySelector(".hidden");
    const toggleMenu = ()=>{
        hidden.classList.add("active");
    };
    btn.addEventListener("click", toggleMenu);
};



console.log("expand");
var $267df001b0e933ae$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.propertiesExpander = ($this)=>{
    const content = $this.querySelector(".user-content");
    let htmlContent = content.innerHTML;
    let parentElement = content.parentElement;
    let closestMoreContent = $this.querySelector(".properties-partial-content-more-text");
    closestMoreContent.innerHTML = htmlContent;
    if (htmlContent.length > 500) {
        const shortenedContent = htmlContent.substring(0, 500) + "...";
        content.innerHTML = shortenedContent;
    }
    let showMoreButton = $this.querySelector(".toggle-intro-content");
    showMoreButton.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        content.classList.add("hide");
        showMoreButton.classList.add("hide");
        closestMoreContent.classList.remove("hidden");
    });
};



parcelRequire("1FCkY");
var $aPlzd = parcelRequire("aPlzd");
parcelRequire("8h94B");
var $9FG0d = parcelRequire("9FG0d");
var $0827cd6eee774b5c$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.propertyItemSlider = ($this)=>{
    const swiperEl = $this.querySelector(".swiper");
    const prev = $this.querySelector(".swiper-button-prev");
    const next = $this.querySelector(".swiper-button-next");
    new (0, $aPlzd.S)(swiperEl, {
        modules: [
            (0, $9FG0d.default)
        ],
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            prevEl: prev,
            nextEl: next
        }
    });
};



console.log("expand");
var $f5dc8ee2844ccb6b$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.loadDetails = ($this)=>{
    const content = $this.querySelector(".user-content");
    const showMoreButton = $this.querySelector(".property-btn");
    let initialText = content.textContent + "";
    let contentText = JSON.parse(JSON.stringify(initialText));
    let splitSentence = initialText.split("\n").filter((n)=>n.trim());
    splitSentence = splitSentence.filter((n)=>n);
    let contentLength = $f5dc8ee2844ccb6b$var$wordCount(contentText);
    // let htmlContent = content.innerHTML;
    if (splitSentence.length > 10) {
        content.textContent = splitSentence.slice(0, 10).join("\n").trim();
        showMoreButton.classList.remove("hide");
        showMoreButton.onclick = function(event) {
            event.preventDefault();
            content.textContent = splitSentence.join("\n").trim(); // Join all lines back
            showMoreButton.classList.add("hide");
        };
    } else showMoreButton.classList.add("hide");
};
function $f5dc8ee2844ccb6b$var$wordCount(str) {
    if (str) return str.split(" ").length;
    return 0;
}
function $f5dc8ee2844ccb6b$var$cutSentence(str) {
    return str.split(" ").splice(0, 46).join(" ");
}



var $85bfbd2013785186$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.addView = ()=>{
    const postId = croatiaPageID;
    console.log("add view", croatiaPageID);
    let viewedPosts = localStorage.getItem("viewedPosts");
    viewedPosts = viewedPosts ? JSON.parse(viewedPosts) : [];
    if (!viewedPosts.includes(postId)) {
        viewedPosts.push(postId);
        localStorage.setItem("viewedPosts", JSON.stringify(viewedPosts));
        try {
            const changeUrl = MyScriptVars.rest_url + "view";
            const viewsResponse = fetch(changeUrl, {
                method: "POST",
                credentials: "same-origin",
                headers: new Headers({
                    "X-WP-Nonce": MyScriptVars.nonce,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify({
                    post_id: postId
                })
            });
            if (!viewsResponse.ok) throw new Error("Network response was not ok for views");
        } catch (e) {
            console.log(e);
        }
    }
};



const $94a77394c8ec2b9e$var$conversionRates = {
    euro: 1,
    dollar: 1.1,
    pound: 0.85
};
function $94a77394c8ec2b9e$var$formatCurrency(value, currency) {
    const currencySymbols = {
        euro: "\u20AC",
        dollar: "$",
        pound: "\xa3"
    };
    const symbol = currencySymbols[currency.toLowerCase()] || "\u20AC";
    // Custom formatter for the number
    const formattedNumber = value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${symbol} ${formattedNumber}`;
}
var $94a77394c8ec2b9e$export$2e2bcd8739ae039 = (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).Methods.changeCurrency = ()=>{
    const currencySwitchers = document.querySelectorAll('select[data-function="changeCurrency"]');
    // Load saved currency from local storage
    const savedCurrency = localStorage.getItem("selectedCurrency");
    if (savedCurrency) {
        currencySwitchers.forEach((currencySwitcher)=>{
            currencySwitcher.value = savedCurrency;
        });
        updatePrices(savedCurrency);
    }
    // Add event listener for currency change
    currencySwitchers.forEach((currencySwitcher)=>{
        currencySwitcher.addEventListener("change", function() {
            console.log("change");
            const selectedCurrency = currencySwitcher.value;
            localStorage.setItem("selectedCurrency", selectedCurrency);
            updatePrices(selectedCurrency);
        });
    });
    function updatePrices(currency) {
        const prices = document.querySelectorAll(".change-price");
        prices.forEach((priceElement)=>{
            const basePrice = priceElement.getAttribute("data-base-price");
            // Check if base price is a number, ignore if it's a string like "Price upon request"
            if (!isNaN(basePrice)) {
                const convertedPrice = parseFloat(basePrice) * $94a77394c8ec2b9e$var$conversionRates[currency];
                priceElement.textContent = $94a77394c8ec2b9e$var$formatCurrency(convertedPrice, currency);
            } else // If the base price is not a number, leave it as is
            priceElement.textContent = basePrice;
        });
    }
};


const $089c40fcbb903d20$var$staticRoutes = [
    {
        path: "/faq",
        component: (0, $0687840166c2cf07$export$2e2bcd8739ae039)
    },
    {
        path: "/blog",
        component: (0, $34aa403184cfd4ec$export$2e2bcd8739ae039)
    },
    {
        path: "/favorites",
        component: (0, $2a55205248174ca0$export$2e2bcd8739ae039)
    }
];
// Catch-all route to handle all dynamic paths
$089c40fcbb903d20$var$staticRoutes.push({
    path: "/:catchAll(.*)*",
    component: (0, $27e2160a7c3a8629$export$2e2bcd8739ae039)
});
const $089c40fcbb903d20$var$router = (0, $59lkq.createRouter)({
    history: (0, $59lkq.createWebHistory)(),
    routes: $089c40fcbb903d20$var$staticRoutes
});
document.addEventListener("DOMContentLoaded", ()=>{
    const app = (0, $6zPDN.createApp)((0, $27e2160a7c3a8629$export$2e2bcd8739ae039));
    app.use($089c40fcbb903d20$var$router);
    app.mount("#app");
    (0, $6zPDN.createApp)((0, $0687840166c2cf07$export$2e2bcd8739ae039)).mount("#faq-app");
    (0, $6zPDN.createApp)((0, $34aa403184cfd4ec$export$2e2bcd8739ae039)).mount("#blog-app");
    (0, $6zPDN.createApp)((0, $2a55205248174ca0$export$2e2bcd8739ae039)).mount("#favorites-app");
    (0, $46b2dffdb64e485a$export$2e2bcd8739ae039).loadFunctions();
});



})();
//# sourceMappingURL=index.js.map
